import {
  BRAND_SPACE_ADDRESS_MAX_LENGTH,
  BRAND_SPACE_APPLICATIONS_API_PATH,
  BRAND_SPACE_APPLICATION_ANSWERS_MAX_BYTES,
  BRAND_SPACE_APPLICATION_CHALLENGE_API_PATH,
  BRAND_SPACE_APPLICATION_DECISION_OUTCOMES,
  BRAND_SPACE_APPLICATION_DELIVERY_STATUS,
  BRAND_SPACE_APPLICATION_IDENTITY_LIMITS,
  BRAND_SPACE_APPLICATION_PROOF_LIMITS,
  BRAND_SPACE_APPLICATION_QUESTION_KINDS,
  BRAND_SPACE_APPLICATION_STATE,
  BRAND_SPACE_APPLICATION_TABLE_SORT_FIELDS,
  BRAND_SPACE_CONFIG_DB_MAX_BYTES,
  BRAND_SPACE_CONFIG_MAX_BYTES,
  BRAND_SPACE_CONFIG_VERSION,
  BRAND_SPACE_CREATOR_PLATFORMS,
  BRAND_SPACE_DASHBOARD_APPLICATIONS_API_PATH,
  BRAND_SPACE_DEFAULT_COPY,
  BRAND_SPACE_DEFAULT_PUBLIC_ORIGIN,
  BRAND_SPACE_EMERGENCY_UNPUBLISH_ACTOR_ASSERTION_DOMAIN,
  BRAND_SPACE_FALLBACK_LOCALE,
  BRAND_SPACE_FONT_PAIRINGS,
  BRAND_SPACE_HOME_API_PATH,
  BRAND_SPACE_INTERNAL_API_PATH,
  BRAND_SPACE_ITEM_KEY_PATTERN,
  BRAND_SPACE_LAYOUTS,
  BRAND_SPACE_LEGACY_PUBLIC_PATH,
  BRAND_SPACE_LIMITS,
  BRAND_SPACE_LINK_ICON_IDS,
  BRAND_SPACE_OVERRIDE_DB_MAX_BYTES,
  BRAND_SPACE_OVERRIDE_MAX_BYTES,
  BRAND_SPACE_OVERRIDE_PATHS,
  BRAND_SPACE_PRESENTATION_LIMITS,
  BRAND_SPACE_PREVIEW_API_SEGMENT,
  BRAND_SPACE_PREVIEW_CHANNEL,
  BRAND_SPACE_PREVIEW_HEADER,
  BRAND_SPACE_PREVIEW_MESSAGE_MAX_BYTES,
  BRAND_SPACE_PREVIEW_TOKEN_API_PATH,
  BRAND_SPACE_PREVIEW_VERSION,
  BRAND_SPACE_PRIVATE_CACHE_CONTROL,
  BRAND_SPACE_PROFILE_DESCRIPTION_DISPLAY_LIMIT,
  BRAND_SPACE_PROGRAMME_SEGMENT,
  BRAND_SPACE_PUBLIC_API_PATH,
  BRAND_SPACE_PUBLIC_CACHE_CONTROL,
  BRAND_SPACE_PUBLIC_LOCALES,
  BRAND_SPACE_RESERVED_SEGMENTS,
  BRAND_SPACE_REVALIDATION_ADDRESS_CAP,
  BRAND_SPACE_SECTION_KEYS,
  BRAND_SPACE_SITEMAP_API_PATH,
  BRAND_SPACE_SITEMAP_ENTRY_CAP,
  BRAND_SPACE_SLUG_AVAILABILITY_REASONS,
  BRAND_SPACE_STATUSES,
  BRAND_SPACE_STUDIO_API_PATH,
  BRAND_SPACE_STUDIO_DRAFT_API_PATH,
  BRAND_SPACE_STUDIO_MENTIONS_API_PATH,
  BRAND_SPACE_STUDIO_MENTIONS_MAX_PAGE,
  BRAND_SPACE_STUDIO_MENTIONS_PAGE_SIZE,
  BRAND_SPACE_STUDIO_MENTION_SORTS,
  BRAND_SPACE_STUDIO_MENTION_THUMBNAIL_KINDS,
  BRAND_SPACE_STUDIO_MIRROR_BATCH_STATUSES,
  BRAND_SPACE_STUDIO_PUBLISH_API_PATH,
  BRAND_SPACE_STUDIO_SLUG_AVAILABILITY_API_PATH,
  BRAND_SPACE_STUDIO_VARIANTS_API_PATH,
  BRAND_SPACE_VARIANTS_API_SEGMENT,
  BRAND_SPACE_VARIANT_V1_CAP,
  BRAND_SPACE_VISITOR_IP_HEADER,
  BRAND_SPACE_VISITOR_USER_AGENT_HEADER,
  BrandSpaceConfigUpgradeError,
  BrandSpaceOverrideError,
  BrandSpacePreviewProtocolError,
  BrandSpaceStorageError,
  DEFAULT_BRAND_SPACE_CONFIG,
  HOSTED_MENTION_THUMBNAIL_FILENAME,
  HOSTED_MENTION_THUMBNAIL_PATH,
  HOSTED_MENTION_VIDEO_FILENAME,
  brandSpaceGraphemes,
  brandSpaceHarvestedPlatforms,
  brandSpaceJsonByteLength,
  brandSpaceOffersApplications,
  brandSpaceUtf8ByteLength,
  buildBrandSpaceEmergencyUnpublishActorAssertionPayload,
  buildBrandSpaceLegacyPublicPath,
  buildBrandSpacePublicPath,
  buildHostedMentionPath,
  buildHostedMentionThumbnailUrl,
  buildHostedMentionVideoUrl,
  clampBrandSpaceDisplayText,
  classifyBrandSpaceAddressSegment,
  coerceBrandSpacePublicLocale,
  countBrandSpaceOverrides,
  createBrandSpacePreviewAppliedMessage,
  createBrandSpacePreviewReadyMessage,
  createBrandSpacePreviewRenderMessage,
  createDefaultBrandSpaceConfig,
  deriveBrandSpaceStudioMirrorBatchStatus,
  diffBrandSpaceConfig,
  exceedsBrandSpaceGraphemeLimit,
  hasUniqueBrandSpaceItemKeys,
  hasUniqueBrandSpaceLinkKeys,
  isBrandSpaceApplicationQuestion,
  isBrandSpaceConfig,
  isBrandSpaceConfigV1,
  isBrandSpaceConfigV2,
  isBrandSpaceConfigV3,
  isBrandSpaceConfigV4,
  isBrandSpaceGraphemeBoundedString,
  isBrandSpaceItemKey,
  isBrandSpaceMediaHost,
  isBrandSpacePreviewInstanceId,
  isBrandSpaceProgramId,
  isBrandSpacePublicLocale,
  isSafeBrandSpaceWebUrl,
  mergeBrandSpaceConfig,
  normalizeBrandSpaceAddressSegment,
  normalizeBrandSpaceMentionHandleQuery,
  normalizeBrandSpaceStudioOrigin,
  normalizeBrandSpaceText,
  parseBrandSpacePreviewControlMessage,
  parseBrandSpacePreviewRenderMessage,
  parseBrandSpacePublicAddress,
  removeBrandSpaceOverride,
  retainBrandSpaceEmergencyUnpublishAttempt,
  toBrandSpacePublicConfig,
  toBrandSpaceStudioCreatorContentCandidate,
  truncateBrandSpaceMetadataText,
  upgradeBrandSpaceConfig,
  upgradeBrandSpaceConfigOverride,
  validateBrandSpaceApplicationAnswers,
  validateBrandSpaceConfigStorage,
  validateBrandSpaceCreatorContentPresentation,
  validateBrandSpaceOverrideStorage,
  validateBrandSpacePublicConfigStorage
} from "./chunk-AFJLTX7Z.mjs";

// src/shared/common.ts
var Gender = /* @__PURE__ */ ((Gender2) => {
  Gender2["MALE"] = "male";
  Gender2["FEMALE"] = "female";
  Gender2["NON_BINARY"] = "non-binary";
  Gender2["PREFER_NOT_TO_SAY"] = "prefer-not-to-say";
  return Gender2;
})(Gender || {});
var Language = /* @__PURE__ */ ((Language2) => {
  Language2["ENGLISH"] = "en";
  Language2["FRENCH"] = "fr";
  Language2["SPANISH"] = "es";
  Language2["GERMAN"] = "de";
  Language2["ITALIAN"] = "it";
  Language2["PORTUGUESE"] = "pt";
  return Language2;
})(Language || {});

// src/shared/product-analytics.ts
var PRODUCT_ANALYTICS_VERSION = 1;
var ANALYTICS_SURFACES = ["dashboard", "collab_portal"];
var ANALYTICS_EVENTS = [
  "screen_viewed",
  "authentication_started",
  "authentication_completed",
  "account_created",
  "onboarding_step_completed",
  "feature_attempted",
  "feature_completed",
  "feature_refused",
  "feature_failed",
  "invitation_delivered",
  "referral_attributed",
  "referral_earned",
  "withdrawal_status_changed"
];
var ANALYTICS_CLIENT_EVENTS = [
  "screen_viewed",
  "authentication_started",
  "feature_attempted",
  "feature_refused",
  "feature_failed"
];
var ANALYTICS_FEATURES = [
  "authentication",
  "onboarding",
  "brand_dna",
  "plans",
  "integrations",
  "discovery",
  "recommendations",
  "favorites",
  "creators",
  "contacts",
  "programs",
  "invitations",
  "applications",
  "collabs",
  "briefs",
  "contents",
  "rights",
  "co_ads",
  "gifts",
  "conversations",
  "orders",
  "commissions",
  "funding",
  "payments",
  "withdrawals",
  "documents",
  "performance",
  "referrals",
  "flows",
  "companion",
  "assistants",
  "brand_space",
  "settings",
  "team",
  "studio",
  "imports",
  "exports",
  "profile",
  "notifications",
  "pwa",
  "phone_handoff",
  "demo"
];
var ANALYTICS_ACTIONS = [
  "view",
  "start",
  "submit",
  "create",
  "update",
  "delete",
  "search",
  "add",
  "remove",
  "publish",
  "pause",
  "send",
  "accept",
  "decline",
  "question",
  "reply",
  "upload",
  "validate",
  "confirm",
  "request",
  "download",
  "connect",
  "disconnect",
  "select",
  "copy",
  "share",
  "invite",
  "subscribe",
  "unsubscribe",
  "install",
  "open"
];
var ANALYTICS_STEPS = [
  "entry",
  "email",
  "verification",
  "profile",
  "terms",
  "brand",
  "brand_dna",
  "plan",
  "integration",
  "complete",
  "payment_details",
  "withdrawal_request",
  "withdrawal_result",
  "invitation",
  "attribution",
  "eligible_earning"
];
var ANALYTICS_OUTCOMES = [
  "success",
  "plan_refused",
  "permission_refused",
  "business_refused",
  "technical_failure",
  "pending"
];
var ANALYTICS_ENTRY_POINTS = [
  "self_serve",
  "creator_signup",
  "creator_login",
  "brand_login",
  "team_invitation",
  "brand_invitation",
  "program_invitation",
  "collab_invitation",
  "google",
  "code",
  "email",
  "phone_handoff",
  "referral"
];
var ANALYTICS_ROUTES = [
  "/",
  "/login",
  "/signup",
  "/signup/profile",
  "/signup/networks",
  "/signup/configuration",
  "/signup/ready",
  "/verify",
  "/onboarding",
  "/onboarding/:step",
  "/checkout",
  "/checkout/:step",
  "/space",
  "/dashboard",
  "/collabs",
  "/collabs/:id",
  "/c/:lookupKey",
  "/rights/:lookupKey",
  "/opportunities",
  "/opportunities/:id",
  "/wallet",
  "/wallet/documents",
  "/wallet/:section",
  "/profile",
  "/profile/:section",
  "/referrals",
  "/performance",
  "/messages",
  "/messages/:id",
  "/conversations",
  "/conversations/:id",
  "/gifts",
  "/gifts/:id",
  "/discovery",
  "/recommendations",
  "/favorites",
  "/creators",
  "/creators/:id",
  "/contacts",
  "/contacts/:id",
  "/programs",
  "/programs/:id",
  "/invitations",
  "/applications",
  "/briefs",
  "/briefs/:id",
  "/contents",
  "/mentions",
  "/orders",
  "/commissions",
  "/funding",
  "/payments",
  "/withdrawals",
  "/documents",
  "/flows",
  "/flows/:id",
  "/companion",
  "/assistants",
  "/assistants/:id",
  "/mcp",
  "/mcp/:section",
  "/brand-space",
  "/studio",
  "/settings",
  "/settings/:section",
  "/team",
  "/imports",
  "/exports",
  "/other",
  "/creators/discovery",
  "/collabs/suivi",
  "/collabs/brief-templates",
  "/collabs/brief-templates/:id",
  "/gifting",
  "/programs/browse",
  "/programs/:id/overview",
  "/programs/:id/affiliates",
  "/programs/:id/invitation",
  "/payout/:id/checkout",
  "/payout/:id/checkout/summary",
  "/payout/:id/checkout/processing",
  "/onboarding/brand",
  "/onboarding/creators",
  "/onboarding/collaborations",
  "/onboarding/sales",
  "/onboarding/connect",
  "/onboarding/welcome",
  "/onboarding/dna",
  "/onboarding/plan",
  "/onboarding/billing",
  "/onboarding/shopify",
  "/onboarding/companion",
  "/mcp/authorize",
  "/mcp/copublicity/review/:id",
  "/brand-space/studio",
  "/messages/sent/:id",
  "/payments/commissions",
  "/settings/account",
  "/settings/account/profile",
  "/settings/account/preferences",
  "/settings/account/notifications",
  "/settings/account/security",
  "/settings/account/assistants",
  "/settings/general",
  "/settings/brand-dna",
  "/settings/integrations",
  "/settings/integrations/:platform",
  "/settings/billing",
  "/settings/invoices",
  "/settings/agents",
  "/settings/team",
  "/settings/templates",
  "/affiliates",
  "/affiliates/invitations",
  "/affiliates/applications",
  "/forgot-password",
  "/reset-password",
  "/team/join",
  "/welcome/shopify",
  "/not-found",
  "/extension/authorize",
  "/extension/callback"
];
var PROPERTY_VALUES = {
  feature: ANALYTICS_FEATURES,
  action: ANALYTICS_ACTIONS,
  step: ANALYTICS_STEPS,
  route: ANALYTICS_ROUTES,
  outcome: ANALYTICS_OUTCOMES,
  entry_point: ANALYTICS_ENTRY_POINTS,
  account_status: ["new", "recognized"],
  browser_mode: ["browser", "standalone"],
  language: ["fr", "en", "it"],
  withdrawal_status: ["succeeded", "failed"]
};
function isProductAnalyticsProperties(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) return false;
  return Object.entries(value).every(
    ([key, entry]) => Object.prototype.hasOwnProperty.call(PROPERTY_VALUES, key) && typeof entry === "string" && PROPERTY_VALUES[key].includes(entry)
  );
}
function isProductAnalyticsClientEvent(value) {
  return typeof value === "string" && ANALYTICS_CLIENT_EVENTS.includes(value);
}
function normalizeProductAnalyticsRoute(pathname) {
  const path = pathname.split(/[?#]/, 1)[0].replace(/\/+$/, "") || "/";
  if (ANALYTICS_ROUTES.includes(path) && !path.includes(":"))
    return path;
  const segments = path.split("/").filter(Boolean);
  const matched = ANALYTICS_ROUTES.find((template) => {
    if (!template.includes(":")) return false;
    const parts = template.split("/").filter(Boolean);
    return parts.length === segments.length && parts.every(
      (part, index) => part.startsWith(":") || part === segments[index]
    );
  });
  if (matched) return matched;
  const root = `/${segments[0]}`;
  if (root === "/c") return "/c/:lookupKey";
  if (root === "/rights") return "/rights/:lookupKey";
  if (["onboarding", "checkout"].includes(segments[0]))
    return `${root}/:step`;
  if (["wallet", "profile", "settings", "mcp"].includes(segments[0]))
    return `${root}/:section`;
  if ([
    "collabs",
    "opportunities",
    "messages",
    "conversations",
    "gifts",
    "creators",
    "contacts",
    "programs",
    "briefs",
    "flows",
    "assistants"
  ].includes(segments[0]))
    return `${root}/:id`;
  return "/other";
}

// src/shared/consent-version.ts
var CURRENT_CONSENT_VERSIONS = {
  terms: "1.0",
  privacy: "1.0",
  age: "1.0",
  marketing: "1.0",
  cgv: "2026-10.2",
  cgu: "1.0",
  success_fee_terms: "2026-10.2",
  collab_payment_terms: "2026-10.2"
};
var SUCCESS_FEE_TERMS_CONSENT_TYPE = "success_fee_terms";
var COLLAB_PAYMENT_TERMS_CONSENT_TYPE = "collab_payment_terms";
function currentConsentVersion(type) {
  return CURRENT_CONSENT_VERSIONS[type];
}

// src/shared/country-registration.ts
var SUPPORTED_COUNTRIES = [
  "FR",
  "EE",
  "DE",
  "ES",
  "IT",
  "NL",
  "BE",
  "PT",
  "AT",
  "IE",
  "FI",
  "LU",
  "GB",
  "CH",
  "US",
  "CA"
];
var NOT_YET_OPEN_TO_NEW_PAYOUT_SETUPS = ["US", "CA"];
var WEB_PAYOUT_COUNTRIES = SUPPORTED_COUNTRIES.filter(
  (code) => !NOT_YET_OPEN_TO_NEW_PAYOUT_SETUPS.includes(code)
);
function isWebPayoutCountry(code) {
  return WEB_PAYOUT_COUNTRIES.includes(code);
}
var ALLOWED_SHIPPING_COUNTRIES = [
  // EU members
  "at",
  "be",
  "bg",
  "hr",
  "cy",
  "cz",
  "dk",
  "ee",
  "fi",
  "fr",
  "de",
  "gr",
  "hu",
  "ie",
  "it",
  "lv",
  "lt",
  "lu",
  "mt",
  "nl",
  "pl",
  "pt",
  "ro",
  "sk",
  "si",
  "es",
  "se",
  // EEA (non-EU)
  "is",
  "li",
  "no",
  // Other European
  "gb",
  "ch",
  // North America
  "us",
  "ca"
];
var ALLOWED_SHIPPING_COUNTRIES_UPPER = ALLOWED_SHIPPING_COUNTRIES.map(
  (code) => code.toUpperCase()
);
var ALLOWED_SHIPPING_COUNTRIES_UPPER_SET = new Set(ALLOWED_SHIPPING_COUNTRIES_UPPER);
function isSupportedCountry(code) {
  return SUPPORTED_COUNTRIES.includes(code);
}
var COUNTRY_REGISTRATION_CONFIGS = {
  FR: {
    // French companies may submit either the 9-digit SIREN (the legal entity)
    // or the 14-digit SIRET (the establishment). Stripe accepts both as
    // `company.tax_id`, so both are accepted here; anything in between is a
    // typo and is caught by the pattern, not by the length range.
    countryCode: "FR",
    name: "SIREN / SIRET",
    shortName: "SIREN/SIRET",
    length: { min: 9, max: 14 },
    pattern: /^(\d{9}|\d{14})$/,
    formatDescription: "9 digits (SIREN) or 14 digits (SIRET)",
    placeholder: "XXX XXX XXX XXXXX",
    hasChecksum: true,
    checksumType: "luhn",
    infoUrl: "https://www.service-public.fr/professionnels-entreprises/vosdroits/F32135"
  },
  EE: {
    countryCode: "EE",
    name: "Registrikood",
    shortName: "Reg. code",
    length: 8,
    pattern: /^\d{8}$/,
    formatDescription: "8 digits",
    placeholder: "12345678",
    hasChecksum: false,
    infoUrl: "https://ariregister.rik.ee/"
  },
  DE: {
    countryCode: "DE",
    name: "Handelsregisternummer",
    shortName: "HRB/HRA",
    length: { min: 4, max: 20 },
    pattern: /^(HRA|HRB|PR|GnR|VR)\s?\d{1,6}(\s?[A-Z])?$/i,
    formatDescription: "HRA/HRB + 1-6 digits",
    placeholder: "HRB 12345",
    companyRegisterOnly: true,
    hasChecksum: false,
    infoUrl: "https://www.handelsregister.de/"
  },
  ES: {
    // Spain has three nine-character tax ids and a sole trader holds a personal
    // one, never a CIF: the NIF of a resident (8 digits + control letter), the
    // NIE of a foreign resident (X/Y/Z + 7 digits + control letter) and the CIF
    // of a legal entity (letter + 7 digits + control char). Accepting the CIF
    // shape alone kept every autónoma out of the form. The checksum dispatch
    // picks the rule from the shape.
    countryCode: "ES",
    name: "NIF / NIE / CIF",
    shortName: "NIF",
    length: 9,
    pattern: /^(\d{8}[A-Z]|[A-Z]\d{7}[A-Z0-9])$/i,
    formatDescription: "8 digits + letter (NIF), X/Y/Z + 7 digits + letter (NIE) or letter + 7 digits + control char (CIF)",
    placeholder: "12345678Z",
    hasChecksum: true,
    checksumType: "spanish",
    infoUrl: "https://www.agenciatributaria.es/"
  },
  IT: {
    // Italian individuals (no VAT) submit a 16-char Codice Fiscale; businesses
    // submit an 11-digit Partita IVA. Stripe accepts either as
    // `individual.id_number` / `company.tax_id`, so we accept both formats here
    // and let the checksum dispatch pick the right algorithm.
    countryCode: "IT",
    name: "Partita IVA / Codice Fiscale",
    shortName: "P.IVA / CF",
    length: { min: 11, max: 16 },
    pattern: /^(\d{11}|[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z])$/i,
    formatDescription: "11 digits (P.IVA) or 16 alphanumeric chars (Codice Fiscale)",
    placeholder: "12345678901",
    hasChecksum: true,
    checksumType: "italian",
    infoUrl: "https://www.agenziaentrate.gov.it/"
  },
  NL: {
    countryCode: "NL",
    name: "KvK-nummer",
    shortName: "KvK",
    length: 8,
    pattern: /^\d{8}$/,
    formatDescription: "8 digits",
    placeholder: "12345678",
    hasChecksum: false,
    infoUrl: "https://www.kvk.nl/"
  },
  BE: {
    countryCode: "BE",
    name: "Ondernemingsnummer",
    shortName: "BCE/KBO",
    length: 10,
    pattern: /^[01]\d{9}$/,
    formatDescription: "10 digits (starts with 0 or 1)",
    placeholder: "0123456789",
    hasChecksum: true,
    checksumType: "mod97",
    infoUrl: "https://kbopub.economie.fgov.be/"
  },
  PT: {
    countryCode: "PT",
    name: "NIPC",
    shortName: "NIPC",
    length: 9,
    pattern: /^\d{9}$/,
    formatDescription: "9 digits",
    placeholder: "123456789",
    hasChecksum: false,
    infoUrl: "https://eportugal.gov.pt/"
  },
  AT: {
    countryCode: "AT",
    name: "Firmenbuchnummer",
    shortName: "FN",
    length: { min: 5, max: 10 },
    pattern: /^FN\s?\d{3,6}\s?[A-Z]$/i,
    formatDescription: "FN + 3-6 digits + letter",
    placeholder: "FN 123456 A",
    companyRegisterOnly: true,
    hasChecksum: false,
    infoUrl: "https://www.justiz.gv.at/"
  },
  IE: {
    countryCode: "IE",
    name: "Company Number",
    shortName: "CRO",
    length: { min: 1, max: 7 },
    pattern: /^[1-9]\d{0,6}$/,
    formatDescription: "1-7 digits (no leading zero)",
    placeholder: "123456",
    companyRegisterOnly: true,
    hasChecksum: false,
    infoUrl: "https://www.cro.ie/"
  },
  FI: {
    countryCode: "FI",
    name: "Y-tunnus",
    shortName: "Y-tunnus",
    length: 9,
    pattern: /^\d{7}-\d$/,
    formatDescription: "7 digits + hyphen + check digit",
    placeholder: "1234567-8",
    hasChecksum: true,
    checksumType: "finnish",
    infoUrl: "https://www.ytj.fi/"
  },
  LU: {
    countryCode: "LU",
    name: "RCS Number",
    shortName: "RCS",
    length: { min: 6, max: 7 },
    pattern: /^[A-Z]\d{5,6}$/i,
    formatDescription: "Letter + 5-6 digits",
    placeholder: "B123456",
    hasChecksum: false,
    infoUrl: "https://www.lbr.lu/"
  },
  GB: {
    countryCode: "GB",
    name: "Company Number",
    shortName: "CRN",
    length: 8,
    pattern: /^\d{8}$|^(SC|NI|OC|SO|NC|NL|FC|SF|NF|GE|LP|SL|SP|NO|IP|SI|IC|AC|PC|ZC|CE|CS|RS|SE|SA|NA|NV|RC|SR|NP|R0)\d{6}$/i,
    formatDescription: "8 digits or 2 letters + 6 digits",
    placeholder: "12345678",
    companyRegisterOnly: true,
    hasChecksum: false,
    infoUrl: "https://www.gov.uk/government/organisations/companies-house"
  },
  CH: {
    countryCode: "CH",
    name: "UID (Unternehmens-Identifikationsnummer)",
    shortName: "IDE/UID",
    length: { min: 12, max: 15 },
    pattern: /^CHE-?\d{3}\.?\d{3}\.?\d{3}$/,
    formatDescription: "CHE + 9 digits (e.g., CHE-123.456.789)",
    placeholder: "CHE-123.456.789",
    hasChecksum: false,
    infoUrl: "https://www.uid.admin.ch/"
  },
  US: {
    // Employer Identification Number: 9 digits, canonically written XX-XXXXXXX.
    // The dash is optional on input because both forms are accepted upstream.
    countryCode: "US",
    name: "EIN (Employer Identification Number)",
    shortName: "EIN",
    length: { min: 9, max: 10 },
    pattern: /^\d{2}-?\d{7}$/,
    formatDescription: "9 digits (EIN)",
    placeholder: "12-3456789",
    hasChecksum: false,
    infoUrl: "https://www.irs.gov/businesses/small-businesses-self-employed/employer-identification-number"
  },
  CA: {
    // Federal Business Number: the 9-digit root, without the program account
    // suffix (RC0001 and friends), which is not a company identifier.
    countryCode: "CA",
    name: "Business Number",
    shortName: "BN",
    length: 9,
    pattern: /^\d{9}$/,
    formatDescription: "9 digits",
    placeholder: "123456789",
    hasChecksum: false,
    infoUrl: "https://www.canada.ca/en/revenue-agency/services/tax/businesses/topics/registering-your-business/business-number.html"
  }
};
function validateLuhnChecksum(digits) {
  if (!/^\d+$/.test(digits)) return false;
  let sum = 0;
  const len = digits.length;
  for (let i = 0; i < len; i++) {
    let digit = parseInt(digits.charAt(i), 10);
    if ((len - i) % 2 === 0) {
      digit *= 2;
      if (digit > 9) digit -= 9;
    }
    sum += digit;
  }
  return sum % 10 === 0;
}
function validateMod97Checksum(digits) {
  if (!/^\d{10}$/.test(digits)) return false;
  const baseNumber = parseInt(digits.substring(0, 8), 10);
  const checkDigits = parseInt(digits.substring(8, 10), 10);
  const expectedCheck = 97 - baseNumber % 97;
  return checkDigits === expectedCheck;
}
function validateFinnishChecksum(value) {
  const match = value.match(/^(\d{7})-(\d)$/);
  if (!match) return false;
  const base = match[1];
  const checkDigit = parseInt(match[2], 10);
  const weights = [7, 9, 10, 5, 8, 4, 2];
  let sum = 0;
  for (let i = 0; i < 7; i++) {
    sum += parseInt(base[i], 10) * weights[i];
  }
  const remainder = sum % 11;
  const expectedCheck = remainder === 0 ? 0 : 11 - remainder;
  if (remainder === 1) return false;
  return checkDigit === expectedCheck;
}
var NIF_CONTROL_LETTERS = "TRWAGMYFPDXBNJZSQVHLCKE";
var NIE_PREFIX_DIGITS = { X: "0", Y: "1", Z: "2" };
var SPANISH_PERSONAL_ID_PATTERN = /^[XYZ0-9]\d{7}[A-Z]$/;
function validateSpanishNifChecksum(upper) {
  const body = (NIE_PREFIX_DIGITS[upper[0]] ?? upper[0]) + upper.substring(1, 8);
  return upper[8] === NIF_CONTROL_LETTERS[Number(body) % 23];
}
function validateSpanishCifChecksum(value) {
  if (!/^[A-Z]\d{7}[A-Z0-9]$/i.test(value)) return false;
  const letter = value[0].toUpperCase();
  const digits = value.substring(1, 8);
  const control = value[8].toUpperCase();
  let sumOdd = 0;
  let sumEven = 0;
  for (let i = 0; i < 7; i++) {
    const digit = parseInt(digits[i], 10);
    if (i % 2 === 0) {
      const doubled = digit * 2;
      sumOdd += doubled > 9 ? doubled - 9 : doubled;
    } else {
      sumEven += digit;
    }
  }
  const total = sumOdd + sumEven;
  const controlDigit = (10 - total % 10) % 10;
  const controlLetter = "JABCDEFGHI"[controlDigit];
  const numericControlEntities = ["A", "B", "E", "H"];
  const letterControlEntities = ["K", "P", "Q", "S"];
  if (numericControlEntities.includes(letter)) {
    return control === controlDigit.toString();
  } else if (letterControlEntities.includes(letter)) {
    return control === controlLetter;
  } else {
    return control === controlDigit.toString() || control === controlLetter;
  }
}
function validateSpanishChecksum(value) {
  const upper = value.toUpperCase();
  return SPANISH_PERSONAL_ID_PATTERN.test(upper) ? validateSpanishNifChecksum(upper) : validateSpanishCifChecksum(upper);
}
var CF_ODD_VALUES = {
  "0": 1,
  "1": 0,
  "2": 5,
  "3": 7,
  "4": 9,
  "5": 13,
  "6": 15,
  "7": 17,
  "8": 19,
  "9": 21,
  A: 1,
  B: 0,
  C: 5,
  D: 7,
  E: 9,
  F: 13,
  G: 15,
  H: 17,
  I: 19,
  J: 21,
  K: 2,
  L: 4,
  M: 18,
  N: 20,
  O: 11,
  P: 3,
  Q: 6,
  R: 8,
  S: 12,
  T: 14,
  U: 16,
  V: 10,
  W: 22,
  X: 25,
  Y: 24,
  Z: 23
};
var CF_EVEN_VALUES = {
  "0": 0,
  "1": 1,
  "2": 2,
  "3": 3,
  "4": 4,
  "5": 5,
  "6": 6,
  "7": 7,
  "8": 8,
  "9": 9,
  A: 0,
  B: 1,
  C: 2,
  D: 3,
  E: 4,
  F: 5,
  G: 6,
  H: 7,
  I: 8,
  J: 9,
  K: 10,
  L: 11,
  M: 12,
  N: 13,
  O: 14,
  P: 15,
  Q: 16,
  R: 17,
  S: 18,
  T: 19,
  U: 20,
  V: 21,
  W: 22,
  X: 23,
  Y: 24,
  Z: 25
};
var CF_CONTROL_ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
function validateItalianCodiceFiscale(value) {
  const upper = value.toUpperCase();
  if (!/^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/.test(upper)) return false;
  let sum = 0;
  for (let i = 0; i < 15; i++) {
    const table = i % 2 === 0 ? CF_ODD_VALUES : CF_EVEN_VALUES;
    const charValue = table[upper[i]];
    if (charValue === void 0) return false;
    sum += charValue;
  }
  return upper[15] === CF_CONTROL_ALPHABET[sum % 26];
}
function validateItalianChecksum(value) {
  const cleaned = value.toUpperCase();
  if (/^\d{11}$/.test(cleaned)) {
    return validateLuhnChecksum(cleaned);
  }
  return validateItalianCodiceFiscale(cleaned);
}
function cleanRegistrationNumber(value) {
  return value.replace(/[\s.]/g, "").trim();
}
var FREE_FORM_REGISTRATION_MAX_LENGTH = 64;
function validateRegistrationNumber(value, countryCode, options = {}) {
  if (!isSupportedCountry(countryCode)) {
    return {
      valid: false,
      error: `Country ${countryCode} is not supported`,
      errorCode: "E_UNSUPPORTED_COUNTRY"
    };
  }
  const config = COUNTRY_REGISTRATION_CONFIGS[countryCode];
  const cleanedValue = cleanRegistrationNumber(value);
  if (options.businessType === "individual" && config.companyRegisterOnly) {
    if (cleanedValue.length > FREE_FORM_REGISTRATION_MAX_LENGTH) {
      return {
        valid: false,
        error: `${config.name} must be at most ${FREE_FORM_REGISTRATION_MAX_LENGTH} characters`,
        errorCode: "E_INVALID_LENGTH"
      };
    }
    return { valid: true };
  }
  if (typeof config.length === "number") {
    if (cleanedValue.length !== config.length) {
      return {
        valid: false,
        error: `${config.name} must be exactly ${config.length} characters`,
        errorCode: "E_INVALID_LENGTH"
      };
    }
  } else {
    if (cleanedValue.length < config.length.min || cleanedValue.length > config.length.max) {
      return {
        valid: false,
        error: `${config.name} must be between ${config.length.min} and ${config.length.max} characters`,
        errorCode: "E_INVALID_LENGTH"
      };
    }
  }
  if (!config.pattern.test(cleanedValue)) {
    return {
      valid: false,
      error: `Invalid ${config.name} format. Expected: ${config.formatDescription}`,
      errorCode: "E_INVALID_FORMAT"
    };
  }
  if (config.hasChecksum) {
    let checksumValid = true;
    switch (config.checksumType) {
      case "luhn":
        checksumValid = validateLuhnChecksum(cleanedValue);
        break;
      case "mod97":
        checksumValid = validateMod97Checksum(cleanedValue);
        break;
      case "finnish":
        checksumValid = validateFinnishChecksum(cleanedValue);
        break;
      case "spanish":
        checksumValid = validateSpanishChecksum(cleanedValue);
        break;
      case "italian":
        checksumValid = validateItalianChecksum(cleanedValue);
        break;
    }
    if (!checksumValid) {
      return {
        valid: false,
        error: `Invalid ${config.name} checksum`,
        errorCode: "E_INVALID_CHECKSUM"
      };
    }
  }
  return { valid: true };
}
function getCountryRegistrationConfig(countryCode) {
  if (!isSupportedCountry(countryCode)) {
    return null;
  }
  return COUNTRY_REGISTRATION_CONFIGS[countryCode];
}
function formatRegistrationNumber(value, countryCode) {
  if (!isSupportedCountry(countryCode)) {
    return value;
  }
  const cleanedValue = cleanRegistrationNumber(value);
  switch (countryCode) {
    case "FR":
      if (cleanedValue.length === 14) {
        return `${cleanedValue.slice(0, 3)} ${cleanedValue.slice(3, 6)} ${cleanedValue.slice(6, 9)} ${cleanedValue.slice(9)}`;
      }
      if (/^\d{9}$/.test(cleanedValue)) {
        return `${cleanedValue.slice(0, 3)} ${cleanedValue.slice(3, 6)} ${cleanedValue.slice(6)}`;
      }
      break;
    case "US":
      if (/^\d{9}$/.test(cleanedValue)) {
        return `${cleanedValue.slice(0, 2)}-${cleanedValue.slice(2)}`;
      }
      break;
    case "BE":
      if (cleanedValue.length === 10) {
        return `${cleanedValue.slice(0, 4)}.${cleanedValue.slice(4, 7)}.${cleanedValue.slice(7)}`;
      }
      break;
    case "FI":
      if (/^\d{7}\d$/.test(cleanedValue)) {
        return `${cleanedValue.slice(0, 7)}-${cleanedValue.slice(7)}`;
      }
      break;
    case "ES":
    case "IT":
      return cleanedValue.toUpperCase();
  }
  return cleanedValue;
}
var COUNTRY_CURRENCIES = {
  FR: "eur",
  EE: "eur",
  DE: "eur",
  ES: "eur",
  IT: "eur",
  NL: "eur",
  BE: "eur",
  PT: "eur",
  AT: "eur",
  IE: "eur",
  FI: "eur",
  LU: "eur",
  GB: "gbp",
  CH: "chf",
  US: "usd",
  CA: "cad"
};
var IBAN_LENGTHS = {
  FR: 27,
  EE: 20,
  DE: 22,
  ES: 24,
  IT: 27,
  NL: 18,
  BE: 16,
  PT: 25,
  AT: 20,
  IE: 22,
  FI: 18,
  LU: 20,
  GB: 22,
  CH: 21
};

// src/shared/brand-legal-identity.ts
var BRAND_LEGAL_IDENTITY_REQUIRED_FIELDS = [
  "name",
  "addressLine1",
  "postalCode",
  "city",
  "country",
  "registrationNumber"
];
function isBrandLegalIdentityComplete(details) {
  if (!details) return false;
  return BRAND_LEGAL_IDENTITY_REQUIRED_FIELDS.every((field) => {
    const value = details[field];
    return typeof value === "string" && value.trim().length > 0;
  });
}

// src/shared/currency.ts
var DEFAULT_CURRENCY_CODE = "EUR";

// src/shared/eu-vat.ts
var EU_MEMBER_COUNTRIES = [
  "AT",
  "BE",
  "BG",
  "CY",
  "CZ",
  "DE",
  "DK",
  "EE",
  "ES",
  "FI",
  "FR",
  "GR",
  "HR",
  "HU",
  "IE",
  "IT",
  "LT",
  "LU",
  "LV",
  "MT",
  "NL",
  "PL",
  "PT",
  "RO",
  "SE",
  "SI",
  "SK"
];
var EU_MEMBER_COUNTRY_SET = new Set(EU_MEMBER_COUNTRIES);
function isEuMemberCountry(code) {
  const candidate = code?.trim().toUpperCase();
  if (!candidate) return false;
  return EU_MEMBER_COUNTRY_SET.has(candidate);
}
var EU_VAT_NUMBER_SHAPES = {
  AT: { prefix: "ATU", pattern: /^ATU\d{8}$/, example: "ATU12345678" },
  BE: { prefix: "BE", pattern: /^BE[01]\d{9}$/, example: "BE0123456789" },
  BG: { prefix: "BG", pattern: /^BG\d{9,10}$/, example: "BG123456789" },
  CY: { prefix: "CY", pattern: /^CY\d{8}[A-Z]$/, example: "CY12345678L" },
  CZ: { prefix: "CZ", pattern: /^CZ\d{8,10}$/, example: "CZ12345678" },
  DE: { prefix: "DE", pattern: /^DE\d{9}$/, example: "DE123456789" },
  DK: { prefix: "DK", pattern: /^DK\d{8}$/, example: "DK12345678" },
  EE: { prefix: "EE", pattern: /^EE\d{9}$/, example: "EE123456789" },
  ES: {
    prefix: "ES",
    pattern: /^ES[A-Z0-9]\d{7}[A-Z0-9]$/,
    example: "ESA12345674"
  },
  FI: { prefix: "FI", pattern: /^FI\d{8}$/, example: "FI12345678" },
  FR: {
    prefix: "FR",
    pattern: /^FR[A-Z0-9]{2}\d{9}$/,
    example: "FR12345678901"
  },
  // Greece is the one country whose VAT prefix is not its country code.
  GR: { prefix: "EL", pattern: /^EL\d{9}$/, example: "EL123456789" },
  HR: { prefix: "HR", pattern: /^HR\d{11}$/, example: "HR12345678901" },
  HU: { prefix: "HU", pattern: /^HU\d{8}$/, example: "HU12345678" },
  IE: { prefix: "IE", pattern: /^IE[A-Z0-9]{8,9}$/, example: "IE1234567FA" },
  IT: { prefix: "IT", pattern: /^IT\d{11}$/, example: "IT12345678901" },
  LT: { prefix: "LT", pattern: /^LT(\d{9}|\d{12})$/, example: "LT123456789" },
  LU: { prefix: "LU", pattern: /^LU\d{8}$/, example: "LU12345678" },
  LV: { prefix: "LV", pattern: /^LV\d{11}$/, example: "LV12345678901" },
  MT: { prefix: "MT", pattern: /^MT\d{8}$/, example: "MT12345678" },
  NL: {
    prefix: "NL",
    pattern: /^NL\d{9}B\d{2}$/,
    example: "NL123456789B01"
  },
  PL: { prefix: "PL", pattern: /^PL\d{10}$/, example: "PL1234567890" },
  PT: { prefix: "PT", pattern: /^PT\d{9}$/, example: "PT123456789" },
  RO: { prefix: "RO", pattern: /^RO\d{2,10}$/, example: "RO1234567890" },
  SE: { prefix: "SE", pattern: /^SE\d{12}$/, example: "SE123456789012" },
  SI: { prefix: "SI", pattern: /^SI\d{8}$/, example: "SI12345678" },
  SK: { prefix: "SK", pattern: /^SK\d{10}$/, example: "SK1234567890" }
};
function normalizeEuVatNumber(value) {
  return (value ?? "").replace(/[\s.\-_/]/g, "").toUpperCase();
}
function euVatNumberShape(country) {
  const code = country?.trim().toUpperCase();
  if (!code) return null;
  return EU_VAT_NUMBER_SHAPES[code] ?? null;
}
function looksLikeEuVatNumber(country, value) {
  const normalized = normalizeEuVatNumber(value);
  if (!normalized) return true;
  const shape = euVatNumberShape(country);
  if (!shape) return true;
  return shape.pattern.test(normalized);
}

// src/shared/dashboard-table.ts
var DASHBOARD_TABLE_SORT_DIRECTIONS = ["asc", "desc"];

// src/shared/integration.ts
var IntegrationStatus = /* @__PURE__ */ ((IntegrationStatus2) => {
  IntegrationStatus2["PENDING_BILLING"] = "pending_billing";
  IntegrationStatus2["ACTIVE"] = "active";
  IntegrationStatus2["INACTIVE"] = "inactive";
  IntegrationStatus2["PAUSED"] = "paused";
  IntegrationStatus2["EXPIRED"] = "expired";
  IntegrationStatus2["CANCELLED"] = "cancelled";
  return IntegrationStatus2;
})(IntegrationStatus || {});

// src/shared/money.ts
var MoneyUtils = class _MoneyUtils {
  static fromObject(money) {
    return money;
  }
  static format(money, locale = "en-US") {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: money.currencyCode
    }).format(money.amount);
  }
  static formatAmount(amount, currencyCode, locale = "en-US") {
    return _MoneyUtils.format({ amount, currencyCode }, locale);
  }
};

// src/shared/payout-flow.ts
function normalizeCountry(countryCode) {
  return countryCode.trim().toUpperCase();
}
function isCountryOutsidePayoutPerimeter(countryCode, allowedCountries) {
  const country = normalizeCountry(countryCode);
  if (country.length === 0 || allowedCountries.length === 0) return false;
  return !allowedCountries.some((allowed) => normalizeCountry(allowed) === country);
}
var PAYOUT_STEP_BY_SECTION = {
  bank_account: "bank",
  business_type: "business",
  company_address: "business",
  company_details: "business",
  identity_document: "document",
  individual_address: "business",
  individual_identity: "business",
  representative_identity: "business",
  terms_acceptance: "terms"
};
var PAYOUT_FLOW_STEP_ORDER = [
  "terms",
  "business",
  "bank",
  "document"
];
var INITIAL_COLLECTION = [
  "terms_acceptance",
  "business_type",
  "individual_identity",
  "individual_address",
  "bank_account"
];
function selectPayoutFlowSteps(readiness, missing) {
  if (readiness.status === "restricted") return [];
  const sections = readiness.status === "setup_required" ? INITIAL_COLLECTION : missing;
  const required = new Set(sections.map((section) => PAYOUT_STEP_BY_SECTION[section]));
  return PAYOUT_FLOW_STEP_ORDER.filter((step) => required.has(step));
}
function describeRegistrationNumber(countryCode) {
  const config = getCountryRegistrationConfig(normalizeCountry(countryCode));
  if (!config) {
    return { format: null, label: null, placeholder: "" };
  }
  return {
    format: config.formatDescription,
    label: config.name,
    placeholder: config.placeholder
  };
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/metadata.min.json.js
var metadata_min_json_default = { "version": 4, "country_calling_codes": { "1": ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], "7": ["RU", "KZ"], "20": ["EG"], "27": ["ZA"], "30": ["GR"], "31": ["NL"], "32": ["BE"], "33": ["FR"], "34": ["ES"], "36": ["HU"], "39": ["IT", "VA"], "40": ["RO"], "41": ["CH"], "43": ["AT"], "44": ["GB", "GG", "IM", "JE"], "45": ["DK"], "46": ["SE"], "47": ["NO", "SJ"], "48": ["PL"], "49": ["DE"], "51": ["PE"], "52": ["MX"], "53": ["CU"], "54": ["AR"], "55": ["BR"], "56": ["CL"], "57": ["CO"], "58": ["VE"], "60": ["MY"], "61": ["AU", "CC", "CX"], "62": ["ID"], "63": ["PH"], "64": ["NZ"], "65": ["SG"], "66": ["TH"], "81": ["JP"], "82": ["KR"], "84": ["VN"], "86": ["CN"], "90": ["TR"], "91": ["IN"], "92": ["PK"], "93": ["AF"], "94": ["LK"], "95": ["MM"], "98": ["IR"], "211": ["SS"], "212": ["MA", "EH"], "213": ["DZ"], "216": ["TN"], "218": ["LY"], "220": ["GM"], "221": ["SN"], "222": ["MR"], "223": ["ML"], "224": ["GN"], "225": ["CI"], "226": ["BF"], "227": ["NE"], "228": ["TG"], "229": ["BJ"], "230": ["MU"], "231": ["LR"], "232": ["SL"], "233": ["GH"], "234": ["NG"], "235": ["TD"], "236": ["CF"], "237": ["CM"], "238": ["CV"], "239": ["ST"], "240": ["GQ"], "241": ["GA"], "242": ["CG"], "243": ["CD"], "244": ["AO"], "245": ["GW"], "246": ["IO"], "247": ["AC"], "248": ["SC"], "249": ["SD"], "250": ["RW"], "251": ["ET"], "252": ["SO"], "253": ["DJ"], "254": ["KE"], "255": ["TZ"], "256": ["UG"], "257": ["BI"], "258": ["MZ"], "260": ["ZM"], "261": ["MG"], "262": ["RE", "YT"], "263": ["ZW"], "264": ["NA"], "265": ["MW"], "266": ["LS"], "267": ["BW"], "268": ["SZ"], "269": ["KM"], "290": ["SH", "TA"], "291": ["ER"], "297": ["AW"], "298": ["FO"], "299": ["GL"], "350": ["GI"], "351": ["PT"], "352": ["LU"], "353": ["IE"], "354": ["IS"], "355": ["AL"], "356": ["MT"], "357": ["CY"], "358": ["FI", "AX"], "359": ["BG"], "370": ["LT"], "371": ["LV"], "372": ["EE"], "373": ["MD"], "374": ["AM"], "375": ["BY"], "376": ["AD"], "377": ["MC"], "378": ["SM"], "380": ["UA"], "381": ["RS"], "382": ["ME"], "383": ["XK"], "385": ["HR"], "386": ["SI"], "387": ["BA"], "389": ["MK"], "420": ["CZ"], "421": ["SK"], "423": ["LI"], "500": ["FK"], "501": ["BZ"], "502": ["GT"], "503": ["SV"], "504": ["HN"], "505": ["NI"], "506": ["CR"], "507": ["PA"], "508": ["PM"], "509": ["HT"], "590": ["GP", "BL", "MF"], "591": ["BO"], "592": ["GY"], "593": ["EC"], "594": ["GF"], "595": ["PY"], "596": ["MQ"], "597": ["SR"], "598": ["UY"], "599": ["CW", "BQ"], "670": ["TL"], "672": ["NF"], "673": ["BN"], "674": ["NR"], "675": ["PG"], "676": ["TO"], "677": ["SB"], "678": ["VU"], "679": ["FJ"], "680": ["PW"], "681": ["WF"], "682": ["CK"], "683": ["NU"], "685": ["WS"], "686": ["KI"], "687": ["NC"], "688": ["TV"], "689": ["PF"], "690": ["TK"], "691": ["FM"], "692": ["MH"], "850": ["KP"], "852": ["HK"], "853": ["MO"], "855": ["KH"], "856": ["LA"], "880": ["BD"], "886": ["TW"], "960": ["MV"], "961": ["LB"], "962": ["JO"], "963": ["SY"], "964": ["IQ"], "965": ["KW"], "966": ["SA"], "967": ["YE"], "968": ["OM"], "970": ["PS"], "971": ["AE"], "972": ["IL"], "973": ["BH"], "974": ["QA"], "975": ["BT"], "976": ["MN"], "977": ["NP"], "992": ["TJ"], "993": ["TM"], "994": ["AZ"], "995": ["GE"], "996": ["KG"], "998": ["UZ"] }, "countries": { "AC": ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], "AD": ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], "AE": ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], "AF": ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], "AG": ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], "AI": ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], "AL": ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], "AM": ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], "AO": ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], "AR": ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], "AS": ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], "AT": ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]", "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], "AU": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:2(?:(?:[0-26-9]\\d|3[0-8]|5[0135-9])\\d|4(?:[02-9]\\d|10))|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90))|7(?:[013-57-9]\\d|2[0-8])\\d)\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|[34]\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-478])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], "AW": ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], "AX": ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], "AZ": ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], "BA": ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], "BB": ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], "BD": ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], "BE": ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], "BF": ["226", "00", "(?:[025-7]\\d|44)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[024-7]"]]]], "BG": ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], "BH": ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], "BI": ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], "BJ": ["229", "00", "(?:01\\d|[24-689])\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]]], "BL": ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], "BM": ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], "BN": ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], "BO": ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], "BQ": ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], "BR": ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "[1-467]\\d{9,10}|55[0-46-9]\\d{8}|[34]\\d{7}|55\\d{7,8}|(?:5[0-46-9]|[89]\\d)\\d{7,9}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37|86)", "300|4(?:0(?:0|20)|370|864)"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], "BS": ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], "BT": ["975", "00", "[178]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-6]|7[246]|8[2-4]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|[78]"]]]], "BW": ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], "BY": ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], "BZ": ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], "CA": ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|5[07]|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], "CC": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-478])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], "CD": ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0"], "CF": ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], "CG": ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], "CH": ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], "CI": ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], "CK": ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], "CL": ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["60|809"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9(?:10|[2-9])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-8]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], "CM": ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], "CN": ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], "CO": ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|9[14]"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], "CR": ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], "CU": ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], "CV": ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], "CW": ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], "CX": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-478])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], "CY": ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], "CZ": ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], "DE": ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|3[13])"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], "DJ": ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], "DK": ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], "DM": ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], "DO": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], "DZ": ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], "EC": ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], "EE": ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], "EG": ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], "EH": ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], "ER": ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], "ES": ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], "ET": ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], "FI": ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], "FJ": ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "FK": ["500", "00", "[2-7]\\d{4}", [5]], "FM": ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], "FO": ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], "FR": ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], "GA": ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], "GB": ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, "0|180020", 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], "GD": ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], "GE": ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], "GF": ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], "GG": ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0|180020", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], "GH": ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], "GI": ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], "GL": ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], "GM": ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], "GN": ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], "GP": ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], "GQ": ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], "GR": ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], "GT": ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], "GU": ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], "GW": ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], "GY": ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], "HK": ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "HN": ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], "HR": ["385", "00", "[2-69]\\d{8}|80\\d{5,7}|[1-79]\\d{7}|6\\d{6}", [7, 8, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], "HT": ["509", "00", "[2-589]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], "HU": ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], "ID": ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], "IE": ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "IL": ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], "IM": ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0|180020", "1624$1", 0, "74576|(?:16|7[56])24"], "IN": ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], "IO": ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], "IQ": ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], "IR": ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], "IS": ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "IT": ["39", "00", "0\\d{5,11}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[03]"]]], 0, 0, 0, 0, 0, 0, [["0(?:669[0-79]\\d{1,6}|831\\d{2,8})|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[2356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], "JE": ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0|180020", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], "JM": ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], "JO": ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|427|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[47]"], "0$1"]], "0"], "JP": ["81", "010", "00[1-9]\\d{6,14}|[25-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["3|4(?:2[09]|7[01])|6[1-9]", "3|4(?:2(?:0|9[02-69])|7(?:0[019]|1))|6[1-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[25-9]"], "0$1"]], "0", 0, "(000[2569]\\d{4,6})$|(?:(?:003768)0?)|0", "$1"], "KE": ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], "KG": ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "KH": ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], "KI": ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], "KM": ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], "KN": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], "KP": ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], "KR": ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], "KW": ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], "KY": ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], "KZ": ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33622|7", 0, "8~10"], "LA": ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["3"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], "LB": ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-6]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], "LC": ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], "LI": ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], "LK": ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], "LR": ["231", "00", "(?:[2457]\\d|33|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"], "LS": ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], "LT": ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]"], "LU": ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], "LV": ["371", "00", "(?:[268]\\d|78|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2679]|8[01]"]]]], "LY": ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], "MA": ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-8]|5[0-5]|8[0-7]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], "MC": ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], "MD": ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], "ME": ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], "MF": ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], "MG": ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], "MH": ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], "MK": ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], "ML": ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], "MM": ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], "MN": ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], "MO": ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], "MP": ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], "MQ": ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "MR": ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], "MS": ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], "MT": ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], "MU": ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], "MV": ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "MW": ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], "MX": ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "MY": ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], "MZ": ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], "NA": ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], "NC": ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], "NE": ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]]], "NF": ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], "NG": ["234", "009", "(?:20|9\\d)\\d{8}|[78]\\d{9,13}", [10, 11, 12, 13, 14], [["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], "NI": ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], "NL": ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], "NO": ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], "NP": ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], "NR": ["674", "00", "(?:222|444|(?:55|8\\d)\\d|666|777|999)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[24-9]"]]]], "NU": ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], "NZ": ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], "OM": ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], "PA": ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], "PE": ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], "PF": ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], "PG": ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "PH": ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], "PK": ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], "PL": ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], "PM": ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "PR": ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], "PS": ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], "PT": ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], "PW": ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], "PY": ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], "QA": ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[136]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], "RE": ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[0-3]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], "RO": ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], "RS": ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], "RU": ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, 0, [["336(?:[013-9]\\d|2[013-9])\\d{5}|(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15-7]|6[0-35-79]|7[1-37-9]))\\d{7}", [10]], ["9\\d{9}", [10]], ["8(?:0[04]|108\\d{3})\\d{7}"], ["80[39]\\d{7}", [10]], ["808\\d{7}", [10]]], "8~10"], "RW": ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], "SA": ["966", "00", "(?:[15]\\d|800|92)\\d{7}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], "SB": ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], "SC": ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "SD": ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], "SE": ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], "SG": ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], "SH": ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], "SI": ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], "SJ": ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], "SK": ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], "SL": ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], "SM": ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], "SN": ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], "SO": ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], "0"], "SR": ["597", "00", "(?:[2-5]|[6-8]\\d|90)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-9]"]]]], "SS": ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], "ST": ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], "SV": ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], "SX": ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], "SY": ["963", "00", "[1-359]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-4]|5[1-3]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[59]"], "0$1", 1]], "0"], "SZ": ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], "TA": ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], "TC": ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], "TD": ["235", "00|16", "(?:22|30|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[236-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "TG": ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], "TH": ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], "TJ": ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], "TK": ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], "TL": ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], "TM": ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], "TN": ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], "TO": ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], "TR": ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], "TT": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], "TV": ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], "TW": ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], "TZ": ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], "UA": ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], "UG": ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], "US": ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["3052(?:0[0-8]|[1-9]\\d)\\d{4}|(?:2742|305[3-9])\\d{6}|(?:472|983)[2-47-9]\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[013-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-269])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[0378]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], "UY": ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|2\\d{3,4}|(?:[49]\\d|80)\\d{5}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{4,5})", "$1", ["21"]], ["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], "UZ": ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]]], "VA": ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698"], "VC": ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], "VE": ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], "VG": ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], "VI": ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], "VN": ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], "VU": ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], "WF": ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], "WS": ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], "XK": ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0"], "YE": ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], "YT": ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], "ZA": ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], "ZM": ["260", "00", "800\\d{6}|(?:21|[579]\\d|63)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[579]"], "0$1"]], "0"], "ZW": ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, "nonGeographic": { "800": ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], "808": ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], "870": ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]], "878": ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], "881": ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], "882": ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], "883": ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], "888": ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], "979": ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/min/exports/withMetadataArgument.js
function withMetadataArgument(func, _arguments) {
  var args = Array.prototype.slice.call(_arguments);
  args.push(metadata_min_json_default);
  return func.apply(this, args);
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/tools/semver-compare.js
function semver_compare_default(a, b) {
  a = a.split("-");
  b = b.split("-");
  var pa = a[0].split(".");
  var pb = b[0].split(".");
  for (var i = 0; i < 3; i++) {
    var na = Number(pa[i]);
    var nb = Number(pb[i]);
    if (na > nb) return 1;
    if (nb > na) return -1;
    if (!isNaN(na) && isNaN(nb)) return 1;
    if (isNaN(na) && !isNaN(nb)) return -1;
  }
  if (a[1] && b[1]) {
    return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
  }
  return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/helpers/isObject.js
var objectConstructor = {}.constructor;
function isObject(object) {
  return object !== void 0 && object !== null && object.constructor === objectConstructor;
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/metadata.js
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var V3 = "1.2.0";
var V4 = "1.7.35";
var DEFAULT_EXT_PREFIX = " ext. ";
var CALLING_CODE_REG_EXP = /^\d+$/;
var Metadata = /* @__PURE__ */ function() {
  function Metadata2(metadata) {
    _classCallCheck(this, Metadata2);
    validateMetadata(metadata);
    this.metadata = metadata;
    setVersion.call(this, metadata);
  }
  return _createClass(Metadata2, [{
    key: "getCountries",
    value: function getCountries3() {
      return Object.keys(this.metadata.countries).filter(function(_) {
        return _ !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function getCountryMetadata(countryCode) {
      return this.metadata.countries[countryCode];
    }
  }, {
    key: "nonGeographic",
    value: function nonGeographic() {
      if (this.v1 || this.v2 || this.v3) return;
      return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function hasCountry(country) {
      return this.getCountryMetadata(country) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function hasCallingCode(callingCode) {
      if (this.getCountryCodesForCallingCode(callingCode)) {
        return true;
      }
      if (this.nonGeographic()) {
        if (this.nonGeographic()[callingCode]) {
          return true;
        }
      } else {
        var countryCodes = this.countryCallingCodes()[callingCode];
        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") {
          return true;
        }
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function isNonGeographicCallingCode(callingCode) {
      if (this.nonGeographic()) {
        return this.nonGeographic()[callingCode] ? true : false;
      } else {
        return this.getCountryCodesForCallingCode(callingCode) ? false : true;
      }
    }
    // Deprecated.
  }, {
    key: "country",
    value: function country(countryCode) {
      return this.selectNumberingPlan(countryCode);
    }
  }, {
    key: "selectNumberingPlan",
    value: function selectNumberingPlan(countryCode, callingCode) {
      if (countryCode && CALLING_CODE_REG_EXP.test(countryCode)) {
        callingCode = countryCode;
        countryCode = null;
      }
      if (countryCode && countryCode !== "001") {
        if (!this.hasCountry(countryCode)) {
          throw new Error("Unknown country: ".concat(countryCode));
        }
        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(countryCode), this);
      } else if (callingCode) {
        if (!this.hasCallingCode(callingCode)) {
          throw new Error("Unknown calling code: ".concat(callingCode));
        }
        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
      } else {
        this.numberingPlan = void 0;
      }
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function getCountryCodesForCallingCode(callingCode) {
      var countryCodes = this.countryCallingCodes()[callingCode];
      if (countryCodes) {
        if (countryCodes.length === 1 && countryCodes[0].length === 3) {
          return;
        }
        return countryCodes;
      }
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function getCountryCodeForCallingCode(callingCode) {
      var countryCodes = this.getCountryCodesForCallingCode(callingCode);
      if (countryCodes) {
        return countryCodes[0];
      }
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function getNumberingPlanMetadata(callingCode) {
      var countryCode = this.getCountryCodeForCallingCode(callingCode);
      if (countryCode) {
        return this.getCountryMetadata(countryCode);
      }
      if (this.nonGeographic()) {
        var metadata = this.nonGeographic()[callingCode];
        if (metadata) {
          return metadata;
        }
      } else {
        var countryCodes = this.countryCallingCodes()[callingCode];
        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") {
          return this.metadata.countries["001"];
        }
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function countryCallingCode() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function formats() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function type(_type) {
      return this.numberingPlan.type(_type);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function ext() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function countryCallingCodes() {
      if (this.v1) return this.metadata.country_phone_code_to_countries;
      return this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function chooseCountryByCountryCallingCode(callingCode) {
      return this.selectNumberingPlan(callingCode);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function hasSelectedNumberingPlan() {
      return this.numberingPlan !== void 0;
    }
  }]);
}();
var NumberingPlan = /* @__PURE__ */ function() {
  function NumberingPlan2(metadata, globalMetadataObject) {
    _classCallCheck(this, NumberingPlan2);
    this.globalMetadataObject = globalMetadataObject;
    this.metadata = metadata;
    setVersion.call(this, globalMetadataObject.metadata);
  }
  return _createClass(NumberingPlan2, [{
    key: "callingCode",
    value: function callingCode() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function getDefaultCountryMetadataForRegion() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      if (this.v1 || this.v2) return this.metadata[1];
      return this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.v1) return;
      return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function _getFormats(metadata) {
      return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function formats() {
      var _this = this;
      var formats2 = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return formats2.map(function(_) {
        return new Format(_, _this);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function nationalPrefix() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function _getNationalPrefixFormattingRule(metadata) {
      return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function _nationalPrefixForParsing() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function _getNationalPrefixIsOptionalWhenFormatting() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function types() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      if (this.types() && this.types().length === 0) {
        return false;
      }
      return !!this.types();
    }
  }, {
    key: "type",
    value: function type(_type2) {
      if (this.hasTypes() && getType(this.types(), _type2)) {
        return new Type(getType(this.types(), _type2), this);
      }
    }
  }, {
    key: "ext",
    value: function ext() {
      if (this.v1 || this.v2) return DEFAULT_EXT_PREFIX;
      return this.metadata[13] || DEFAULT_EXT_PREFIX;
    }
  }]);
}();
var Format = /* @__PURE__ */ function() {
  function Format2(format, metadata) {
    _classCallCheck(this, Format2);
    this._format = format;
    this.metadata = metadata;
  }
  return _createClass(Format2, [{
    key: "pattern",
    value: function pattern() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function format() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function leadingDigitsPatterns() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function usesNationalPrefix() {
      return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) ? true : false;
    }
  }, {
    key: "internationalFormat",
    value: function internationalFormat() {
      return this._format[5] || this.format();
    }
  }]);
}();
var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var Type = /* @__PURE__ */ function() {
  function Type2(type, metadata) {
    _classCallCheck(this, Type2);
    this.type = type;
    this.metadata = metadata;
  }
  return _createClass(Type2, [{
    key: "pattern",
    value: function pattern() {
      if (this.metadata.v1) return this.type;
      return this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.metadata.v1) return;
      return this.type[1] || this.metadata.possibleLengths();
    }
  }]);
}();
function getType(types, type) {
  switch (type) {
    case "FIXED_LINE":
      return types[0];
    case "MOBILE":
      return types[1];
    case "TOLL_FREE":
      return types[2];
    case "PREMIUM_RATE":
      return types[3];
    case "PERSONAL_NUMBER":
      return types[4];
    case "VOICEMAIL":
      return types[5];
    case "UAN":
      return types[6];
    case "PAGER":
      return types[7];
    case "VOIP":
      return types[8];
    case "SHARED_COST":
      return types[9];
  }
}
function validateMetadata(metadata) {
  if (!metadata) {
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  }
  if (!isObject(metadata) || !isObject(metadata.countries)) {
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(isObject(metadata) ? "an object of shape: { " + Object.keys(metadata).join(", ") + " }" : "a " + typeOf(metadata) + ": " + metadata, "."));
  }
}
var typeOf = function typeOf2(_) {
  return _typeof(_);
};
function getCountryCallingCode(country, metadata) {
  metadata = new Metadata(metadata);
  if (metadata.hasCountry(country)) {
    return metadata.selectNumberingPlan(country).countryCallingCode();
  }
  throw new Error("Unknown country: ".concat(country));
}
function isSupportedCountry2(country, metadata) {
  return metadata.countries.hasOwnProperty(country);
}
function setVersion(metadata) {
  var version = metadata.version;
  if (typeof version === "number") {
    this.v1 = version === 1;
    this.v2 = version === 2;
    this.v3 = version === 3;
    this.v4 = version === 4;
  } else {
    if (!version) {
      this.v1 = true;
    } else if (semver_compare_default(version, V3) === -1) {
      this.v2 = true;
    } else if (semver_compare_default(version, V4) === -1) {
      this.v3 = true;
    } else {
      this.v4 = true;
    }
  }
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/helpers/mergeArrays.js
function _createForOfIteratorHelperLoose(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (t) return (t = t.call(r)).next.bind(t);
  if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
    t && (r = t);
    var o = 0;
    return function() {
      return o >= r.length ? { done: true } : { done: false, value: r[o++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function mergeArrays(a, b) {
  var merged = a.slice();
  for (var _iterator = _createForOfIteratorHelperLoose(b), _step; !(_step = _iterator()).done; ) {
    var element = _step.value;
    if (a.indexOf(element) < 0) {
      merged.push(element);
    }
  }
  return merged.sort(function(a2, b2) {
    return a2 - b2;
  });
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/helpers/checkNumberLength.js
function checkNumberLength(nationalNumber, country, metadata) {
  return checkNumberLengthForType(nationalNumber, country, void 0, metadata);
}
function checkNumberLengthForType(nationalNumber, country, type, metadata) {
  if (country) {
    metadata = new Metadata(metadata.metadata);
    metadata.selectNumberingPlan(country);
  }
  var type_info = metadata.type(type);
  var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths();
  if (!possible_lengths) {
    return "IS_POSSIBLE";
  }
  if (type === "FIXED_LINE_OR_MOBILE") {
    if (!metadata.type("FIXED_LINE")) {
      return checkNumberLengthForType(nationalNumber, country, "MOBILE", metadata);
    }
    var mobile_type = metadata.type("MOBILE");
    if (mobile_type) {
      possible_lengths = mergeArrays(possible_lengths, mobile_type.possibleLengths());
    }
  } else if (type && !type_info) {
    return "INVALID_LENGTH";
  }
  var actual_length = nationalNumber.length;
  var minimum_length = possible_lengths[0];
  if (minimum_length === actual_length) {
    return "IS_POSSIBLE";
  }
  if (minimum_length > actual_length) {
    return "TOO_SHORT";
  }
  if (possible_lengths[possible_lengths.length - 1] < actual_length) {
    return "TOO_LONG";
  }
  return possible_lengths.indexOf(actual_length, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/isPossible.js
function isPossiblePhoneNumber(input, options, metadata) {
  if (options === void 0) {
    options = {};
  }
  metadata = new Metadata(metadata);
  if (options.v2) {
    if (!input.countryCallingCode) {
      throw new Error("Invalid phone number object passed");
    }
    metadata.selectNumberingPlan(input.countryCallingCode);
  } else {
    if (!input.phone) {
      return false;
    }
    if (input.country) {
      if (!metadata.hasCountry(input.country)) {
        throw new Error("Unknown country: ".concat(input.country));
      }
      metadata.selectNumberingPlan(input.country);
    } else {
      if (!input.countryCallingCode) {
        throw new Error("Invalid phone number object passed");
      }
      metadata.selectNumberingPlan(input.countryCallingCode);
    }
  }
  if (metadata.possibleLengths()) {
    return isPossibleNumber(input.phone || input.nationalNumber, input.country, metadata);
  } else {
    if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) {
      return true;
    } else {
      throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
  }
}
function isPossibleNumber(nationalNumber, country, metadata) {
  switch (checkNumberLength(nationalNumber, country, metadata)) {
    case "IS_POSSIBLE":
      return true;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational
    default:
      return false;
  }
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/helpers/matchesEntirely.js
function matchesEntirely(text, regularExpressionText) {
  text = text || "";
  return new RegExp("^(?:" + regularExpressionText + ")$").test(text);
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/helpers/getNumberType.js
function _createForOfIteratorHelperLoose2(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (t) return (t = t.call(r)).next.bind(t);
  if (Array.isArray(r) || (t = _unsupportedIterableToArray2(r)) || e && r && "number" == typeof r.length) {
    t && (r = t);
    var o = 0;
    return function() {
      return o >= r.length ? { done: true } : { done: false, value: r[o++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray2(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray2(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray2(r, a) : void 0;
  }
}
function _arrayLikeToArray2(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
var NON_FIXED_LINE_PHONE_TYPES = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function getNumberType(input, options, metadata) {
  options = options || {};
  if (!input.country && !input.countryCallingCode) {
    return;
  }
  metadata = new Metadata(metadata);
  metadata.selectNumberingPlan(input.country, input.countryCallingCode);
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern())) {
    return;
  }
  if (isNumberTypeEqualTo(nationalNumber, "FIXED_LINE", metadata)) {
    if (metadata.type("MOBILE") && metadata.type("MOBILE").pattern() === "") {
      return "FIXED_LINE_OR_MOBILE";
    }
    if (!metadata.type("MOBILE")) {
      return "FIXED_LINE_OR_MOBILE";
    }
    if (isNumberTypeEqualTo(nationalNumber, "MOBILE", metadata)) {
      return "FIXED_LINE_OR_MOBILE";
    }
    return "FIXED_LINE";
  }
  for (var _iterator = _createForOfIteratorHelperLoose2(NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done; ) {
    var type = _step.value;
    if (isNumberTypeEqualTo(nationalNumber, type, metadata)) {
      return type;
    }
  }
}
function isNumberTypeEqualTo(nationalNumber, type, metadata) {
  type = metadata.type(type);
  if (!type || !type.pattern()) {
    return false;
  }
  if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) {
    return false;
  }
  return matchesEntirely(nationalNumber, type.pattern());
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/isValid.js
function isValidNumber(input, options, metadata) {
  options = options || {};
  metadata = new Metadata(metadata);
  metadata.selectNumberingPlan(input.country, input.countryCallingCode);
  if (metadata.hasTypes()) {
    return getNumberType(input, options, metadata.metadata) !== void 0;
  }
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  return matchesEntirely(nationalNumber, metadata.nationalNumberPattern());
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/helpers/getPossibleCountriesForNumber.js
function getPossibleCountriesForNumber(callingCode, nationalNumber, metadata) {
  var _metadata = new Metadata(metadata);
  var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
  if (!possibleCountries) {
    return [];
  }
  return possibleCountries.filter(function(country) {
    return couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
  });
}
function couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
  var _metadata = new Metadata(metadata);
  _metadata.selectNumberingPlan(country);
  if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) {
    return true;
  }
  return false;
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/constants.js
var MIN_LENGTH_FOR_NSN = 2;
var MAX_LENGTH_FOR_NSN = 17;
var MAX_LENGTH_COUNTRY_CODE = 3;
var VALID_DIGITS = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9";
var DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var SLASHES = "\uFF0F/";
var DOTS = "\uFF0E.";
var WHITESPACE = " \xA0\xAD\u200B\u2060\u3000";
var BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]";
var TILDES = "~\u2053\u223C\uFF5E";
var VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES);
var PLUS_CHARS = "+\uFF0B";

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/helpers/stripIddPrefix.js
var CAPTURING_DIGIT_PATTERN = new RegExp("([" + VALID_DIGITS + "])");
function stripIddPrefix(number, country, callingCode, metadata) {
  if (!country) {
    return;
  }
  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);
  var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
  if (number.search(IDDPrefixPattern) !== 0) {
    return;
  }
  number = number.slice(number.match(IDDPrefixPattern)[0].length);
  var matchedGroups = number.match(CAPTURING_DIGIT_PATTERN);
  if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
    if (matchedGroups[1] === "0") {
      return;
    }
  }
  return number;
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/helpers/extractNationalNumberFromPossiblyIncompleteNumber.js
function extractNationalNumberFromPossiblyIncompleteNumber(number, metadata) {
  if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
    var prefixPattern = new RegExp("^(?:" + metadata.numberingPlan.nationalPrefixForParsing() + ")");
    var prefixMatch = prefixPattern.exec(number);
    if (prefixMatch) {
      var nationalNumber;
      var carrierCode;
      var capturedGroupsCount = prefixMatch.length - 1;
      var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
      if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
        nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule());
        if (capturedGroupsCount > 1) {
          carrierCode = prefixMatch[1];
        }
      } else {
        var prefixBeforeNationalNumber = prefixMatch[0];
        nationalNumber = number.slice(prefixBeforeNationalNumber.length);
        if (hasCapturedGroups) {
          carrierCode = prefixMatch[1];
        }
      }
      var nationalPrefix;
      if (hasCapturedGroups) {
        var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
        var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup);
        if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) {
          nationalPrefix = metadata.numberingPlan.nationalPrefix();
        }
      } else {
        nationalPrefix = prefixMatch[0];
      }
      return {
        nationalNumber,
        nationalPrefix,
        carrierCode
      };
    }
  }
  return {
    nationalNumber: number
  };
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/helpers/getCountryByNationalNumber.js
function _createForOfIteratorHelperLoose3(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (t) return (t = t.call(r)).next.bind(t);
  if (Array.isArray(r) || (t = _unsupportedIterableToArray3(r)) || e && r && "number" == typeof r.length) {
    t && (r = t);
    var o = 0;
    return function() {
      return o >= r.length ? { done: true } : { done: false, value: r[o++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray3(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray3(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray3(r, a) : void 0;
  }
}
function _arrayLikeToArray3(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function getCountryByNationalNumber(nationalPhoneNumber, _ref) {
  var countries = _ref.countries, metadata = _ref.metadata;
  metadata = new Metadata(metadata);
  for (var _iterator = _createForOfIteratorHelperLoose3(countries), _step; !(_step = _iterator()).done; ) {
    var country = _step.value;
    metadata.selectNumberingPlan(country);
    if (metadata.leadingDigits()) {
      if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) {
        return country;
      }
    } else if (getNumberType({
      phone: nationalPhoneNumber,
      country
    }, void 0, metadata.metadata)) {
      return country;
    }
  }
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/helpers/getCountryByCallingCode.js
var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function getCountryByCallingCode(callingCode, _ref) {
  var nationalPhoneNumber = _ref.nationalNumber, metadata = _ref.metadata;
  if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
    if (metadata.isNonGeographicCallingCode(callingCode)) {
      return "001";
    }
  }
  var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
  if (!possibleCountries) {
    return;
  }
  if (possibleCountries.length === 1) {
    return possibleCountries[0];
  }
  return getCountryByNationalNumber(nationalPhoneNumber, {
    countries: possibleCountries,
    metadata: metadata.metadata
  });
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/helpers/extractNationalNumber.js
function extractNationalNumber(number, country, metadata) {
  var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(number, metadata), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
  if (nationalNumber !== number) {
    if (!shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) {
      return {
        nationalNumber: number
      };
    }
    if (metadata.numberingPlan.possibleLengths()) {
      if (!country) {
        country = getCountryByCallingCode(metadata.numberingPlan.callingCode(), {
          nationalNumber,
          metadata
        });
      }
      if (!isPossibleIncompleteNationalNumber(nationalNumber, country, metadata)) {
        return {
          nationalNumber: number
        };
      }
    }
  }
  return {
    nationalNumber,
    carrierCode
  };
}
function shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
  if (matchesEntirely(nationalNumberBefore, metadata.nationalNumberPattern()) && !matchesEntirely(nationalNumberAfter, metadata.nationalNumberPattern())) {
    return false;
  }
  return true;
}
function isPossibleIncompleteNationalNumber(nationalNumber, country, metadata) {
  switch (checkNumberLength(nationalNumber, country, metadata)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return false;
    default:
      return true;
  }
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/helpers/extractCountryCallingCodeFromInternationalNumberWithoutPlusSign.js
function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, defaultCountry, defaultCallingCode, metadata) {
  var countryCallingCode = country || defaultCountry ? getCountryCallingCode(country || defaultCountry, metadata) : defaultCallingCode;
  if (number.indexOf(countryCallingCode) === 0) {
    metadata = new Metadata(metadata);
    metadata.selectNumberingPlan(country || defaultCountry, countryCallingCode);
    var possibleShorterNumber = number.slice(countryCallingCode.length);
    var _extractNationalNumbe = extractNationalNumber(possibleShorterNumber, country, metadata), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
    var _extractNationalNumbe2 = extractNationalNumber(number, country, metadata), nationalNumber = _extractNationalNumbe2.nationalNumber;
    if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) && matchesEntirely(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || checkNumberLength(nationalNumber, country, metadata) === "TOO_LONG") {
      return {
        countryCallingCode,
        number: possibleShorterNumber
      };
    }
  }
  return {
    number
  };
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/helpers/extractCountryCallingCode.js
function extractCountryCallingCode(number, country, defaultCountry, defaultCallingCode, metadata) {
  if (!number) {
    return {};
  }
  var isNumberWithIddPrefix;
  if (number[0] !== "+") {
    var numberWithoutIDD = stripIddPrefix(number, country || defaultCountry, defaultCallingCode, metadata);
    if (numberWithoutIDD && numberWithoutIDD !== number) {
      isNumberWithIddPrefix = true;
      number = "+" + numberWithoutIDD;
    } else {
      if (country || defaultCountry || defaultCallingCode) {
        var _extractCountryCallin = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, defaultCountry, defaultCallingCode, metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
        if (countryCallingCode) {
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode,
            number: shorterNumber
          };
        }
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number
      };
    }
  }
  if (number[1] === "0") {
    return {};
  }
  metadata = new Metadata(metadata);
  var i = 2;
  while (i - 1 <= MAX_LENGTH_COUNTRY_CODE && i <= number.length) {
    var _countryCallingCode = number.slice(1, i);
    if (metadata.hasCallingCode(_countryCallingCode)) {
      metadata.selectNumberingPlan(_countryCallingCode);
      return {
        countryCallingCodeSource: isNumberWithIddPrefix ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: _countryCallingCode,
        number: number.slice(i)
      };
    }
    i++;
  }
  return {};
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/helpers/applyInternationalSeparatorStyle.js
function applyInternationalSeparatorStyle(formattedNumber) {
  return formattedNumber.replace(new RegExp("[".concat(VALID_PUNCTUATION, "]+"), "g"), " ").trim();
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/helpers/formatNationalNumberUsingFormat.js
var FIRST_GROUP_PATTERN = /(\$\d)/;
function formatNationalNumberUsingFormat(number, format, _ref) {
  var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix, carrierCode = _ref.carrierCode, metadata = _ref.metadata;
  var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()) : format.format()
  ));
  if (useInternationalFormat) {
    return applyInternationalSeparatorStyle(formattedNumber);
  }
  return formattedNumber;
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/helpers/getIddPrefix.js
var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function getIddPrefix(country, callingCode, metadata) {
  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);
  if (countryMetadata.defaultIDDPrefix()) {
    return countryMetadata.defaultIDDPrefix();
  }
  if (SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) {
    return countryMetadata.IDDPrefix();
  }
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/helpers/extension/createExtensionPattern.js
var RFC3966_EXTN_PREFIX = ";ext=";
var getExtensionDigitsPattern = function getExtensionDigitsPattern2(maxLength) {
  return "([".concat(VALID_DIGITS, "]{1,").concat(maxLength, "})");
};
function createExtensionPattern(purpose) {
  var extLimitAfterExplicitLabel = "20";
  var extLimitAfterLikelyLabel = "15";
  var extLimitAfterAmbiguousChar = "9";
  var extLimitWhenNotSure = "6";
  var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*";
  var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
  var optionalExtnSuffix = "#?";
  var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)";
  var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)";
  var ambiguousSeparator = "[- ]+";
  var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*";
  var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
  var rfcExtn = RFC3966_EXTN_PREFIX + getExtensionDigitsPattern(extLimitAfterExplicitLabel);
  var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
  var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  var americanStyleExtnWithSuffix = ambiguousSeparator + getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
  var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
  var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/helpers/isViablePhoneNumber.js
var MIN_LENGTH_PHONE_NUMBER_PATTERN = "[" + VALID_DIGITS + "]{" + MIN_LENGTH_FOR_NSN + "}";
var VALID_PHONE_NUMBER = "[" + PLUS_CHARS + "]{0,1}(?:[" + VALID_PUNCTUATION + "]*[" + VALID_DIGITS + "]){3,}[" + VALID_PUNCTUATION + VALID_DIGITS + "]*";
var VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + PLUS_CHARS + "]{0,1}(?:[" + VALID_PUNCTUATION + "]*[" + VALID_DIGITS + "]){1,2}$", "i");
var VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER + // Phone number extensions
"(?:" + createExtensionPattern() + ")?";
var VALID_PHONE_NUMBER_PATTERN = new RegExp(
  // Either a short two-digit-only phone number
  "^" + MIN_LENGTH_PHONE_NUMBER_PATTERN + "$|^" + VALID_PHONE_NUMBER_WITH_EXTENSION + "$",
  "i"
);
function isViablePhoneNumber(number) {
  return number.length >= MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(number);
}
function isViablePhoneNumberStart(number) {
  return VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/helpers/RFC3966.js
function formatRFC3966(_ref) {
  var number = _ref.number, ext = _ref.ext;
  if (!number) {
    return "";
  }
  if (number[0] !== "+") {
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  }
  return "tel:".concat(number).concat(ext ? ";ext=" + ext : "");
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/format.js
var DEFAULT_OPTIONS = {
  formatExtension: function formatExtension(formattedNumber, extension, metadata) {
    return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
  }
};
function formatNumber(input, format, options, metadata) {
  if (options) {
    options = merge({}, DEFAULT_OPTIONS, options);
  } else {
    options = DEFAULT_OPTIONS;
  }
  metadata = new Metadata(metadata);
  if (input.country && input.country !== "001") {
    if (!metadata.hasCountry(input.country)) {
      throw new Error("Unknown country: ".concat(input.country));
    }
    metadata.selectNumberingPlan(input.country);
  } else if (input.countryCallingCode) {
    metadata.selectNumberingPlan(input.countryCallingCode);
  } else return input.phone || "";
  var countryCallingCode = metadata.countryCallingCode();
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  var number;
  switch (format) {
    case "NATIONAL":
      if (!nationalNumber) {
        return "";
      }
      number = formatNationalNumber(nationalNumber, input.carrierCode, "NATIONAL", metadata, options);
      return addExtension(number, input.ext, metadata, options.formatExtension);
    case "INTERNATIONAL":
      if (!nationalNumber) {
        return "+".concat(countryCallingCode);
      }
      number = formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata, options);
      number = "+".concat(countryCallingCode, " ").concat(number);
      return addExtension(number, input.ext, metadata, options.formatExtension);
    case "E.164":
      return "+".concat(countryCallingCode).concat(nationalNumber);
    case "RFC3966":
      return formatRFC3966({
        number: "+".concat(countryCallingCode).concat(nationalNumber),
        ext: input.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?
    case "IDD":
      if (!options.fromCountry) {
        return;
      }
      var formattedNumber = formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
      return addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(format, '"'));
  }
}
function formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
  var format = chooseFormatForNumber(metadata.formats(), number);
  if (!format) {
    return number;
  }
  return formatNationalNumberUsingFormat(number, format, {
    useInternationalFormat: formatAs === "INTERNATIONAL",
    withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
    carrierCode,
    metadata
  });
}
function chooseFormatForNumber(availableFormats, nationalNumber) {
  return pickFirstMatchingElement(availableFormats, function(format) {
    if (format.leadingDigitsPatterns().length > 0) {
      var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1];
      if (nationalNumber.search(lastLeadingDigitsPattern) !== 0) {
        return false;
      }
    }
    return matchesEntirely(nationalNumber, format.pattern());
  });
}
function addExtension(formattedNumber, ext, metadata, formatExtension2) {
  return ext ? formatExtension2(formattedNumber, ext, metadata) : formattedNumber;
}
function formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
  var fromCountryCallingCode = getCountryCallingCode(fromCountry, metadata.metadata);
  if (fromCountryCallingCode === countryCallingCode) {
    var formattedNumber = formatNationalNumber(nationalNumber, carrierCode, "NATIONAL", metadata);
    if (countryCallingCode === "1") {
      return countryCallingCode + " " + formattedNumber;
    }
    return formattedNumber;
  }
  var iddPrefix = getIddPrefix(fromCountry, void 0, metadata.metadata);
  if (iddPrefix) {
    return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata));
  }
}
function merge() {
  var i = 1;
  for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
    objects[_key] = arguments[_key];
  }
  while (i < objects.length) {
    if (objects[i]) {
      for (var key in objects[i]) {
        objects[0][key] = objects[i][key];
      }
    }
    i++;
  }
  return objects[0];
}
function pickFirstMatchingElement(elements, testFunction) {
  var i = 0;
  while (i < elements.length) {
    if (testFunction(elements[i])) {
      return elements[i];
    }
    i++;
  }
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/PhoneNumber.js
function _typeof2(o) {
  "@babel/helpers - typeof";
  return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof2(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey2(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _classCallCheck2(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties2(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey2(o.key), o);
  }
}
function _createClass2(e, r, t) {
  return r && _defineProperties2(e.prototype, r), t && _defineProperties2(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey2(t) {
  var i = _toPrimitive2(t, "string");
  return "symbol" == _typeof2(i) ? i : i + "";
}
function _toPrimitive2(t, r) {
  if ("object" != _typeof2(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof2(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var USE_NON_GEOGRAPHIC_COUNTRY_CODE2 = false;
var PhoneNumber = /* @__PURE__ */ function() {
  function PhoneNumber2(countryOrCountryCallingCode, nationalNumber, metadata) {
    _classCallCheck2(this, PhoneNumber2);
    if (!countryOrCountryCallingCode) {
      throw new TypeError("First argument is required");
    }
    if (typeof countryOrCountryCallingCode !== "string") {
      throw new TypeError("First argument must be a string");
    }
    if (countryOrCountryCallingCode[0] === "+" && !nationalNumber) {
      throw new TypeError("`metadata` argument not passed");
    }
    if (isObject(nationalNumber) && isObject(nationalNumber.countries)) {
      metadata = nationalNumber;
      var e164Number = countryOrCountryCallingCode;
      if (!E164_NUMBER_REGEXP.test(e164Number)) {
        throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
      }
      var _extractCountryCallin = extractCountryCallingCode(e164Number, void 0, void 0, void 0, metadata), _countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number;
      nationalNumber = number;
      countryOrCountryCallingCode = _countryCallingCode;
      if (!nationalNumber) {
        throw new Error("Invalid `number` argument passed: too short");
      }
    }
    if (!nationalNumber) {
      throw new TypeError("`nationalNumber` argument is required");
    }
    if (typeof nationalNumber !== "string") {
      throw new TypeError("`nationalNumber` argument must be a string");
    }
    validateMetadata(metadata);
    var _getCountryAndCountry = getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata), country = _getCountryAndCountry.country, countryCallingCode = _getCountryAndCountry.countryCallingCode;
    this.country = country;
    this.countryCallingCode = countryCallingCode;
    this.nationalNumber = nationalNumber;
    this.number = "+" + this.countryCallingCode + this.nationalNumber;
    this.getMetadata = function() {
      return metadata;
    };
  }
  return _createClass2(PhoneNumber2, [{
    key: "setExt",
    value: function setExt(ext) {
      this.ext = ext;
    }
  }, {
    key: "getPossibleCountries",
    value: function getPossibleCountries() {
      if (this.country) {
        return [this.country];
      }
      return getPossibleCountriesForNumber(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function isPossible() {
      return isPossiblePhoneNumber(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return isValidNumber(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function isNonGeographic() {
      var metadata = new Metadata(this.getMetadata());
      return metadata.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function isEqual(phoneNumber) {
      return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function getType2() {
      return getNumberType(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function format(_format, options) {
      return formatNumber(this, _format, options ? _objectSpread(_objectSpread({}, options), {}, {
        v2: true
      }) : {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function formatNational(options) {
      return this.format("NATIONAL", options);
    }
  }, {
    key: "formatInternational",
    value: function formatInternational(options) {
      return this.format("INTERNATIONAL", options);
    }
  }, {
    key: "getURI",
    value: function getURI(options) {
      return this.format("RFC3966", options);
    }
  }]);
}();
var isCountryCode = function isCountryCode2(value) {
  return /^[A-Z]{2}$/.test(value);
};
function getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
  var country;
  var countryCallingCode;
  var metadata = new Metadata(metadataJson);
  if (isCountryCode(countryOrCountryCallingCode)) {
    country = countryOrCountryCallingCode;
    metadata.selectNumberingPlan(country);
    countryCallingCode = metadata.countryCallingCode();
  } else {
    countryCallingCode = countryOrCountryCallingCode;
    if (USE_NON_GEOGRAPHIC_COUNTRY_CODE2) {
      if (metadata.isNonGeographicCallingCode(countryCallingCode)) {
        country = "001";
      }
    }
  }
  return {
    country,
    countryCallingCode
  };
}
var E164_NUMBER_REGEXP = /^\+\d+$/;

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/ParseError.js
function _typeof3(o) {
  "@babel/helpers - typeof";
  return _typeof3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof3(o);
}
function _defineProperties3(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey3(o.key), o);
  }
}
function _createClass3(e, r, t) {
  return r && _defineProperties3(e.prototype, r), t && _defineProperties3(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey3(t) {
  var i = _toPrimitive3(t, "string");
  return "symbol" == _typeof3(i) ? i : i + "";
}
function _toPrimitive3(t, r) {
  if ("object" != _typeof3(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof3(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _classCallCheck3(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof3(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf(t, e);
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? /* @__PURE__ */ new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper2(t2) {
    if (null === t2 || !_isNativeFunction(t2)) return t2;
    if ("function" != typeof t2) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t2)) return r.get(t2);
      r.set(t2, Wrapper);
    }
    function Wrapper() {
      return _construct(t2, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t2.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }), _setPrototypeOf(Wrapper, t2);
  }, _wrapNativeSuper(t);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct2() {
    return !!t;
  })();
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf(t, e);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t2) {
    return t2.__proto__ || Object.getPrototypeOf(t2);
  }, _getPrototypeOf(t);
}
var ParseError = /* @__PURE__ */ function(_Error) {
  function ParseError2(code) {
    var _this;
    _classCallCheck3(this, ParseError2);
    _this = _callSuper(this, ParseError2, [code]);
    Object.setPrototypeOf(_this, ParseError2.prototype);
    _this.name = _this.constructor.name;
    return _this;
  }
  _inherits(ParseError2, _Error);
  return _createClass3(ParseError2);
}(/* @__PURE__ */ _wrapNativeSuper(Error));

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/helpers/extension/extractExtension.js
var EXTN_PATTERN = new RegExp("(?:" + createExtensionPattern() + ")$", "i");
function extractExtension(number) {
  var start = number.search(EXTN_PATTERN);
  if (start < 0) {
    return {};
  }
  var numberWithoutExtension = number.slice(0, start);
  var matches = number.match(EXTN_PATTERN);
  var i = 1;
  while (i < matches.length) {
    if (matches[i]) {
      return {
        number: numberWithoutExtension,
        ext: matches[i]
      };
    }
    i++;
  }
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/helpers/parseDigits.js
var DIGITS = {
  "0": "0",
  "1": "1",
  "2": "2",
  "3": "3",
  "4": "4",
  "5": "5",
  "6": "6",
  "7": "7",
  "8": "8",
  "9": "9",
  "\uFF10": "0",
  // Fullwidth digit 0
  "\uFF11": "1",
  // Fullwidth digit 1
  "\uFF12": "2",
  // Fullwidth digit 2
  "\uFF13": "3",
  // Fullwidth digit 3
  "\uFF14": "4",
  // Fullwidth digit 4
  "\uFF15": "5",
  // Fullwidth digit 5
  "\uFF16": "6",
  // Fullwidth digit 6
  "\uFF17": "7",
  // Fullwidth digit 7
  "\uFF18": "8",
  // Fullwidth digit 8
  "\uFF19": "9",
  // Fullwidth digit 9
  "\u0660": "0",
  // Arabic-indic digit 0
  "\u0661": "1",
  // Arabic-indic digit 1
  "\u0662": "2",
  // Arabic-indic digit 2
  "\u0663": "3",
  // Arabic-indic digit 3
  "\u0664": "4",
  // Arabic-indic digit 4
  "\u0665": "5",
  // Arabic-indic digit 5
  "\u0666": "6",
  // Arabic-indic digit 6
  "\u0667": "7",
  // Arabic-indic digit 7
  "\u0668": "8",
  // Arabic-indic digit 8
  "\u0669": "9",
  // Arabic-indic digit 9
  "\u06F0": "0",
  // Eastern-Arabic digit 0
  "\u06F1": "1",
  // Eastern-Arabic digit 1
  "\u06F2": "2",
  // Eastern-Arabic digit 2
  "\u06F3": "3",
  // Eastern-Arabic digit 3
  "\u06F4": "4",
  // Eastern-Arabic digit 4
  "\u06F5": "5",
  // Eastern-Arabic digit 5
  "\u06F6": "6",
  // Eastern-Arabic digit 6
  "\u06F7": "7",
  // Eastern-Arabic digit 7
  "\u06F8": "8",
  // Eastern-Arabic digit 8
  "\u06F9": "9"
  // Eastern-Arabic digit 9
};
function parseDigit(character) {
  return DIGITS[character];
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/parseIncompletePhoneNumber.js
function _createForOfIteratorHelperLoose4(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (t) return (t = t.call(r)).next.bind(t);
  if (Array.isArray(r) || (t = _unsupportedIterableToArray4(r)) || e && r && "number" == typeof r.length) {
    t && (r = t);
    var o = 0;
    return function() {
      return o >= r.length ? { done: true } : { done: false, value: r[o++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray4(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray4(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray4(r, a) : void 0;
  }
}
function _arrayLikeToArray4(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function parseIncompletePhoneNumber(string) {
  var result2 = "";
  for (var _iterator = _createForOfIteratorHelperLoose4(string.split("")), _step; !(_step = _iterator()).done; ) {
    var character = _step.value;
    result2 += parsePhoneNumberCharacter(character, result2) || "";
  }
  return result2;
}
function parsePhoneNumberCharacter(character, prevParsedCharacters, eventListener) {
  if (character === "+") {
    if (prevParsedCharacters) {
      if (typeof eventListener === "function") {
        eventListener("end");
      }
      return;
    }
    return "+";
  }
  return parseDigit(character);
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/helpers/extractPhoneContext.js
var PLUS_SIGN = "+";
var RFC3966_VISUAL_SEPARATOR_ = "[\\-\\.\\(\\)]?";
var RFC3966_PHONE_DIGIT_ = "([" + VALID_DIGITS + "]|" + RFC3966_VISUAL_SEPARATOR_ + ")";
var RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + PLUS_SIGN + RFC3966_PHONE_DIGIT_ + "*[" + VALID_DIGITS + "]" + RFC3966_PHONE_DIGIT_ + "*$";
var RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp(RFC3966_GLOBAL_NUMBER_DIGITS_, "g");
var ALPHANUM_ = VALID_DIGITS;
var RFC3966_DOMAINLABEL_ = "[" + ALPHANUM_ + "]+((\\-)*[" + ALPHANUM_ + "])*";
var VALID_ALPHA_ = "a-zA-Z";
var RFC3966_TOPLABEL_ = "[" + VALID_ALPHA_ + "]+((\\-)*[" + ALPHANUM_ + "])*";
var RFC3966_DOMAINNAME_ = "^(" + RFC3966_DOMAINLABEL_ + "\\.)*" + RFC3966_TOPLABEL_ + "\\.?$";
var RFC3966_DOMAINNAME_PATTERN_ = new RegExp(RFC3966_DOMAINNAME_, "g");
var RFC3966_PREFIX_ = "tel:";
var RFC3966_PHONE_CONTEXT_ = ";phone-context=";
var RFC3966_ISDN_SUBADDRESS_ = ";isub=";
function extractPhoneContext(numberToExtractFrom) {
  var indexOfPhoneContext = numberToExtractFrom.indexOf(RFC3966_PHONE_CONTEXT_);
  if (indexOfPhoneContext < 0) {
    return null;
  }
  var phoneContextStart = indexOfPhoneContext + RFC3966_PHONE_CONTEXT_.length;
  if (phoneContextStart >= numberToExtractFrom.length) {
    return "";
  }
  var phoneContextEnd = numberToExtractFrom.indexOf(";", phoneContextStart);
  if (phoneContextEnd >= 0) {
    return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
  } else {
    return numberToExtractFrom.substring(phoneContextStart);
  }
}
function isPhoneContextValid(phoneContext) {
  if (phoneContext === null) {
    return true;
  }
  if (phoneContext.length === 0) {
    return false;
  }
  return RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/helpers/extractFormattedPhoneNumberFromPossibleRfc3966NumberUri.js
function extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(numberToParse, _ref) {
  var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
  var phoneContext = extractPhoneContext(numberToParse);
  if (!isPhoneContextValid(phoneContext)) {
    throw new ParseError("NOT_A_NUMBER");
  }
  var phoneNumberString;
  if (phoneContext === null) {
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || "";
  } else {
    phoneNumberString = "";
    if (phoneContext.charAt(0) === PLUS_SIGN) {
      phoneNumberString += phoneContext;
    }
    var indexOfRfc3966Prefix = numberToParse.indexOf(RFC3966_PREFIX_);
    var indexOfNationalNumber;
    if (indexOfRfc3966Prefix >= 0) {
      indexOfNationalNumber = indexOfRfc3966Prefix + RFC3966_PREFIX_.length;
    } else {
      indexOfNationalNumber = 0;
    }
    var indexOfPhoneContext = numberToParse.indexOf(RFC3966_PHONE_CONTEXT_);
    phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
  }
  var indexOfIsdn = phoneNumberString.indexOf(RFC3966_ISDN_SUBADDRESS_);
  if (indexOfIsdn > 0) {
    phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
  }
  if (phoneNumberString !== "") {
    return phoneNumberString;
  }
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/parse.js
var MAX_INPUT_STRING_LENGTH = 250;
var PHONE_NUMBER_START_PATTERN = new RegExp("[" + PLUS_CHARS + VALID_DIGITS + "]");
var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp("[^" + VALID_DIGITS + "#]+$");
var USE_NON_GEOGRAPHIC_COUNTRY_CODE3 = false;
function parse(text, options, metadata) {
  options = options || {};
  metadata = new Metadata(metadata);
  if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
    if (options.v2) {
      throw new ParseError("INVALID_COUNTRY");
    }
    throw new Error("Unknown country: ".concat(options.defaultCountry));
  }
  var _parseInput = parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error;
  if (!formattedPhoneNumber) {
    if (options.v2) {
      if (error === "TOO_SHORT") {
        throw new ParseError("TOO_SHORT");
      }
      throw new ParseError("NOT_A_NUMBER");
    }
    return {};
  }
  var _parsePhoneNumber = parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource, carrierCode = _parsePhoneNumber.carrierCode;
  if (!metadata.hasSelectedNumberingPlan()) {
    if (options.v2) {
      throw new ParseError("INVALID_COUNTRY");
    }
    return {};
  }
  if (!nationalNumber || nationalNumber.length < MIN_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError("TOO_SHORT");
    }
    return {};
  }
  if (nationalNumber.length > MAX_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError("TOO_LONG");
    }
    return {};
  }
  if (options.v2) {
    var phoneNumber = new PhoneNumber(countryCallingCode, nationalNumber, metadata.metadata);
    if (country) {
      phoneNumber.country = country;
    }
    if (carrierCode) {
      phoneNumber.carrierCode = carrierCode;
    }
    if (ext) {
      phoneNumber.ext = ext;
    }
    phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
    return phoneNumber;
  }
  var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) : false;
  if (!options.extended) {
    return valid ? result(country, nationalNumber, ext) : {};
  }
  return {
    country,
    countryCallingCode,
    carrierCode,
    valid,
    possible: valid ? true : options.extended === true && metadata.possibleLengths() && isPossibleNumber(nationalNumber, country, metadata) ? true : false,
    phone: nationalNumber,
    ext
  };
}
function _extractFormattedPhoneNumber(text, extract, throwOnError) {
  if (!text) {
    return;
  }
  if (text.length > MAX_INPUT_STRING_LENGTH) {
    if (throwOnError) {
      throw new ParseError("TOO_LONG");
    }
    return;
  }
  if (extract === false) {
    return text;
  }
  var startsAt = text.search(PHONE_NUMBER_START_PATTERN);
  if (startsAt < 0) {
    return;
  }
  return text.slice(startsAt).replace(AFTER_PHONE_NUMBER_END_PATTERN, "");
}
function parseInput(text, v2, extract) {
  var number = extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(text, {
    extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text2) {
      return _extractFormattedPhoneNumber(text2, extract, v2);
    }
  });
  if (!number) {
    return {};
  }
  if (!isViablePhoneNumber(number)) {
    if (isViablePhoneNumberStart(number)) {
      return {
        error: "TOO_SHORT"
      };
    }
    return {};
  }
  var withExtensionStripped = extractExtension(number);
  if (withExtensionStripped.ext) {
    return withExtensionStripped;
  }
  return {
    number
  };
}
function result(country, nationalNumber, ext) {
  var result2 = {
    country,
    phone: nationalNumber
  };
  if (ext) {
    result2.ext = ext;
  }
  return result2;
}
function parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
  var _extractCountryCallin = extractCountryCallingCode(parseIncompletePhoneNumber(formattedPhoneNumber), void 0, defaultCountry, defaultCallingCode, metadata.metadata), countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource, countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number;
  var country;
  if (countryCallingCode) {
    metadata.selectNumberingPlan(countryCallingCode);
  } else if (number && (defaultCountry || defaultCallingCode)) {
    metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);
    if (defaultCountry) {
      country = defaultCountry;
    } else {
      if (USE_NON_GEOGRAPHIC_COUNTRY_CODE3) {
        if (metadata.isNonGeographicCallingCode(defaultCallingCode)) {
          country = "001";
        }
      }
    }
    countryCallingCode = defaultCallingCode || getCountryCallingCode(defaultCountry, metadata.metadata);
  } else return {};
  if (!number) {
    return {
      countryCallingCodeSource,
      countryCallingCode
    };
  }
  var _extractNationalNumbe = extractNationalNumber(parseIncompletePhoneNumber(number), country, metadata), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode;
  var exactCountry = getCountryByCallingCode(countryCallingCode, {
    nationalNumber,
    metadata
  });
  if (exactCountry) {
    country = exactCountry;
    if (exactCountry === "001") {
    } else {
      metadata.selectNumberingPlan(country);
    }
  }
  return {
    country,
    countryCallingCode,
    countryCallingCodeSource,
    nationalNumber,
    carrierCode
  };
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/parsePhoneNumberWithError_.js
function _typeof4(o) {
  "@babel/helpers - typeof";
  return _typeof4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof4(o);
}
function ownKeys2(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys2(Object(t), true).forEach(function(r2) {
      _defineProperty2(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys2(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty2(e, r, t) {
  return (r = _toPropertyKey4(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey4(t) {
  var i = _toPrimitive4(t, "string");
  return "symbol" == _typeof4(i) ? i : i + "";
}
function _toPrimitive4(t, r) {
  if ("object" != _typeof4(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof4(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function parsePhoneNumberWithError(text, options, metadata) {
  return parse(text, _objectSpread2(_objectSpread2({}, options), {}, {
    v2: true
  }), metadata);
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/normalizeArguments.js
function _typeof5(o) {
  "@babel/helpers - typeof";
  return _typeof5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof5(o);
}
function ownKeys3(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread3(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys3(Object(t), true).forEach(function(r2) {
      _defineProperty3(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys3(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty3(e, r, t) {
  return (r = _toPropertyKey5(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey5(t) {
  var i = _toPrimitive5(t, "string");
  return "symbol" == _typeof5(i) ? i : i + "";
}
function _toPrimitive5(t, r) {
  if ("object" != _typeof5(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof5(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray5(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray5(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray5(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray5(r, a) : void 0;
  }
}
function _arrayLikeToArray5(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = false;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true) ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function normalizeArguments(args) {
  var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = _slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
  var text;
  var options;
  var metadata;
  if (typeof arg_1 === "string") {
    text = arg_1;
  } else throw new TypeError("A text for parsing must be a string.");
  if (!arg_2 || typeof arg_2 === "string") {
    if (arg_4) {
      options = arg_3;
      metadata = arg_4;
    } else {
      options = void 0;
      metadata = arg_3;
    }
    if (arg_2) {
      options = _objectSpread3({
        defaultCountry: arg_2
      }, options);
    }
  } else if (isObject(arg_2)) {
    if (arg_3) {
      options = arg_2;
      metadata = arg_3;
    } else {
      metadata = arg_2;
    }
  } else throw new Error("Invalid second argument: ".concat(arg_2));
  return {
    text,
    options,
    metadata
  };
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/parsePhoneNumber_.js
function _typeof6(o) {
  "@babel/helpers - typeof";
  return _typeof6 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof6(o);
}
function ownKeys4(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread4(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys4(Object(t), true).forEach(function(r2) {
      _defineProperty4(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys4(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty4(e, r, t) {
  return (r = _toPropertyKey6(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey6(t) {
  var i = _toPrimitive6(t, "string");
  return "symbol" == _typeof6(i) ? i : i + "";
}
function _toPrimitive6(t, r) {
  if ("object" != _typeof6(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof6(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function parsePhoneNumber2(text, options, metadata) {
  if (options && options.defaultCountry && !isSupportedCountry2(options.defaultCountry, metadata)) {
    options = _objectSpread4(_objectSpread4({}, options), {}, {
      defaultCountry: void 0
    });
  }
  try {
    return parsePhoneNumberWithError(text, options, metadata);
  } catch (error) {
    if (error instanceof ParseError) {
    } else {
      throw error;
    }
  }
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/parsePhoneNumber.js
function parsePhoneNumber3() {
  var _normalizeArguments = normalizeArguments(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
  return parsePhoneNumber2(text, options, metadata);
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/es6/getCountries.js
function getCountries(metadata) {
  return new Metadata(metadata).getCountries();
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/min/exports/parsePhoneNumber.js
function parsePhoneNumber4() {
  return withMetadataArgument(parsePhoneNumber3, arguments);
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/min/exports/getCountries.js
function getCountries2() {
  return withMetadataArgument(getCountries, arguments);
}

// ../../node_modules/.pnpm/libphonenumber-js@1.12.24/node_modules/libphonenumber-js/min/exports/getCountryCallingCode.js
function getCountryCallingCode2() {
  return withMetadataArgument(getCountryCallingCode, arguments);
}

// src/shared/phone.ts
function parsePhoneNumberValue(value, country) {
  if (typeof value !== "string" || !value.trim()) return void 0;
  const input = value.trim();
  if (!country && !input.startsWith("+")) return void 0;
  try {
    return parsePhoneNumber4(input, { defaultCountry: country, extract: false });
  } catch {
    return void 0;
  }
}
function normalizePhoneNumber(value, country) {
  const parsed = parsePhoneNumberValue(value, country);
  return parsed?.isValid() && !parsed.ext ? parsed.number : null;
}
function getPhoneCountryOptions(locale = "en") {
  let names;
  try {
    names = new Intl.DisplayNames([locale], { type: "region" });
  } catch {
  }
  return getCountries2().map((value) => ({
    value,
    label: names?.of(value) ?? value,
    dialCode: `+${getCountryCallingCode2(value)}`
  }));
}

// src/shared/subscription.ts
var SUBSCRIPTION_SYNC_GRACE_PERIOD_HOURS = 48;
var PLAN_IDS = {
  ESSENTIAL: "essential_monthly",
  GROWTH: "growth_monthly"
};

// src/shared/tax-residence.ts
var TAX_RESIDENCE_COUNTRIES = [
  { code: "AF", name: "Afghanistan" },
  { code: "AX", name: "\xC5land Islands" },
  { code: "AL", name: "Albania" },
  { code: "DZ", name: "Algeria" },
  { code: "AS", name: "American Samoa" },
  { code: "AD", name: "Andorra" },
  { code: "AO", name: "Angola" },
  { code: "AI", name: "Anguilla" },
  { code: "AQ", name: "Antarctica" },
  { code: "AG", name: "Antigua & Barbuda" },
  { code: "AR", name: "Argentina" },
  { code: "AM", name: "Armenia" },
  { code: "AW", name: "Aruba" },
  { code: "AU", name: "Australia" },
  { code: "AT", name: "Austria" },
  { code: "AZ", name: "Azerbaijan" },
  { code: "BS", name: "Bahamas" },
  { code: "BH", name: "Bahrain" },
  { code: "BD", name: "Bangladesh" },
  { code: "BB", name: "Barbados" },
  { code: "BY", name: "Belarus" },
  { code: "BE", name: "Belgium" },
  { code: "BZ", name: "Belize" },
  { code: "BJ", name: "Benin" },
  { code: "BM", name: "Bermuda" },
  { code: "BT", name: "Bhutan" },
  { code: "BO", name: "Bolivia" },
  { code: "BA", name: "Bosnia & Herzegovina" },
  { code: "BW", name: "Botswana" },
  { code: "BV", name: "Bouvet Island" },
  { code: "BR", name: "Brazil" },
  { code: "IO", name: "British Indian Ocean Territory" },
  { code: "VG", name: "British Virgin Islands" },
  { code: "BN", name: "Brunei" },
  { code: "BG", name: "Bulgaria" },
  { code: "BF", name: "Burkina Faso" },
  { code: "BI", name: "Burundi" },
  { code: "KH", name: "Cambodia" },
  { code: "CM", name: "Cameroon" },
  { code: "CA", name: "Canada" },
  { code: "CV", name: "Cape Verde" },
  { code: "BQ", name: "Caribbean Netherlands" },
  { code: "KY", name: "Cayman Islands" },
  { code: "CF", name: "Central African Republic" },
  { code: "TD", name: "Chad" },
  { code: "CL", name: "Chile" },
  { code: "CN", name: "China" },
  { code: "CX", name: "Christmas Island" },
  { code: "CC", name: "Cocos (Keeling) Islands" },
  { code: "CO", name: "Colombia" },
  { code: "KM", name: "Comoros" },
  { code: "CG", name: "Congo - Brazzaville" },
  { code: "CD", name: "Congo - Kinshasa" },
  { code: "CK", name: "Cook Islands" },
  { code: "CR", name: "Costa Rica" },
  { code: "CI", name: "C\xF4te d\u2019Ivoire" },
  { code: "HR", name: "Croatia" },
  { code: "CU", name: "Cuba" },
  { code: "CW", name: "Cura\xE7ao" },
  { code: "CY", name: "Cyprus" },
  { code: "CZ", name: "Czechia" },
  { code: "DK", name: "Denmark" },
  { code: "DJ", name: "Djibouti" },
  { code: "DM", name: "Dominica" },
  { code: "DO", name: "Dominican Republic" },
  { code: "EC", name: "Ecuador" },
  { code: "EG", name: "Egypt" },
  { code: "SV", name: "El Salvador" },
  { code: "GQ", name: "Equatorial Guinea" },
  { code: "ER", name: "Eritrea" },
  { code: "EE", name: "Estonia" },
  { code: "SZ", name: "Eswatini" },
  { code: "ET", name: "Ethiopia" },
  { code: "FK", name: "Falkland Islands" },
  { code: "FO", name: "Faroe Islands" },
  { code: "FJ", name: "Fiji" },
  { code: "FI", name: "Finland" },
  { code: "FR", name: "France" },
  { code: "GF", name: "French Guiana" },
  { code: "PF", name: "French Polynesia" },
  { code: "TF", name: "French Southern Territories" },
  { code: "GA", name: "Gabon" },
  { code: "GM", name: "Gambia" },
  { code: "GE", name: "Georgia" },
  { code: "DE", name: "Germany" },
  { code: "GH", name: "Ghana" },
  { code: "GI", name: "Gibraltar" },
  { code: "GR", name: "Greece" },
  { code: "GL", name: "Greenland" },
  { code: "GD", name: "Grenada" },
  { code: "GP", name: "Guadeloupe" },
  { code: "GU", name: "Guam" },
  { code: "GT", name: "Guatemala" },
  { code: "GG", name: "Guernsey" },
  { code: "GN", name: "Guinea" },
  { code: "GW", name: "Guinea-Bissau" },
  { code: "GY", name: "Guyana" },
  { code: "HT", name: "Haiti" },
  { code: "HM", name: "Heard & McDonald Islands" },
  { code: "HN", name: "Honduras" },
  { code: "HK", name: "Hong Kong SAR China" },
  { code: "HU", name: "Hungary" },
  { code: "IS", name: "Iceland" },
  { code: "IN", name: "India" },
  { code: "ID", name: "Indonesia" },
  { code: "IR", name: "Iran" },
  { code: "IQ", name: "Iraq" },
  { code: "IE", name: "Ireland" },
  { code: "IM", name: "Isle of Man" },
  { code: "IL", name: "Israel" },
  { code: "IT", name: "Italy" },
  { code: "JM", name: "Jamaica" },
  { code: "JP", name: "Japan" },
  { code: "JE", name: "Jersey" },
  { code: "JO", name: "Jordan" },
  { code: "KZ", name: "Kazakhstan" },
  { code: "KE", name: "Kenya" },
  { code: "KI", name: "Kiribati" },
  { code: "KW", name: "Kuwait" },
  { code: "KG", name: "Kyrgyzstan" },
  { code: "LA", name: "Laos" },
  { code: "LV", name: "Latvia" },
  { code: "LB", name: "Lebanon" },
  { code: "LS", name: "Lesotho" },
  { code: "LR", name: "Liberia" },
  { code: "LY", name: "Libya" },
  { code: "LI", name: "Liechtenstein" },
  { code: "LT", name: "Lithuania" },
  { code: "LU", name: "Luxembourg" },
  { code: "MO", name: "Macao SAR China" },
  { code: "MG", name: "Madagascar" },
  { code: "MW", name: "Malawi" },
  { code: "MY", name: "Malaysia" },
  { code: "MV", name: "Maldives" },
  { code: "ML", name: "Mali" },
  { code: "MT", name: "Malta" },
  { code: "MH", name: "Marshall Islands" },
  { code: "MQ", name: "Martinique" },
  { code: "MR", name: "Mauritania" },
  { code: "MU", name: "Mauritius" },
  { code: "YT", name: "Mayotte" },
  { code: "MX", name: "Mexico" },
  { code: "FM", name: "Micronesia" },
  { code: "MD", name: "Moldova" },
  { code: "MC", name: "Monaco" },
  { code: "MN", name: "Mongolia" },
  { code: "ME", name: "Montenegro" },
  { code: "MS", name: "Montserrat" },
  { code: "MA", name: "Morocco" },
  { code: "MZ", name: "Mozambique" },
  { code: "MM", name: "Myanmar (Burma)" },
  { code: "NA", name: "Namibia" },
  { code: "NR", name: "Nauru" },
  { code: "NP", name: "Nepal" },
  { code: "NL", name: "Netherlands" },
  { code: "NC", name: "New Caledonia" },
  { code: "NZ", name: "New Zealand" },
  { code: "NI", name: "Nicaragua" },
  { code: "NE", name: "Niger" },
  { code: "NG", name: "Nigeria" },
  { code: "NU", name: "Niue" },
  { code: "NF", name: "Norfolk Island" },
  { code: "KP", name: "North Korea" },
  { code: "MK", name: "North Macedonia" },
  { code: "MP", name: "Northern Mariana Islands" },
  { code: "NO", name: "Norway" },
  { code: "OM", name: "Oman" },
  { code: "PK", name: "Pakistan" },
  { code: "PW", name: "Palau" },
  { code: "PS", name: "Palestinian Territories" },
  { code: "PA", name: "Panama" },
  { code: "PG", name: "Papua New Guinea" },
  { code: "PY", name: "Paraguay" },
  { code: "PE", name: "Peru" },
  { code: "PH", name: "Philippines" },
  { code: "PN", name: "Pitcairn Islands" },
  { code: "PL", name: "Poland" },
  { code: "PT", name: "Portugal" },
  { code: "PR", name: "Puerto Rico" },
  { code: "QA", name: "Qatar" },
  { code: "RE", name: "R\xE9union" },
  { code: "RO", name: "Romania" },
  { code: "RU", name: "Russia" },
  { code: "RW", name: "Rwanda" },
  { code: "WS", name: "Samoa" },
  { code: "SM", name: "San Marino" },
  { code: "ST", name: "S\xE3o Tom\xE9 & Pr\xEDncipe" },
  { code: "SA", name: "Saudi Arabia" },
  { code: "SN", name: "Senegal" },
  { code: "RS", name: "Serbia" },
  { code: "SC", name: "Seychelles" },
  { code: "SL", name: "Sierra Leone" },
  { code: "SG", name: "Singapore" },
  { code: "SX", name: "Sint Maarten" },
  { code: "SK", name: "Slovakia" },
  { code: "SI", name: "Slovenia" },
  { code: "SB", name: "Solomon Islands" },
  { code: "SO", name: "Somalia" },
  { code: "ZA", name: "South Africa" },
  { code: "GS", name: "South Georgia & South Sandwich Islands" },
  { code: "KR", name: "South Korea" },
  { code: "SS", name: "South Sudan" },
  { code: "ES", name: "Spain" },
  { code: "LK", name: "Sri Lanka" },
  { code: "BL", name: "St. Barth\xE9lemy" },
  { code: "SH", name: "St. Helena" },
  { code: "KN", name: "St. Kitts & Nevis" },
  { code: "LC", name: "St. Lucia" },
  { code: "MF", name: "St. Martin" },
  { code: "PM", name: "St. Pierre & Miquelon" },
  { code: "VC", name: "St. Vincent & Grenadines" },
  { code: "SD", name: "Sudan" },
  { code: "SR", name: "Suriname" },
  { code: "SJ", name: "Svalbard & Jan Mayen" },
  { code: "SE", name: "Sweden" },
  { code: "CH", name: "Switzerland" },
  { code: "SY", name: "Syria" },
  { code: "TW", name: "Taiwan" },
  { code: "TJ", name: "Tajikistan" },
  { code: "TZ", name: "Tanzania" },
  { code: "TH", name: "Thailand" },
  { code: "TL", name: "Timor-Leste" },
  { code: "TG", name: "Togo" },
  { code: "TK", name: "Tokelau" },
  { code: "TO", name: "Tonga" },
  { code: "TT", name: "Trinidad & Tobago" },
  { code: "TN", name: "Tunisia" },
  { code: "TR", name: "T\xFCrkiye" },
  { code: "TM", name: "Turkmenistan" },
  { code: "TC", name: "Turks & Caicos Islands" },
  { code: "TV", name: "Tuvalu" },
  { code: "UM", name: "U.S. Outlying Islands" },
  { code: "VI", name: "U.S. Virgin Islands" },
  { code: "UG", name: "Uganda" },
  { code: "UA", name: "Ukraine" },
  { code: "AE", name: "United Arab Emirates" },
  { code: "GB", name: "United Kingdom" },
  { code: "US", name: "United States" },
  { code: "UY", name: "Uruguay" },
  { code: "UZ", name: "Uzbekistan" },
  { code: "VU", name: "Vanuatu" },
  { code: "VA", name: "Vatican City" },
  { code: "VE", name: "Venezuela" },
  { code: "VN", name: "Vietnam" },
  { code: "WF", name: "Wallis & Futuna" },
  { code: "EH", name: "Western Sahara" },
  { code: "YE", name: "Yemen" },
  { code: "ZM", name: "Zambia" },
  { code: "ZW", name: "Zimbabwe" }
];
var TAX_RESIDENCE_COUNTRY_CODES = TAX_RESIDENCE_COUNTRIES.map((country) => country.code);
var TAX_RESIDENCE_COUNTRY_CODE_SET = new Set(
  TAX_RESIDENCE_COUNTRY_CODES
);
function isTaxResidenceCountry(code) {
  if (!code) return false;
  return TAX_RESIDENCE_COUNTRY_CODE_SET.has(code);
}

// src/api/companion.ts
var CompanionActionKind = {
  RIGHTS_EXPIRING: "rights_expiring",
  PAYOUT_PENDING: "payout_pending",
  GIFT_STOCK: "gift_stock",
  GIFT_EXPIRED_REOFFER: "gift_expired_reoffer",
  GIFT_UNCLAIMED: "gift_unclaimed",
  BRIEF_APPLICATION: "brief_application",
  MENTION_NOTABLE: "mention_notable",
  AFFILIATE_SILENT: "affiliate_silent",
  BRANDMATCH_BATCH: "brandmatch_batch"
};
var COMPANION_KIND_RANK = [
  CompanionActionKind.RIGHTS_EXPIRING,
  CompanionActionKind.PAYOUT_PENDING,
  CompanionActionKind.GIFT_STOCK,
  CompanionActionKind.GIFT_EXPIRED_REOFFER,
  CompanionActionKind.GIFT_UNCLAIMED,
  CompanionActionKind.BRIEF_APPLICATION,
  CompanionActionKind.MENTION_NOTABLE,
  CompanionActionKind.AFFILIATE_SILENT,
  CompanionActionKind.BRANDMATCH_BATCH
];
var CompanionActionStatus = {
  QUEUED: "queued",
  PROPOSED: "proposed",
  OPENED: "opened",
  SNOOZED: "snoozed",
  DONE: "done",
  DISMISSED: "dismissed",
  EXPIRED: "expired"
};
var CompanionResumeStatus = {
  PROPOSED: CompanionActionStatus.PROPOSED,
  OPENED: CompanionActionStatus.OPENED
};
var COMPANION_NON_TERMINAL_STATUSES = [
  CompanionActionStatus.QUEUED,
  CompanionActionStatus.PROPOSED,
  CompanionActionStatus.OPENED,
  CompanionActionStatus.SNOOZED
];
var CompanionActionVisibility = {
  WAITING: "waiting",
  VISIBLE: "visible",
  HIDDEN: "hidden"
};
var CompanionDoneSource = {
  EVENT: "event",
  RECONCILED: "reconciled",
  USER: "user"
};
var CompanionOutcome = {
  TASK_EXECUTED: "task_executed",
  CONDITION_RESOLVED: "condition_resolved",
  USER_REPORTED: "user_reported"
};
var CompanionDismissReason = {
  IRRELEVANT: "irrelevant",
  DONE: "done",
  LATER: "later"
};
var CompanionRunStatus = {
  SCHEDULED: "scheduled",
  RUNNING: "running",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
  MISSED: "missed"
};
var CompanionEventType = {
  PROPOSED: "proposed",
  SEEN: "seen",
  OPENED: "opened",
  DISMISSED: "dismissed",
  SNOOZED: "snoozed",
  RESUMED: "resumed",
  /** The card kept its place and its deadline, but what it says changed. */
  REFRESHED: "refreshed",
  DONE: "done",
  EXPIRED: "expired",
  UNDONE: "undone",
  PANEL_OPENED: "panel_opened",
  BUSINESS_OBSERVED: "business_observed",
  WAITING: "waiting"
};
var CompanionUnavailableReason = {
  KILL_SWITCH: "kill_switch",
  NOT_IN_COHORT: "not_in_cohort",
  BRAND_NOT_FOUND: "brand_not_found",
  NO_PROGRAM_NO_OBLIGATION: "no_program_no_obligation",
  NO_DEPLOYED_KIND: "no_deployed_kind",
  ALL_KINDS_DISABLED: "all_kinds_disabled"
};
var CompanionPerformanceMetric = {
  CLICK_RATE: "click_rate"
};
var CompanionPayoutExclusionReason = {
  SETUP_INCOMPLETE: "setup_incomplete",
  UNDER_REVIEW: "under_review",
  RESTRICTED: "restricted",
  PROVIDER_UNAVAILABLE: "provider_unavailable"
};
var CompanionMentionSignal = {
  TREND: "trend",
  SCORE: "score",
  FREQUENCY: "frequency"
};
var CompanionBrandContactChannel = {
  BULK_EMAIL: "bulk_email",
  PROGRAM_INVITATION: "program_invitation",
  FLOW_EMAIL: "flow_email",
  CONVERSATION_MESSAGE: "conversation_message",
  COLLAB_PROPOSAL: "collab_proposal",
  BOOST_REQUEST: "boost_request",
  /**
   * A display rights proposal delivered. Kept out of the contact readings the
   * silent-affiliate and notable-mention cards make: a proposal can leave as a
   * link the brand copied, which reaches nobody by itself.
   */
  DISPLAY_RIGHTS_PROPOSAL: "display_rights_proposal"
};
var CompanionCtaWorkflow = {
  DISCOVERY: "discovery",
  BULK_EMAIL: "bulk_email",
  DISPLAY_RIGHTS_RENEWAL: "display_rights_renewal",
  PAYOUT_PREPARE: "payout_prepare",
  BOOST_REQUEST: "boost_request",
  PROGRAM_INVITE: "program_invite",
  COLLAB_PROPOSAL: "collab_proposal",
  CONVERSATION_REPLY: "conversation_reply",
  GIFT_REOFFER: "gift_reoffer",
  GIFT_STOCK_RESTOCK: "gift_stock_restock",
  BRIEF_APPLICATION_REVIEW: "brief_application_review"
};
var CompanionGiftReofferDecisionStatus = {
  PENDING: "pending",
  REFUSED: "refused",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
  SNOOZED: "snoozed"
};
var CompanionNarrationSource = {
  TEMPLATE: "template",
  LLM: "llm"
};
var CompanionRealtimeEventName = {
  FEED_CHANGED: "companion.feed.changed"
};
var CompanionRealtimeReason = {
  RUN: "run",
  MUTATION: "mutation",
  EXPIRY: "expiry",
  DELIVERY: "delivery"
};
function companionBrandChannel(brandId) {
  return `companion/brands/${brandId}`;
}

// src/api/agents.ts
var AgentSlug = {
  PREFS_EXTRACTOR: "prefs-extractor",
  BRAND_MATCH: "brand-match",
  /**
   * Internal Fluenceur tooling (FOU-515). Records invocations for the
   * weekly similarity-curation eval. NOT a per-brand agent: it bypasses
   * `enabledAgents` opt-in and writes to `agent_invocations` solely for
   * audit + cost visibility on the gateway side.
   */
  BRAND_EVAL: "brand-eval",
  /**
   * One slug per companion feed kind, so a brand switches off a single kind of
   * card without losing the rest of the feed. The detectors behind them are
   * deterministic and reserve no LLM budget; the slug is the brand's consent,
   * not a cost control.
   */
  COMPANION_RIGHTS_EXPIRING: "companion-rights-expiring",
  COMPANION_PAYOUT_PENDING: "companion-payout-pending",
  COMPANION_GIFT_STOCK: "companion-gift-stock",
  COMPANION_MENTION_NOTABLE: "companion-mention-notable",
  COMPANION_AFFILIATE_SILENT: "companion-affiliate-silent",
  COMPANION_GIFT_UNCLAIMED: "companion-gift-unclaimed",
  COMPANION_GIFT_EXPIRED_REOFFER: "companion-gift-expired-reoffer",
  COMPANION_BRIEF_APPLICATION: "companion-brief-application",
  COMPANION_BRANDMATCH_BATCH: "companion-brandmatch-batch",
  /**
   * The optional narrator that rewrites a card's title and reason before it is
   * published. Like `brand-eval`, it is NOT a per-brand consent slug: the brand
   * already consented to the card through its kind slug, and the narrator is a
   * platform capability switched on by its own environment flag. It is named
   * here so its invocations, and their cost, are audited under a stable name.
   */
  COMPANION_NARRATOR: "companion-narrator"
};
var COMPANION_KIND_SLUGS = {
  [CompanionActionKind.RIGHTS_EXPIRING]: AgentSlug.COMPANION_RIGHTS_EXPIRING,
  [CompanionActionKind.PAYOUT_PENDING]: AgentSlug.COMPANION_PAYOUT_PENDING,
  [CompanionActionKind.GIFT_STOCK]: AgentSlug.COMPANION_GIFT_STOCK,
  [CompanionActionKind.MENTION_NOTABLE]: AgentSlug.COMPANION_MENTION_NOTABLE,
  [CompanionActionKind.AFFILIATE_SILENT]: AgentSlug.COMPANION_AFFILIATE_SILENT,
  [CompanionActionKind.GIFT_UNCLAIMED]: AgentSlug.COMPANION_GIFT_UNCLAIMED,
  [CompanionActionKind.GIFT_EXPIRED_REOFFER]: AgentSlug.COMPANION_GIFT_EXPIRED_REOFFER,
  [CompanionActionKind.BRIEF_APPLICATION]: AgentSlug.COMPANION_BRIEF_APPLICATION,
  [CompanionActionKind.BRANDMATCH_BATCH]: AgentSlug.COMPANION_BRANDMATCH_BATCH
};
var COMPANION_SLUGS_SEED_VERSION = 5;
var AgentInvocationStatus = {
  SUCCESS: "success",
  FAILED: "failed",
  BUDGET_EXCEEDED: "budget_exceeded",
  VALIDATION_FAILED: "validation_failed"
};

// src/api/affiliate.ts
var AffiliateEnrollmentSource = /* @__PURE__ */ ((AffiliateEnrollmentSource2) => {
  AffiliateEnrollmentSource2["CSV_IMPORT"] = "csv_import";
  AffiliateEnrollmentSource2["INVITATION"] = "invitation";
  AffiliateEnrollmentSource2["DISCOVERY"] = "discovery";
  AffiliateEnrollmentSource2["BRAND_SPACE_APPLICATION"] = "brand_space_application";
  AffiliateEnrollmentSource2["MANUAL"] = "manual";
  AffiliateEnrollmentSource2["EXTENSION"] = "extension";
  return AffiliateEnrollmentSource2;
})(AffiliateEnrollmentSource || {});
var AFFILIATE_TABLE_SORT_FIELDS = [
  "joinedAt",
  "orders",
  "visits",
  "revenue",
  "conversion",
  "averageOrderValue",
  "payableCommission",
  "lastOrderAt",
  "earnings"
];
var AFFILIATE_TABLE_DATE_FILTER_TYPES = [
  "joinedAt",
  "lastOrderAt"
];
var InfluenceSector = /* @__PURE__ */ ((InfluenceSector2) => {
  InfluenceSector2["FASHION"] = "fashion";
  InfluenceSector2["BEAUTY"] = "beauty";
  InfluenceSector2["FITNESS"] = "fitness";
  InfluenceSector2["TECHNOLOGY"] = "technology";
  InfluenceSector2["TRAVEL"] = "travel";
  InfluenceSector2["FOOD"] = "food";
  InfluenceSector2["AUTOMOTIVE"] = "automotive";
  InfluenceSector2["HOME_GARDEN"] = "home_garden";
  InfluenceSector2["FAMILY_PARENTING"] = "family_parenting";
  InfluenceSector2["ENTERTAINMENT"] = "entertainment";
  InfluenceSector2["EDUCATION"] = "education";
  InfluenceSector2["LIFESTYLE"] = "lifestyle";
  InfluenceSector2["HEALTHCARE"] = "healthcare";
  return InfluenceSector2;
})(InfluenceSector || {});
var MAX_INFLUENCE_SECTORS = 5;
var DEFAULT_AFFILIATE_USER_SETTINGS = {
  emailNotifications: true,
  pushNotifications: false,
  preferredLanguage: "en"
};

// src/api/affiliate-import.ts
var AFFILIATE_CSV_IMPORT_LIMITS = {
  maxRows: 2e3,
  maxSubjectLength: 255,
  maxCustomMessageLength: 5e4,
  maxCompiledMessageLength: 1e4
};

// src/api/brand.ts
var BrandAccountType = {
  SHOPIFY: "shopify",
  INTERNAL: "internal",
  PARTNER: "partner"
};

// src/api/brand-signup-invitation.ts
var BrandSignupInvitationStatus = /* @__PURE__ */ ((BrandSignupInvitationStatus2) => {
  BrandSignupInvitationStatus2["PENDING"] = "pending";
  BrandSignupInvitationStatus2["ACCEPTED"] = "accepted";
  BrandSignupInvitationStatus2["EXPIRED"] = "expired";
  BrandSignupInvitationStatus2["REVOKED"] = "revoked";
  return BrandSignupInvitationStatus2;
})(BrandSignupInvitationStatus || {});

// src/api/brand-self-signup.ts
var BrandCollaborationType = {
  UGC: "ugc",
  GIFTING: "gifting",
  SPONSORED: "sponsored",
  AFFILIATION: "affiliation"
};
var BRAND_COLLABORATION_TYPES = Object.values(BrandCollaborationType);
var BrandSalesChannel = {
  SHOPIFY: "shopify",
  STRIPE: "stripe",
  API: "api",
  NONE: "none"
};
var BRAND_SALES_CHANNELS = Object.values(BrandSalesChannel);

// src/api/discount-code-management.ts
var DiscountCodeManagementMode = {
  PLATFORM: "platform",
  LOCAL: "local"
};
var ACCOUNT_TYPE_TO_DISCOUNT_CODE_MODE = {
  [BrandAccountType.SHOPIFY]: DiscountCodeManagementMode.PLATFORM,
  [BrandAccountType.INTERNAL]: DiscountCodeManagementMode.LOCAL,
  [BrandAccountType.PARTNER]: DiscountCodeManagementMode.LOCAL
};
function discountCodeMode(accountType) {
  return ACCOUNT_TYPE_TO_DISCOUNT_CODE_MODE[accountType];
}
var SHOPIFY_ONLY_DISCOUNT_SETTINGS = [
  "minPurchaseAmount",
  "autoApplyDiscount",
  "oncePerCustomer"
];
function sanitizeDiscountSettingsForMode(settings, mode) {
  if (!settings || mode === DiscountCodeManagementMode.PLATFORM) {
    return settings;
  }
  const sanitized = { ...settings };
  for (const key of SHOPIFY_ONLY_DISCOUNT_SETTINGS) {
    delete sanitized[key];
  }
  return sanitized;
}

// src/api/collab-brief.ts
var CollabType = /* @__PURE__ */ ((CollabType2) => {
  CollabType2["SPONSORED_POST"] = "sponsored_post";
  CollabType2["UGC"] = "ugc";
  CollabType2["GIFTING"] = "gifting";
  return CollabType2;
})(CollabType || {});
var BriefTemplateStatus = /* @__PURE__ */ ((BriefTemplateStatus2) => {
  BriefTemplateStatus2["ACTIVE"] = "active";
  BriefTemplateStatus2["ARCHIVED"] = "archived";
  return BriefTemplateStatus2;
})(BriefTemplateStatus || {});
var BriefDiffusionStatus = /* @__PURE__ */ ((BriefDiffusionStatus2) => {
  BriefDiffusionStatus2["OFF"] = "off";
  BriefDiffusionStatus2["OPEN"] = "open";
  BriefDiffusionStatus2["STOPPED"] = "stopped";
  return BriefDiffusionStatus2;
})(BriefDiffusionStatus || {});
function briefGiftChoiceLabel(product, locale = "en", fallbackCurrency) {
  if (product?.source !== "catalog" || !product.catalogProducts || product.catalogProducts.length < 2) return null;
  const maximum = product.maxSelectableProducts ?? 1;
  const language = locale.split("-")[0];
  const names = product.catalogProducts.map((offered) => {
    const currency = offered.currency ?? fallbackCurrency;
    if (offered.priceInCents === null || !currency) return offered.title;
    let value;
    try {
      value = new Intl.NumberFormat(locale, { style: "currency", currency }).format(offered.priceInCents / 100);
    } catch {
      value = `${(offered.priceInCents / 100).toFixed(2)} ${currency}`;
    }
    return `${offered.title} (${value})`;
  }).join(", ");
  if (language === "fr") return `Choisissez jusqu\u2019\xE0 ${maximum} produit${maximum > 1 ? "s" : ""} parmi : ${names}`;
  if (language === "it") return `Scegli fino a ${maximum} prodott${maximum > 1 ? "i" : "o"} tra: ${names}`;
  return `Choose up to ${maximum} product${maximum > 1 ? "s" : ""} from: ${names}`;
}
function compensationOfferedProduct(compensation, collabType) {
  if (compensation.type === "gifted_product") return compensation.giftedProduct;
  if (compensation.type === "fixed_payment" && collabType === "ugc" /* UGC */) {
    return compensation.giftedProduct;
  }
  return null;
}
function offeredCatalogProducts(product) {
  if (product?.source !== "catalog") return [];
  return product.catalogProducts ?? (product.catalog ? [product.catalog] : []);
}
var BriefGenerationObjective = /* @__PURE__ */ ((BriefGenerationObjective2) => {
  BriefGenerationObjective2["PRODUCT_LAUNCH"] = "product_launch";
  BriefGenerationObjective2["AWARENESS"] = "awareness";
  BriefGenerationObjective2["AUTHENTIC_UGC"] = "authentic_ugc";
  BriefGenerationObjective2["OTHER"] = "other";
  return BriefGenerationObjective2;
})(BriefGenerationObjective || {});

// src/api/collab-pricing.ts
var COLLAB_PLATFORM_FEE_FLOOR_MINOR_UNITS = 1e3;
var COLLAB_PROCESSING_FEE_BASIS_POINTS_DOMESTIC = 0;
var COLLAB_PROCESSING_FEE_BASIS_POINTS_CROSS_CURRENCY = 0;
var SETTLEMENT_CURRENCY = "EUR";
function collabProcessingFeeBasisPoints(currency) {
  return currency.trim().toUpperCase() === SETTLEMENT_CURRENCY ? COLLAB_PROCESSING_FEE_BASIS_POINTS_DOMESTIC : COLLAB_PROCESSING_FEE_BASIS_POINTS_CROSS_CURRENCY;
}
var COLLAB_PAID_BRIEF_MAX_AMOUNT_MINOR_UNITS = 2e5;
var COLLAB_PAID_BRIEF_MAX_END_DAYS = 60;
var COLLAB_FUNDING_WINDOW_HOURS = 72;
var COLLAB_HOLD_WARNING_DAYS = 75;
var COLLAB_HOLD_LIMIT_DAYS = 85;
var COLLAB_END_DEADLINE_DECISION_DAYS = 7;
var COLLAB_END_DEADLINE_EXTENSION_DAYS = 7;

// src/api/creator-hub-ugc.ts
var CONTRACT_AMOUNT_MAX_CENTS = 5e6;
var CREATOR_UGC_MAX_SAMPLE_URLS = 3;
var CREATOR_UGC_MAX_SAMPLES = 3;
var CREATOR_UGC_MODIFICATION_REQUEST_CHOICES = [2, 3];
var DEFAULT_CREATOR_UGC_MODIFICATION_REQUESTS = 2;

// src/api/ugc-brief.ts
var UGC_DELIVERABLE_FORMATS = [
  "ugc_video",
  "ugc_video_4x5",
  "ugc_photo"
];
var UGC_MAX_DURATION_SECONDS = [15, 30, 60];
var UGC_USAGE_RIGHTS_DURATIONS = [6, 12, 24];
var UGC_DELIVERY_RESOLUTIONS = [
  "720p",
  "1080p"
];
var DEFAULT_UGC_DELIVERY = {
  minResolution: "1080p",
  music: false,
  burnedSubtitles: false
};
var UGC_BRIEF_MAX_END_DAYS = 45;
function paidBriefMaxEndDays(collabType) {
  return collabType === "ugc" /* UGC */ ? UGC_BRIEF_MAX_END_DAYS : COLLAB_PAID_BRIEF_MAX_END_DAYS;
}
function isUgcDeliverableFormat(format) {
  return UGC_DELIVERABLE_FORMATS.includes(format);
}
function isUgcVideoFormat(format) {
  return format === "ugc_video" || format === "ugc_video_4x5";
}
function isValidUgcDeliverable(deliverable) {
  if (deliverable.platform !== null && deliverable.platform !== void 0) return false;
  if (!Number.isSafeInteger(deliverable.quantity) || deliverable.quantity < 1) return false;
  const duration = deliverable.maxDurationSeconds ?? null;
  if (isUgcVideoFormat(deliverable.format)) {
    return duration !== null && UGC_MAX_DURATION_SECONDS.includes(duration);
  }
  return deliverable.format === "ugc_photo" && duration === null;
}
function ugcRightsPriceSplit(fixedAmountCents, adsShareCents) {
  if (!isWholePositive(fixedAmountCents) || !isWholePositive(adsShareCents)) return null;
  if (adsShareCents >= fixedAmountCents) return null;
  return { organicCents: fixedAmountCents - adsShareCents, adsCents: adsShareCents };
}
function ugcBriefGaps(content) {
  const gaps = [];
  if (content.deliverables.length === 0 || !content.deliverables.every(isValidUgcDeliverable)) {
    gaps.push("deliverables");
  }
  if (!isDeliveryStated(content.delivery)) gaps.push("delivery");
  if (!areUsageRightsStated(content)) gaps.push("usage_rights");
  if (!isFixedPaymentStated(content)) gaps.push("compensation");
  const { firstContentDays, endDays } = content.timeline;
  if (firstContentDays === null || endDays === null || endDays <= firstContentDays) {
    gaps.push("timeline");
  }
  return gaps;
}
function ugcModificationRequestsOf(content) {
  return content.modificationRequestsPerContent ?? DEFAULT_CREATOR_UGC_MODIFICATION_REQUESTS;
}
function ugcVideoUnits(deliverables) {
  return deliverables.filter((deliverable) => isUgcVideoFormat(deliverable.format)).reduce((total, deliverable) => total + deliverable.quantity, 0);
}
function ugcDeliverableLabel(deliverable, words) {
  const count = `\xD7${deliverable.quantity}`;
  if (isUgcVideoFormat(deliverable.format)) {
    const name = deliverable.format === "ugc_video_4x5" ? words.video4x5 : words.video;
    const seconds = deliverable.maxDurationSeconds;
    return seconds ? [name, words.maxDuration.replace("{{seconds}}", String(seconds)), count].join(" \xB7 ") : [name, count].join(" \xB7 ");
  }
  if (deliverable.format === "ugc_photo") return [words.photo, count].join(" \xB7 ");
  return null;
}
function isDeliveryStated(delivery) {
  return !!delivery && UGC_DELIVERY_RESOLUTIONS.includes(delivery.minResolution) && typeof delivery.music === "boolean" && typeof delivery.burnedSubtitles === "boolean";
}
function areUsageRightsStated(content) {
  const { durationMonths, channels, adsShareCents } = content.usageRights;
  if (durationMonths === null || !UGC_USAGE_RIGHTS_DURATIONS.includes(durationMonths)) return false;
  if (!channels.includes("organic")) return false;
  if (!channels.includes("paid_ads")) return true;
  if (!isWholePositive(adsShareCents)) return false;
  const amount = content.compensation.fixedPayment?.amountCents;
  return !isWholePositive(amount) || adsShareCents < amount;
}
function isFixedPaymentStated(content) {
  const { type, fixedPayment } = content.compensation;
  return type === "fixed_payment" && isWholePositive(fixedPayment?.amountCents);
}
function isWholePositive(value) {
  return typeof value === "number" && Number.isSafeInteger(value) && value > 0;
}

// src/api/collab.ts
var CollabStatus = /* @__PURE__ */ ((CollabStatus2) => {
  CollabStatus2["DRAFT"] = "draft";
  CollabStatus2["PROPOSED"] = "proposed";
  CollabStatus2["VIEWED"] = "viewed";
  CollabStatus2["ACCEPTED"] = "accepted";
  CollabStatus2["DECLINED"] = "declined";
  CollabStatus2["EXPIRED"] = "expired";
  CollabStatus2["WITHDRAWN"] = "withdrawn";
  CollabStatus2["COMPLETED"] = "completed";
  CollabStatus2["ABANDONED"] = "abandoned";
  CollabStatus2["UNFUNDED"] = "unfunded";
  CollabStatus2["CANCELLED"] = "cancelled";
  return CollabStatus2;
})(CollabStatus || {});
var COLLAB_CANCELLATION_REASONS = [
  "creator_withdrawal",
  "deadline_without_content",
  "hold_expired",
  "bank_dispute_lost",
  "dispute_refunded",
  // UGC: the product never shipped, or never arrived. Principal and fees go back.
  "ugc_product_not_shipped",
  "ugc_product_not_received"
];
var COLLAB_DISPUTE_GROUNDS = [
  "rejections_exhausted",
  "partial_content_at_deadline",
  "illicit_content"
];
var COLLAB_DISPUTE_OUTCOMES = [
  "released",
  "refunded",
  "superseded",
  /**
   * A person found one modification request outside the brief: the request no
   * longer counts, the content it sent back is validated, and the collab goes
   * on. Nobody's money moves on this outcome itself.
   */
  "request_overturned"
];
var CollabDeliverableStatus = /* @__PURE__ */ ((CollabDeliverableStatus2) => {
  CollabDeliverableStatus2["TODO"] = "todo";
  CollabDeliverableStatus2["PUBLISHED"] = "published";
  CollabDeliverableStatus2["DETECTED"] = "detected";
  CollabDeliverableStatus2["VALIDATED"] = "validated";
  CollabDeliverableStatus2["WAIVED"] = "waived";
  return CollabDeliverableStatus2;
})(CollabDeliverableStatus || {});
var COLLAB_DELIVERABLE_BOARD_STATUSES = [
  "todo" /* TODO */,
  "published" /* PUBLISHED */,
  "detected" /* DETECTED */,
  "validated" /* VALIDATED */
];
var COLLAB_DELIVERABLE_MAX_REJECTIONS = 3;
var COLLAB_TACIT_VALIDATION_DAYS = 7;
var COLLAB_TACIT_REMINDER_MILESTONE_DAYS = [3, 6];
var CollabPaymentRightStatus = /* @__PURE__ */ ((CollabPaymentRightStatus2) => {
  CollabPaymentRightStatus2["DUE"] = "due";
  CollabPaymentRightStatus2["SECURED"] = "secured";
  CollabPaymentRightStatus2["PAID"] = "paid";
  CollabPaymentRightStatus2["VOID"] = "void";
  return CollabPaymentRightStatus2;
})(CollabPaymentRightStatus || {});
var COLLAB_PAYMENT_RIGHT_VOID_REASONS = [
  ...COLLAB_CANCELLATION_REASONS,
  "unfunded",
  "beneficiary_unreachable",
  "late_capture",
  // The endings that void an obligation without cancelling the collaboration:
  // the brand walking away (the collab is `abandoned`), and a refund made
  // outside the product that the rail recognised after the fact.
  "brand_abandon",
  "manual"
];
var CollabEventType = /* @__PURE__ */ ((CollabEventType2) => {
  CollabEventType2["CREATED"] = "created";
  CollabEventType2["SENT"] = "sent";
  CollabEventType2["VIEWED"] = "viewed";
  CollabEventType2["ACCEPTED"] = "accepted";
  CollabEventType2["DECLINED"] = "declined";
  CollabEventType2["WITHDRAWN"] = "withdrawn";
  CollabEventType2["EXPIRED"] = "expired";
  CollabEventType2["COMPLETED"] = "completed";
  CollabEventType2["ABANDONED"] = "abandoned";
  CollabEventType2["REMINDED"] = "reminded";
  CollabEventType2["DELIVERED"] = "delivered";
  CollabEventType2["DELIVERY_FAILED"] = "delivery_failed";
  CollabEventType2["RECOVERY_CODE_RESOLVED"] = "recovery_code_resolved";
  CollabEventType2["DELIVERABLE_PUBLISHED"] = "deliverable_published";
  CollabEventType2["DELIVERABLE_DETECTED"] = "deliverable_detected";
  CollabEventType2["DELIVERABLE_VALIDATED"] = "deliverable_validated";
  CollabEventType2["DELIVERABLE_REJECTED"] = "deliverable_rejected";
  CollabEventType2["DELIVERABLE_MENTION_DETACHED"] = "deliverable_mention_detached";
  CollabEventType2["PAYMENT_DUE"] = "payment_due";
  CollabEventType2["PAYMENT_MARKED_PAID"] = "payment_marked_paid";
  CollabEventType2["PAYMENT_INITIATED"] = "payment_initiated";
  CollabEventType2["PAYMENT_FAILED"] = "payment_failed";
  CollabEventType2["PAYMENT_INTERRUPTED"] = "payment_interrupted";
  CollabEventType2["PAYMENT_LATE_CAPTURE"] = "payment_late_capture";
  CollabEventType2["FUNDED"] = "funded";
  CollabEventType2["UNFUNDED"] = "unfunded";
  CollabEventType2["CANCELLED"] = "cancelled";
  CollabEventType2["FUNDING_REMINDED"] = "funding_reminded";
  CollabEventType2["FUNDING_SUSPENDED"] = "funding_suspended";
  CollabEventType2["FUNDING_RESUMED"] = "funding_resumed";
  CollabEventType2["DEADLINE_EXTENDED"] = "deadline_extended";
  CollabEventType2["DELIVERABLE_TACITLY_VALIDATED"] = "deliverable_tacitly_validated";
  CollabEventType2["DELIVERABLE_WAIVED"] = "deliverable_waived";
  CollabEventType2["DISPUTE_OPENED"] = "dispute_opened";
  CollabEventType2["DISPUTE_RESOLVED"] = "dispute_resolved";
  CollabEventType2["DISPUTE_SUPERSEDED"] = "dispute_superseded";
  CollabEventType2["PAYMENT_SECURED"] = "payment_secured";
  CollabEventType2["PAYMENT_REFUNDED"] = "payment_refunded";
  CollabEventType2["BANK_DISPUTE_OPENED"] = "bank_dispute_opened";
  CollabEventType2["BANK_DISPUTE_CLOSED"] = "bank_dispute_closed";
  CollabEventType2["BANK_DISPUTE_EVENT_IGNORED"] = "bank_dispute_event_ignored";
  CollabEventType2["PRODUCT_RECEIVED"] = "product_received";
  CollabEventType2["SHIPMENT_EXTENDED"] = "shipment_extended";
  CollabEventType2["MODIFICATION_REQUEST_OVERTURNED"] = "modification_request_overturned";
  CollabEventType2["PRODUCT_NOT_YET_RECEIVED"] = "product_not_yet_received";
  CollabEventType2["PRODUCT_RESHIPPED"] = "product_reshipped";
  return CollabEventType2;
})(CollabEventType || {});
var CollabDeliveryChannel = /* @__PURE__ */ ((CollabDeliveryChannel2) => {
  CollabDeliveryChannel2["EMAIL_CONNECTED"] = "email_connected";
  CollabDeliveryChannel2["EMAIL_TRANSACTIONAL"] = "email_transactional";
  CollabDeliveryChannel2["DM"] = "dm";
  CollabDeliveryChannel2["LINK_ONLY"] = "link_only";
  return CollabDeliveryChannel2;
})(CollabDeliveryChannel || {});
var REMIND_COOLDOWN_HOURS = 72;
var CollabAcceptanceMethod = /* @__PURE__ */ ((CollabAcceptanceMethod2) => {
  CollabAcceptanceMethod2["EMAIL_CODE"] = "email_code";
  CollabAcceptanceMethod2["CREATOR_APP"] = "creator_app";
  CollabAcceptanceMethod2["WEB_PORTAL"] = "web_portal";
  return CollabAcceptanceMethod2;
})(CollabAcceptanceMethod || {});
var CollabDeclineReasonCode = /* @__PURE__ */ ((CollabDeclineReasonCode2) => {
  CollabDeclineReasonCode2["NOT_THE_RIGHT_TIME"] = "not_the_right_time";
  CollabDeclineReasonCode2["RATE_TOO_LOW"] = "rate_too_low";
  CollabDeclineReasonCode2["NOT_MY_WORLD"] = "not_my_world";
  CollabDeclineReasonCode2["DEADLINE_TOO_SHORT"] = "deadline_too_short";
  CollabDeclineReasonCode2["OTHER"] = "other";
  return CollabDeclineReasonCode2;
})(CollabDeclineReasonCode || {});
var COLLAB_DECLINE_REASON_CODES = Object.values(
  CollabDeclineReasonCode
);
var CollabCloseOutcome = /* @__PURE__ */ ((CollabCloseOutcome2) => {
  CollabCloseOutcome2["COMPLETED"] = "completed";
  CollabCloseOutcome2["ABANDONED"] = "abandoned";
  return CollabCloseOutcome2;
})(CollabCloseOutcome || {});
var COLLAB_ABANDON_REASON_MAX_LENGTH = 1e3;
var COLLAB_SETTLEABLE_CURRENCIES = ["EUR", "USD", "CAD"];
function isCollabSettleableCurrency(currency) {
  return COLLAB_SETTLEABLE_CURRENCIES.includes(
    currency.trim().toUpperCase()
  );
}
var CollabSettlementStatus = /* @__PURE__ */ ((CollabSettlementStatus2) => {
  CollabSettlementStatus2["QUOTE"] = "quote";
  CollabSettlementStatus2["COLLECTING"] = "collecting";
  CollabSettlementStatus2["TRANSFERRING"] = "transferring";
  CollabSettlementStatus2["PAID"] = "paid";
  CollabSettlementStatus2["RETRYABLE_FAILURE"] = "retryable_failure";
  CollabSettlementStatus2["HELD"] = "held";
  CollabSettlementStatus2["REFUNDED"] = "refunded";
  CollabSettlementStatus2["CANCELLED"] = "cancelled";
  return CollabSettlementStatus2;
})(CollabSettlementStatus || {});
var COLLAB_SETTLEMENT_REFUND_REASONS = [
  "brand_abandon",
  ...COLLAB_CANCELLATION_REASONS,
  "beneficiary_unreachable",
  "late_capture",
  "manual"
];
var COLLAB_MONEY_STATES = [
  "none",
  "to_fund",
  "funding_delayed",
  "held",
  "awaiting_creator_account",
  "dispute",
  "bank_dispute",
  "paid",
  "refunded",
  "unfunded"
];
var COLLAB_COLLECTION_FAILURE_OUTCOMES = [
  "refused",
  "canceled",
  "not_opened"
];
var COLLAB_CODE_PURPOSES = [
  "accept",
  "decline",
  "withdraw",
  "dispute"
];

// src/api/ugc-lifecycle.ts
var UGC_MINIMUM_CENTS_PER_FORMAT = {
  ugc_video: 5e3,
  ugc_video_4x5: 5e3,
  ugc_photo: 1500
};
function ugcMinimumPaymentCents(deliverables) {
  return deliverables.reduce((total, deliverable) => {
    const perUnit = UGC_MINIMUM_CENTS_PER_FORMAT[deliverable.format];
    if (perUnit === void 0) return total;
    const quantity = Number.isSafeInteger(deliverable.quantity) ? Math.max(deliverable.quantity, 0) : 0;
    return total + perUnit * quantity;
  }, 0);
}
function ugcPaymentShortfall(content) {
  const minimumCents = ugcMinimumPaymentCents(content.deliverables);
  if (minimumCents === 0) return null;
  const amountCents = content.compensation?.fixedPayment?.amountCents ?? 0;
  if (amountCents >= minimumCents) return null;
  return {
    amountCents,
    minimumCents,
    perFormatMinimumCents: UGC_MINIMUM_CENTS_PER_FORMAT
  };
}
var UGC_PRODUCT_RECEPTION_SOURCES = [
  "creator",
  "shopify",
  "default"
];
function ugcDeliverableState(row) {
  switch (row.status) {
    case "published" /* PUBLISHED */:
    case "detected" /* DETECTED */:
      return { brand: "to_review", creator: "in_validation" };
    case "validated" /* VALIDATED */:
      return { brand: "validated", creator: "validated" };
    case "waived" /* WAIVED */:
      return { brand: "not_delivered", creator: "no_longer_expected" };
    default:
      return row.rejectionCount > 0 ? { brand: "modification_requested", creator: "to_fix" } : { brand: "to_deliver", creator: "to_deliver" };
  }
}
function isUgcContentLate(content, collabStatus, now = /* @__PURE__ */ new Date()) {
  if (collabStatus !== "accepted" /* ACCEPTED */) return false;
  if (content.dueAt === null || content.versionProcessing === true) return false;
  const state = ugcDeliverableState(content).creator;
  if (state !== "to_deliver" && state !== "to_fix") return false;
  return new Date(content.dueAt).getTime() < now.getTime();
}
var UGC_RECEPTION_QUESTION_DAYS = [5, 7, 10];
var UGC_RECEPTION_ASSUMED_AFTER_DAYS = 14;
var UGC_PRODUCT_RECEPTION_ANSWERS = ["yes", "not_yet"];

// src/api/ugc-tracking.ts
var COLLAB_TRACKING_PATH = "/collabs/suivi";
var UGC_TRACKING_PATH = "/collabs/ugc";
function collabDashboardHref(collab, options = {}) {
  const isUgc = collab.collabType === "ugc" /* UGC */;
  const path = isUgc ? UGC_TRACKING_PATH : COLLAB_TRACKING_PATH;
  const href = `${path}?collab=${encodeURIComponent(collab.id)}`;
  if (!isUgc) return href;
  const tab = options.ugcContent ? "contents" : options.ugcTab;
  return [
    href,
    tab ? `&ugcTab=${tab}` : "",
    options.ugcContent ? `&ugcContent=${encodeURIComponent(options.ugcContent)}` : "",
    options.ugcContent && options.ugcVersion ? `&ugcVersion=${encodeURIComponent(options.ugcVersion)}` : ""
  ].join("");
}
var UGC_DECISION_URGENT_HOURS = 24;
var UGC_DECISION_CALENDAR_DAYS = 14;
var UGC_CONTENT_STATUS_FILTERS = [
  "validated",
  "to_review",
  "modification_requested",
  "all"
];
var UGC_CONTENT_FORMAT_FILTERS = ["video", "photo"];

// src/api/ugc-files.ts
var MEGABYTE = 1024 * 1024;
var UGC_FILE_LIMITS = {
  video: { mimeTypes: ["video/quicktime", "video/mp4"], maxBytes: 300 * MEGABYTE },
  photo: { mimeTypes: ["image/jpeg", "image/png"], maxBytes: 20 * MEGABYTE }
};
function ugcFileKindOf(mimeType) {
  const normalized = mimeType.trim().toLowerCase();
  if (UGC_FILE_LIMITS.video.mimeTypes.includes(normalized)) return "video";
  if (UGC_FILE_LIMITS.photo.mimeTypes.includes(normalized)) return "photo";
  return null;
}
function ugcFileKindForFormat(format) {
  if (isUgcVideoFormat(format)) return "video";
  if (format === "ugc_photo") return "photo";
  return null;
}
var UGC_VERSION_STATUSES = [
  "uploading",
  "processing",
  "ready",
  "rejected",
  "failed"
];
var UGC_RESOLUTION_SHORT_SIDE = {
  "720p": 720,
  "1080p": 1080
};
var UGC_FILE_RATIOS = {
  video: { label: "9:16", value: 9 / 16 },
  photo: { label: "4:5", value: 4 / 5 }
};
function ugcFileRatioForFormat(format) {
  if (format === "ugc_video_4x5") return UGC_FILE_RATIOS.photo;
  const kind = ugcFileKindForFormat(format);
  return kind ? UGC_FILE_RATIOS[kind] : null;
}
var UGC_RATIO_TOLERANCE = 0.02;
var UGC_DURATION_TOLERANCE_SECONDS = 0.5;
var UGC_FEEDBACK_MAX_CHARACTERS = 1e3;
var UGC_PENDING_FEEDBACK_CHOICES = ["send", "discard"];
var UGC_VERSION_NOTE_MAX_CHARACTERS = 500;

// src/api/ugc-rights.ts
var UGC_FALLBACK_RIGHTS_MONTHS = 24;
function ugcRightsEndDate(validatedAt, durationMonths) {
  const months = durationMonths && durationMonths > 0 ? durationMonths : UGC_FALLBACK_RIGHTS_MONTHS;
  const end = new Date(validatedAt.getTime());
  const day = end.getUTCDate();
  end.setUTCDate(1);
  end.setUTCMonth(end.getUTCMonth() + months);
  const lastDay = new Date(
    Date.UTC(end.getUTCFullYear(), end.getUTCMonth() + 1, 0)
  ).getUTCDate();
  end.setUTCDate(Math.min(day, lastDay));
  return end;
}
var UGC_RIGHTS_NOTICE_DAYS = 30;
var UGC_ORIGINALS_KEPT_MONTHS = 3;
var DAY_MS = 24 * 60 * 60 * 1e3;
function ugcRightsExpireSoon(rightsEndAt, now) {
  if (rightsEndAt.getTime() <= now.getTime()) return false;
  const utcDay = (at) => Math.floor(at.getTime() / DAY_MS);
  return utcDay(rightsEndAt) - utcDay(now) <= UGC_RIGHTS_NOTICE_DAYS;
}

// src/api/collab-review-policy.ts
var UGC_TACIT_VALIDATION_HOURS = 72;
var UGC_TACIT_REMINDER_HOURS = [24, 48];
var UGC_MODIFICATION_REQUEST_CATEGORIES = [
  "missing_requested_element",
  "forbidden_element_present",
  "technical_spec",
  "quality"
];
function isUgcModificationRequestCategory(value) {
  return typeof value === "string" && UGC_MODIFICATION_REQUEST_CATEGORIES.includes(value);
}
var SPONSORED_POLICY = {
  maxModificationRequests: COLLAB_DELIVERABLE_MAX_REJECTIONS,
  tacitValidationHours: COLLAB_TACIT_VALIDATION_DAYS * 24,
  tacitReminderHours: COLLAB_TACIT_REMINDER_MILESTONE_DAYS.map(
    (days) => days * 24
  )
};
function reviewPolicyFor(collab) {
  if (collab.collabType !== "ugc" /* UGC */) return SPONSORED_POLICY;
  return {
    maxModificationRequests: ugcModificationRequestsOf(collab.content),
    tacitValidationHours: UGC_TACIT_VALIDATION_HOURS,
    tacitReminderHours: UGC_TACIT_REMINDER_HOURS
  };
}
var LOWEST_REVIEW_BOUNDS = {
  maxModificationRequests: Math.min(
    COLLAB_DELIVERABLE_MAX_REJECTIONS,
    ...CREATOR_UGC_MODIFICATION_REQUEST_CHOICES
  ),
  tacitValidationHours: UGC_TACIT_VALIDATION_HOURS
};
function tacitReminderMilestoneHours(policy, elapsedHours) {
  const reached = policy.tacitReminderHours.filter(
    (hours) => elapsedHours >= hours
  );
  return reached.length > 0 ? reached[reached.length - 1] : null;
}

// src/api/brief-applications.ts
var BRIEF_APPLICATION_MESSAGE_MAX_LENGTH = 2e3;
var BriefApplicationState = /* @__PURE__ */ ((BriefApplicationState2) => {
  BriefApplicationState2["PENDING"] = "pending";
  BriefApplicationState2["PROPOSED"] = "proposed";
  BriefApplicationState2["DECLINED"] = "declined";
  return BriefApplicationState2;
})(BriefApplicationState || {});
var BrandSpaceApplicationSource = /* @__PURE__ */ ((BrandSpaceApplicationSource2) => {
  BrandSpaceApplicationSource2["BRAND_SPACE"] = "brand_space";
  BrandSpaceApplicationSource2["CREATOR_PORTAL"] = "creator_portal";
  return BrandSpaceApplicationSource2;
})(BrandSpaceApplicationSource || {});

// src/api/collab-next-action.ts
var MS_PER_DAY = 24 * 60 * 60 * 1e3;
var daysUntil = (iso, now) => {
  if (!iso) return null;
  const target = Date.parse(iso);
  if (Number.isNaN(target)) return null;
  return Math.ceil((target - now) / MS_PER_DAY);
};
var REMIND_EXPIRY_WINDOW_DAYS = 3;
var REMIND_COOLDOWN_MS = REMIND_COOLDOWN_HOURS * 60 * 60 * 1e3;
var isRemindCooldownOver = (lastRemindedAt, now) => {
  if (!lastRemindedAt) return true;
  const last = new Date(lastRemindedAt).getTime();
  if (Number.isNaN(last)) return true;
  return now - last >= REMIND_COOLDOWN_MS;
};
var nextRemindAllowedAt = (lastRemindedAt) => {
  if (!lastRemindedAt) return null;
  const last = new Date(lastRemindedAt).getTime();
  if (Number.isNaN(last)) return null;
  return new Date(last + REMIND_COOLDOWN_MS).toISOString();
};
var hasUnresolvedDeliveryFailure = (collab) => {
  if (!collab.deliveryFailedAt) return false;
  const failed = new Date(collab.deliveryFailedAt).getTime();
  if (Number.isNaN(failed)) return false;
  if (!collab.deliveredAt) return true;
  const delivered = new Date(collab.deliveredAt).getTime();
  if (Number.isNaN(delivered)) return true;
  return failed > delivered;
};
var isDeliveryFailureActionable = (collab) => (collab.status === "proposed" /* PROPOSED */ || collab.status === "viewed" /* VIEWED */) && hasUnresolvedDeliveryFailure(collab);
var deriveNextAction = (collab, now) => {
  if (isDeliveryFailureActionable(collab)) {
    return { kind: "deliveryFailed", opensDrawer: true };
  }
  if (collab.status === "proposed" /* PROPOSED */ || collab.status === "viewed" /* VIEWED */) {
    const remaining = daysUntil(collab.expiresAt, now);
    if (remaining !== null && remaining <= REMIND_EXPIRY_WINDOW_DAYS && isRemindCooldownOver(collab.lastRemindedAt, now)) {
      return {
        kind: "remind",
        expiresInDays: Math.max(remaining, 0),
        opensDrawer: false
      };
    }
    return null;
  }
  if (collab.status === "declined" /* DECLINED */) {
    return collab.declineReason ? { kind: "readReason", opensDrawer: true } : null;
  }
  if (collab.status === "expired" /* EXPIRED */) {
    return { kind: "repropose", opensDrawer: true };
  }
  if (collab.status === "withdrawn" /* WITHDRAWN */) {
    return { kind: "fixResend", opensDrawer: true };
  }
  return null;
};
var WITHDRAWN_RECENCY_WINDOW_DAYS = 14;
var isWithdrawnRecent = (collab, now) => {
  if (collab.status !== "withdrawn" /* WITHDRAWN */) return true;
  if (!collab.withdrawnAt) return true;
  const withdrawn = new Date(collab.withdrawnAt).getTime();
  if (Number.isNaN(withdrawn)) return true;
  return now - withdrawn <= WITHDRAWN_RECENCY_WINDOW_DAYS * MS_PER_DAY;
};
var deriveToBeHandled = (collabs, now, readDeclineIds) => {
  const items = [];
  for (const collab of collabs) {
    if (collab.status === "declined" /* DECLINED */ && readDeclineIds.has(collab.id)) {
      continue;
    }
    if (!isWithdrawnRecent(collab, now)) {
      continue;
    }
    const action = deriveNextAction(collab, now);
    if (action) {
      items.push({ collab, action });
    }
  }
  const failed = items.filter((item) => item.action.kind === "deliveryFailed");
  if (failed.length === 0) return items;
  return [...failed, ...items.filter((item) => item.action.kind !== "deliveryFailed")];
};

// src/api/collab-publication-url.ts
var INSTAGRAM_HOSTS = /* @__PURE__ */ new Set(["instagram.com", "www.instagram.com", "m.instagram.com"]);
var TIKTOK_HOSTS = /* @__PURE__ */ new Set(["tiktok.com", "www.tiktok.com", "m.tiktok.com"]);
var TIKTOK_SHORT_HOSTS = /* @__PURE__ */ new Set(["vm.tiktok.com", "vt.tiktok.com"]);
var CODE = "[A-Za-z0-9_-]+";
var HANDLE = "[A-Za-z0-9._]+";
var INSTAGRAM_POST_PATHS = [
  // /p/<code>, /reel/<code>, /reels/<code>, /tv/<code>, with or without the handle before.
  new RegExp(`^(?:/${HANDLE})?/(?:p|reels?|tv)/${CODE}/?$`),
  new RegExp(`^/stories/${HANDLE}/\\d+/?$`)
];
var TIKTOK_POST_PATHS = [
  new RegExp(`^/@${HANDLE}/(?:video|photo)/\\d+/?$`),
  new RegExp(`^/t/${CODE}/?$`),
  /^\/v\/\d+(?:\.html)?\/?$/
];
var TIKTOK_SHORT_PATH = new RegExp(`^/${CODE}/?$`);
function platformOf(url) {
  const host = url.hostname.toLowerCase();
  const path = url.pathname;
  if (INSTAGRAM_HOSTS.has(host)) {
    return INSTAGRAM_POST_PATHS.some((shape) => shape.test(path)) ? "instagram" : null;
  }
  if (TIKTOK_HOSTS.has(host)) {
    return TIKTOK_POST_PATHS.some((shape) => shape.test(path)) ? "tiktok" : null;
  }
  if (TIKTOK_SHORT_HOSTS.has(host)) {
    return TIKTOK_SHORT_PATH.test(path) ? "tiktok" : null;
  }
  return null;
}
function readCollabPublicationUrl(value) {
  const trimmed = value.trim();
  if (!trimmed) return null;
  let url;
  try {
    url = new URL(trimmed);
  } catch {
    return null;
  }
  if (url.protocol !== "http:" && url.protocol !== "https:") return null;
  const platform = platformOf(url);
  return platform ? { url: trimmed, platform } : null;
}
function judgeCollabPublicationUrl(value, expectedPlatform) {
  const post = readCollabPublicationUrl(value);
  if (!post) return { ok: false, reason: "not_a_post" };
  if (expectedPlatform && post.platform !== expectedPlatform) {
    return { ok: false, reason: "wrong_platform", expectedPlatform };
  }
  return { ok: true, ...post };
}

// src/api/collab-age-attestation.ts
var COLLAB_AGE_ATTESTATION_SCOPE = "once_per_account";
function isCollabAgeAttestationAsked(standingAttestation) {
  return COLLAB_AGE_ATTESTATION_SCOPE === "every_collab" || !standingAttestation;
}

// src/api/discovery-preferences.ts
var SIZE_TARGETS = ["nano", "micro", "mid", "macro"];
var DEFAULT_SIZE_TARGETS = ["nano", "micro"];
var NICHE_VALUES = [
  "mode_fashion",
  "beaute_beauty",
  "food_cuisine",
  "voyage_travel",
  "fitness_sport",
  "lifestyle",
  "famille_parenting",
  "tech_gaming",
  "humour_comedy",
  "business_entrepreneuriat",
  "art_culture",
  "musique_music",
  "education_science",
  "decoration_home",
  "finance_money",
  "sante_wellness",
  "automobile",
  "photographie",
  "animaux_pets",
  "other"
];

// src/api/discovery-search.ts
var DISCOVERY_SIZE_RANGES = [
  { name: "nano", min: 1e3, max: 9999 },
  { name: "micro", min: 1e4, max: 99999 },
  { name: "mid", min: 1e5, max: 499999 },
  { name: "macro", min: 5e5, max: null }
];
var DISCOVERY_SEARCH_ERROR_CODES = {
  INVALID_CURSOR: "E_DISCOVERY_INVALID_CURSOR",
  TIMEOUT: "E_DISCOVERY_TIMEOUT",
  QUOTA_EXCEEDED: "E_DISCOVERY_QUOTA_EXCEEDED",
  UNAVAILABLE: "E_DISCOVERY_UNAVAILABLE"
};

// src/api/mention.ts
var MentionPlatform = /* @__PURE__ */ ((MentionPlatform2) => {
  MentionPlatform2["INSTAGRAM"] = "instagram";
  MentionPlatform2["TIKTOK"] = "tiktok";
  return MentionPlatform2;
})(MentionPlatform || {});
var MentionType = /* @__PURE__ */ ((MentionType2) => {
  MentionType2["STORY"] = "story_mention";
  MentionType2["CAPTION"] = "caption_mention";
  MentionType2["TEMPLATE"] = "template";
  return MentionType2;
})(MentionType || {});
var MentionMediaType = /* @__PURE__ */ ((MentionMediaType2) => {
  MentionMediaType2["IMAGE"] = "IMAGE";
  MentionMediaType2["VIDEO"] = "VIDEO";
  MentionMediaType2["CAROUSEL_ALBUM"] = "CAROUSEL_ALBUM";
  return MentionMediaType2;
})(MentionMediaType || {});
var MentionDriveArchiveStatus = /* @__PURE__ */ ((MentionDriveArchiveStatus2) => {
  MentionDriveArchiveStatus2["IN_PROGRESS"] = "IN_PROGRESS";
  MentionDriveArchiveStatus2["ARCHIVED"] = "ARCHIVED";
  MentionDriveArchiveStatus2["FAILED"] = "FAILED";
  MentionDriveArchiveStatus2["EXPIRED"] = "EXPIRED";
  MentionDriveArchiveStatus2["OPTED_OUT"] = "OPTED_OUT";
  MentionDriveArchiveStatus2["DEDUPLICATED"] = "DEDUPLICATED";
  return MentionDriveArchiveStatus2;
})(MentionDriveArchiveStatus || {});
var MentionDownloadAuditStatus = /* @__PURE__ */ ((MentionDownloadAuditStatus2) => {
  MentionDownloadAuditStatus2["SUCCESS"] = "success";
  MentionDownloadAuditStatus2["FAILED"] = "failed";
  return MentionDownloadAuditStatus2;
})(MentionDownloadAuditStatus || {});
var MentionTrackingStatus = /* @__PURE__ */ ((MentionTrackingStatus2) => {
  MentionTrackingStatus2["ACTIVE"] = "active";
  MentionTrackingStatus2["COLLECTING"] = "collecting";
  MentionTrackingStatus2["TRACKING_STOPPED"] = "tracking_stopped";
  MentionTrackingStatus2["UNSUPPORTED_STORY"] = "unsupported_story";
  MentionTrackingStatus2["UNSUPPORTED_MEDIA"] = "unsupported_media";
  MentionTrackingStatus2["INTEGRATION_DISCONNECTED"] = "integration_disconnected";
  return MentionTrackingStatus2;
})(MentionTrackingStatus || {});
var MentionBoostEligibilityStatus = /* @__PURE__ */ ((MentionBoostEligibilityStatus2) => {
  MentionBoostEligibilityStatus2["BLOCKED"] = "blocked";
  MentionBoostEligibilityStatus2["PERMISSION_NEEDED"] = "permission_needed";
  MentionBoostEligibilityStatus2["PENDING"] = "pending";
  MentionBoostEligibilityStatus2["READY"] = "ready";
  MentionBoostEligibilityStatus2["DECLINED"] = "declined";
  MentionBoostEligibilityStatus2["REVOKED"] = "revoked";
  MentionBoostEligibilityStatus2["EXPIRED"] = "expired";
  MentionBoostEligibilityStatus2["FAILED"] = "failed";
  return MentionBoostEligibilityStatus2;
})(MentionBoostEligibilityStatus || {});
var MentionBoostEligibilityBlockerCode = /* @__PURE__ */ ((MentionBoostEligibilityBlockerCode2) => {
  MentionBoostEligibilityBlockerCode2["UNSUPPORTED_PLATFORM"] = "unsupported_platform";
  MentionBoostEligibilityBlockerCode2["STORY_NOT_BOOSTABLE"] = "story_not_boostable";
  MentionBoostEligibilityBlockerCode2["MEDIA_EXPIRED"] = "media_expired";
  MentionBoostEligibilityBlockerCode2["MEDIA_UNAVAILABLE"] = "media_unavailable";
  MentionBoostEligibilityBlockerCode2["MEDIA_REFERENCE_MISSING"] = "media_reference_missing";
  MentionBoostEligibilityBlockerCode2["INSTAGRAM_INTEGRATION_MISSING"] = "instagram_integration_missing";
  MentionBoostEligibilityBlockerCode2["META_PERMISSIONS_MISSING"] = "meta_permissions_missing";
  MentionBoostEligibilityBlockerCode2["OFFICIAL_META_PATH_UNAVAILABLE"] = "official_meta_path_unavailable";
  return MentionBoostEligibilityBlockerCode2;
})(MentionBoostEligibilityBlockerCode || {});
var MentionBoostAuthorizationScope = /* @__PURE__ */ ((MentionBoostAuthorizationScope2) => {
  MentionBoostAuthorizationScope2["ACCOUNT_LEVEL"] = "account_level";
  MentionBoostAuthorizationScope2["CONTENT_LEVEL"] = "content_level";
  return MentionBoostAuthorizationScope2;
})(MentionBoostAuthorizationScope || {});
var MentionBoostAuthorizationStatus = /* @__PURE__ */ ((MentionBoostAuthorizationStatus2) => {
  MentionBoostAuthorizationStatus2["PENDING"] = "pending";
  MentionBoostAuthorizationStatus2["AUTHORIZED"] = "authorized";
  MentionBoostAuthorizationStatus2["DECLINED"] = "declined";
  MentionBoostAuthorizationStatus2["REVOKED"] = "revoked";
  MentionBoostAuthorizationStatus2["EXPIRED"] = "expired";
  MentionBoostAuthorizationStatus2["FAILED"] = "failed";
  return MentionBoostAuthorizationStatus2;
})(MentionBoostAuthorizationStatus || {});
var MentionBoostAuthorizationSource = /* @__PURE__ */ ((MentionBoostAuthorizationSource2) => {
  MentionBoostAuthorizationSource2["INTERNAL_PREFLIGHT"] = "internal_preflight";
  MentionBoostAuthorizationSource2["PARTNERSHIP_ADS_HUB"] = "partnership_ads_hub";
  MentionBoostAuthorizationSource2["AD_CODE"] = "ad_code";
  MentionBoostAuthorizationSource2["ALLOW_BRAND_PARTNER_TO_BOOST"] = "allow_brand_partner_to_boost";
  MentionBoostAuthorizationSource2["CREATOR_MARKETPLACE"] = "creator_marketplace";
  return MentionBoostAuthorizationSource2;
})(MentionBoostAuthorizationSource || {});
var MentionBoostSetupAudienceMode = /* @__PURE__ */ ((MentionBoostSetupAudienceMode2) => {
  MentionBoostSetupAudienceMode2["ADVANTAGE_PLUS"] = "advantage_plus";
  MentionBoostSetupAudienceMode2["MANUAL"] = "manual";
  return MentionBoostSetupAudienceMode2;
})(MentionBoostSetupAudienceMode || {});
var MentionBoostDestinationType = /* @__PURE__ */ ((MentionBoostDestinationType2) => {
  MentionBoostDestinationType2["PRODUCT_PAGE"] = "product_page";
  MentionBoostDestinationType2["WEBSITE"] = "website";
  return MentionBoostDestinationType2;
})(MentionBoostDestinationType || {});
var MentionBoostPlacementMode = /* @__PURE__ */ ((MentionBoostPlacementMode2) => {
  MentionBoostPlacementMode2["NEW_CAMPAIGN"] = "new_campaign";
  MentionBoostPlacementMode2["EXISTING_CAMPAIGN"] = "existing_campaign";
  return MentionBoostPlacementMode2;
})(MentionBoostPlacementMode || {});
var MentionBoostCampaignObjective = /* @__PURE__ */ ((MentionBoostCampaignObjective2) => {
  MentionBoostCampaignObjective2["SALES"] = "sales";
  MentionBoostCampaignObjective2["TRAFFIC"] = "traffic";
  return MentionBoostCampaignObjective2;
})(MentionBoostCampaignObjective || {});
var MentionBoostCampaignStatus = /* @__PURE__ */ ((MentionBoostCampaignStatus2) => {
  MentionBoostCampaignStatus2["ACTIVE"] = "active";
  MentionBoostCampaignStatus2["PAUSED"] = "paused";
  return MentionBoostCampaignStatus2;
})(MentionBoostCampaignStatus || {});
var MentionBoostCampaignBudgetMode = /* @__PURE__ */ ((MentionBoostCampaignBudgetMode2) => {
  MentionBoostCampaignBudgetMode2["CAMPAIGN"] = "campaign";
  MentionBoostCampaignBudgetMode2["AD_SET"] = "ad_set";
  return MentionBoostCampaignBudgetMode2;
})(MentionBoostCampaignBudgetMode || {});
var MentionBoostTargetLocationType = /* @__PURE__ */ ((MentionBoostTargetLocationType2) => {
  MentionBoostTargetLocationType2["COUNTRY"] = "country";
  return MentionBoostTargetLocationType2;
})(MentionBoostTargetLocationType || {});
var MentionBoostProvider = /* @__PURE__ */ ((MentionBoostProvider2) => {
  MentionBoostProvider2["META"] = "meta";
  MentionBoostProvider2["TIKTOK"] = "tiktok";
  return MentionBoostProvider2;
})(MentionBoostProvider || {});
var MentionBoostDeliveryState = /* @__PURE__ */ ((MentionBoostDeliveryState2) => {
  MentionBoostDeliveryState2["DRAFT"] = "draft";
  MentionBoostDeliveryState2["PUBLISHING"] = "publishing";
  MentionBoostDeliveryState2["ACTIVE"] = "active";
  MentionBoostDeliveryState2["NEEDS_ATTENTION"] = "needs_attention";
  MentionBoostDeliveryState2["FAILED"] = "failed";
  MentionBoostDeliveryState2["STOPPING"] = "stopping";
  MentionBoostDeliveryState2["STOPPED"] = "stopped";
  return MentionBoostDeliveryState2;
})(MentionBoostDeliveryState || {});
var LIVE_MENTION_BOOST_DELIVERY_STATES = [
  "publishing" /* PUBLISHING */,
  "active" /* ACTIVE */,
  "needs_attention" /* NEEDS_ATTENTION */,
  "stopping" /* STOPPING */
];
var MentionBoostLaunchFailureReason = /* @__PURE__ */ ((MentionBoostLaunchFailureReason2) => {
  MentionBoostLaunchFailureReason2["MEDIA_NO_LONGER_BOOSTABLE"] = "media_no_longer_boostable";
  MentionBoostLaunchFailureReason2["AUTHORIZATION_REVOKED"] = "authorization_revoked";
  MentionBoostLaunchFailureReason2["LAUNCH_REJECTED"] = "launch_rejected";
  MentionBoostLaunchFailureReason2["CREATOR_NOT_ELIGIBLE"] = "creator_not_eligible";
  MentionBoostLaunchFailureReason2["CONFIGURATION_ERROR"] = "configuration_error";
  MentionBoostLaunchFailureReason2["INSTAGRAM_RECONNECT_REQUIRED"] = "instagram_reconnect_required";
  MentionBoostLaunchFailureReason2["AD_ACCOUNT_PAYMENT_MISSING"] = "ad_account_payment_missing";
  MentionBoostLaunchFailureReason2["AD_ACCOUNT_DISABLED"] = "ad_account_disabled";
  MentionBoostLaunchFailureReason2["PROVIDER_UNAVAILABLE"] = "provider_unavailable";
  MentionBoostLaunchFailureReason2["PARENT_CAMPAIGN_PAUSED"] = "parent_campaign_paused";
  MentionBoostLaunchFailureReason2["USAGE_RIGHTS_EXPIRED"] = "usage_rights_expired";
  MentionBoostLaunchFailureReason2["UNKNOWN"] = "unknown";
  return MentionBoostLaunchFailureReason2;
})(MentionBoostLaunchFailureReason || {});
var MENTION_BOOST_TREND_MIN_POINTS = 3;
var CO_PUBLICITE_TABLE_SORT_FIELDS = [
  "spend",
  "performance",
  "lastSyncedAt",
  "launchedAt"
];
var MentionBoostReadinessBlockerCode = /* @__PURE__ */ ((MentionBoostReadinessBlockerCode2) => {
  MentionBoostReadinessBlockerCode2["INSTAGRAM_INTEGRATION_MISSING"] = "instagram_integration_missing";
  MentionBoostReadinessBlockerCode2["INSTAGRAM_RECONNECT_REQUIRED"] = "instagram_reconnect_required";
  MentionBoostReadinessBlockerCode2["BOOST_PERMISSIONS_MISSING"] = "boost_permissions_missing";
  MentionBoostReadinessBlockerCode2["META_ADS_NOT_CONNECTED"] = "meta_ads_not_connected";
  MentionBoostReadinessBlockerCode2["AD_ACCOUNT_MISSING"] = "ad_account_missing";
  MentionBoostReadinessBlockerCode2["AD_ACCOUNT_VERIFICATION_FAILED"] = "ad_account_verification_failed";
  MentionBoostReadinessBlockerCode2["AD_ACCOUNT_SELECTION_REQUIRED"] = "ad_account_selection_required";
  MentionBoostReadinessBlockerCode2["AD_ACCOUNT_PAYMENT_MISSING"] = "ad_account_payment_missing";
  MentionBoostReadinessBlockerCode2["AD_ACCOUNT_CURRENCY_MISMATCH"] = "ad_account_currency_mismatch";
  MentionBoostReadinessBlockerCode2["AD_ACCOUNT_DISABLED"] = "ad_account_disabled";
  MentionBoostReadinessBlockerCode2["DSA_BENEFICIARY_MISSING"] = "dsa_beneficiary_missing";
  return MentionBoostReadinessBlockerCode2;
})(MentionBoostReadinessBlockerCode || {});

// src/api/display-rights.ts
var DisplayRightsProposalStatus = /* @__PURE__ */ ((DisplayRightsProposalStatus2) => {
  DisplayRightsProposalStatus2["DRAFT"] = "draft";
  DisplayRightsProposalStatus2["SENT"] = "sent";
  DisplayRightsProposalStatus2["ACCEPTED"] = "accepted";
  DisplayRightsProposalStatus2["DECLINED"] = "declined";
  DisplayRightsProposalStatus2["EXPIRED"] = "expired";
  DisplayRightsProposalStatus2["SUPERSEDED"] = "superseded";
  return DisplayRightsProposalStatus2;
})(DisplayRightsProposalStatus || {});
var DISPLAY_RIGHTS_OPEN_STATUSES = [
  "draft" /* DRAFT */,
  "sent" /* SENT */
];
function isDisplayRightsProposalOpen(status) {
  return DISPLAY_RIGHTS_OPEN_STATUSES.includes(status);
}
function canCarryDisplayRightsTerms(status) {
  return status === "pending" /* PENDING */ || status === "authorized" /* AUTHORIZED */;
}
var DisplayRightsCompensationModel = /* @__PURE__ */ ((DisplayRightsCompensationModel2) => {
  DisplayRightsCompensationModel2["MONTHLY"] = "monthly";
  DisplayRightsCompensationModel2["FLAT"] = "flat";
  return DisplayRightsCompensationModel2;
})(DisplayRightsCompensationModel || {});
var DisplayRightsDeclineReason = /* @__PURE__ */ ((DisplayRightsDeclineReason2) => {
  DisplayRightsDeclineReason2["AMOUNT_TOO_LOW"] = "amount_too_low";
  DisplayRightsDeclineReason2["DURATION_TOO_LONG"] = "duration_too_long";
  DisplayRightsDeclineReason2["SCOPE_TOO_BROAD"] = "scope_too_broad";
  DisplayRightsDeclineReason2["NO_ADS_ON_CONTENT"] = "no_ads_on_content";
  DisplayRightsDeclineReason2["OTHER"] = "other";
  return DisplayRightsDeclineReason2;
})(DisplayRightsDeclineReason || {});
var DisplayRightsDeliveryChannel = /* @__PURE__ */ ((DisplayRightsDeliveryChannel2) => {
  DisplayRightsDeliveryChannel2["CONNECTED_EMAIL"] = "connected_email";
  DisplayRightsDeliveryChannel2["LINK_COPY"] = "link_copy";
  return DisplayRightsDeliveryChannel2;
})(DisplayRightsDeliveryChannel || {});
var DisplayRightsAcceptanceMethod = /* @__PURE__ */ ((DisplayRightsAcceptanceMethod2) => {
  DisplayRightsAcceptanceMethod2["EMAIL_CODE"] = "email_code";
  return DisplayRightsAcceptanceMethod2;
})(DisplayRightsAcceptanceMethod || {});
var DisplayRightsEndReason = /* @__PURE__ */ ((DisplayRightsEndReason2) => {
  DisplayRightsEndReason2["RUN_TIME_ELAPSED"] = "run_time_elapsed";
  DisplayRightsEndReason2["AUTHORIZATION_REVOKED"] = "authorization_revoked";
  return DisplayRightsEndReason2;
})(DisplayRightsEndReason || {});
var DISPLAY_RIGHTS_DEFAULT_EXPIRES_IN_DAYS = 7;
var DISPLAY_RIGHTS_MIN_EXPIRES_IN_DAYS = 1;
var DISPLAY_RIGHTS_MAX_EXPIRES_IN_DAYS = 30;
var DISPLAY_RIGHTS_MIN_DURATION_MONTHS = 1;
var DISPLAY_RIGHTS_MAX_DURATION_MONTHS = 24;
var DISPLAY_RIGHTS_EXPIRY_NOTICE_DAYS = 14;
function displayRightsDaysUntil(rightsEndAt, now = /* @__PURE__ */ new Date()) {
  if (!rightsEndAt) return null;
  const end = rightsEndAt instanceof Date ? rightsEndAt.getTime() : new Date(rightsEndAt).getTime();
  if (!Number.isFinite(end)) return null;
  return Math.ceil((end - now.getTime()) / 864e5);
}
var DISPLAY_RIGHTS_MIN_AMOUNT_CENTS = 1;
var DISPLAY_RIGHTS_MAX_NOTE_LENGTH = 2e3;
var DISPLAY_RIGHTS_LINKS_BASE_PATH = "/display-rights-links";
var DISPLAY_RIGHTS_LINK_SEGMENTS = {
  requestCode: "request-code",
  accept: "accept",
  decline: "decline"
};
function displayRightsLinkPaths(lookupKey) {
  const base = `${DISPLAY_RIGHTS_LINKS_BASE_PATH}/${lookupKey}`;
  return {
    show: base,
    requestCode: `${base}/${DISPLAY_RIGHTS_LINK_SEGMENTS.requestCode}`,
    accept: `${base}/${DISPLAY_RIGHTS_LINK_SEGMENTS.accept}`,
    decline: `${base}/${DISPLAY_RIGHTS_LINK_SEGMENTS.decline}`
  };
}
var DISPLAY_RIGHTS_DASHBOARD_BASE_PATH = "/display-rights";
var DISPLAY_RIGHTS_DASHBOARD_SEGMENTS = {
  proposals: "/proposals",
  revision: "/proposals/:id/revision",
  reminder: "/proposals/:id/reminder",
  composition: "/authorizations/:authorizationId/composition"
};
function displayRightsDashboardPaths(ids) {
  const base = DISPLAY_RIGHTS_DASHBOARD_BASE_PATH;
  return {
    send: `${base}${DISPLAY_RIGHTS_DASHBOARD_SEGMENTS.proposals}`,
    revision: `${base}/proposals/${ids.proposalId}/revision`,
    reminder: `${base}/proposals/${ids.proposalId}/reminder`,
    composition: `${base}/authorizations/${ids.authorizationId}/composition`
  };
}
var DISPLAY_RIGHTS_CODE_LENGTH = 6;
var DISPLAY_RIGHTS_CODE_EXPIRY_MINUTES = 10;
var DISPLAY_RIGHTS_CODE_MAX_ATTEMPTS = 3;
var DISPLAY_RIGHTS_CODE_RESEND_COOLDOWN_SECONDS = 50;
var DisplayRightsEmailChannelBlocker = /* @__PURE__ */ ((DisplayRightsEmailChannelBlocker2) => {
  DisplayRightsEmailChannelBlocker2["NO_CREATOR_EMAIL"] = "no_creator_email";
  DisplayRightsEmailChannelBlocker2["NO_CONNECTED_MAILBOX"] = "no_connected_mailbox";
  return DisplayRightsEmailChannelBlocker2;
})(DisplayRightsEmailChannelBlocker || {});

// src/api/commission.ts
var CommissionStatus = /* @__PURE__ */ ((CommissionStatus2) => {
  CommissionStatus2["PENDING"] = "pending";
  CommissionStatus2["PROCESSING"] = "processing";
  CommissionStatus2["PAID"] = "paid";
  CommissionStatus2["CANCELLED"] = "cancelled";
  return CommissionStatus2;
})(CommissionStatus || {});
var CommissionFeeRegime = /* @__PURE__ */ ((CommissionFeeRegime2) => {
  CommissionFeeRegime2["LEGACY"] = "legacy";
  CommissionFeeRegime2["SUCCESS_FEE"] = "success_fee";
  CommissionFeeRegime2["PARTNER_SUCCESS_FEE"] = "partner_success_fee";
  CommissionFeeRegime2["RECURRING"] = "recurring";
  return CommissionFeeRegime2;
})(CommissionFeeRegime || {});

// src/api/companion-panel.ts
var COMPANION_PAGE_IDS = [
  "dashboard",
  "collabs_tracking",
  "copublicity",
  "ugc",
  "brief_templates",
  "applications",
  "gifting",
  "affiliates",
  "programs",
  "mentions",
  "discovery",
  "flows",
  "other"
];
var COMPANION_PAGE_FILTER_KEYS = {
  dashboard: [],
  collabs_tracking: [],
  copublicity: [],
  ugc: [],
  brief_templates: [],
  applications: [],
  gifting: [],
  affiliates: [],
  programs: [],
  mentions: [],
  discovery: [],
  flows: [],
  other: []
};
var COMPANION_PANEL_QUESTION_MAX_LENGTH = 2e3;
var COMPANION_PANEL_FILTER_MAX_KEYS = 10;
var COMPANION_PANEL_FILTER_VALUE_MAX_LENGTH = 200;

// src/api/dashboard-overview.ts
var DASHBOARD_TODO_SOURCE_KEYS = [
  "applications",
  "ugcDecisions",
  "blockedGifts",
  "owedCommissions"
];
var DASHBOARD_DECISION_SOURCE_KEYS = [
  "ugc",
  "sponsored",
  "gifts",
  "payouts"
];

// src/api/decisions.ts
var UGC_DECISION_GESTURES = [
  "review_contents",
  "fund",
  "shipment_choice",
  "reception_choice"
];
function decisionFromUgcLine(line) {
  const { action } = line;
  if (!action.actionable) return null;
  if (!UGC_DECISION_GESTURES.includes(action.kind)) return null;
  return {
    id: `ugc:${line.collabId}`,
    type: "ugc",
    gesture: action.kind,
    at: action.at,
    count: action.count,
    amountMinorUnits: action.amountMinorUnits,
    currency: action.currency,
    creatorName: line.creatorDisplayName || null,
    subject: line.briefName ?? line.collabName,
    target: { kind: "collab", id: line.collabId }
  };
}

// src/api/contacts.ts
var CONTACT_DRAWER_QUERY_KEYS = {
  contactId: "contactId",
  contactEntry: "contactEntry",
  contactView: "contactView",
  contactPlatform: "contactPlatform",
  contactCollab: "contactCollab",
  contactDeliverable: "contactDeliverable",
  contactAd: "contactAd",
  contactAdCompose: "contactAdCompose",
  contactSourceCreatorId: "contactSourceCreatorId"
};
var CONTACT_PLATFORMS = ["ig", "tiktok"];
var CONTACT_ENTRIES = ["affiliate", "creator", "identity", "source"];
var CREATOR_DISCOVERY_PATH = "/creators/discovery";

// src/api/contract-clause.ts
var CONTRACT_CLAUSE_REGISTRY = {
  /**
   * v1 — pending legal review. Names the law and the court in one breath, in
   * the plainest words a creator can read without a lawyer.
   */
  governing_law_france: {
    1: {
      en: "This agreement is governed by French law. If a disagreement cannot be settled between the parties, the French courts decide.",
      fr: "Ce contrat est soumis au droit fran\xE7ais. \xC0 d\xE9faut d'accord entre les parties, le litige rel\xE8ve des tribunaux fran\xE7ais.",
      it: "Questo contratto \xE8 regolato dal diritto francese. In mancanza di accordo tra le parti, la controversia \xE8 di competenza dei tribunali francesi."
    }
  },
  /**
   * v1 — pending legal review. Deliberately generic: it frames the duration and
   * the channels the brief already carries as structured values, and states
   * none of them. Putting a duration in the wording would turn the same clause
   * into a different clause on every brief.
   */
  content_usage_rights: {
    1: {
      en: "The brand may reuse the content produced for this collaboration only on the channels and for the duration stated in this brief. Any other use requires a new written agreement.",
      fr: "La marque peut r\xE9utiliser les contenus produits pour cette collaboration uniquement sur les canaux et pendant la dur\xE9e indiqu\xE9s dans ce brief. Tout autre usage demande un nouvel accord \xE9crit.",
      it: "Il brand pu\xF2 riutilizzare i contenuti prodotti per questa collaborazione solo sui canali e per la durata indicati in questo brief. Qualsiasi altro utilizzo richiede un nuovo accordo scritto."
    }
  },
  /**
   * The delay is written into the sentence on purpose: a per-brief field no
   * interface sets would be dead structure always carrying its default.
   * Changing the delay is a new version, which is exactly the traceability we
   * want. v1 said fourteen days and stays on the briefs that showed it; v2 says
   * seven, the delay the product enforces since payment moved to the acceptance
   * (tacit validation seven days after the content is recorded), validated by
   * counsel on 9 September 2026.
   */
  deliverable_tacit_approval: {
    1: {
      en: "The brand has 14 days to review each deliverable. Without an answer within those 14 days, the deliverable is considered approved.",
      fr: "La marque dispose de 14 jours pour examiner chaque livrable. Sans r\xE9ponse dans ce d\xE9lai, le livrable est consid\xE9r\xE9 comme valid\xE9.",
      it: "Il brand ha 14 giorni per esaminare ogni contenuto consegnato. In assenza di risposta entro tale termine, il contenuto si considera approvato."
    },
    2: {
      en: "The brand has 7 days to review each deliverable once its content is recorded. Without an answer within those 7 days, the deliverable is considered approved.",
      fr: "La marque dispose de 7 jours pour examiner chaque livrable \xE0 compter de l'enregistrement de son contenu. Sans r\xE9ponse dans ce d\xE9lai, le livrable est consid\xE9r\xE9 comme valid\xE9.",
      it: "Il brand ha 7 giorni per esaminare ogni contenuto consegnato a partire dalla sua registrazione. In assenza di risposta entro tale termine, il contenuto si considera approvato."
    }
  },
  /**
   * v1, pending legal review: the UGC flag stays closed until counsel signs
   * this wording off. A UGC content is a file the brand reviews, not a post, and
   * the product holds it to 72 hours from the moment its preview is ready
   * (`UGC_TACIT_VALIDATION_HOURS`), so a UGC brief seals this clause in place of
   * the seven-day `deliverable_tacit_approval`. Same structure as that one: the
   * delay in the sentence, a new delay a new version.
   */
  ugc_tacit_approval: {
    1: {
      en: "The brand has 72 hours from the moment the content preview is ready to review each content. Without an answer within those 72 hours, the content is considered validated.",
      fr: "La marque dispose de 72 heures \xE0 partir du moment o\xF9 l'aper\xE7u du contenu est pr\xEAt pour examiner chaque contenu. Sans r\xE9ponse dans ce d\xE9lai, le contenu est consid\xE9r\xE9 comme valid\xE9.",
      it: "Il brand ha 72 ore dal momento in cui l'anteprima del contenuto \xE8 pronta per esaminare ogni contenuto. In assenza di risposta entro tale termine, il contenuto si considera convalidato."
    }
  },
  /**
   * v1, pending legal review: the UGC flag stays closed until counsel signs
   * this wording off. The rights of a UGC brief, which a creator grants on her
   * own image and voice, so the clause names its whole frame: channels,
   * duration counted from each content's validation, territory and media,
   * the adaptations allowed, no exclusivity, and how the fixed payment splits
   * between organic use and ads when ads are granted.
   *
   * Unlike the clauses above it carries placeholders, filled from the sealed
   * content by `contractClauseSentence`: the values are covered by the content
   * fingerprint, the sentence around them by this version. The fragments the
   * placeholders take are frozen with it, in `UGC_USAGE_RIGHTS_CLAUSE_TERMS`.
   */
  ugc_usage_rights: {
    1: {
      en: "The creator authorises the brand, without exclusivity, to use each content delivered for this collaboration, including the creator's image and voice as they appear in it, {{channels}}, worldwide and on digital media, for {{months}} months from the validation of each content. The brand may adapt the content: cropping, editing, subtitles, added text and logo, excerpts.{{adsSplit}}",
      fr: "Le cr\xE9ateur autorise la marque, sans exclusivit\xE9, \xE0 utiliser chaque contenu livr\xE9 pour cette collaboration, y compris son image et sa voix telles qu'elles y figurent, {{channels}}, dans le monde entier et sur supports num\xE9riques, pendant {{months}} mois \xE0 compter de la validation de chaque contenu. La marque peut adapter le contenu : recadrage, montage, sous-titres, ajout de texte et de logo, extraits.{{adsSplit}}",
      it: "Il creator autorizza il brand, senza esclusiva, a utilizzare ogni contenuto consegnato per questa collaborazione, compresi la sua immagine e la sua voce cos\xEC come vi compaiono, {{channels}}, in tutto il mondo e sui supporti digitali, per {{months}} mesi dalla convalida di ciascun contenuto. Il brand pu\xF2 adattare il contenuto: ritaglio, montaggio, sottotitoli, aggiunta di testo e di logo, estratti.{{adsSplit}}"
    }
  }
};
var UGC_USAGE_RIGHTS_CLAUSE_TERMS = {
  1: {
    en: {
      channels: {
        organic: "on its organic channels",
        paid_ads: "in paid advertising",
        organic_and_paid_ads: "on its organic channels and in paid advertising"
      },
      adsSplit: " The fixed payment is split into {{organic}} for organic use and {{ads}} for ads."
    },
    fr: {
      channels: {
        organic: "sur ses canaux organiques",
        paid_ads: "en publicit\xE9 payante",
        organic_and_paid_ads: "sur ses canaux organiques et en publicit\xE9 payante"
      },
      adsSplit: " Le paiement fixe se r\xE9partit en {{organic}} pour l'usage organique et {{ads}} pour la publicit\xE9."
    },
    it: {
      channels: {
        organic: "sui propri canali organici",
        paid_ads: "nella pubblicit\xE0 a pagamento",
        organic_and_paid_ads: "sui propri canali organici e nella pubblicit\xE0 a pagamento"
      },
      adsSplit: " Il pagamento fisso si ripartisce in {{organic}} per l'uso organico e {{ads}} per la pubblicit\xE0."
    }
  }
};
var CURRENT_CONTRACT_CLAUSES = [
  { key: "content_usage_rights", version: 1 },
  { key: "deliverable_tacit_approval", version: 2 },
  { key: "governing_law_france", version: 1 }
];
var CURRENT_UGC_CONTRACT_CLAUSES = [
  { key: "ugc_usage_rights", version: 1 },
  { key: "ugc_tacit_approval", version: 1 },
  { key: "governing_law_france", version: 1 }
];
function contractClauseSentence(clause, language = "en", facts) {
  if (!clause) return null;
  const versions = CONTRACT_CLAUSE_REGISTRY[clause.key];
  if (!versions) return null;
  const wording = versions[clause.version];
  if (!wording) return null;
  const sentence = wording[language] ?? wording.en;
  if (clause.key !== "ugc_usage_rights") return sentence;
  const terms = UGC_USAGE_RIGHTS_CLAUSE_TERMS[clause.version];
  if (!terms || !facts) return null;
  return fillUgcUsageRights(sentence, terms[language] ?? terms.en, facts, language);
}
function fillUgcUsageRights(sentence, terms, facts, language) {
  const { durationMonths, channels } = facts.usageRights;
  const channelsKey = clauseChannels(channels);
  if (durationMonths === null || !channelsKey) return null;
  let adsSplit = "";
  if (channels.includes("paid_ads")) {
    const fixedPayment = facts.compensation.fixedPayment;
    const split = ugcRightsPriceSplit(fixedPayment?.amountCents, facts.usageRights.adsShareCents);
    if (!split || !fixedPayment) return null;
    adsSplit = terms.adsSplit.replace("{{organic}}", clauseAmount(split.organicCents, fixedPayment.currency, language)).replace("{{ads}}", clauseAmount(split.adsCents, fixedPayment.currency, language));
  }
  return sentence.replace("{{channels}}", terms.channels[channelsKey]).replace("{{months}}", String(durationMonths)).replace("{{adsSplit}}", adsSplit);
}
function clauseChannels(channels) {
  const organic = channels.includes("organic");
  const ads = channels.includes("paid_ads");
  if (organic && ads) return "organic_and_paid_ads";
  if (organic) return "organic";
  if (ads) return "paid_ads";
  return null;
}
var CLAUSE_LOCALES = {
  en: "en-GB",
  fr: "fr-FR",
  it: "it-IT"
};
function clauseAmount(cents, currency, language) {
  const whole = cents % 100 === 0;
  const amount = new Intl.NumberFormat(CLAUSE_LOCALES[language], {
    minimumFractionDigits: whole ? 0 : 2,
    maximumFractionDigits: whole ? 0 : 2
  }).format(cents / 100);
  return `${amount} ${currency.trim().toUpperCase()}`;
}

// src/api/integration.ts
var PlatformEnum = /* @__PURE__ */ ((PlatformEnum2) => {
  PlatformEnum2["Instagram"] = "instagram";
  PlatformEnum2["TikTok"] = "tiktok";
  PlatformEnum2["Shopify"] = "shopify";
  PlatformEnum2["Gmail"] = "gmail";
  PlatformEnum2["Outlook"] = "outlook";
  PlatformEnum2["GoogleDrive"] = "google_drive";
  PlatformEnum2["MetaAds"] = "meta_ads";
  return PlatformEnum2;
})(PlatformEnum || {});
var DRIVE_SHARE_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// src/api/creator-hub-messaging.ts
var ConversationChannelType = {
  INSTAGRAM: "instagram",
  TIKTOK: "tiktok",
  EMAIL: "email",
  NATIVE_APP: "native_app"
};
var ConversationChannelTypeValues = Object.values(
  ConversationChannelType
);
var ConversationChannelExternalPlatform = {
  [ConversationChannelType.INSTAGRAM]: "instagram" /* Instagram */,
  [ConversationChannelType.TIKTOK]: "tiktok" /* TikTok */,
  [ConversationChannelType.EMAIL]: null,
  [ConversationChannelType.NATIVE_APP]: null
};
var CreatorHubCapabilityReason = {
  NOT_AUTHORIZED: "not_authorized",
  BLOCKED: "blocked",
  ARCHIVED: "archived",
  CHANNEL_UNAVAILABLE: "channel_unavailable",
  ALREADY_IN_STATE: "already_in_state"
};
var CreatorHubConversationSide = {
  BRAND: "brand",
  CREATOR: "creator"
};
var CreatorHubConversationRelationshipKind = {
  AFFILIATION: "affiliation",
  COLLAB: "collab",
  /** An open sponsored proposal the creator has not answered yet. */
  PROPOSAL: "proposal"
};
var ConversationAwaitNature = {
  /** A deliverable of an accepted collab, due and not yet submitted. */
  DELIVERABLE_DUE: "deliverable_due"
};
var ConversationAwaitNatureValues = Object.values(
  ConversationAwaitNature
);
var CreatorHubFeedItemType = {
  MESSAGE: "message",
  SYSTEM_EVENT: "system_event"
};
var CreatorHubFeedItemTypeValues = Object.values(
  CreatorHubFeedItemType
);
var CreatorHubSystemEventName = {
  CONVERSATION_CREATED: "conversation_created",
  CONVERSATION_ARCHIVED: "conversation_archived",
  CONVERSATION_UNARCHIVED: "conversation_unarchived",
  CONVERSATION_BLOCKED: "conversation_blocked",
  CONVERSATION_UNBLOCKED: "conversation_unblocked",
  CHANNEL_CHANGED: "channel_changed",
  /**
   * Brand-side only, and deliberately absent from
   * `CreatorHubSystemEventFeedItem` below: a mention marker carries no channel,
   * while every creator hub feed item is required to carry one. The creator
   * does not need his own app to tell him he posted.
   */
  MENTION_RECEIVED: "mention_received",
  /**
   * The two collaboration facts the thread registers. Unlike the mention, both
   * are seen by both parties at the same moment, so both carry the couple's
   * native channel — without one the creator app drops them silently.
   */
  COLLAB_BRIEF_ACCEPTED: "collab_brief_accepted",
  COLLAB_PAYMENT_DUE: "collab_payment_due",
  /**
   * The moments of a gift, written by the gifting rail, seen by both parties.
   * One marker per shipment and moment: a collaboration can carry several gifts
   * over time. Withdrawn means the brand cancelled an offer never shipped.
   */
  GIFT_OFFERED: "gift_offered",
  GIFT_CLAIMED: "gift_claimed",
  GIFT_SHIPPED: "gift_shipped",
  GIFT_DELIVERED: "gift_delivered",
  GIFT_EXPIRED: "gift_expired",
  GIFT_WITHDRAWN: "gift_withdrawn",
  /**
   * The proposal a question was asked about, written once per conversation and
   * collab at the first question. Seen by both parties.
   */
  COLLAB_PROPOSED: "collab_proposed",
  /**
   * A signed-up creator applied to one of the brand's briefs, or to one of its
   * programs from the portal. Written once per application, seen by both
   * parties: an application is not an accepted collaboration.
   */
  BRIEF_APPLICATION_SUBMITTED: "brief_application_submitted",
  PROGRAM_APPLICATION_SUBMITTED: "program_application_submitted",
  /**
   * Fluenceur asks the creator whether the product of a UGC collab arrived, five,
   * seven and ten days after it shipped. The one marker that waits for an
   * answer: the creator answers it in place, the brand reads it.
   */
  PRODUCT_RECEPTION_QUESTION: "product_reception_question",
  /**
   * The creator's silence stood in for the reception of a UGC product on the
   * fourteenth day: « Réception comptée le … », written once per collab and
   * shipment. Seen by both parties.
   */
  PRODUCT_RECEPTION_COUNTED: "product_reception_counted"
};
var CREATOR_HUB_MESSAGE_MAX_CHARACTERS = 4e3;
var ConversationAttachmentKind = {
  IMAGE: "image",
  DOCUMENT: "document"
};
var MEGABYTE2 = 1024 * 1024;
var CONVERSATION_ATTACHMENT_RULES = {
  image: {
    maxBytes: 5 * MEGABYTE2,
    mimeTypes: ["image/jpeg", "image/png", "image/webp"]
  },
  document: {
    maxBytes: 8 * MEGABYTE2,
    mimeTypes: ["application/pdf"]
  }
};
function conversationAttachmentKindOf(mimeType) {
  const normalized = mimeType.trim().toLowerCase();
  for (const kind of Object.values(ConversationAttachmentKind)) {
    if (CONVERSATION_ATTACHMENT_RULES[kind].mimeTypes.includes(normalized)) {
      return kind;
    }
  }
  return null;
}
var CreatorHubRealtimeEventName = {
  CONVERSATION_UPDATED: "creator_hub.conversation.updated"
};
var CreatorHubReportReason = {
  SPAM: "spam",
  HARASSMENT: "harassment",
  INAPPROPRIATE_CONTENT: "inappropriate_content",
  OTHER: "other"
};

// src/api/conversation.ts
var DM_MAX_CHARACTERS = 1e3;
function conversationMessageMaxCharacters(channelType) {
  return channelType === ConversationChannelType.NATIVE_APP ? CREATOR_HUB_MESSAGE_MAX_CHARACTERS : DM_MAX_CHARACTERS;
}
function countMessageCharacters(content) {
  return Array.from(content).length;
}
var MessagingMethod = /* @__PURE__ */ ((MessagingMethod2) => {
  MessagingMethod2["DIRECT_MESSAGE"] = "direct_message";
  MessagingMethod2["COMMENT"] = "comment";
  return MessagingMethod2;
})(MessagingMethod || {});
var MessageTypeEnum = /* @__PURE__ */ ((MessageTypeEnum2) => {
  MessageTypeEnum2["TEXT"] = "text";
  MessageTypeEnum2["STORY_MENTION"] = "story_mention";
  MessageTypeEnum2["CAPTION_MENTION"] = "caption_mention";
  MessageTypeEnum2["INVITATION"] = "invitation";
  MessageTypeEnum2["EMAIL"] = "email";
  MessageTypeEnum2["ATTACHMENT"] = "attachment";
  return MessageTypeEnum2;
})(MessageTypeEnum || {});
var MENTION_MESSAGE_TYPES = [
  "story_mention" /* STORY_MENTION */,
  "caption_mention" /* CAPTION_MENTION */
];
var DashboardConversationFeedItemType = {
  MESSAGE: "message",
  SYSTEM_EVENT: "system_event"
};
var DashboardConversationSystemEventNames = [
  CreatorHubSystemEventName.CONVERSATION_CREATED,
  CreatorHubSystemEventName.CONVERSATION_ARCHIVED,
  CreatorHubSystemEventName.CONVERSATION_UNARCHIVED,
  CreatorHubSystemEventName.CONVERSATION_BLOCKED,
  CreatorHubSystemEventName.CONVERSATION_UNBLOCKED,
  CreatorHubSystemEventName.CHANNEL_CHANGED,
  CreatorHubSystemEventName.MENTION_RECEIVED,
  CreatorHubSystemEventName.COLLAB_BRIEF_ACCEPTED,
  CreatorHubSystemEventName.COLLAB_PAYMENT_DUE,
  CreatorHubSystemEventName.COLLAB_PROPOSED,
  CreatorHubSystemEventName.BRIEF_APPLICATION_SUBMITTED,
  CreatorHubSystemEventName.PROGRAM_APPLICATION_SUBMITTED,
  CreatorHubSystemEventName.GIFT_OFFERED,
  CreatorHubSystemEventName.GIFT_CLAIMED,
  CreatorHubSystemEventName.GIFT_SHIPPED,
  CreatorHubSystemEventName.GIFT_DELIVERED,
  CreatorHubSystemEventName.GIFT_EXPIRED,
  CreatorHubSystemEventName.GIFT_WITHDRAWN,
  CreatorHubSystemEventName.PRODUCT_RECEPTION_QUESTION,
  CreatorHubSystemEventName.PRODUCT_RECEPTION_COUNTED
];
var isCreatorParticipant = (participant) => {
  return participant?.type === "creator";
};
var isAffiliateParticipant = (participant) => {
  return participant?.type === "affiliate";
};
var EMAIL_SOURCE = {
  FLOW: "flow",
  OUTREACH: "outreach"
};

// src/api/creator-hub-onboarding.ts
var CREATOR_HUB_CONTENT_FORMAT_VALUES = [
  "instagram_reel",
  "instagram_story",
  "instagram_post",
  "tiktok_video",
  "ugc"
];
var CREATOR_HUB_CONTENT_LANGUAGE_VALUES = [
  "fr",
  "en",
  "es",
  "it",
  "de"
];
var CREATOR_HUB_OPPORTUNITY_INTEREST_VALUES = [
  "paid_collaboration",
  "affiliation",
  "gifting",
  "ugc"
];
var CREATOR_HUB_AVAILABILITY_VALUES = [
  "available",
  "unavailable"
];
var CREATOR_HUB_ONBOARDING_STEP_VALUES = [
  "profile",
  "sectors",
  "socials",
  "activity",
  "payout",
  "complete"
];
var CREATOR_HUB_SECTOR_VALUES = [
  "fashion",
  "beauty",
  "fitness",
  "technology",
  "travel",
  "food_drink",
  "automotive",
  "home_garden",
  "family",
  "entertainment",
  "education",
  "lifestyle",
  "health"
];

// src/api/creator-hub-payouts.ts
var CREATOR_HUB_WITHDRAWAL_ARRIVAL_NOTICES = ["few_business_days"];
var CREATOR_HUB_WITHDRAWAL_FAILURE_REASONS = [
  "provider_unavailable",
  "account_not_ready",
  "destination_missing",
  "amount_below_minimum",
  "balance_insufficient",
  "unknown"
];

// src/api/creator-hub-push.ts
var CreatorHubPushEnvironmentValues = ["development", "preview", "production"];
var CreatorHubPushMessageVersion = 2;
var CreatorHubPushMessageType = "creator-hub.inbox.message";
var CreatorHubPushCollabProposalVersion = 2;
var CreatorHubPushCollabProposalType = "creator-hub.collab.proposal";
var CreatorHubPushWalletVersion = 2;
var CreatorHubPushWalletType = "creator-hub.wallet";
var CreatorHubPushWithdrawalVersion = 2;
var CreatorHubPushWithdrawalType = "creator-hub.wallet.withdrawal";
var CreatorHubPushCollabMomentVersion = 1;
var CreatorHubPushCollabMomentType = "creator-hub.collab.moment";
var CreatorHubPushGiftVersion = 1;
var CreatorHubPushGiftType = "creator-hub.gift";
var CreatorHubPushDeadlineVersion = 1;
var CreatorHubPushDeadlineType = "creator-hub.collab.deadline";
var CreatorHubPushApplicationVersion = 1;
var CreatorHubPushApplicationType = "creator-hub.application";
var CreatorHubPushOpportunityVersion = 1;
var CreatorHubPushOpportunityType = "creator-hub.opportunity";
var CREATOR_HUB_COLLAB_MOMENTS = [
  /** The brand paid: the collab starts and the deadlines begin to run. */
  "funds_secured",
  /** The window closed without a payment. Terminal. */
  "unfunded",
  /** The window is frozen because the brand is blocked by its bank. */
  "funding_delayed",
  /** A deliverable was sent back, with the brand's reason. */
  "deliverable_rejected",
  /** The third rejection is spent: the brand must validate or open a dispute. */
  "deliverable_rejections_exhausted",
  /** Seven days without an answer: the deliverable is validated. */
  "deliverable_tacitly_validated",
  /** The brand decided at the end deadline: extension, closure, cancellation or dispute. */
  "end_deadline_decided",
  /** Fluenceur is looking at the collab. */
  "dispute_opened",
  /** Fluenceur decided, with the written motivation. */
  "dispute_resolved",
  /** The collab ended before it closed. */
  "cancelled",
  /** The payment went back to the brand for want of a payout account. */
  "payment_refunded_to_brand",
  /** The brand's bank took the money back: the collab is cancelled. */
  "bank_dispute_lost",
  /** The brand's bank is reclaiming the payment: the collab is suspended. */
  "bank_dispute_suspended",
  /** The brand's bank gave up: the collab resumes, with its new dates. */
  "bank_dispute_resumed",
  /**
   * The brand validated a deliverable explicitly. Sent to web devices only
   * until a native build knows it.
   */
  "deliverable_validated",
  /**
   * UGC: asked five, seven and ten days after the shipment whether the product
   * arrived. Web devices only until a native build knows it.
   */
  "product_reception_question",
  /**
   * UGC: fourteen days after the shipment without an answer, the product counts
   * as received and the deadlines start. Web devices only, like the question.
   */
  "product_reception_assumed",
  /**
   * UGC: the product left the shop, and the creator is asked to say when it
   * arrives. Once per collab, whatever the shop reports next. Web devices only.
   */
  "product_shipped",
  /**
   * UGC: the shop says the product was delivered, so the deadlines start with
   * their dates. Web devices only, like the other reception moments.
   */
  "product_delivered"
];
function isCreatorHubCollabMoment(value) {
  return typeof value === "string" && CREATOR_HUB_COLLAB_MOMENTS.includes(value);
}
var creatorHubAffiliationCollabIdPrefix = "chc_v1_";
var creatorHubContractualCollabIdPrefix = "chc_v2_";
var creatorHubBase64UrlPattern = /^[A-Za-z0-9_-]+$/;
var creatorHubUuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
function decodeCreatorHubContractualCollabId(value) {
  return decodeCreatorHubPrefixedUuid(value, creatorHubContractualCollabIdPrefix);
}
function decodeCreatorHubAffiliationCollabId(value) {
  return decodeCreatorHubPrefixedUuid(value, creatorHubAffiliationCollabIdPrefix);
}
function decodeCreatorHubPrefixedUuid(value, prefix) {
  if (typeof value !== "string" || !value.startsWith(prefix)) {
    return null;
  }
  const encoded = value.slice(prefix.length);
  if (encoded.length !== 48 || !creatorHubBase64UrlPattern.test(encoded)) return null;
  let decoded = "";
  for (let index = 0; index < encoded.length; index += 4) {
    const first = base64UrlValue(encoded[index]);
    const second = base64UrlValue(encoded[index + 1]);
    const third = base64UrlValue(encoded[index + 2]);
    const fourth = base64UrlValue(encoded[index + 3]);
    if (first < 0 || second < 0 || third < 0 || fourth < 0) return null;
    decoded += String.fromCharCode(
      first << 2 | second >> 4,
      (second & 15) << 4 | third >> 2,
      (third & 3) << 6 | fourth
    );
  }
  return creatorHubUuidPattern.test(decoded) ? decoded : null;
}
function base64UrlValue(value) {
  if (value >= "A" && value <= "Z") return value.charCodeAt(0) - 65;
  if (value >= "a" && value <= "z") return value.charCodeAt(0) - 71;
  if (value >= "0" && value <= "9") return value.charCodeAt(0) + 4;
  if (value === "-") return 62;
  if (value === "_") return 63;
  return -1;
}
var CREATOR_HUB_PUSH_CATEGORIES = [
  "messages",
  "proposals",
  "gifts",
  "deadlines",
  "payments"
];

// src/api/creator-notifications.ts
var CREATOR_NOTIFICATIONS_DEFAULT_LIMIT = 30;
var CREATOR_NOTIFICATIONS_MAX_LIMIT = 50;

// src/api/creator.ts
var CreatorStatus = /* @__PURE__ */ ((CreatorStatus2) => {
  CreatorStatus2["NOT_CONTACTED"] = "not contacted";
  CreatorStatus2["CONTACTED"] = "contacted";
  CreatorStatus2["ENROLLED"] = "enrolled";
  CreatorStatus2["INACTIVE"] = "inactive";
  CreatorStatus2["UNKNOWN"] = "unknown";
  return CreatorStatus2;
})(CreatorStatus || {});

// src/api/creator-hub-profile-settings.ts
var CREATOR_HUB_LANGUAGE_VALUES = ["en", "fr", "it"];
var CREATOR_HUB_NAME_MAX_LENGTH = 100;

// src/api/creator-signals.ts
var CREATOR_GROWTH_DAYS = [90, 180, 365];
var DEFAULT_CREATOR_GROWTH_DAYS = 180;

// src/api/creator-hub-social.ts
var CREATOR_HUB_SOCIAL_PLATFORMS = ["instagram", "tiktok"];
var CREATOR_HUB_SOCIAL_OAUTH_RESULTS = [
  "connected",
  "cancelled",
  "conflict",
  "ineligible",
  "insufficient_scopes",
  "failed"
];

// src/api/errors.ts
var ErrorCode = /* @__PURE__ */ ((ErrorCode2) => {
  ErrorCode2["E_AFFILIATE_MEMBERSHIP_CHANGED"] = "E_AFFILIATE_MEMBERSHIP_CHANGED";
  ErrorCode2["E_AFFILIATE_REMOVED"] = "E_AFFILIATE_REMOVED";
  ErrorCode2["E_CREATOR_OPPORTUNITY_UNAVAILABLE"] = "E_CREATOR_OPPORTUNITY_UNAVAILABLE";
  ErrorCode2["E_VALIDATION_ERROR"] = "E_VALIDATION_ERROR";
  ErrorCode2["E_TRACKING_EVENT_INVALID"] = "E_TRACKING_EVENT_INVALID";
  ErrorCode2["E_INSTAGRAM_RECONNECT_REQUIRED"] = "E_INSTAGRAM_RECONNECT_REQUIRED";
  ErrorCode2["E_CREATOR_REFERRAL_INVITATION_INVALID"] = "E_CREATOR_REFERRAL_INVITATION_INVALID";
  ErrorCode2["E_CREATOR_REFERRAL_INVITATION_BLOCKED"] = "E_CREATOR_REFERRAL_INVITATION_BLOCKED";
  ErrorCode2["E_CREATOR_REFERRAL_NUDGE_UNAVAILABLE"] = "E_CREATOR_REFERRAL_NUDGE_UNAVAILABLE";
  ErrorCode2["E_CREATOR_HANDOFF_EXPIRED"] = "E_CREATOR_HANDOFF_EXPIRED";
  ErrorCode2["E_CREATOR_HANDOFF_NOT_FOUND"] = "E_CREATOR_HANDOFF_NOT_FOUND";
  ErrorCode2["E_CREATOR_HANDOFF_ANOTHER_ACCOUNT"] = "E_CREATOR_HANDOFF_ANOTHER_ACCOUNT";
  ErrorCode2["E_CREATOR_HANDOFF_SOURCE_REQUIRED"] = "E_CREATOR_HANDOFF_SOURCE_REQUIRED";
  ErrorCode2["E_CREATOR_REFERRAL_UNAVAILABLE"] = "E_CREATOR_REFERRAL_UNAVAILABLE";
  ErrorCode2["E_MCP_REVIEW_CHANGED"] = "E_MCP_REVIEW_CHANGED";
  ErrorCode2["E_MCP_AUTHORIZATION_INVALID"] = "E_MCP_AUTHORIZATION_INVALID";
  ErrorCode2["E_MCP_ACCESS_DENIED"] = "E_MCP_ACCESS_DENIED";
  ErrorCode2["E_MCP_GROWTH_REQUIRED"] = "E_MCP_GROWTH_REQUIRED";
  ErrorCode2["E_MCP_CONNECTION_NOT_FOUND"] = "E_MCP_CONNECTION_NOT_FOUND";
  ErrorCode2["E_MCP_ORGANIZATION_CONTEXT_REQUIRED"] = "E_MCP_ORGANIZATION_CONTEXT_REQUIRED";
  ErrorCode2["E_MCP_TEMPORARILY_UNAVAILABLE"] = "E_MCP_TEMPORARILY_UNAVAILABLE";
  ErrorCode2["E_MCP_DISABLED"] = "E_MCP_DISABLED";
  ErrorCode2["E_PROGRAM_SETTINGS_INVALID"] = "E_PROGRAM_SETTINGS_INVALID";
  ErrorCode2["E_RECURRING_COMMISSION_NOT_FOUND"] = "E_RECURRING_COMMISSION_NOT_FOUND";
  ErrorCode2["E_RECURRING_COMMISSION_REJECTION_REASON_REQUIRED"] = "E_RECURRING_COMMISSION_REJECTION_REASON_REQUIRED";
  ErrorCode2["E_RECURRING_COMMISSION_ALREADY_DECIDED"] = "E_RECURRING_COMMISSION_ALREADY_DECIDED";
  ErrorCode2["E_RECURRING_PROGRAM_DISABLED"] = "E_RECURRING_PROGRAM_DISABLED";
  ErrorCode2["E_RECURRING_POLICY_REQUIRED"] = "E_RECURRING_POLICY_REQUIRED";
  ErrorCode2["E_RECURRING_POLICY_STALE"] = "E_RECURRING_POLICY_STALE";
  ErrorCode2["E_RECURRING_POLICY_UNAVAILABLE"] = "E_RECURRING_POLICY_UNAVAILABLE";
  ErrorCode2["E_RECURRING_RELATIONSHIP_INVALID"] = "E_RECURRING_RELATIONSHIP_INVALID";
  ErrorCode2["E_RECURRING_MEMBERSHIP_BATCH_LIMIT"] = "E_RECURRING_MEMBERSHIP_BATCH_LIMIT";
  ErrorCode2["E_ANNOUNCEMENT_NOT_FOUND"] = "E_ANNOUNCEMENT_NOT_FOUND";
  ErrorCode2["E_ANNOUNCEMENT_VISUAL_INVALID"] = "E_ANNOUNCEMENT_VISUAL_INVALID";
  ErrorCode2["E_ANNOUNCEMENT_VISUAL_TOO_LARGE"] = "E_ANNOUNCEMENT_VISUAL_TOO_LARGE";
  ErrorCode2["E_ANNOUNCEMENT_VISUAL_UPLOAD_FAILED"] = "E_ANNOUNCEMENT_VISUAL_UPLOAD_FAILED";
  ErrorCode2["E_ANNOUNCEMENT_VISUAL_NOT_FOUND"] = "E_ANNOUNCEMENT_VISUAL_NOT_FOUND";
  ErrorCode2["E_ANNOUNCEMENT_VISUAL_IN_USE"] = "E_ANNOUNCEMENT_VISUAL_IN_USE";
  ErrorCode2["E_NO_PLATFORM_DETAILS_FOUND"] = "E_NO_PLATFORM_DETAILS_FOUND";
  ErrorCode2["E_MESSAGE_THREAD_CREATE_FAILED"] = "E_MESSAGE_THREAD_CREATE_FAILED";
  ErrorCode2["E_INTEGRATION_NOT_FOUND"] = "E_INTEGRATION_NOT_FOUND";
  ErrorCode2["E_CREATOR_CREATE_FAILED"] = "E_CREATOR_CREATE_FAILED";
  ErrorCode2["E_USER_INFO_FETCH_FAILED"] = "E_USER_INFO_FETCH_FAILED";
  ErrorCode2["E_INVALID_WEBHOOK_PAYLOAD"] = "E_INVALID_WEBHOOK_PAYLOAD";
  ErrorCode2["E_MISSING_REQUIRED_FIELD"] = "E_MISSING_REQUIRED_FIELD";
  ErrorCode2["E_INVALID_STATUS"] = "E_INVALID_STATUS";
  ErrorCode2["E_HANDLING_ERROR"] = "E_HANDLING_ERROR";
  ErrorCode2["E_INVALID_QUERY_PARAMS"] = "E_INVALID_QUERY_PARAMS";
  ErrorCode2["E_TEMPLATE_NOT_FOUND"] = "E_TEMPLATE_NOT_FOUND";
  ErrorCode2["E_TEMPLATE_COMPILATION_FAILED"] = "E_TEMPLATE_COMPILATION_FAILED";
  ErrorCode2["E_MESSAGE_TOO_LONG"] = "E_MESSAGE_TOO_LONG";
  ErrorCode2["E_AUTHENTICATION_ERROR"] = "E_AUTHENTICATION_ERROR";
  ErrorCode2["E_OTP_INVALID"] = "E_OTP_INVALID";
  ErrorCode2["E_OTP_EXPIRED"] = "E_OTP_EXPIRED";
  ErrorCode2["E_OTP_ALREADY_USED"] = "E_OTP_ALREADY_USED";
  ErrorCode2["E_OTP_MAX_ATTEMPTS"] = "E_OTP_MAX_ATTEMPTS";
  ErrorCode2["E_OTP_RATE_LIMIT"] = "E_OTP_RATE_LIMIT";
  ErrorCode2["E_MISSING_AUTHORIZATION"] = "E_MISSING_AUTHORIZATION";
  ErrorCode2["E_INTERNAL_SERVER_ERROR"] = "E_INTERNAL_SERVER_ERROR";
  ErrorCode2["E_NETWORK_ERROR"] = "E_NETWORK_ERROR";
  ErrorCode2["E_INVALID_CREDENTIALS"] = "E_INVALID_CREDENTIALS";
  ErrorCode2["E_NOT_FOUND"] = "E_NOT_FOUND";
  ErrorCode2["E_MEDIA_NOT_FOUND"] = "E_MEDIA_NOT_FOUND";
  ErrorCode2["E_FORBIDDEN"] = "E_FORBIDDEN";
  ErrorCode2["E_SHOPIFY_ERROR"] = "E_SHOPIFY_ERROR";
  ErrorCode2["E_SHOPIFY_FREE_APPROVAL_REQUIRED"] = "E_SHOPIFY_FREE_APPROVAL_REQUIRED";
  ErrorCode2["E_SHOPIFY_FREE_APPROVAL_CONFIGURATION_INVALID"] = "E_SHOPIFY_FREE_APPROVAL_CONFIGURATION_INVALID";
  ErrorCode2["E_SESSION_ERROR"] = "E_SESSION_ERROR";
  ErrorCode2["E_SHOPIFY_WEBHOOK_ERROR"] = "E_SHOPIFY_WEBHOOK_ERROR";
  ErrorCode2["E_INVITATION_FAILED"] = "E_INVITATION_FAILED";
  ErrorCode2["E_INVITATION_PROGRAM_DELETED"] = "E_INVITATION_PROGRAM_DELETED";
  ErrorCode2["E_INVITATION_PROGRAM_NOT_FOUND"] = "E_INVITATION_PROGRAM_NOT_FOUND";
  ErrorCode2["E_INVITATION_PROGRAM_INACTIVE"] = "E_INVITATION_PROGRAM_INACTIVE";
  ErrorCode2["E_INVITATION_UNDELIVERABLE"] = "E_INVITATION_UNDELIVERABLE";
  ErrorCode2["E_INVITATION_RECIPIENT_SUPPRESSED"] = "E_INVITATION_RECIPIENT_SUPPRESSED";
  ErrorCode2["E_INVALID_PLATFORM"] = "E_INVALID_PLATFORM";
  ErrorCode2["E_RATE_LIMIT_EXCEEDED"] = "E_RATE_LIMIT_EXCEEDED";
  ErrorCode2["E_RECIPIENT_NOT_FOUND"] = "E_RECIPIENT_NOT_FOUND";
  ErrorCode2["E_THREAD_NOT_FOUND"] = "E_THREAD_NOT_FOUND";
  ErrorCode2["E_CONVERSATION_NOT_FOUND"] = "E_CONVERSATION_NOT_FOUND";
  ErrorCode2["E_NOTIFICATION_NOT_FOUND"] = "E_NOTIFICATION_NOT_FOUND";
  ErrorCode2["E_AFFILIATE_ALREADY_EXISTS"] = "E_AFFILIATE_ALREADY_EXISTS";
  ErrorCode2["E_AFFILIATE_NOT_FOUND"] = "E_AFFILIATE_NOT_FOUND";
  ErrorCode2["E_CREATOR_ALREADY_LINKED"] = "E_CREATOR_ALREADY_LINKED";
  ErrorCode2["E_CREATOR_HUB_IDENTITY_REQUIRED"] = "E_CREATOR_HUB_IDENTITY_REQUIRED";
  ErrorCode2["E_CREATOR_HUB_REFRESH_TOKEN_INVALID"] = "E_CREATOR_HUB_REFRESH_TOKEN_INVALID";
  ErrorCode2["E_CREATOR_HUB_REFRESH_TOKEN_REQUIRED"] = "E_CREATOR_HUB_REFRESH_TOKEN_REQUIRED";
  ErrorCode2["E_CREATOR_HUB_REFRESH_SUPERSEDED"] = "E_CREATOR_HUB_REFRESH_SUPERSEDED";
  ErrorCode2["E_CREATOR_HUB_SESSION_NOT_FOUND"] = "E_CREATOR_HUB_SESSION_NOT_FOUND";
  ErrorCode2["E_CREATOR_HUB_MAGIC_LINK_INVALID"] = "E_CREATOR_HUB_MAGIC_LINK_INVALID";
  ErrorCode2["E_CREATOR_HUB_MAGIC_LINK_SEND_FAILED"] = "E_CREATOR_HUB_MAGIC_LINK_SEND_FAILED";
  ErrorCode2["E_CREATOR_HUB_GOOGLE_TOKEN_INVALID"] = "E_CREATOR_HUB_GOOGLE_TOKEN_INVALID";
  ErrorCode2["E_CREATOR_HUB_APPLE_TOKEN_INVALID"] = "E_CREATOR_HUB_APPLE_TOKEN_INVALID";
  ErrorCode2["E_CREATOR_HUB_REVIEW_ACCESS_INVALID"] = "E_CREATOR_HUB_REVIEW_ACCESS_INVALID";
  ErrorCode2["E_CREATOR_HUB_ACCOUNT_CLOSED"] = "E_CREATOR_HUB_ACCOUNT_CLOSED";
  ErrorCode2["E_CREATOR_HUB_EMAIL_LINK_NEEDS_REVIEW"] = "E_CREATOR_HUB_EMAIL_LINK_NEEDS_REVIEW";
  ErrorCode2["E_CREATOR_HUB_EMAIL_LINK_CODE_INVALID"] = "E_CREATOR_HUB_EMAIL_LINK_CODE_INVALID";
  ErrorCode2["E_CREATOR_HUB_EMAIL_LINK_TOO_MANY_ATTEMPTS"] = "E_CREATOR_HUB_EMAIL_LINK_TOO_MANY_ATTEMPTS";
  ErrorCode2["E_CREATOR_HUB_EMAIL_LINK_TOO_MANY_CODES"] = "E_CREATOR_HUB_EMAIL_LINK_TOO_MANY_CODES";
  ErrorCode2["E_CREATOR_HUB_EMAIL_LINK_SEND_FAILED"] = "E_CREATOR_HUB_EMAIL_LINK_SEND_FAILED";
  ErrorCode2["E_CREATOR_HUB_EMAIL_LINK_UNAVAILABLE"] = "E_CREATOR_HUB_EMAIL_LINK_UNAVAILABLE";
  ErrorCode2["E_CREATOR_HUB_SIGN_IN_CODE_EXPIRED"] = "E_CREATOR_HUB_SIGN_IN_CODE_EXPIRED";
  ErrorCode2["E_CREATOR_HUB_SIGN_IN_CODE_ALREADY_USED"] = "E_CREATOR_HUB_SIGN_IN_CODE_ALREADY_USED";
  ErrorCode2["E_CREATOR_HUB_SIGN_IN_CODE_INVALID"] = "E_CREATOR_HUB_SIGN_IN_CODE_INVALID";
  ErrorCode2["E_CREATOR_HUB_SIGN_IN_CODE_TOO_MANY_ATTEMPTS"] = "E_CREATOR_HUB_SIGN_IN_CODE_TOO_MANY_ATTEMPTS";
  ErrorCode2["E_CREATOR_HUB_SIGN_IN_TOO_MANY_CODES"] = "E_CREATOR_HUB_SIGN_IN_TOO_MANY_CODES";
  ErrorCode2["E_CREATOR_HUB_SIGN_IN_CODE_SEND_FAILED"] = "E_CREATOR_HUB_SIGN_IN_CODE_SEND_FAILED";
  ErrorCode2["E_CREATOR_HUB_ACCOUNT_DELETION_ROLE_FORBIDDEN"] = "E_CREATOR_HUB_ACCOUNT_DELETION_ROLE_FORBIDDEN";
  ErrorCode2["E_CREATOR_HUB_ACCOUNT_DELETION_CHALLENGE_INVALID"] = "E_CREATOR_HUB_ACCOUNT_DELETION_CHALLENGE_INVALID";
  ErrorCode2["E_CREATOR_HUB_ACCOUNT_DELETION_REQUEST_CONFLICT"] = "E_CREATOR_HUB_ACCOUNT_DELETION_REQUEST_CONFLICT";
  ErrorCode2["E_CREATOR_HUB_ACCOUNT_DELETION_WITHDRAWAL_IN_PROGRESS"] = "E_CREATOR_HUB_ACCOUNT_DELETION_WITHDRAWAL_IN_PROGRESS";
  ErrorCode2["E_CREATOR_HUB_COLLAB_NOT_FOUND"] = "E_CREATOR_HUB_COLLAB_NOT_FOUND";
  ErrorCode2["E_CREATOR_HUB_INVALID_CURSOR"] = "E_CREATOR_HUB_INVALID_CURSOR";
  ErrorCode2["E_CREATOR_HUB_WALLET_INVALID_CURSOR"] = "E_CREATOR_HUB_WALLET_INVALID_CURSOR";
  ErrorCode2["E_CREATOR_HUB_WALLET_BALANCE_UNAVAILABLE"] = "E_CREATOR_HUB_WALLET_BALANCE_UNAVAILABLE";
  ErrorCode2["E_CREATOR_HUB_WALLET_MONEY_INTEGRITY"] = "E_CREATOR_HUB_WALLET_MONEY_INTEGRITY";
  ErrorCode2["E_CREATOR_HUB_WALLET_MOVEMENT_NOT_FOUND"] = "E_CREATOR_HUB_WALLET_MOVEMENT_NOT_FOUND";
  ErrorCode2["E_CREATOR_HUB_GIFT_INVALID_CURSOR"] = "E_CREATOR_HUB_GIFT_INVALID_CURSOR";
  ErrorCode2["E_CREATOR_HUB_SOCIAL_OAUTH_STATE_INVALID"] = "E_CREATOR_HUB_SOCIAL_OAUTH_STATE_INVALID";
  ErrorCode2["E_CREATOR_HUB_SOCIAL_ACCOUNT_CONFLICT"] = "E_CREATOR_HUB_SOCIAL_ACCOUNT_CONFLICT";
  ErrorCode2["E_CREATOR_HUB_SOCIAL_ACCOUNT_INELIGIBLE"] = "E_CREATOR_HUB_SOCIAL_ACCOUNT_INELIGIBLE";
  ErrorCode2["E_CREATOR_HUB_SOCIAL_PROVIDER_UNAVAILABLE"] = "E_CREATOR_HUB_SOCIAL_PROVIDER_UNAVAILABLE";
  ErrorCode2["E_CREATOR_HUB_SOCIAL_CONNECTION_NOT_FOUND"] = "E_CREATOR_HUB_SOCIAL_CONNECTION_NOT_FOUND";
  ErrorCode2["E_CREATOR_HUB_LEGAL_ACCEPTANCE_REQUIRED"] = "E_CREATOR_HUB_LEGAL_ACCEPTANCE_REQUIRED";
  ErrorCode2["E_CREATOR_HUB_ONBOARDING_SKIP_REQUIRED"] = "E_CREATOR_HUB_ONBOARDING_SKIP_REQUIRED";
  ErrorCode2["E_CREATOR_HUB_ONBOARDING_STEP_ORDER_INVALID"] = "E_CREATOR_HUB_ONBOARDING_STEP_ORDER_INVALID";
  ErrorCode2["E_CREATOR_HUB_AFFILIATION_INACTIVE"] = "E_CREATOR_HUB_AFFILIATION_INACTIVE";
  ErrorCode2["E_CREATOR_HUB_PRODUCT_CATALOG_UNAVAILABLE"] = "E_CREATOR_HUB_PRODUCT_CATALOG_UNAVAILABLE";
  ErrorCode2["E_CREATOR_HUB_PAYOUT_TOKEN_INVALID"] = "E_CREATOR_HUB_PAYOUT_TOKEN_INVALID";
  ErrorCode2["E_CREATOR_HUB_PAYOUT_ACCOUNT_UPDATE_REJECTED"] = "E_CREATOR_HUB_PAYOUT_ACCOUNT_UPDATE_REJECTED";
  ErrorCode2["E_CREATOR_HUB_PAYOUT_DOCUMENT_REJECTED"] = "E_CREATOR_HUB_PAYOUT_DOCUMENT_REJECTED";
  ErrorCode2["E_CREATOR_HUB_PAYOUT_COUNTRY_UNSUPPORTED"] = "E_CREATOR_HUB_PAYOUT_COUNTRY_UNSUPPORTED";
  ErrorCode2["E_CREATOR_HUB_PAYOUT_ACCOUNT_CONFLICT"] = "E_CREATOR_HUB_PAYOUT_ACCOUNT_CONFLICT";
  ErrorCode2["E_CREATOR_HUB_PAYOUT_PROVIDER_UNAVAILABLE"] = "E_CREATOR_HUB_PAYOUT_PROVIDER_UNAVAILABLE";
  ErrorCode2["E_CREATOR_HUB_PAYOUT_REFRESH_THROTTLED"] = "E_CREATOR_HUB_PAYOUT_REFRESH_THROTTLED";
  ErrorCode2["E_CREATOR_HUB_WITHDRAWAL_NOT_READY"] = "E_CREATOR_HUB_WITHDRAWAL_NOT_READY";
  ErrorCode2["E_CREATOR_HUB_WITHDRAWAL_ALREADY_IN_FLIGHT"] = "E_CREATOR_HUB_WITHDRAWAL_ALREADY_IN_FLIGHT";
  ErrorCode2["E_CREATOR_HUB_WITHDRAWAL_PREVIEW_STALE"] = "E_CREATOR_HUB_WITHDRAWAL_PREVIEW_STALE";
  ErrorCode2["E_CREATOR_HUB_WITHDRAWAL_NO_FUNDS"] = "E_CREATOR_HUB_WITHDRAWAL_NO_FUNDS";
  ErrorCode2["E_CREATOR_HUB_WITHDRAWAL_NOT_FOUND"] = "E_CREATOR_HUB_WITHDRAWAL_NOT_FOUND";
  ErrorCode2["E_CREATOR_HUB_WITHDRAWAL_PROVIDER_UNAVAILABLE"] = "E_CREATOR_HUB_WITHDRAWAL_PROVIDER_UNAVAILABLE";
  ErrorCode2["E_CREATOR_HUB_WITHDRAWAL_DESTINATION_MISSING"] = "E_CREATOR_HUB_WITHDRAWAL_DESTINATION_MISSING";
  ErrorCode2["E_CREATOR_HUB_WITHDRAWAL_BELOW_MINIMUM"] = "E_CREATOR_HUB_WITHDRAWAL_BELOW_MINIMUM";
  ErrorCode2["E_CREATOR_HUB_PAYOUT_STATEMENT_NOT_FOUND"] = "E_CREATOR_HUB_PAYOUT_STATEMENT_NOT_FOUND";
  ErrorCode2["E_AFFILIATE_WITHDRAWAL_PROVIDER_UNAVAILABLE"] = "E_AFFILIATE_WITHDRAWAL_PROVIDER_UNAVAILABLE";
  ErrorCode2["E_AFFILIATE_WITHDRAWAL_ACCOUNT_INCOMPLETE"] = "E_AFFILIATE_WITHDRAWAL_ACCOUNT_INCOMPLETE";
  ErrorCode2["E_AFFILIATE_WITHDRAWAL_ACCOUNT_UNDER_REVIEW"] = "E_AFFILIATE_WITHDRAWAL_ACCOUNT_UNDER_REVIEW";
  ErrorCode2["E_AFFILIATE_WITHDRAWAL_ACCOUNT_RESTRICTED"] = "E_AFFILIATE_WITHDRAWAL_ACCOUNT_RESTRICTED";
  ErrorCode2["E_EMAIL_NOT_ASCII"] = "E_EMAIL_NOT_ASCII";
  ErrorCode2["E_EMAIL_AFFILIATE_ACCOUNT"] = "E_EMAIL_AFFILIATE_ACCOUNT";
  ErrorCode2["E_EMAIL_BRAND_ACCOUNT"] = "E_EMAIL_BRAND_ACCOUNT";
  ErrorCode2["E_EMAIL_CREATOR_ACCOUNT"] = "E_EMAIL_CREATOR_ACCOUNT";
  ErrorCode2["E_EMAIL_ALREADY_REGISTERED"] = "E_EMAIL_ALREADY_REGISTERED";
  ErrorCode2["E_EMAIL_ADMIN_ACCOUNT"] = "E_EMAIL_ADMIN_ACCOUNT";
  ErrorCode2["E_WEAK_PASSWORD"] = "E_WEAK_PASSWORD";
  ErrorCode2["E_OAUTH_FAILED"] = "E_OAUTH_FAILED";
  ErrorCode2["E_USER_ALREADY_HAS_BRAND"] = "E_USER_ALREADY_HAS_BRAND";
  ErrorCode2["E_INVALID_COMPANY_NAME"] = "E_INVALID_COMPANY_NAME";
  ErrorCode2["E_REGISTRATION_FAILED"] = "E_REGISTRATION_FAILED";
  ErrorCode2["E_SHOPIFY_DOMAIN_INVALID"] = "E_SHOPIFY_DOMAIN_INVALID";
  ErrorCode2["E_SHOPIFY_ALREADY_CONNECTED"] = "E_SHOPIFY_ALREADY_CONNECTED";
  ErrorCode2["E_SHOPIFY_OAUTH_FAILED"] = "E_SHOPIFY_OAUTH_FAILED";
  ErrorCode2["E_SHOPIFY_NOT_CONNECTED"] = "E_SHOPIFY_NOT_CONNECTED";
  ErrorCode2["E_AFFILIATION_UNAVAILABLE"] = "E_AFFILIATION_UNAVAILABLE";
  ErrorCode2["E_SHOPIFY_SESSION_EXPIRED"] = "E_SHOPIFY_SESSION_EXPIRED";
  ErrorCode2["E_NO_BRAND_SELECTED"] = "E_NO_BRAND_SELECTED";
  ErrorCode2["E_NO_PRODUCTS"] = "E_NO_PRODUCTS";
  ErrorCode2["E_SUBSCRIPTION_NOT_FOUND"] = "E_SUBSCRIPTION_NOT_FOUND";
  ErrorCode2["E_SUBSCRIPTION_INACTIVE"] = "E_SUBSCRIPTION_INACTIVE";
  ErrorCode2["E_INVALID_PLAN_CHANGE"] = "E_INVALID_PLAN_CHANGE";
  ErrorCode2["E_PLAN_CHANGE_CURRENCY_MISMATCH"] = "E_PLAN_CHANGE_CURRENCY_MISMATCH";
  ErrorCode2["E_PENDING_SUBSCRIPTION_CHANGE_EXISTS"] = "E_PENDING_SUBSCRIPTION_CHANGE_EXISTS";
  ErrorCode2["E_SUBSCRIPTION_ALREADY_EXISTS"] = "E_SUBSCRIPTION_ALREADY_EXISTS";
  ErrorCode2["E_PENDING_COMMISSIONS_EXIST"] = "E_PENDING_COMMISSIONS_EXIST";
  ErrorCode2["E_SHOPIFY_MANUAL_DELETION_NOT_ALLOWED"] = "E_SHOPIFY_MANUAL_DELETION_NOT_ALLOWED";
  ErrorCode2["E_INTEGRATION_DELETION_FAILED"] = "E_INTEGRATION_DELETION_FAILED";
  ErrorCode2["E_META_ADS_CODE_EXCHANGE_FAILED"] = "E_META_ADS_CODE_EXCHANGE_FAILED";
  ErrorCode2["E_META_ADS_SCOPE_MISSING"] = "E_META_ADS_SCOPE_MISSING";
  ErrorCode2["E_META_ADS_NO_AD_ACCOUNT"] = "E_META_ADS_NO_AD_ACCOUNT";
  ErrorCode2["E_META_ADS_PROVIDER_UNAVAILABLE"] = "E_META_ADS_PROVIDER_UNAVAILABLE";
  ErrorCode2["E_META_ADS_STATE_INVALID"] = "E_META_ADS_STATE_INVALID";
  ErrorCode2["E_META_ADS_INVALID_AD_ACCOUNT"] = "E_META_ADS_INVALID_AD_ACCOUNT";
  ErrorCode2["E_STRIPE_CUSTOMER_FAILED"] = "E_STRIPE_CUSTOMER_FAILED";
  ErrorCode2["E_STRIPE_BILLING_IDENTITY_REQUIRED"] = "E_STRIPE_BILLING_IDENTITY_REQUIRED";
  ErrorCode2["E_STRIPE_BILLING_CARD_REQUIRED"] = "E_STRIPE_BILLING_CARD_REQUIRED";
  ErrorCode2["E_STRIPE_BILLING_EMAIL_VERIFICATION_REQUIRED"] = "E_STRIPE_BILLING_EMAIL_VERIFICATION_REQUIRED";
  ErrorCode2["E_STRIPE_BILLING_CARD_SETUP_RATE_LIMITED"] = "E_STRIPE_BILLING_CARD_SETUP_RATE_LIMITED";
  ErrorCode2["E_STRIPE_BILLING_IDENTITY_CONFLICT"] = "E_STRIPE_BILLING_IDENTITY_CONFLICT";
  ErrorCode2["E_STRIPE_BILLING_CONFIGURATION_INVALID"] = "E_STRIPE_BILLING_CONFIGURATION_INVALID";
  ErrorCode2["E_STRIPE_BILLING_RECONCILIATION_REQUIRED"] = "E_STRIPE_BILLING_RECONCILIATION_REQUIRED";
  ErrorCode2["E_STRIPE_BILLING_MODE_MISMATCH"] = "E_STRIPE_BILLING_MODE_MISMATCH";
  ErrorCode2["E_STRIPE_BILLING_SYNC_PENDING"] = "E_STRIPE_BILLING_SYNC_PENDING";
  ErrorCode2["E_STRIPE_BILLING_TAX_QUALIFICATION_REQUIRED"] = "E_STRIPE_BILLING_TAX_QUALIFICATION_REQUIRED";
  ErrorCode2["E_STRIPE_BILLING_TAX_PROFILE_CONFLICT"] = "E_STRIPE_BILLING_TAX_PROFILE_CONFLICT";
  ErrorCode2["E_TRANSACTION_FAILED"] = "E_TRANSACTION_FAILED";
  ErrorCode2["E_VALIDATION_TOKEN_EXPIRED"] = "E_VALIDATION_TOKEN_EXPIRED";
  ErrorCode2["E_INVALID_FILE_TYPE"] = "E_INVALID_FILE_TYPE";
  ErrorCode2["E_FILE_TOO_LARGE"] = "E_FILE_TOO_LARGE";
  ErrorCode2["E_INVALID_IMAGE_FILE"] = "E_INVALID_IMAGE_FILE";
  ErrorCode2["E_FILE_UPLOAD_FAILED"] = "E_FILE_UPLOAD_FAILED";
  ErrorCode2["E_PASSWORD_RESET_TOKEN_REQUIRED"] = "E_PASSWORD_RESET_TOKEN_REQUIRED";
  ErrorCode2["E_PASSWORD_RESET_TOKEN_INVALID"] = "E_PASSWORD_RESET_TOKEN_INVALID";
  ErrorCode2["E_PASSWORD_RESET_PASSWORDS_MISMATCH"] = "E_PASSWORD_RESET_PASSWORDS_MISMATCH";
  ErrorCode2["E_PASSWORD_RESET_FAILED"] = "E_PASSWORD_RESET_FAILED";
  ErrorCode2["E_DISCOUNT_CODE_ALREADY_ASSIGNED"] = "E_DISCOUNT_CODE_ALREADY_ASSIGNED";
  ErrorCode2["E_DISCOUNT_CODE_IMMUTABLE"] = "E_DISCOUNT_CODE_IMMUTABLE";
  ErrorCode2["E_DISCOUNT_CODE_MIGRATION_RUNNING"] = "E_DISCOUNT_CODE_MIGRATION_RUNNING";
  ErrorCode2["E_PAYOUT_BATCH_NOT_FOUND"] = "E_PAYOUT_BATCH_NOT_FOUND";
  ErrorCode2["E_PAYOUT_BATCH_NOT_CANCELLABLE"] = "E_PAYOUT_BATCH_NOT_CANCELLABLE";
  ErrorCode2["E_PAYOUT_SCHEDULE_DATE_PAST"] = "E_PAYOUT_SCHEDULE_DATE_PAST";
  ErrorCode2["E_PAYOUT_BATCH_HAS_INELIGIBLE_RECIPIENTS"] = "E_PAYOUT_BATCH_HAS_INELIGIBLE_RECIPIENTS";
  ErrorCode2["E_INVOICE_NOT_AVAILABLE"] = "E_INVOICE_NOT_AVAILABLE";
  ErrorCode2["E_PAYOUT_TRANSFER_NOT_FOUND"] = "E_PAYOUT_TRANSFER_NOT_FOUND";
  ErrorCode2["E_PAYOUT_STATEMENT_NOT_AVAILABLE"] = "E_PAYOUT_STATEMENT_NOT_AVAILABLE";
  ErrorCode2["E_PAYOUT_BATCH_ALREADY_PAID"] = "E_PAYOUT_BATCH_ALREADY_PAID";
  ErrorCode2["E_PAYOUT_BATCH_PAYMENT_IN_PROGRESS"] = "E_PAYOUT_BATCH_PAYMENT_IN_PROGRESS";
  ErrorCode2["E_PAYOUT_BATCH_NO_LONGER_PAYABLE"] = "E_PAYOUT_BATCH_NO_LONGER_PAYABLE";
  ErrorCode2["E_DEMO_SLOT_UNAVAILABLE"] = "E_DEMO_SLOT_UNAVAILABLE";
  ErrorCode2["E_DEMO_BOOKING_UNAVAILABLE"] = "E_DEMO_BOOKING_UNAVAILABLE";
  ErrorCode2["E_DEMO_BOOKING_NOT_OFFERED"] = "E_DEMO_BOOKING_NOT_OFFERED";
  ErrorCode2["E_AI_FILTER_EXTRACTION_FAILED"] = "E_AI_FILTER_EXTRACTION_FAILED";
  ErrorCode2["E_AI_INVALID_API_KEY"] = "E_AI_INVALID_API_KEY";
  ErrorCode2["E_AI_RATE_LIMIT_EXCEEDED"] = "E_AI_RATE_LIMIT_EXCEEDED";
  ErrorCode2["E_AI_SERVICE_UNAVAILABLE"] = "E_AI_SERVICE_UNAVAILABLE";
  ErrorCode2["E_AI_CONTENT_BLOCKED"] = "E_AI_CONTENT_BLOCKED";
  ErrorCode2["E_BRAND_DNA_GENERATION_FAILED"] = "E_BRAND_DNA_GENERATION_FAILED";
  ErrorCode2["E_BRAND_DNA_WEBSITE_UNREACHABLE"] = "E_BRAND_DNA_WEBSITE_UNREACHABLE";
  ErrorCode2["E_AI_CONVERSATION_NOT_FOUND"] = "E_AI_CONVERSATION_NOT_FOUND";
  ErrorCode2["E_AI_CONVERSATION_DELETED"] = "E_AI_CONVERSATION_DELETED";
  ErrorCode2["E_AI_MESSAGE_TOO_LONG"] = "E_AI_MESSAGE_TOO_LONG";
  ErrorCode2["E_AI_MESSAGE_EMPTY"] = "E_AI_MESSAGE_EMPTY";
  ErrorCode2["E_AI_TOOL_EXECUTION_FAILED"] = "E_AI_TOOL_EXECUTION_FAILED";
  ErrorCode2["E_AI_STREAM_FAILED"] = "E_AI_STREAM_FAILED";
  ErrorCode2["E_AI_NO_SEARCH_TO_REORDER"] = "E_AI_NO_SEARCH_TO_REORDER";
  ErrorCode2["E_CREATOR_MARKETPLACE_INVALID_FILTERS"] = "E_CREATOR_MARKETPLACE_INVALID_FILTERS";
  ErrorCode2["E_UNSUPPORTED_DISCOVERY_FILTER"] = "E_UNSUPPORTED_DISCOVERY_FILTER";
  ErrorCode2["E_GMAIL_OAUTH_FAILED"] = "E_GMAIL_OAUTH_FAILED";
  ErrorCode2["E_GMAIL_NOT_CONNECTED"] = "E_GMAIL_NOT_CONNECTED";
  ErrorCode2["E_GMAIL_TOKEN_REFRESH_FAILED"] = "E_GMAIL_TOKEN_REFRESH_FAILED";
  ErrorCode2["E_OUTLOOK_OAUTH_FAILED"] = "E_OUTLOOK_OAUTH_FAILED";
  ErrorCode2["E_OUTLOOK_NOT_CONNECTED"] = "E_OUTLOOK_NOT_CONNECTED";
  ErrorCode2["E_OUTLOOK_TOKEN_REFRESH_FAILED"] = "E_OUTLOOK_TOKEN_REFRESH_FAILED";
  ErrorCode2["E_EMAIL_ALREADY_CONNECTED"] = "E_EMAIL_ALREADY_CONNECTED";
  ErrorCode2["E_EMAIL_OAUTH_STATE_INVALID"] = "E_EMAIL_OAUTH_STATE_INVALID";
  ErrorCode2["E_EMAIL_TOKEN_REVOKED"] = "E_EMAIL_TOKEN_REVOKED";
  ErrorCode2["E_EMAIL_QUOTA_EXCEEDED"] = "E_EMAIL_QUOTA_EXCEEDED";
  ErrorCode2["E_EMAIL_INSUFFICIENT_SCOPE"] = "E_EMAIL_INSUFFICIENT_SCOPE";
  ErrorCode2["E_EMAIL_SENDER_ADDRESS_MISSING"] = "E_EMAIL_SENDER_ADDRESS_MISSING";
  ErrorCode2["E_EMAIL_RECIPIENT_INVALID"] = "E_EMAIL_RECIPIENT_INVALID";
  ErrorCode2["E_EMAIL_MAIL_SERVICE_DISABLED"] = "E_EMAIL_MAIL_SERVICE_DISABLED";
  ErrorCode2["E_EMAIL_API_ERROR"] = "E_EMAIL_API_ERROR";
  ErrorCode2["E_EMAIL_INTEGRATION_DISCONNECTED"] = "E_EMAIL_INTEGRATION_DISCONNECTED";
  ErrorCode2["E_EMAIL_SUPPRESSED"] = "E_EMAIL_SUPPRESSED";
  ErrorCode2["E_GOOGLE_DRIVE_OAUTH_FAILED"] = "E_GOOGLE_DRIVE_OAUTH_FAILED";
  ErrorCode2["E_GOOGLE_DRIVE_NOT_CONNECTED"] = "E_GOOGLE_DRIVE_NOT_CONNECTED";
  ErrorCode2["E_GOOGLE_DRIVE_ALREADY_CONNECTED"] = "E_GOOGLE_DRIVE_ALREADY_CONNECTED";
  ErrorCode2["E_GOOGLE_DRIVE_TOKEN_REFRESH_FAILED"] = "E_GOOGLE_DRIVE_TOKEN_REFRESH_FAILED";
  ErrorCode2["E_GOOGLE_DRIVE_UPLOAD_FAILED"] = "E_GOOGLE_DRIVE_UPLOAD_FAILED";
  ErrorCode2["E_GOOGLE_DRIVE_QUOTA_EXCEEDED"] = "E_GOOGLE_DRIVE_QUOTA_EXCEEDED";
  ErrorCode2["E_GOOGLE_DRIVE_ROOT_FOLDER_MISSING"] = "E_GOOGLE_DRIVE_ROOT_FOLDER_MISSING";
  ErrorCode2["E_GOOGLE_DRIVE_PERMISSION_DENIED"] = "E_GOOGLE_DRIVE_PERMISSION_DENIED";
  ErrorCode2["E_GOOGLE_DRIVE_SHARE_FAILED"] = "E_GOOGLE_DRIVE_SHARE_FAILED";
  ErrorCode2["E_GOOGLE_DRIVE_DOMAIN_POLICY"] = "E_GOOGLE_DRIVE_DOMAIN_POLICY";
  ErrorCode2["E_MENTION_ARCHIVE_IN_PROGRESS"] = "E_MENTION_ARCHIVE_IN_PROGRESS";
  ErrorCode2["E_MENTION_ARCHIVE_ALREADY_DONE"] = "E_MENTION_ARCHIVE_ALREADY_DONE";
  ErrorCode2["E_MENTION_ARCHIVE_DISCLAIMER_REQUIRED"] = "E_MENTION_ARCHIVE_DISCLAIMER_REQUIRED";
  ErrorCode2["E_MENTION_ARCHIVE_MEDIA_EXPIRED"] = "E_MENTION_ARCHIVE_MEDIA_EXPIRED";
  ErrorCode2["E_MENTION_ARCHIVE_CREATOR_OPTED_OUT"] = "E_MENTION_ARCHIVE_CREATOR_OPTED_OUT";
  ErrorCode2["E_MENTION_ARCHIVE_TIKTOK_EXTRACTION_FAILED"] = "E_MENTION_ARCHIVE_TIKTOK_EXTRACTION_FAILED";
  ErrorCode2["E_MENTION_BOOST_NOT_ELIGIBLE"] = "E_MENTION_BOOST_NOT_ELIGIBLE";
  ErrorCode2["E_MENTION_BOOST_AUTHORIZATION_FORBIDDEN"] = "E_MENTION_BOOST_AUTHORIZATION_FORBIDDEN";
  ErrorCode2["E_MENTION_BOOST_META_PATH_UNAVAILABLE"] = "E_MENTION_BOOST_META_PATH_UNAVAILABLE";
  ErrorCode2["E_MENTION_BOOST_META_REQUEST_FAILED"] = "E_MENTION_BOOST_META_REQUEST_FAILED";
  ErrorCode2["E_MENTION_BOOST_SETUP_NOT_READY"] = "E_MENTION_BOOST_SETUP_NOT_READY";
  ErrorCode2["E_MENTION_BOOST_SETUP_BUDGET_INVALID"] = "E_MENTION_BOOST_SETUP_BUDGET_INVALID";
  ErrorCode2["E_MENTION_BOOST_SETUP_PRODUCT_UNAVAILABLE"] = "E_MENTION_BOOST_SETUP_PRODUCT_UNAVAILABLE";
  ErrorCode2["E_MENTION_BOOST_LAUNCH_NOT_READY"] = "E_MENTION_BOOST_LAUNCH_NOT_READY";
  ErrorCode2["E_MENTION_BOOST_LAUNCH_AD_ACCOUNT_REQUIRED"] = "E_MENTION_BOOST_LAUNCH_AD_ACCOUNT_REQUIRED";
  ErrorCode2["E_MENTION_BOOST_LAUNCH_DESTINATION_UNRESOLVED"] = "E_MENTION_BOOST_LAUNCH_DESTINATION_UNRESOLVED";
  ErrorCode2["E_MENTION_BOOST_LAUNCH_AUTHORIZATION_INVALID"] = "E_MENTION_BOOST_LAUNCH_AUTHORIZATION_INVALID";
  ErrorCode2["E_MENTION_BOOST_LAUNCH_AUTHORIZATION_MEDIA_MISMATCH"] = "E_MENTION_BOOST_LAUNCH_AUTHORIZATION_MEDIA_MISMATCH";
  ErrorCode2["E_MENTION_BOOST_LAUNCH_MEDIA_UNAVAILABLE"] = "E_MENTION_BOOST_LAUNCH_MEDIA_UNAVAILABLE";
  ErrorCode2["E_MENTION_BOOST_LAUNCH_STORY_NOT_BOOSTABLE"] = "E_MENTION_BOOST_LAUNCH_STORY_NOT_BOOSTABLE";
  ErrorCode2["E_MENTION_BOOST_LAUNCH_INSTAGRAM_RECONNECT_REQUIRED"] = "E_MENTION_BOOST_LAUNCH_INSTAGRAM_RECONNECT_REQUIRED";
  ErrorCode2["E_MENTION_BOOST_LAUNCH_AD_ACCOUNT_PAYMENT_MISSING"] = "E_MENTION_BOOST_LAUNCH_AD_ACCOUNT_PAYMENT_MISSING";
  ErrorCode2["E_MENTION_BOOST_LAUNCH_AD_ACCOUNT_DISABLED"] = "E_MENTION_BOOST_LAUNCH_AD_ACCOUNT_DISABLED";
  ErrorCode2["E_MENTION_BOOST_LAUNCH_CAMPAIGN_INCOMPATIBLE"] = "E_MENTION_BOOST_LAUNCH_CAMPAIGN_INCOMPATIBLE";
  ErrorCode2["E_MENTION_BOOST_LAUNCH_REJECTED"] = "E_MENTION_BOOST_LAUNCH_REJECTED";
  ErrorCode2["E_MENTION_BOOST_LAUNCH_CREATOR_NOT_ELIGIBLE"] = "E_MENTION_BOOST_LAUNCH_CREATOR_NOT_ELIGIBLE";
  ErrorCode2["E_MENTION_BOOST_LAUNCH_PROVIDER_UNAVAILABLE"] = "E_MENTION_BOOST_LAUNCH_PROVIDER_UNAVAILABLE";
  ErrorCode2["E_MENTION_BOOST_LAUNCH_FAILED"] = "E_MENTION_BOOST_LAUNCH_FAILED";
  ErrorCode2["E_MENTION_BOOST_STOP_NOT_FOUND"] = "E_MENTION_BOOST_STOP_NOT_FOUND";
  ErrorCode2["E_MENTION_BOOST_STOP_FORBIDDEN"] = "E_MENTION_BOOST_STOP_FORBIDDEN";
  ErrorCode2["E_MENTION_BOOST_STOP_NOT_STOPPABLE"] = "E_MENTION_BOOST_STOP_NOT_STOPPABLE";
  ErrorCode2["E_MENTION_BOOST_STOP_PROVIDER_UNAVAILABLE"] = "E_MENTION_BOOST_STOP_PROVIDER_UNAVAILABLE";
  ErrorCode2["E_MENTION_BOOST_STOP_FAILED"] = "E_MENTION_BOOST_STOP_FAILED";
  ErrorCode2["E_DISPLAY_RIGHTS_PROPOSAL_NOT_FOUND"] = "E_DISPLAY_RIGHTS_PROPOSAL_NOT_FOUND";
  ErrorCode2["E_DISPLAY_RIGHTS_PROPOSAL_SUPERSEDED"] = "E_DISPLAY_RIGHTS_PROPOSAL_SUPERSEDED";
  ErrorCode2["E_DISPLAY_RIGHTS_PROPOSAL_EXPIRED"] = "E_DISPLAY_RIGHTS_PROPOSAL_EXPIRED";
  ErrorCode2["E_DISPLAY_RIGHTS_PROPOSAL_CONFLICT"] = "E_DISPLAY_RIGHTS_PROPOSAL_CONFLICT";
  ErrorCode2["E_DISPLAY_RIGHTS_INVALID_TRANSITION"] = "E_DISPLAY_RIGHTS_INVALID_TRANSITION";
  ErrorCode2["E_DISPLAY_RIGHTS_TERMS_INVALID"] = "E_DISPLAY_RIGHTS_TERMS_INVALID";
  ErrorCode2["E_DISPLAY_RIGHTS_ACCEPTANCE_EMAIL_INVALID"] = "E_DISPLAY_RIGHTS_ACCEPTANCE_EMAIL_INVALID";
  ErrorCode2["E_DISPLAY_RIGHTS_CODE_INVALID"] = "E_DISPLAY_RIGHTS_CODE_INVALID";
  ErrorCode2["E_DISPLAY_RIGHTS_LAUNCH_BLOCKED"] = "E_DISPLAY_RIGHTS_LAUNCH_BLOCKED";
  ErrorCode2["E_DOWNLOAD_ACKNOWLEDGMENT_REQUIRED"] = "E_DOWNLOAD_ACKNOWLEDGMENT_REQUIRED";
  ErrorCode2["E_BULK_EMAIL_RATE_LIMIT"] = "E_BULK_EMAIL_RATE_LIMIT";
  ErrorCode2["E_BULK_EMAIL_DAILY_LIMIT"] = "E_BULK_EMAIL_DAILY_LIMIT";
  ErrorCode2["E_BULK_EMAIL_BATCH_IN_PROGRESS"] = "E_BULK_EMAIL_BATCH_IN_PROGRESS";
  ErrorCode2["E_BULK_EMAIL_NO_CONNECTED_EMAIL"] = "E_BULK_EMAIL_NO_CONNECTED_EMAIL";
  ErrorCode2["E_BULK_EMAIL_NO_RECIPIENTS"] = "E_BULK_EMAIL_NO_RECIPIENTS";
  ErrorCode2["E_BULK_EMAIL_BATCH_NOT_FOUND"] = "E_BULK_EMAIL_BATCH_NOT_FOUND";
  ErrorCode2["E_BULK_EMAIL_SEND_FAILED"] = "E_BULK_EMAIL_SEND_FAILED";
  ErrorCode2["E_BULK_EMAIL_LIMIT_EXCEEDED"] = "E_BULK_EMAIL_LIMIT_EXCEEDED";
  ErrorCode2["E_BULK_EMAIL_IDEMPOTENCY_CONFLICT"] = "E_BULK_EMAIL_IDEMPOTENCY_CONFLICT";
  ErrorCode2["E_CREATOR_OUTREACH_NO_CONNECTED_EMAIL"] = "E_CREATOR_OUTREACH_NO_CONNECTED_EMAIL";
  ErrorCode2["E_CREATOR_OUTREACH_EMAIL_MISSING"] = "E_CREATOR_OUTREACH_EMAIL_MISSING";
  ErrorCode2["E_CREATOR_OUTREACH_RECENTLY_SENT"] = "E_CREATOR_OUTREACH_RECENTLY_SENT";
  ErrorCode2["E_INVITATION_OUTREACH_NO_CONNECTED_EMAIL"] = "E_INVITATION_OUTREACH_NO_CONNECTED_EMAIL";
  ErrorCode2["E_INVITATION_OUTREACH_EMAIL_MISSING"] = "E_INVITATION_OUTREACH_EMAIL_MISSING";
  ErrorCode2["E_INVITATION_OUTREACH_RECENTLY_SENT"] = "E_INVITATION_OUTREACH_RECENTLY_SENT";
  ErrorCode2["E_INVITATION_OUTREACH_ALREADY_JOINED"] = "E_INVITATION_OUTREACH_ALREADY_JOINED";
  ErrorCode2["E_INVITATION_OUTREACH_EXPIRED"] = "E_INVITATION_OUTREACH_EXPIRED";
  ErrorCode2["E_ATTACHMENT_EMPTY"] = "E_ATTACHMENT_EMPTY";
  ErrorCode2["E_ATTACHMENT_PROVIDER_SIZE_EXCEEDED"] = "E_ATTACHMENT_PROVIDER_SIZE_EXCEEDED";
  ErrorCode2["E_EMAIL_SEND_OUTCOME_UNKNOWN"] = "E_EMAIL_SEND_OUTCOME_UNKNOWN";
  ErrorCode2["E_EMAIL_MESSAGE_TOO_LARGE"] = "E_EMAIL_MESSAGE_TOO_LARGE";
  ErrorCode2["E_ATTACHMENT_INVALID_TYPE"] = "E_ATTACHMENT_INVALID_TYPE";
  ErrorCode2["E_ATTACHMENT_TOO_LARGE"] = "E_ATTACHMENT_TOO_LARGE";
  ErrorCode2["E_ATTACHMENT_BATCH_SIZE_EXCEEDED"] = "E_ATTACHMENT_BATCH_SIZE_EXCEEDED";
  ErrorCode2["E_ATTACHMENT_MAX_COUNT"] = "E_ATTACHMENT_MAX_COUNT";
  ErrorCode2["E_ATTACHMENT_NOT_FOUND"] = "E_ATTACHMENT_NOT_FOUND";
  ErrorCode2["E_ATTACHMENT_MAGIC_BYTE_MISMATCH"] = "E_ATTACHMENT_MAGIC_BYTE_MISMATCH";
  ErrorCode2["E_TOKEN_EXPIRED"] = "E_TOKEN_EXPIRED";
  ErrorCode2["E_TOKEN_MISSING"] = "E_TOKEN_MISSING";
  ErrorCode2["E_TOKEN_INVALID"] = "E_TOKEN_INVALID";
  ErrorCode2["E_BULK_INVITATION_BATCH_NOT_FOUND"] = "E_BULK_INVITATION_BATCH_NOT_FOUND";
  ErrorCode2["E_BULK_INVITATION_NO_VALID_RECIPIENTS"] = "E_BULK_INVITATION_NO_VALID_RECIPIENTS";
  ErrorCode2["E_BULK_INVITATION_LIMIT_EXCEEDED"] = "E_BULK_INVITATION_LIMIT_EXCEEDED";
  ErrorCode2["E_BULK_INVITATION_ITEM_NO_ANCHOR"] = "E_BULK_INVITATION_ITEM_NO_ANCHOR";
  ErrorCode2["E_BULK_INVITATION_ITEM_FAILED"] = "E_BULK_INVITATION_ITEM_FAILED";
  ErrorCode2["E_BULK_INVITATION_ALREADY_INVITED"] = "E_BULK_INVITATION_ALREADY_INVITED";
  ErrorCode2["E_WISHLIST_ITEM_NOT_FOUND"] = "E_WISHLIST_ITEM_NOT_FOUND";
  ErrorCode2["E_WISHLIST_ITEM_NO_EMAIL"] = "E_WISHLIST_ITEM_NO_EMAIL";
  ErrorCode2["E_DEEP_LINK_NOT_FOUND"] = "E_DEEP_LINK_NOT_FOUND";
  ErrorCode2["E_DEEP_LINK_LIMIT_REACHED"] = "E_DEEP_LINK_LIMIT_REACHED";
  ErrorCode2["E_DEEP_LINK_INVALID_URL"] = "E_DEEP_LINK_INVALID_URL";
  ErrorCode2["E_DEEP_LINK_DUPLICATE"] = "E_DEEP_LINK_DUPLICATE";
  ErrorCode2["E_DEEP_LINK_CREATION_FAILED"] = "E_DEEP_LINK_CREATION_FAILED";
  ErrorCode2["E_DEEP_LINKING_DISABLED"] = "E_DEEP_LINKING_DISABLED";
  ErrorCode2["E_FEATURE_NOT_AVAILABLE"] = "E_FEATURE_NOT_AVAILABLE";
  ErrorCode2["E_LIMIT_EXCEEDED"] = "E_LIMIT_EXCEEDED";
  ErrorCode2["E_PLAN_LIMIT_REACHED"] = "E_PLAN_LIMIT_REACHED";
  ErrorCode2["E_PLAN_DISCOVERY_QUOTA_REACHED"] = "E_PLAN_DISCOVERY_QUOTA_REACHED";
  ErrorCode2["E_PLAN_PROGRAM_LIMIT_REACHED"] = "E_PLAN_PROGRAM_LIMIT_REACHED";
  ErrorCode2["E_PLAN_FLOWS_LOCKED"] = "E_PLAN_FLOWS_LOCKED";
  ErrorCode2["E_PLAN_FLOW_LIMIT_REACHED"] = "E_PLAN_FLOW_LIMIT_REACHED";
  ErrorCode2["E_PLAN_BRIEF_LIMIT_REACHED"] = "E_PLAN_BRIEF_LIMIT_REACHED";
  ErrorCode2["E_PLAN_TEAM_MEMBERS_LOCKED"] = "E_PLAN_TEAM_MEMBERS_LOCKED";
  ErrorCode2["E_PLAN_MCP_LOCKED"] = "E_PLAN_MCP_LOCKED";
  ErrorCode2["E_PLAN_RECOMMENDATIONS_QUOTA_REACHED"] = "E_PLAN_RECOMMENDATIONS_QUOTA_REACHED";
  ErrorCode2["E_PLAN_CREATOR_CONTACT_LOCKED"] = "E_PLAN_CREATOR_CONTACT_LOCKED";
  ErrorCode2["E_PLAN_PROFILE_UNLOCKS_QUOTA_REACHED"] = "E_PLAN_PROFILE_UNLOCKS_QUOTA_REACHED";
  ErrorCode2["E_PLAN_GIFTING_INVITATIONS_QUOTA_REACHED"] = "E_PLAN_GIFTING_INVITATIONS_QUOTA_REACHED";
  ErrorCode2["E_FREE_PLAN_KEEP_PROGRAM_REQUIRED"] = "E_FREE_PLAN_KEEP_PROGRAM_REQUIRED";
  ErrorCode2["E_FREE_PLAN_KEEP_PROGRAM_INVALID"] = "E_FREE_PLAN_KEEP_PROGRAM_INVALID";
  ErrorCode2["E_MISSING_ORGANIZATION"] = "E_MISSING_ORGANIZATION";
  ErrorCode2["E_BRAND_TERMS_NOT_FOUND"] = "E_BRAND_TERMS_NOT_FOUND";
  ErrorCode2["E_BRAND_TERMS_REQUIRED"] = "E_BRAND_TERMS_REQUIRED";
  ErrorCode2["E_BRAND_TERMS_STALE"] = "E_BRAND_TERMS_STALE";
  ErrorCode2["E_BRAND_TERMS_EMPTY"] = "E_BRAND_TERMS_EMPTY";
  ErrorCode2["E_BRAND_TERMS_PAYLOAD_UNAVAILABLE"] = "E_BRAND_TERMS_PAYLOAD_UNAVAILABLE";
  ErrorCode2["E_LEGAL_ACCEPTANCE_REQUIRED"] = "E_LEGAL_ACCEPTANCE_REQUIRED";
  ErrorCode2["E_GIFT_REQUEST_NOT_FOUND"] = "E_GIFT_REQUEST_NOT_FOUND";
  ErrorCode2["E_GIFT_REQUEST_EXPIRED"] = "E_GIFT_REQUEST_EXPIRED";
  ErrorCode2["E_GIFT_INVALID_TRANSITION"] = "E_GIFT_INVALID_TRANSITION";
  ErrorCode2["E_GIFT_ALREADY_CLAIMED"] = "E_GIFT_ALREADY_CLAIMED";
  ErrorCode2["E_GIFT_NOT_CLAIMABLE"] = "E_GIFT_NOT_CLAIMABLE";
  ErrorCode2["E_GIFT_INVALID_PRODUCT_SELECTION"] = "E_GIFT_INVALID_PRODUCT_SELECTION";
  ErrorCode2["E_GIFT_INVALID_PRODUCT_COUNT"] = "E_GIFT_INVALID_PRODUCT_COUNT";
  ErrorCode2["E_GIFT_SHIPPING_ADDRESS_REQUIRED"] = "E_GIFT_SHIPPING_ADDRESS_REQUIRED";
  ErrorCode2["E_GIFT_PHONE_REQUIRED"] = "E_GIFT_PHONE_REQUIRED";
  ErrorCode2["E_GIFT_PHONE_INVALID"] = "E_GIFT_PHONE_INVALID";
  ErrorCode2["E_GIFT_ORDER_CREATION_FAILED"] = "E_GIFT_ORDER_CREATION_FAILED";
  ErrorCode2["E_GIFT_UNAUTHORIZED"] = "E_GIFT_UNAUTHORIZED";
  ErrorCode2["E_GIFT_INVALID_CUSTOM_FIELDS"] = "E_GIFT_INVALID_CUSTOM_FIELDS";
  ErrorCode2["E_GIFT_TRACKING_UNAVAILABLE"] = "E_GIFT_TRACKING_UNAVAILABLE";
  ErrorCode2["E_GIFT_CANCEL_REQUIRES_SHOPIFY"] = "E_GIFT_CANCEL_REQUIRES_SHOPIFY";
  ErrorCode2["E_GIFT_CANCEL_ORDER_IN_PROGRESS"] = "E_GIFT_CANCEL_ORDER_IN_PROGRESS";
  ErrorCode2["E_GIFT_RETRY_NOT_ALLOWED"] = "E_GIFT_RETRY_NOT_ALLOWED";
  ErrorCode2["E_GIFT_RETRY_TOO_SOON"] = "E_GIFT_RETRY_TOO_SOON";
  ErrorCode2["E_GIFT_REOFFER_NOT_ALLOWED"] = "E_GIFT_REOFFER_NOT_ALLOWED";
  ErrorCode2["E_GIFT_REOFFER_INVALID_DURATION"] = "E_GIFT_REOFFER_INVALID_DURATION";
  ErrorCode2["E_GIFT_REOFFER_RECIPIENT_INELIGIBLE"] = "E_GIFT_REOFFER_RECIPIENT_INELIGIBLE";
  ErrorCode2["E_GIFT_REOFFER_CATALOG_INVALID"] = "E_GIFT_REOFFER_CATALOG_INVALID";
  ErrorCode2["E_GIFT_REOFFER_STOCK_OVERRIDE_REQUIRED"] = "E_GIFT_REOFFER_STOCK_OVERRIDE_REQUIRED";
  ErrorCode2["E_GIFT_CATALOG_VERIFICATION_UNAVAILABLE"] = "E_GIFT_CATALOG_VERIFICATION_UNAVAILABLE";
  ErrorCode2["E_GIFT_VARIANT_OUT_OF_STOCK"] = "E_GIFT_VARIANT_OUT_OF_STOCK";
  ErrorCode2["E_FLOW_NOT_FOUND"] = "E_FLOW_NOT_FOUND";
  ErrorCode2["E_FLOW_INVALID_TRANSITION"] = "E_FLOW_INVALID_TRANSITION";
  ErrorCode2["E_FLOW_CANNOT_MODIFY_ARCHIVED"] = "E_FLOW_CANNOT_MODIFY_ARCHIVED";
  ErrorCode2["E_FLOW_INVALID_DEFINITION"] = "E_FLOW_INVALID_DEFINITION";
  ErrorCode2["E_FLOW_VERSION_CONFLICT"] = "E_FLOW_VERSION_CONFLICT";
  ErrorCode2["E_FLOW_EXECUTION_NOT_FOUND"] = "E_FLOW_EXECUTION_NOT_FOUND";
  ErrorCode2["E_FLOW_EXECUTION_INVALID_TRANSITION"] = "E_FLOW_EXECUTION_INVALID_TRANSITION";
  ErrorCode2["E_FLOW_EXECUTION_ALREADY_RUNNING"] = "E_FLOW_EXECUTION_ALREADY_RUNNING";
  ErrorCode2["E_FLOW_EXECUTION_STEP_FAILED"] = "E_FLOW_EXECUTION_STEP_FAILED";
  ErrorCode2["E_FLOW_UNSUPPORTED_ACTION_TYPE"] = "E_FLOW_UNSUPPORTED_ACTION_TYPE";
  ErrorCode2["E_FLOW_STEP_INCOMPATIBLE_WITH_TRIGGER"] = "E_FLOW_STEP_INCOMPATIBLE_WITH_TRIGGER";
  ErrorCode2["E_FLOW_STEP_NOT_FOUND"] = "E_FLOW_STEP_NOT_FOUND";
  ErrorCode2["E_FLOW_UNAUTHORIZED"] = "E_FLOW_UNAUTHORIZED";
  ErrorCode2["E_FLOW_SEND_EMAIL_MISSING_REPLY_TO"] = "E_FLOW_SEND_EMAIL_MISSING_REPLY_TO";
  ErrorCode2["E_FLOW_SEND_EMAIL_QUOTA_EXCEEDED"] = "E_FLOW_SEND_EMAIL_QUOTA_EXCEEDED";
  ErrorCode2["E_FLOW_SEND_EMAIL_INVALID_CONFIG"] = "E_FLOW_SEND_EMAIL_INVALID_CONFIG";
  ErrorCode2["E_FLOW_SEND_EMAIL_MISSING_RECIPIENT"] = "E_FLOW_SEND_EMAIL_MISSING_RECIPIENT";
  ErrorCode2["E_FLOW_SEND_EMAIL_DISPATCH_FAILED"] = "E_FLOW_SEND_EMAIL_DISPATCH_FAILED";
  ErrorCode2["E_PERMISSION_DENIED"] = "E_PERMISSION_DENIED";
  ErrorCode2["E_INSUFFICIENT_BRAND_ACCESS"] = "E_INSUFFICIENT_BRAND_ACCESS";
  ErrorCode2["E_NOT_ORGANIZATION_MEMBER"] = "E_NOT_ORGANIZATION_MEMBER";
  ErrorCode2["E_NOT_ORGANIZATION_OWNER"] = "E_NOT_ORGANIZATION_OWNER";
  ErrorCode2["E_BRAND_ACCESS_NOT_FOUND"] = "E_BRAND_ACCESS_NOT_FOUND";
  ErrorCode2["E_TEAM_MEMBER_NOT_FOUND"] = "E_TEAM_MEMBER_NOT_FOUND";
  ErrorCode2["E_CANNOT_REMOVE_OWNER"] = "E_CANNOT_REMOVE_OWNER";
  ErrorCode2["E_CANNOT_REMOVE_SELF"] = "E_CANNOT_REMOVE_SELF";
  ErrorCode2["E_CANNOT_MODIFY_OWNER_ACCESS"] = "E_CANNOT_MODIFY_OWNER_ACCESS";
  ErrorCode2["E_TEAM_INVITATION_NOT_FOUND"] = "E_TEAM_INVITATION_NOT_FOUND";
  ErrorCode2["E_TEAM_INVITATION_NOT_PENDING"] = "E_TEAM_INVITATION_NOT_PENDING";
  ErrorCode2["E_TEAM_INVITATION_EXPIRED"] = "E_TEAM_INVITATION_EXPIRED";
  ErrorCode2["E_TEAM_INVITATION_CANCELLED"] = "E_TEAM_INVITATION_CANCELLED";
  ErrorCode2["E_TEAM_INVITATION_ALREADY_ACCEPTED"] = "E_TEAM_INVITATION_ALREADY_ACCEPTED";
  ErrorCode2["E_USER_ALREADY_MEMBER"] = "E_USER_ALREADY_MEMBER";
  ErrorCode2["E_PENDING_INVITATION_EXISTS"] = "E_PENDING_INVITATION_EXISTS";
  ErrorCode2["E_INVITATION_CANONICAL_CONFLICT"] = "E_INVITATION_CANONICAL_CONFLICT";
  ErrorCode2["E_NATIVE_OPERATION_BUSY"] = "E_NATIVE_OPERATION_BUSY";
  ErrorCode2["E_FORMER_MEMBER_NOT_FOUND"] = "E_FORMER_MEMBER_NOT_FOUND";
  ErrorCode2["E_MEMBER_ALREADY_ACTIVE"] = "E_MEMBER_ALREADY_ACTIVE";
  ErrorCode2["E_INVALID_BRAND_ACCESS"] = "E_INVALID_BRAND_ACCESS";
  ErrorCode2["E_EMAIL_MISMATCH"] = "E_EMAIL_MISMATCH";
  ErrorCode2["E_PASSWORD_REQUIRED"] = "E_PASSWORD_REQUIRED";
  ErrorCode2["E_UNAUTHORIZED_BRAND_ACCESS"] = "E_UNAUTHORIZED_BRAND_ACCESS";
  ErrorCode2["E_BRAND_SIGNUP_INVITATION_NOT_FOUND"] = "E_BRAND_SIGNUP_INVITATION_NOT_FOUND";
  ErrorCode2["E_BRAND_SIGNUP_INVITATION_NOT_PENDING"] = "E_BRAND_SIGNUP_INVITATION_NOT_PENDING";
  ErrorCode2["E_BRAND_SIGNUP_INVITATION_EXPIRED"] = "E_BRAND_SIGNUP_INVITATION_EXPIRED";
  ErrorCode2["E_BRAND_SIGNUP_INVITATION_REVOKED"] = "E_BRAND_SIGNUP_INVITATION_REVOKED";
  ErrorCode2["E_BRAND_SIGNUP_INVITATION_ALREADY_ACCEPTED"] = "E_BRAND_SIGNUP_INVITATION_ALREADY_ACCEPTED";
  ErrorCode2["E_BRAND_SIGNUP_INVITATION_PENDING_EXISTS"] = "E_BRAND_SIGNUP_INVITATION_PENDING_EXISTS";
  ErrorCode2["E_BRAND_SIGNUP_INVITATION_EMAIL_REGISTERED"] = "E_BRAND_SIGNUP_INVITATION_EMAIL_REGISTERED";
  ErrorCode2["E_BRAND_SIGNUP_INVITATION_TOKEN_REQUIRED"] = "E_BRAND_SIGNUP_INVITATION_TOKEN_REQUIRED";
  ErrorCode2["E_BRAND_SIGNUP_CODE_INVALID"] = "E_BRAND_SIGNUP_CODE_INVALID";
  ErrorCode2["E_BRAND_SIGNUP_CODE_TOO_MANY_ATTEMPTS"] = "E_BRAND_SIGNUP_CODE_TOO_MANY_ATTEMPTS";
  ErrorCode2["E_BRAND_SIGNUP_CODE_TOO_MANY_REQUESTS"] = "E_BRAND_SIGNUP_CODE_TOO_MANY_REQUESTS";
  ErrorCode2["E_BRAND_SIGNUP_EMAIL_UNVERIFIED"] = "E_BRAND_SIGNUP_EMAIL_UNVERIFIED";
  ErrorCode2["E_BRAND_SIGNUP_WORK_EMAIL_REQUIRED"] = "E_BRAND_SIGNUP_WORK_EMAIL_REQUIRED";
  ErrorCode2["E_BRAND_NAME_TAKEN"] = "E_BRAND_NAME_TAKEN";
  ErrorCode2["E_BRAND_ONBOARDING_NAME_LOCKED"] = "E_BRAND_ONBOARDING_NAME_LOCKED";
  ErrorCode2["E_BRAND_ONBOARDING_WEBSITE_REQUIRED"] = "E_BRAND_ONBOARDING_WEBSITE_REQUIRED";
  ErrorCode2["E_EXPORT_NOT_FOUND"] = "E_EXPORT_NOT_FOUND";
  ErrorCode2["E_EXPORT_FORBIDDEN"] = "E_EXPORT_FORBIDDEN";
  ErrorCode2["E_EXPORT_UNKNOWN_RESOURCE"] = "E_EXPORT_UNKNOWN_RESOURCE";
  ErrorCode2["E_TIKTOK_TOKEN_EXCHANGE"] = "E_TIKTOK_TOKEN_EXCHANGE";
  ErrorCode2["E_TIKTOK_TOKEN_REFRESH"] = "E_TIKTOK_TOKEN_REFRESH";
  ErrorCode2["E_TIKTOK_API_ERROR"] = "E_TIKTOK_API_ERROR";
  ErrorCode2["E_TIKTOK_RATE_LIMITED"] = "E_TIKTOK_RATE_LIMITED";
  ErrorCode2["E_STRIPE_VALIDATION_FAILED"] = "E_STRIPE_VALIDATION_FAILED";
  ErrorCode2["E_STRIPE_BUSINESS_REJECTED"] = "E_STRIPE_BUSINESS_REJECTED";
  ErrorCode2["E_STRIPE_ACCOUNT_NOT_FOUND"] = "E_STRIPE_ACCOUNT_NOT_FOUND";
  ErrorCode2["E_STRIPE_ACCOUNT_CREATION_FAILED"] = "E_STRIPE_ACCOUNT_CREATION_FAILED";
  ErrorCode2["E_BUSINESS_TYPE_REQUIRED"] = "E_BUSINESS_TYPE_REQUIRED";
  ErrorCode2["E_BUSINESS_TYPE_SWITCH_INVALID_PAYLOAD"] = "E_BUSINESS_TYPE_SWITCH_INVALID_PAYLOAD";
  ErrorCode2["E_TEMPLATE_INVALID_PAIR"] = "E_TEMPLATE_INVALID_PAIR";
  ErrorCode2["E_TEMPLATE_INVALID_VARIABLE"] = "E_TEMPLATE_INVALID_VARIABLE";
  ErrorCode2["E_TEMPLATE_MISSING_REQUIRED_VARIABLE"] = "E_TEMPLATE_MISSING_REQUIRED_VARIABLE";
  ErrorCode2["E_TEMPLATE_SYSTEM_DEFAULT_IMMUTABLE"] = "E_TEMPLATE_SYSTEM_DEFAULT_IMMUTABLE";
  ErrorCode2["E_TEMPLATE_BELONGS_TO_OTHER_BRAND"] = "E_TEMPLATE_BELONGS_TO_OTHER_BRAND";
  ErrorCode2["E_TEMPLATE_DEFAULT_CONFLICT"] = "E_TEMPLATE_DEFAULT_CONFLICT";
  ErrorCode2["E_BRAND_BUDGET_EXCEEDED"] = "E_BRAND_BUDGET_EXCEEDED";
  ErrorCode2["E_AGENT_LOOP_DEPTH"] = "E_AGENT_LOOP_DEPTH";
  ErrorCode2["E_AGENT_OUTPUT_INVALID"] = "E_AGENT_OUTPUT_INVALID";
  ErrorCode2["E_AGENT_NOT_ENABLED"] = "E_AGENT_NOT_ENABLED";
  ErrorCode2["E_AGENT_TOOL_NOT_FOUND"] = "E_AGENT_TOOL_NOT_FOUND";
  ErrorCode2["E_BRAND_DNA_MISSING_FOR_EXTRACT"] = "E_BRAND_DNA_MISSING_FOR_EXTRACT";
  ErrorCode2["E_BRIEF_TEMPLATE_NOT_FOUND"] = "E_BRIEF_TEMPLATE_NOT_FOUND";
  ErrorCode2["E_BRIEF_TEMPLATE_ARCHIVED"] = "E_BRIEF_TEMPLATE_ARCHIVED";
  ErrorCode2["E_BRIEF_TEMPLATE_IN_USE"] = "E_BRIEF_TEMPLATE_IN_USE";
  ErrorCode2["E_BRIEF_TEMPLATE_INVALID_TIMELINE"] = "E_BRIEF_TEMPLATE_INVALID_TIMELINE";
  ErrorCode2["E_BRIEF_NOT_OPENABLE"] = "E_BRIEF_NOT_OPENABLE";
  ErrorCode2["E_BRIEF_GENERATION_FAILED"] = "E_BRIEF_GENERATION_FAILED";
  ErrorCode2["E_UGC_NOT_AVAILABLE"] = "E_UGC_NOT_AVAILABLE";
  ErrorCode2["E_UGC_SHOPIFY_NOT_CONNECTED"] = "E_UGC_SHOPIFY_NOT_CONNECTED";
  ErrorCode2["E_UGC_BRIEF_INCOMPLETE"] = "E_UGC_BRIEF_INCOMPLETE";
  ErrorCode2["E_CREATOR_HUB_UGC_NOT_AVAILABLE"] = "E_CREATOR_HUB_UGC_NOT_AVAILABLE";
  ErrorCode2["E_CREATOR_UGC_SAMPLE_LIMIT_REACHED"] = "E_CREATOR_UGC_SAMPLE_LIMIT_REACHED";
  ErrorCode2["E_CREATOR_UGC_SAMPLE_NOT_FOUND"] = "E_CREATOR_UGC_SAMPLE_NOT_FOUND";
  ErrorCode2["E_BRIEF_APPLICATION_NOT_FOUND"] = "E_BRIEF_APPLICATION_NOT_FOUND";
  ErrorCode2["E_OPPORTUNITY_NOT_OPEN"] = "E_OPPORTUNITY_NOT_OPEN";
  ErrorCode2["E_BRIEF_APPLICATION_DECISION_CONFLICT"] = "E_BRIEF_APPLICATION_DECISION_CONFLICT";
  ErrorCode2["E_BRIEF_APPLICATION_RECIPIENT_MISMATCH"] = "E_BRIEF_APPLICATION_RECIPIENT_MISMATCH";
  ErrorCode2["E_BRIEF_APPLICATION_NETWORK_REQUIRED"] = "E_BRIEF_APPLICATION_NETWORK_REQUIRED";
  ErrorCode2["E_PROGRAM_APPLICATION_ALREADY_MEMBER"] = "E_PROGRAM_APPLICATION_ALREADY_MEMBER";
  ErrorCode2["E_OPPORTUNITY_UGC_BADGE_REQUIRED"] = "E_OPPORTUNITY_UGC_BADGE_REQUIRED";
  ErrorCode2["E_OPPORTUNITY_UGC_NOT_AVAILABLE"] = "E_OPPORTUNITY_UGC_NOT_AVAILABLE";
  ErrorCode2["E_COLLAB_NOT_FOUND"] = "E_COLLAB_NOT_FOUND";
  ErrorCode2["E_COLLAB_INVALID_TRANSITION"] = "E_COLLAB_INVALID_TRANSITION";
  ErrorCode2["E_COLLAB_NOT_EDITABLE"] = "E_COLLAB_NOT_EDITABLE";
  ErrorCode2["E_COLLAB_DRAFT_CONFLICT"] = "E_COLLAB_DRAFT_CONFLICT";
  ErrorCode2["E_COLLAB_RECIPIENT_REQUIRED"] = "E_COLLAB_RECIPIENT_REQUIRED";
  ErrorCode2["E_COLLAB_COMPENSATION_REQUIRED"] = "E_COLLAB_COMPENSATION_REQUIRED";
  ErrorCode2["E_COLLAB_EXPIRED"] = "E_COLLAB_EXPIRED";
  ErrorCode2["E_COLLAB_CODE_INVALID"] = "E_COLLAB_CODE_INVALID";
  ErrorCode2["E_COLLAB_CODE_REQUIRED"] = "E_COLLAB_CODE_REQUIRED";
  ErrorCode2["E_COLLAB_ACCEPTANCE_PROOF_INVALID"] = "E_COLLAB_ACCEPTANCE_PROOF_INVALID";
  ErrorCode2["E_COLLAB_FULL_NAME_REQUIRED"] = "E_COLLAB_FULL_NAME_REQUIRED";
  ErrorCode2["E_COLLAB_REMIND_TOO_SOON"] = "E_COLLAB_REMIND_TOO_SOON";
  ErrorCode2["E_COLLAB_REMIND_NO_CHANNEL"] = "E_COLLAB_REMIND_NO_CHANNEL";
  ErrorCode2["E_COLLAB_DELIVERABLE_NOT_FOUND"] = "E_COLLAB_DELIVERABLE_NOT_FOUND";
  ErrorCode2["E_COLLAB_DELIVERABLE_INVALID_TRANSITION"] = "E_COLLAB_DELIVERABLE_INVALID_TRANSITION";
  ErrorCode2["E_COLLAB_DELIVERABLE_IDEMPOTENCY_CONFLICT"] = "E_COLLAB_DELIVERABLE_IDEMPOTENCY_CONFLICT";
  ErrorCode2["E_COLLAB_DELIVERABLE_INVALID_SUBMITTED_URL"] = "E_COLLAB_DELIVERABLE_INVALID_SUBMITTED_URL";
  ErrorCode2["E_COLLAB_DELIVERABLE_URL_WRONG_PLATFORM"] = "E_COLLAB_DELIVERABLE_URL_WRONG_PLATFORM";
  ErrorCode2["E_COLLAB_DELIVERABLE_REJECTION_REASON_REQUIRED"] = "E_COLLAB_DELIVERABLE_REJECTION_REASON_REQUIRED";
  ErrorCode2["E_COLLAB_DELIVERABLE_OPERATION_ID_REQUIRED"] = "E_COLLAB_DELIVERABLE_OPERATION_ID_REQUIRED";
  ErrorCode2["E_COLLAB_DELIVERABLES_INCOMPLETE"] = "E_COLLAB_DELIVERABLES_INCOMPLETE";
  ErrorCode2["E_COLLAB_DELIVERABLE_MENTION_INELIGIBLE"] = "E_COLLAB_DELIVERABLE_MENTION_INELIGIBLE";
  ErrorCode2["E_COLLAB_DELIVERABLE_MENTION_ALREADY_ATTACHED"] = "E_COLLAB_DELIVERABLE_MENTION_ALREADY_ATTACHED";
  ErrorCode2["E_COLLAB_ABANDON_BLOCKED_BY_DELIVERABLES"] = "E_COLLAB_ABANDON_BLOCKED_BY_DELIVERABLES";
  ErrorCode2["E_COLLAB_ABANDON_REASON_REQUIRED"] = "E_COLLAB_ABANDON_REASON_REQUIRED";
  ErrorCode2["E_COLLAB_USAGE_RIGHTS_REQUIRED"] = "E_COLLAB_USAGE_RIGHTS_REQUIRED";
  ErrorCode2["E_COLLAB_GIFTED_PRODUCT_VALUE_REQUIRED"] = "E_COLLAB_GIFTED_PRODUCT_VALUE_REQUIRED";
  ErrorCode2["E_COLLAB_BRAND_IDENTITY_INCOMPLETE"] = "E_COLLAB_BRAND_IDENTITY_INCOMPLETE";
  ErrorCode2["E_COLLAB_TAX_RESIDENCE_REQUIRED"] = "E_COLLAB_TAX_RESIDENCE_REQUIRED";
  ErrorCode2["E_COLLAB_AGE_ATTESTATION_REQUIRED"] = "E_COLLAB_AGE_ATTESTATION_REQUIRED";
  ErrorCode2["E_COLLAB_TAX_RESIDENCE_INVALID"] = "E_COLLAB_TAX_RESIDENCE_INVALID";
  ErrorCode2["E_COLLAB_PAYOUT_COUNTRY_UNSUPPORTED"] = "E_COLLAB_PAYOUT_COUNTRY_UNSUPPORTED";
  ErrorCode2["E_COLLAB_EMAIL_ROLE_CONFLICT"] = "E_COLLAB_EMAIL_ROLE_CONFLICT";
  ErrorCode2["E_COLLAB_EMAIL_ACCOUNT_CLOSED"] = "E_COLLAB_EMAIL_ACCOUNT_CLOSED";
  ErrorCode2["E_COLLAB_PROPOSAL_LINK_MISSING"] = "E_COLLAB_PROPOSAL_LINK_MISSING";
  ErrorCode2["E_COLLAB_MAILBOX_NOT_CONNECTED"] = "E_COLLAB_MAILBOX_NOT_CONNECTED";
  ErrorCode2["E_COLLAB_REPROPOSAL_LIMIT"] = "E_COLLAB_REPROPOSAL_LIMIT";
  ErrorCode2["E_COLLAB_DELIVERABLE_REJECTIONS_EXHAUSTED"] = "E_COLLAB_DELIVERABLE_REJECTIONS_EXHAUSTED";
  ErrorCode2["E_COLLAB_DELIVERABLE_WITHOUT_CONTENT"] = "E_COLLAB_DELIVERABLE_WITHOUT_CONTENT";
  ErrorCode2["E_COLLAB_PAYMENT_TERMS_NOT_ACCEPTED"] = "E_COLLAB_PAYMENT_TERMS_NOT_ACCEPTED";
  ErrorCode2["E_COLLAB_PAYMENT_TERMS_SNAPSHOT_MISMATCH"] = "E_COLLAB_PAYMENT_TERMS_SNAPSHOT_MISMATCH";
  ErrorCode2["E_COLLAB_DISPUTE_ALREADY_OPEN"] = "E_COLLAB_DISPUTE_ALREADY_OPEN";
  ErrorCode2["E_COLLAB_FROZEN_BY_DISPUTE"] = "E_COLLAB_FROZEN_BY_DISPUTE";
  ErrorCode2["E_COLLAB_CREATOR_DISPUTE_ALREADY_USED"] = "E_COLLAB_CREATOR_DISPUTE_ALREADY_USED";
  ErrorCode2["E_COLLAB_WITHDRAW_BLOCKED_BY_CONTENT"] = "E_COLLAB_WITHDRAW_BLOCKED_BY_CONTENT";
  ErrorCode2["E_COLLAB_FUNDING_WINDOW_CLOSED"] = "E_COLLAB_FUNDING_WINDOW_CLOSED";
  ErrorCode2["E_COLLAB_NOT_FUNDED"] = "E_COLLAB_NOT_FUNDED";
  ErrorCode2["E_COLLAB_DEADLINE_EXTENSION_USED"] = "E_COLLAB_DEADLINE_EXTENSION_USED";
  ErrorCode2["E_COLLAB_UGC_END_DEADLINE_AT_CAP"] = "E_COLLAB_UGC_END_DEADLINE_AT_CAP";
  ErrorCode2["E_COLLAB_ADMIN_REQUIRED"] = "E_COLLAB_ADMIN_REQUIRED";
  ErrorCode2["E_COLLAB_END_DEADLINE_REQUIRED"] = "E_COLLAB_END_DEADLINE_REQUIRED";
  ErrorCode2["E_COLLAB_END_DEADLINE_TOO_FAR"] = "E_COLLAB_END_DEADLINE_TOO_FAR";
  ErrorCode2["E_COLLAB_AMOUNT_ABOVE_CAP"] = "E_COLLAB_AMOUNT_ABOVE_CAP";
  ErrorCode2["E_COLLAB_BRAND_BANK_DISPUTED"] = "E_COLLAB_BRAND_BANK_DISPUTED";
  ErrorCode2["E_COLLAB_UGC_PAYMENT_BELOW_MINIMUM"] = "E_COLLAB_UGC_PAYMENT_BELOW_MINIMUM";
  ErrorCode2["E_COLLAB_UGC_PRODUCT_NOT_FROM_CATALOG"] = "E_COLLAB_UGC_PRODUCT_NOT_FROM_CATALOG";
  ErrorCode2["E_COLLAB_UGC_SHIPMENT_EXTENSION_USED"] = "E_COLLAB_UGC_SHIPMENT_EXTENSION_USED";
  ErrorCode2["E_COLLAB_UGC_SHIPMENT_NOT_ACTIONABLE"] = "E_COLLAB_UGC_SHIPMENT_NOT_ACTIONABLE";
  ErrorCode2["E_COLLAB_UGC_PRODUCT_NOT_SHIPPED"] = "E_COLLAB_UGC_PRODUCT_NOT_SHIPPED";
  ErrorCode2["E_COLLAB_UGC_RECEPTION_QUESTION_NOT_OPEN"] = "E_COLLAB_UGC_RECEPTION_QUESTION_NOT_OPEN";
  ErrorCode2["E_COLLAB_UGC_RECEPTION_CHOICE_NOT_OPEN"] = "E_COLLAB_UGC_RECEPTION_CHOICE_NOT_OPEN";
  ErrorCode2["E_COLLAB_UGC_RESHIP_USED"] = "E_COLLAB_UGC_RESHIP_USED";
  ErrorCode2["E_COLLAB_DELIVERABLE_UGC_NOT_A_POST"] = "E_COLLAB_DELIVERABLE_UGC_NOT_A_POST";
  ErrorCode2["E_COLLAB_MODIFICATION_REQUEST_CATEGORY_REQUIRED"] = "E_COLLAB_MODIFICATION_REQUEST_CATEGORY_REQUIRED";
  ErrorCode2["E_COLLAB_NO_MODIFICATION_REQUEST_TO_OVERTURN"] = "E_COLLAB_NO_MODIFICATION_REQUEST_TO_OVERTURN";
  ErrorCode2["E_COLLAB_REQUEST_OVERTURN_UNAVAILABLE"] = "E_COLLAB_REQUEST_OVERTURN_UNAVAILABLE";
  ErrorCode2["E_COLLAB_PAYMENTS_DISABLED"] = "E_COLLAB_PAYMENTS_DISABLED";
  ErrorCode2["E_COLLAB_PAYMENT_RIGHT_NOT_FOUND"] = "E_COLLAB_PAYMENT_RIGHT_NOT_FOUND";
  ErrorCode2["E_COLLAB_PAYMENT_RIGHT_NOT_DUE"] = "E_COLLAB_PAYMENT_RIGHT_NOT_DUE";
  ErrorCode2["E_COLLAB_SETTLEMENT_BENEFICIARY_NOT_PAYABLE"] = "E_COLLAB_SETTLEMENT_BENEFICIARY_NOT_PAYABLE";
  ErrorCode2["E_COLLAB_SETTLEMENT_NOT_PREPARED"] = "E_COLLAB_SETTLEMENT_NOT_PREPARED";
  ErrorCode2["E_COLLAB_SETTLEMENT_NOT_COLLECTABLE"] = "E_COLLAB_SETTLEMENT_NOT_COLLECTABLE";
  ErrorCode2["E_COLLAB_SETTLEMENT_COLLECTION_ATTEMPT_SUPERSEDED"] = "E_COLLAB_SETTLEMENT_COLLECTION_ATTEMPT_SUPERSEDED";
  ErrorCode2["E_COLLAB_SETTLEMENT_BILLING_NOT_CONFIGURED"] = "E_COLLAB_SETTLEMENT_BILLING_NOT_CONFIGURED";
  ErrorCode2["E_COLLAB_SETTLEMENT_COLLECTION_FAILED"] = "E_COLLAB_SETTLEMENT_COLLECTION_FAILED";
  ErrorCode2["E_COLLAB_SETTLEMENT_CURRENCY_UNSUPPORTED"] = "E_COLLAB_SETTLEMENT_CURRENCY_UNSUPPORTED";
  ErrorCode2["E_COLLAB_SETTLEMENT_FEE_POLICY_UNRESOLVED"] = "E_COLLAB_SETTLEMENT_FEE_POLICY_UNRESOLVED";
  ErrorCode2["E_COLLAB_PAYMENT_DOCUMENT_NOT_FOUND"] = "E_COLLAB_PAYMENT_DOCUMENT_NOT_FOUND";
  ErrorCode2["E_COLLAB_PAYMENT_DOCUMENT_NOT_AVAILABLE"] = "E_COLLAB_PAYMENT_DOCUMENT_NOT_AVAILABLE";
  ErrorCode2["E_CREATOR_HUB_INVITATION_INVALID"] = "E_CREATOR_HUB_INVITATION_INVALID";
  ErrorCode2["E_MESSAGE_CHANNEL_NOT_FOUND"] = "E_MESSAGE_CHANNEL_NOT_FOUND";
  ErrorCode2["E_MESSAGE_CHANNEL_UNAVAILABLE"] = "E_MESSAGE_CHANNEL_UNAVAILABLE";
  ErrorCode2["E_MESSAGE_IDEMPOTENCY_CONFLICT"] = "E_MESSAGE_IDEMPOTENCY_CONFLICT";
  ErrorCode2["E_MESSAGE_SEND_FORBIDDEN"] = "E_MESSAGE_SEND_FORBIDDEN";
  ErrorCode2["E_MESSAGE_BLOCKED"] = "E_MESSAGE_BLOCKED";
  ErrorCode2["E_MESSAGE_DELIVERY_FAILED"] = "E_MESSAGE_DELIVERY_FAILED";
  ErrorCode2["E_MESSAGE_DELIVERY_UNKNOWN"] = "E_MESSAGE_DELIVERY_UNKNOWN";
  ErrorCode2["E_CREATOR_CONTACT_UNAVAILABLE"] = "E_CREATOR_CONTACT_UNAVAILABLE";
  ErrorCode2["E_CREATOR_HUB_MALFORMED_CURSOR"] = "E_CREATOR_HUB_MALFORMED_CURSOR";
  ErrorCode2["E_CREATOR_HUB_INVALID_REPORT_TARGET"] = "E_CREATOR_HUB_INVALID_REPORT_TARGET";
  ErrorCode2["E_CREATOR_HUB_PUSH_DEVICE_CONTEXT_REQUIRED"] = "E_CREATOR_HUB_PUSH_DEVICE_CONTEXT_REQUIRED";
  ErrorCode2["E_CREATOR_HUB_PUSH_SESSION_INVALID"] = "E_CREATOR_HUB_PUSH_SESSION_INVALID";
  ErrorCode2["E_CREATOR_HUB_PUSH_TOKEN_TRANSFER_IN_FLIGHT"] = "E_CREATOR_HUB_PUSH_TOKEN_TRANSFER_IN_FLIGHT";
  ErrorCode2["E_CREATOR_HUB_WEB_PUSH_UNAVAILABLE"] = "E_CREATOR_HUB_WEB_PUSH_UNAVAILABLE";
  ErrorCode2["E_MENTION_BOOST_LAUNCH_CURRENCY_MISMATCH"] = "E_MENTION_BOOST_LAUNCH_CURRENCY_MISMATCH";
  ErrorCode2["E_MENTION_BOOST_LAUNCH_DSA_BENEFICIARY_REQUIRED"] = "E_MENTION_BOOST_LAUNCH_DSA_BENEFICIARY_REQUIRED";
  ErrorCode2["E_BRAND_SPACE_NOT_FOUND"] = "E_BRAND_SPACE_NOT_FOUND";
  ErrorCode2["E_BRAND_SPACE_UNAVAILABLE"] = "E_BRAND_SPACE_UNAVAILABLE";
  ErrorCode2["E_BRAND_SPACE_VARIANT_NOT_FOUND"] = "E_BRAND_SPACE_VARIANT_NOT_FOUND";
  ErrorCode2["E_BRAND_SPACE_PREVIEW_INVALID"] = "E_BRAND_SPACE_PREVIEW_INVALID";
  ErrorCode2["E_BRAND_SPACE_DRAFT_CONFLICT"] = "E_BRAND_SPACE_DRAFT_CONFLICT";
  ErrorCode2["E_BRAND_SPACE_DRAFT_INVALID"] = "E_BRAND_SPACE_DRAFT_INVALID";
  ErrorCode2["E_BRAND_SPACE_SLUG_INVALID"] = "E_BRAND_SPACE_SLUG_INVALID";
  ErrorCode2["E_BRAND_SPACE_SLUG_NON_CANONICAL"] = "E_BRAND_SPACE_SLUG_NON_CANONICAL";
  ErrorCode2["E_BRAND_SPACE_SLUG_TAKEN"] = "E_BRAND_SPACE_SLUG_TAKEN";
  ErrorCode2["E_BRAND_SPACE_SLUG_RESERVED"] = "E_BRAND_SPACE_SLUG_RESERVED";
  ErrorCode2["E_BRAND_SPACE_SLUG_CHANGE_CONFIRMATION_REQUIRED"] = "E_BRAND_SPACE_SLUG_CHANGE_CONFIRMATION_REQUIRED";
  ErrorCode2["E_BRAND_SPACE_VARIANT_INVALID"] = "E_BRAND_SPACE_VARIANT_INVALID";
  ErrorCode2["E_BRAND_SPACE_VARIANT_LIMIT_REACHED"] = "E_BRAND_SPACE_VARIANT_LIMIT_REACHED";
  ErrorCode2["E_BRAND_SPACE_VARIANT_SUFFIX_INVALID"] = "E_BRAND_SPACE_VARIANT_SUFFIX_INVALID";
  ErrorCode2["E_BRAND_SPACE_EMERGENCY_UNPUBLISH_INVALID_STATUS"] = "E_BRAND_SPACE_EMERGENCY_UNPUBLISH_INVALID_STATUS";
  ErrorCode2["E_BRAND_SPACE_EMERGENCY_UNPUBLISH_IDEMPOTENCY_CONFLICT"] = "E_BRAND_SPACE_EMERGENCY_UNPUBLISH_IDEMPOTENCY_CONFLICT";
  ErrorCode2["E_BRAND_SPACE_ADMIN_ACTOR_ASSERTION_INVALID"] = "E_BRAND_SPACE_ADMIN_ACTOR_ASSERTION_INVALID";
  ErrorCode2["E_BRAND_SPACE_EMERGENCY_UNPUBLISH_CONFIRMATION_MISMATCH"] = "E_BRAND_SPACE_EMERGENCY_UNPUBLISH_CONFIRMATION_MISMATCH";
  ErrorCode2["E_BRAND_SPACE_VARIANT_SUFFIX_NON_CANONICAL"] = "E_BRAND_SPACE_VARIANT_SUFFIX_NON_CANONICAL";
  ErrorCode2["E_BRAND_SPACE_VARIANT_SUFFIX_RESERVED"] = "E_BRAND_SPACE_VARIANT_SUFFIX_RESERVED";
  ErrorCode2["E_BRAND_SPACE_VARIANT_SUFFIX_TAKEN"] = "E_BRAND_SPACE_VARIANT_SUFFIX_TAKEN";
  ErrorCode2["E_BRAND_SPACE_APPLICATION_UNAVAILABLE"] = "E_BRAND_SPACE_APPLICATION_UNAVAILABLE";
  ErrorCode2["E_BRAND_SPACE_APPLICATION_CHALLENGE_INVALID"] = "E_BRAND_SPACE_APPLICATION_CHALLENGE_INVALID";
  ErrorCode2["E_BRAND_SPACE_APPLICATION_INVALID"] = "E_BRAND_SPACE_APPLICATION_INVALID";
  ErrorCode2["E_BRAND_SPACE_APPLICATION_NOT_FOUND"] = "E_BRAND_SPACE_APPLICATION_NOT_FOUND";
  ErrorCode2["E_BRAND_SPACE_APPLICATION_STATE_CONFLICT"] = "E_BRAND_SPACE_APPLICATION_STATE_CONFLICT";
  ErrorCode2["E_BRAND_SPACE_APPLICATION_ALREADY_AFFILIATE"] = "E_BRAND_SPACE_APPLICATION_ALREADY_AFFILIATE";
  ErrorCode2["E_BRAND_SPACE_APPLICATION_INVITATION_CONFLICT"] = "E_BRAND_SPACE_APPLICATION_INVITATION_CONFLICT";
  ErrorCode2["E_BRAND_SPACE_APPLICATION_PROGRAM_REQUIRED"] = "E_BRAND_SPACE_APPLICATION_PROGRAM_REQUIRED";
  ErrorCode2["E_BRAND_SPACE_APPLICATION_ANSWERS_INVALID"] = "E_BRAND_SPACE_APPLICATION_ANSWERS_INVALID";
  ErrorCode2["E_BRAND_SPACE_APPLICATION_ANSWER_REQUIRED"] = "E_BRAND_SPACE_APPLICATION_ANSWER_REQUIRED";
  ErrorCode2["E_BRAND_SPACE_APPLICATION_QUESTION_UNKNOWN"] = "E_BRAND_SPACE_APPLICATION_QUESTION_UNKNOWN";
  ErrorCode2["E_SUCCESS_FEE_MIGRATION_FORBIDDEN"] = "E_SUCCESS_FEE_MIGRATION_FORBIDDEN";
  ErrorCode2["E_SUCCESS_FEE_MIGRATION_TERMS_NOT_ACCEPTED"] = "E_SUCCESS_FEE_MIGRATION_TERMS_NOT_ACCEPTED";
  ErrorCode2["E_SUCCESS_FEE_MIGRATION_NO_ACTIVE_SUBSCRIPTION"] = "E_SUCCESS_FEE_MIGRATION_NO_ACTIVE_SUBSCRIPTION";
  ErrorCode2["E_SUCCESS_FEE_MIGRATION_CURRENCY_MISMATCH"] = "E_SUCCESS_FEE_MIGRATION_CURRENCY_MISMATCH";
  ErrorCode2["E_SUCCESS_FEE_MIGRATION_INTEGRATION_MISSING"] = "E_SUCCESS_FEE_MIGRATION_INTEGRATION_MISSING";
  ErrorCode2["E_SUCCESS_FEE_TERMS_FORBIDDEN"] = "E_SUCCESS_FEE_TERMS_FORBIDDEN";
  ErrorCode2["E_SUCCESS_FEE_TERMS_NOT_IN_FORCE"] = "E_SUCCESS_FEE_TERMS_NOT_IN_FORCE";
  ErrorCode2["E_SUCCESS_FEE_TERMS_NOT_APPLICABLE"] = "E_SUCCESS_FEE_TERMS_NOT_APPLICABLE";
  ErrorCode2["E_SUCCESS_FEE_TERMS_SNAPSHOT_MISMATCH"] = "E_SUCCESS_FEE_TERMS_SNAPSHOT_MISMATCH";
  ErrorCode2["E_SUCCESS_FEE_TERMS_NOT_ACCEPTED"] = "E_SUCCESS_FEE_TERMS_NOT_ACCEPTED";
  ErrorCode2["E_SUCCESS_FEE_TERMS_LOCKED"] = "E_SUCCESS_FEE_TERMS_LOCKED";
  ErrorCode2["E_COMPANION_FEED_UNAVAILABLE"] = "E_COMPANION_FEED_UNAVAILABLE";
  ErrorCode2["E_COMPANION_ACTION_NOT_FOUND"] = "E_COMPANION_ACTION_NOT_FOUND";
  ErrorCode2["E_COMPANION_VERSION_CONFLICT"] = "E_COMPANION_VERSION_CONFLICT";
  ErrorCode2["E_COMPANION_UNDO_EXPIRED"] = "E_COMPANION_UNDO_EXPIRED";
  ErrorCode2["E_COMPANION_UNDO_CONFLICT"] = "E_COMPANION_UNDO_CONFLICT";
  ErrorCode2["E_COMPANION_SNOOZE_UNAVAILABLE"] = "E_COMPANION_SNOOZE_UNAVAILABLE";
  ErrorCode2["E_COMPANION_PANEL_UNAVAILABLE"] = "E_COMPANION_PANEL_UNAVAILABLE";
  ErrorCode2["E_COMPANION_PANEL_TURN_IN_PROGRESS"] = "E_COMPANION_PANEL_TURN_IN_PROGRESS";
  ErrorCode2["E_COMPANION_PANEL_QUESTION_INVALID"] = "E_COMPANION_PANEL_QUESTION_INVALID";
  ErrorCode2["E_AGENT_TENANT_MISMATCH"] = "E_AGENT_TENANT_MISMATCH";
  ErrorCode2["E_LAST_OWNER_CANNOT_BE_REMOVED"] = "E_LAST_OWNER_CANNOT_BE_REMOVED";
  ErrorCode2["E_ADMIN_ACTOR_REQUIRED"] = "E_ADMIN_ACTOR_REQUIRED";
  ErrorCode2["E_PROGRAM_TRACKING_VERSION_CONFLICT"] = "E_PROGRAM_TRACKING_VERSION_CONFLICT";
  ErrorCode2["E_PROGRAM_TRACKING_INVALID"] = "E_PROGRAM_TRACKING_INVALID";
  ErrorCode2["E_CONVERSATION_ATTACHMENT_TOO_LARGE"] = "E_CONVERSATION_ATTACHMENT_TOO_LARGE";
  ErrorCode2["E_CONVERSATION_ATTACHMENT_TYPE_UNSUPPORTED"] = "E_CONVERSATION_ATTACHMENT_TYPE_UNSUPPORTED";
  ErrorCode2["E_CONVERSATION_ATTACHMENT_UPLOAD_NOT_FOUND"] = "E_CONVERSATION_ATTACHMENT_UPLOAD_NOT_FOUND";
  ErrorCode2["E_CONVERSATION_ATTACHMENT_UPLOAD_INCOMPLETE"] = "E_CONVERSATION_ATTACHMENT_UPLOAD_INCOMPLETE";
  ErrorCode2["E_CONVERSATION_ATTACHMENT_UPLOAD_ALREADY_USED"] = "E_CONVERSATION_ATTACHMENT_UPLOAD_ALREADY_USED";
  ErrorCode2["E_CONVERSATION_ATTACHMENT_DRAFT_DELIVERABLE_INVALID"] = "E_CONVERSATION_ATTACHMENT_DRAFT_DELIVERABLE_INVALID";
  ErrorCode2["E_CONVERSATION_MESSAGE_ABOUT_INVALID"] = "E_CONVERSATION_MESSAGE_ABOUT_INVALID";
  ErrorCode2["E_CONVERSATION_ATTACHMENT_NOT_FOUND"] = "E_CONVERSATION_ATTACHMENT_NOT_FOUND";
  ErrorCode2["E_CONVERSATION_ATTACHMENT_STORAGE_UNAVAILABLE"] = "E_CONVERSATION_ATTACHMENT_STORAGE_UNAVAILABLE";
  ErrorCode2["E_COLLAB_QUESTION_CLOSED"] = "E_COLLAB_QUESTION_CLOSED";
  ErrorCode2["E_COLLAB_QUESTION_HELD_BY_ANOTHER_ACCOUNT"] = "E_COLLAB_QUESTION_HELD_BY_ANOTHER_ACCOUNT";
  ErrorCode2["E_UGC_VERSION_TYPE_UNSUPPORTED"] = "E_UGC_VERSION_TYPE_UNSUPPORTED";
  ErrorCode2["E_UGC_VERSION_TOO_LARGE"] = "E_UGC_VERSION_TOO_LARGE";
  ErrorCode2["E_UGC_VERSION_NOT_EXPECTED"] = "E_UGC_VERSION_NOT_EXPECTED";
  ErrorCode2["E_UGC_VERSION_QUOTA_EXHAUSTED"] = "E_UGC_VERSION_QUOTA_EXHAUSTED";
  ErrorCode2["E_UGC_VERSION_AWAITING_FUNDING"] = "E_UGC_VERSION_AWAITING_FUNDING";
  ErrorCode2["E_UGC_VERSION_NOT_FOUND"] = "E_UGC_VERSION_NOT_FOUND";
  ErrorCode2["E_UGC_VERSION_UPLOAD_INCOMPLETE"] = "E_UGC_VERSION_UPLOAD_INCOMPLETE";
  ErrorCode2["E_UGC_VERSION_NOT_A_MEDIA"] = "E_UGC_VERSION_NOT_A_MEDIA";
  ErrorCode2["E_UGC_VERSION_MUSIC_DECLARATION_REQUIRED"] = "E_UGC_VERSION_MUSIC_DECLARATION_REQUIRED";
  ErrorCode2["E_UGC_VERSION_ORIGINAL_LOCKED"] = "E_UGC_VERSION_ORIGINAL_LOCKED";
  ErrorCode2["E_UGC_VERSION_NOT_READY"] = "E_UGC_VERSION_NOT_READY";
  ErrorCode2["E_UGC_VERSION_STORAGE_UNAVAILABLE"] = "E_UGC_VERSION_STORAGE_UNAVAILABLE";
  ErrorCode2["E_UGC_FEEDBACK_NOT_FOUND"] = "E_UGC_FEEDBACK_NOT_FOUND";
  ErrorCode2["E_UGC_FEEDBACK_NOT_ALLOWED"] = "E_UGC_FEEDBACK_NOT_ALLOWED";
  ErrorCode2["E_UGC_FEEDBACK_BODY_REQUIRED"] = "E_UGC_FEEDBACK_BODY_REQUIRED";
  ErrorCode2["E_UGC_FEEDBACK_ANCHOR_REQUIRED"] = "E_UGC_FEEDBACK_ANCHOR_REQUIRED";
  ErrorCode2["E_UGC_PENDING_FEEDBACK_CHOICE_REQUIRED"] = "E_UGC_PENDING_FEEDBACK_CHOICE_REQUIRED";
  ErrorCode2["E_UGC_SERIES_DECISION_INVALID"] = "E_UGC_SERIES_DECISION_INVALID";
  ErrorCode2["E_CREATOR_NOTIFICATION_NOT_FOUND"] = "E_CREATOR_NOTIFICATION_NOT_FOUND";
  ErrorCode2["E_CREATOR_NOTIFICATION_INVALID_CURSOR"] = "E_CREATOR_NOTIFICATION_INVALID_CURSOR";
  ErrorCode2["E_ACCOUNT_UNAVAILABLE"] = "E_ACCOUNT_UNAVAILABLE";
  ErrorCode2["E_ADMIN_ACTION_NOT_FOUND"] = "E_ADMIN_ACTION_NOT_FOUND";
  ErrorCode2["E_ADMIN_ACTION_BLOCKED"] = "E_ADMIN_ACTION_BLOCKED";
  ErrorCode2["E_ADMIN_ACTION_CODE_INVALID"] = "E_ADMIN_ACTION_CODE_INVALID";
  ErrorCode2["E_ADMIN_ACTION_OPERATOR_INVALID"] = "E_ADMIN_ACTION_OPERATOR_INVALID";
  return ErrorCode2;
})(ErrorCode || {});

// src/api/features.ts
var PlanTier = /* @__PURE__ */ ((PlanTier2) => {
  PlanTier2["FREE"] = "FREE";
  PlanTier2["FREE_BETA"] = "FREE_BETA";
  PlanTier2["ESSENTIAL"] = "ESSENTIAL";
  PlanTier2["GROWTH"] = "GROWTH";
  return PlanTier2;
})(PlanTier || {});
var FeatureFlag = /* @__PURE__ */ ((FeatureFlag2) => {
  FeatureFlag2["MULTI_BRAND"] = "MULTI_BRAND";
  FeatureFlag2["FLOWS"] = "FLOWS";
  FeatureFlag2["FLOWS_V2"] = "FLOWS_V2";
  FeatureFlag2["TEAM_MEMBERS"] = "TEAM_MEMBERS";
  FeatureFlag2["SHOPIFY_INTEGRATION"] = "SHOPIFY_INTEGRATION";
  FeatureFlag2["MANUAL_DRIVE_ARCHIVE"] = "MANUAL_DRIVE_ARCHIVE";
  FeatureFlag2["AGENT_RECOMMENDATIONS"] = "AGENT_RECOMMENDATIONS";
  FeatureFlag2["PARTNERSHIP_ADS_BOOST"] = "PARTNERSHIP_ADS_BOOST";
  FeatureFlag2["TIKTOK_CREATOR_DISCOVERY"] = "TIKTOK_CREATOR_DISCOVERY";
  FeatureFlag2["COLLABS"] = "COLLABS";
  FeatureFlag2["COLLAB_PAYMENTS"] = "COLLAB_PAYMENTS";
  FeatureFlag2["BRAND_TERMS"] = "BRAND_TERMS";
  FeatureFlag2["BRIEF_APPLICATIONS"] = "BRIEF_APPLICATIONS";
  FeatureFlag2["UGC"] = "UGC";
  FeatureFlag2["FLOWS_CUSTOMER_ORDER"] = "FLOWS_CUSTOMER_ORDER";
  FeatureFlag2["COMPANION_PANEL"] = "COMPANION_PANEL";
  return FeatureFlag2;
})(FeatureFlag || {});
var DEFAULT_ON_FLAGS = /* @__PURE__ */ new Set([
  "AGENT_RECOMMENDATIONS" /* AGENT_RECOMMENDATIONS */
]);
var PLAN_FEATURES = {
  ["FREE" /* FREE */]: {
    features: ["SHOPIFY_INTEGRATION" /* SHOPIFY_INTEGRATION */, "MANUAL_DRIVE_ARCHIVE" /* MANUAL_DRIVE_ARCHIVE */],
    limits: {
      maxBrands: 1,
      maxFlows: 0,
      maxActiveBriefs: 1
    }
  },
  ["FREE_BETA" /* FREE_BETA */]: {
    features: ["SHOPIFY_INTEGRATION" /* SHOPIFY_INTEGRATION */, "MANUAL_DRIVE_ARCHIVE" /* MANUAL_DRIVE_ARCHIVE */],
    limits: {
      maxBrands: 1,
      maxFlows: 0,
      maxActiveBriefs: -1
    }
  },
  ["ESSENTIAL" /* ESSENTIAL */]: {
    features: [
      "FLOWS" /* FLOWS */,
      "SHOPIFY_INTEGRATION" /* SHOPIFY_INTEGRATION */,
      "MANUAL_DRIVE_ARCHIVE" /* MANUAL_DRIVE_ARCHIVE */,
      "PARTNERSHIP_ADS_BOOST" /* PARTNERSHIP_ADS_BOOST */
    ],
    limits: {
      maxBrands: 1,
      maxFlows: 1,
      maxActiveBriefs: -1
    }
  },
  ["GROWTH" /* GROWTH */]: {
    features: [
      "MULTI_BRAND" /* MULTI_BRAND */,
      "FLOWS" /* FLOWS */,
      "TEAM_MEMBERS" /* TEAM_MEMBERS */,
      "SHOPIFY_INTEGRATION" /* SHOPIFY_INTEGRATION */,
      "MANUAL_DRIVE_ARCHIVE" /* MANUAL_DRIVE_ARCHIVE */,
      "PARTNERSHIP_ADS_BOOST" /* PARTNERSHIP_ADS_BOOST */
    ],
    limits: {
      maxBrands: 3,
      maxFlows: -1,
      maxActiveBriefs: -1
    }
  }
};
function planFlag(tier, flag) {
  return PLAN_FEATURES[tier].features.includes(flag);
}
var PLAN_ENTITLEMENTS = {
  ["FREE" /* FREE */]: {
    creatorIdentityReveal: false,
    advancedCreatorStats: false,
    discoverySearches: { max: 15, period: "month" },
    profileUnlocks: { max: 10, period: "month" },
    giftingInvitations: { max: 3, period: "month" },
    maxActivePrograms: 1,
    recommendationsPerMonth: 3,
    flows: planFlag("FREE" /* FREE */, "FLOWS" /* FLOWS */),
    mcp: false,
    coPublicity: planFlag("FREE" /* FREE */, "PARTNERSHIP_ADS_BOOST" /* PARTNERSHIP_ADS_BOOST */)
  },
  ["FREE_BETA" /* FREE_BETA */]: {
    creatorIdentityReveal: true,
    advancedCreatorStats: true,
    discoverySearches: null,
    profileUnlocks: null,
    giftingInvitations: null,
    maxActivePrograms: null,
    recommendationsPerMonth: null,
    flows: planFlag("FREE_BETA" /* FREE_BETA */, "FLOWS" /* FLOWS */),
    mcp: true,
    coPublicity: planFlag("FREE_BETA" /* FREE_BETA */, "PARTNERSHIP_ADS_BOOST" /* PARTNERSHIP_ADS_BOOST */)
  },
  ["ESSENTIAL" /* ESSENTIAL */]: {
    creatorIdentityReveal: true,
    advancedCreatorStats: true,
    discoverySearches: { max: 60, period: "month" },
    profileUnlocks: null,
    giftingInvitations: null,
    maxActivePrograms: 3,
    recommendationsPerMonth: null,
    flows: planFlag("ESSENTIAL" /* ESSENTIAL */, "FLOWS" /* FLOWS */),
    mcp: true,
    coPublicity: planFlag("ESSENTIAL" /* ESSENTIAL */, "PARTNERSHIP_ADS_BOOST" /* PARTNERSHIP_ADS_BOOST */)
  },
  ["GROWTH" /* GROWTH */]: {
    creatorIdentityReveal: true,
    advancedCreatorStats: true,
    discoverySearches: null,
    profileUnlocks: null,
    giftingInvitations: null,
    maxActivePrograms: null,
    recommendationsPerMonth: null,
    flows: planFlag("GROWTH" /* GROWTH */, "FLOWS" /* FLOWS */),
    mcp: true,
    coPublicity: planFlag("GROWTH" /* GROWTH */, "PARTNERSHIP_ADS_BOOST" /* PARTNERSHIP_ADS_BOOST */)
  }
};
var PlanLimit = /* @__PURE__ */ ((PlanLimit2) => {
  PlanLimit2["DISCOVERY_SEARCHES"] = "discovery_searches";
  PlanLimit2["ACTIVE_PROGRAMS"] = "active_programs";
  PlanLimit2["FLOWS"] = "flows";
  PlanLimit2["TEAM_MEMBERS"] = "team_members";
  PlanLimit2["BRIEFS"] = "briefs";
  PlanLimit2["MCP"] = "mcp";
  PlanLimit2["RECOMMENDATIONS"] = "recommendations";
  PlanLimit2["CREATOR_CONTACT"] = "creator_contact";
  PlanLimit2["PROFILE_UNLOCKS"] = "profile_unlocks";
  PlanLimit2["GIFTING_INVITATIONS"] = "gifting_invitations";
  return PlanLimit2;
})(PlanLimit || {});
var PAID_TIERS_IN_ORDER = ["ESSENTIAL" /* ESSENTIAL */, "GROWTH" /* GROWTH */];
function lifts(limit, tier, current, used) {
  const target = PLAN_ENTITLEMENTS[tier];
  const now = PLAN_ENTITLEMENTS[current];
  switch (limit) {
    case "discovery_searches" /* DISCOVERY_SEARCHES */:
      return target.discoverySearches === null || now.discoverySearches !== null && target.discoverySearches.period === now.discoverySearches.period && target.discoverySearches.max > (used ?? now.discoverySearches.max);
    case "active_programs" /* ACTIVE_PROGRAMS */:
      return target.maxActivePrograms === null || now.maxActivePrograms !== null && target.maxActivePrograms > now.maxActivePrograms;
    case "flows" /* FLOWS */:
      return target.flows && (used === void 0 || PLAN_FEATURES[tier].limits.maxFlows === -1 || PLAN_FEATURES[tier].limits.maxFlows > used);
    case "team_members" /* TEAM_MEMBERS */:
      return PLAN_FEATURES[tier].features.includes("TEAM_MEMBERS" /* TEAM_MEMBERS */);
    case "briefs" /* BRIEFS */:
      return PLAN_FEATURES[tier].limits.maxActiveBriefs === -1 || PLAN_FEATURES[tier].limits.maxActiveBriefs > (used ?? PLAN_FEATURES[current].limits.maxActiveBriefs);
    case "mcp" /* MCP */:
      return target.mcp;
    case "recommendations" /* RECOMMENDATIONS */:
      return target.recommendationsPerMonth === null;
    case "creator_contact" /* CREATOR_CONTACT */:
      return target.creatorIdentityReveal;
    case "profile_unlocks" /* PROFILE_UNLOCKS */:
      return target.creatorIdentityReveal && target.advancedCreatorStats;
    case "gifting_invitations" /* GIFTING_INVITATIONS */:
      return target.giftingInvitations === null;
  }
}
function upgradeTierFor(limit, current, used) {
  const currentRank = PAID_TIERS_IN_ORDER.indexOf(current);
  for (const tier of PAID_TIERS_IN_ORDER) {
    if (PAID_TIERS_IN_ORDER.indexOf(tier) <= currentRank) continue;
    if (lifts(limit, tier, current, used)) return tier;
  }
  return "GROWTH" /* GROWTH */;
}

// src/api/instagram-marketplace.ts
var AGE_BUCKET_VALUES = [
  "18_to_24",
  "25_to_34",
  "35_to_44",
  "45_to_54",
  "55_to_64",
  "65_and_above"
];
var AUDIENCE_INTEREST_VALUES = [
  "fashion",
  "beauty",
  "fitness",
  "food",
  "travel",
  "lifestyle",
  "home",
  "tech",
  "music",
  "art",
  "business",
  "parenting",
  "gaming",
  "photography",
  "sport",
  "automotive",
  "finance",
  "education"
];
var FOLLOWER_TIERS_META = [
  0,
  1e4,
  25e3,
  5e4,
  75e3,
  1e5
];
var DISCOVERY_SORT_OPTIONS = [
  "relevance",
  "followers",
  "engagement"
];
var DISCOVERY_QUALITY_SORT_OPTIONS = [
  "followers",
  "engagement"
];
var DEFAULT_DISCOVERY_SORT = "followers";
function defaultDiscoverySort(hasText) {
  return hasText ? "relevance" : DEFAULT_DISCOVERY_SORT;
}
function discoverySortOptions(hasText) {
  return hasText ? DISCOVERY_SORT_OPTIONS : DISCOVERY_QUALITY_SORT_OPTIONS;
}
function normalizeDiscoverySort(value) {
  return DISCOVERY_SORT_OPTIONS.includes(value) ? value : DEFAULT_DISCOVERY_SORT;
}
var CREATOR_STRICT_FILTER_VALUES = ["creatorAgeBucket", "creatorGender"];
var CREATOR_TIER_REASON_VALUES = [
  "unmeasured:age",
  "unmeasured:gender",
  "unmeasured:age,gender"
];
var CREATOR_API_DISCOVERY_REGULAR_UNSUPPORTED_FILTERS = [
  "username",
  "similarToCreators",
  "creatorMinEngagedAccounts",
  "creatorMaxEngagedAccounts",
  "reelsInteractionRate",
  "majorAudienceAgeBucket"
];
var CREATOR_API_DISCOVERY_SIMILAR_UNSUPPORTED_FILTERS = [
  "query",
  "username",
  "creatorAgeBucket",
  "creatorGender",
  "creatorNiches",
  "creatorContentFormats",
  "creatorContentLanguages",
  "creatorInterests",
  "creatorMinEngagedAccounts",
  "creatorMaxEngagedAccounts",
  "minEngagementRate",
  "maxEngagementRate",
  "reelsInteractionRate",
  "isVerified",
  "hasEmail",
  "collaboratedWithBrands",
  "notCollaboratedWithBrands",
  "majorAudienceAgeBucket",
  "majorAudienceGender",
  "majorAudienceCountries",
  "majorAudienceInterests"
];

// src/api/creator-plan-redaction.ts
var CREATOR_IDENTITY_FIELDS = [
  "username",
  "email",
  "fullName",
  "biography",
  "associatedProfiles",
  "city",
  "topics",
  "contentFormats",
  "contentLanguages",
  "opportunityInterests",
  "availability",
  "unavailableUntil"
];
var CREATOR_ADVANCED_STAT_FIELDS = [
  "engagementRate",
  "avgLikes",
  "avgComments",
  "reach",
  "estimatedMediaValue",
  "audienceInsights"
];

// src/api/messages.ts
var MessageCode = /* @__PURE__ */ ((MessageCode2) => {
  MessageCode2["SUCCESS_AFFILIATE_REMOVED"] = "SUCCESS_AFFILIATE_REMOVED";
  MessageCode2["SUCCESS_ANALYTICS_PREFERENCES_RETRIEVED"] = "SUCCESS_ANALYTICS_PREFERENCES_RETRIEVED";
  MessageCode2["SUCCESS_ANALYTICS_PREFERENCES_UPDATED"] = "SUCCESS_ANALYTICS_PREFERENCES_UPDATED";
  MessageCode2["SUCCESS_ANALYTICS_EVENT_ACCEPTED"] = "SUCCESS_ANALYTICS_EVENT_ACCEPTED";
  MessageCode2["SUCCESS_TRACKING_EVENT_ACCEPTED"] = "SUCCESS_TRACKING_EVENT_ACCEPTED";
  MessageCode2["SUCCESS_BILLING_CONTEXT_FETCHED"] = "SUCCESS_BILLING_CONTEXT_FETCHED";
  MessageCode2["SUCCESS_ORGANIZATION_BILLING_TAX_PROFILE_FETCHED"] = "SUCCESS_ORGANIZATION_BILLING_TAX_PROFILE_FETCHED";
  MessageCode2["SUCCESS_ORGANIZATION_BILLING_TAX_PROFILE_UPDATED"] = "SUCCESS_ORGANIZATION_BILLING_TAX_PROFILE_UPDATED";
  MessageCode2["SUCCESS_ORGANIZATION_BILLING_SETTINGS_FETCHED"] = "SUCCESS_ORGANIZATION_BILLING_SETTINGS_FETCHED";
  MessageCode2["SUCCESS_ORGANIZATION_BILLING_INVOICES_FETCHED"] = "SUCCESS_ORGANIZATION_BILLING_INVOICES_FETCHED";
  MessageCode2["SUCCESS_ORGANIZATION_BILLING_CONTACT_UPDATED"] = "SUCCESS_ORGANIZATION_BILLING_CONTACT_UPDATED";
  MessageCode2["SUCCESS_ORGANIZATION_BILLING_PORTAL_CREATED"] = "SUCCESS_ORGANIZATION_BILLING_PORTAL_CREATED";
  MessageCode2["SUCCESS_ORGANIZATION_CLOSURE_REQUESTED"] = "SUCCESS_ORGANIZATION_CLOSURE_REQUESTED";
  MessageCode2["SUCCESS_ORGANIZATION_BILLING_VAT_VERIFICATION_FETCHED"] = "SUCCESS_ORGANIZATION_BILLING_VAT_VERIFICATION_FETCHED";
  MessageCode2["SUCCESS_ORGANIZATION_BILLING_VAT_VERIFICATION_CHECKED"] = "SUCCESS_ORGANIZATION_BILLING_VAT_VERIFICATION_CHECKED";
  MessageCode2["SUCCESS_BILLING_CARD_SETUP_REQUESTED"] = "SUCCESS_BILLING_CARD_SETUP_REQUESTED";
  MessageCode2["SUCCESS_BILLING_CARD_SETUP_STATUS_FETCHED"] = "SUCCESS_BILLING_CARD_SETUP_STATUS_FETCHED";
  MessageCode2["SUCCESS_BILLING_EMAIL_CODE_SENT"] = "SUCCESS_BILLING_EMAIL_CODE_SENT";
  MessageCode2["SUCCESS_BILLING_EMAIL_VERIFIED"] = "SUCCESS_BILLING_EMAIL_VERIFIED";
  MessageCode2["SUCCESS_CREATOR_REFERRAL_INVITATION_QUEUED"] = "SUCCESS_CREATOR_REFERRAL_INVITATION_QUEUED";
  MessageCode2["SUCCESS_CREATOR_REFERRAL_NUDGE_QUEUED"] = "SUCCESS_CREATOR_REFERRAL_NUDGE_QUEUED";
  MessageCode2["SUCCESS_CREATOR_HANDOFF_CREATED"] = "SUCCESS_CREATOR_HANDOFF_CREATED";
  MessageCode2["SUCCESS_CREATOR_HANDOFF_STATUS"] = "SUCCESS_CREATOR_HANDOFF_STATUS";
  MessageCode2["SUCCESS_CREATOR_HANDOFF_EMAIL_SENT"] = "SUCCESS_CREATOR_HANDOFF_EMAIL_SENT";
  MessageCode2["SUCCESS_CREATOR_HANDOFF_COMPLETED"] = "SUCCESS_CREATOR_HANDOFF_COMPLETED";
  MessageCode2["SUCCESS_CREATOR_REFERRAL_RETRIEVED"] = "SUCCESS_CREATOR_REFERRAL_RETRIEVED";
  MessageCode2["SUCCESS_CREATOR_REFERRAL_ACTIVATED"] = "SUCCESS_CREATOR_REFERRAL_ACTIVATED";
  MessageCode2["SUCCESS_MCP_REVIEW_RETRIEVED"] = "SUCCESS_MCP_REVIEW_RETRIEVED";
  MessageCode2["SUCCESS_MCP_APPROVAL_ACCEPTED"] = "SUCCESS_MCP_APPROVAL_ACCEPTED";
  MessageCode2["SUCCESS_MCP_OPERATION_RETRIEVED"] = "SUCCESS_MCP_OPERATION_RETRIEVED";
  MessageCode2["SUCCESS_MCP_AUTHORIZATION_READY"] = "SUCCESS_MCP_AUTHORIZATION_READY";
  MessageCode2["SUCCESS_MCP_CONNECTIONS_RETRIEVED"] = "SUCCESS_MCP_CONNECTIONS_RETRIEVED";
  MessageCode2["SUCCESS_MCP_CONNECTION_UPDATED"] = "SUCCESS_MCP_CONNECTION_UPDATED";
  MessageCode2["SUCCESS_MCP_CONNECTION_REVOKED"] = "SUCCESS_MCP_CONNECTION_REVOKED";
  MessageCode2["SUCCESS_MCP_CONNECTION_ACTIVITY_FETCHED"] = "SUCCESS_MCP_CONNECTION_ACTIVITY_FETCHED";
  MessageCode2["SUCCESS_RECURRING_DEMO_REQUEST_PROCESSED"] = "SUCCESS_RECURRING_DEMO_REQUEST_PROCESSED";
  MessageCode2["SUCCESS_ANNOUNCEMENTS_RETRIEVED"] = "SUCCESS_ANNOUNCEMENTS_RETRIEVED";
  MessageCode2["SUCCESS_ANNOUNCEMENT_DISMISSED"] = "SUCCESS_ANNOUNCEMENT_DISMISSED";
  MessageCode2["SUCCESS_ANNOUNCEMENT_VISUAL_UPLOADED"] = "SUCCESS_ANNOUNCEMENT_VISUAL_UPLOADED";
  MessageCode2["SUCCESS_ANNOUNCEMENT_VISUAL_DELETED"] = "SUCCESS_ANNOUNCEMENT_VISUAL_DELETED";
  MessageCode2["SUCCESS_MAGIC_LINK_SENT"] = "SUCCESS_MAGIC_LINK_SENT";
  MessageCode2["SUCCESS_AUTHENTICATION"] = "SUCCESS_AUTHENTICATION";
  MessageCode2["SUCCESS_LOGOUT"] = "SUCCESS_LOGOUT";
  MessageCode2["SUCCESS_OTP_SENT"] = "SUCCESS_OTP_SENT";
  MessageCode2["SUCCESS_OTP_VERIFIED"] = "SUCCESS_OTP_VERIFIED";
  MessageCode2["SUCCESS_TOKEN_REFRESHED"] = "SUCCESS_TOKEN_REFRESHED";
  MessageCode2["SUCCESS_PASSWORD_RESET_EMAIL_SENT"] = "SUCCESS_PASSWORD_RESET_EMAIL_SENT";
  MessageCode2["SUCCESS_PASSWORD_RESET"] = "SUCCESS_PASSWORD_RESET";
  MessageCode2["SUCCESS_PASSWORD_UPDATED"] = "SUCCESS_PASSWORD_UPDATED";
  MessageCode2["SUCCESS_USER_CREATED"] = "SUCCESS_USER_CREATED";
  MessageCode2["SUCCESS_USER_UPDATED"] = "SUCCESS_USER_UPDATED";
  MessageCode2["SUCCESS_USER_DELETED"] = "SUCCESS_USER_DELETED";
  MessageCode2["SUCCESS_USER_RETRIEVED"] = "SUCCESS_USER_RETRIEVED";
  MessageCode2["SUCCESS_PROFILE_UPDATED"] = "SUCCESS_PROFILE_UPDATED";
  MessageCode2["SUCCESS_PROFILE_RETRIEVED"] = "SUCCESS_PROFILE_RETRIEVED";
  MessageCode2["SUCCESS_AVATAR_UPLOADED"] = "SUCCESS_AVATAR_UPLOADED";
  MessageCode2["SUCCESS_AVATAR_DELETED"] = "SUCCESS_AVATAR_DELETED";
  MessageCode2["SUCCESS_SETTINGS_UPDATED"] = "SUCCESS_SETTINGS_UPDATED";
  MessageCode2["SUCCESS_SETTINGS_RETRIEVED"] = "SUCCESS_SETTINGS_RETRIEVED";
  MessageCode2["SUCCESS_PREFERENCES_UPDATED"] = "SUCCESS_PREFERENCES_UPDATED";
  MessageCode2["SUCCESS_OUTREACH_EMAIL_UPDATED"] = "SUCCESS_OUTREACH_EMAIL_UPDATED";
  MessageCode2["SUCCESS_OUTREACH_EMAIL_REMOVED"] = "SUCCESS_OUTREACH_EMAIL_REMOVED";
  MessageCode2["SUCCESS_INVITATION_SENT"] = "SUCCESS_INVITATION_SENT";
  MessageCode2["SUCCESS_INVITATION_CREATED"] = "SUCCESS_INVITATION_CREATED";
  MessageCode2["SUCCESS_INVITATION_ACCEPTED"] = "SUCCESS_INVITATION_ACCEPTED";
  MessageCode2["SUCCESS_INVITATION_CONFIRMED"] = "SUCCESS_INVITATION_CONFIRMED";
  MessageCode2["SUCCESS_INVITATION_RESENT"] = "SUCCESS_INVITATION_RESENT";
  MessageCode2["SUCCESS_INVITATION_CANCELLED"] = "SUCCESS_INVITATION_CANCELLED";
  MessageCode2["SUCCESS_INVITATION_DETAILS_RETRIEVED"] = "SUCCESS_INVITATION_DETAILS_RETRIEVED";
  MessageCode2["SUCCESS_INVITATION_TEMPLATE_UPDATED"] = "SUCCESS_INVITATION_TEMPLATE_UPDATED";
  MessageCode2["SUCCESS_INVITATION_TEMPLATE_RETRIEVED"] = "SUCCESS_INVITATION_TEMPLATE_RETRIEVED";
  MessageCode2["SUCCESS_INVITATION_REMINDER_SENT"] = "SUCCESS_INVITATION_REMINDER_SENT";
  MessageCode2["SUCCESS_INVITATION_OUTREACH_QUEUED"] = "SUCCESS_INVITATION_OUTREACH_QUEUED";
  MessageCode2["SUCCESS_INVITATION_OUTREACH_BULK_QUEUED"] = "SUCCESS_INVITATION_OUTREACH_BULK_QUEUED";
  MessageCode2["SUCCESS_REMINDER_UNSUBSCRIBED"] = "SUCCESS_REMINDER_UNSUBSCRIBED";
  MessageCode2["SUCCESS_AFFILIATE_CREATED"] = "SUCCESS_AFFILIATE_CREATED";
  MessageCode2["SUCCESS_AFFILIATE_ACTIVATED"] = "SUCCESS_AFFILIATE_ACTIVATED";
  MessageCode2["SUCCESS_AFFILIATE_DEACTIVATED"] = "SUCCESS_AFFILIATE_DEACTIVATED";
  MessageCode2["SUCCESS_AFFILIATE_UPDATED"] = "SUCCESS_AFFILIATE_UPDATED";
  MessageCode2["SUCCESS_AFFILIATE_STATUS_UPDATED"] = "SUCCESS_AFFILIATE_STATUS_UPDATED";
  MessageCode2["SUCCESS_AFFILIATE_CONFIGURATION_UPDATED"] = "SUCCESS_AFFILIATE_CONFIGURATION_UPDATED";
  MessageCode2["SUCCESS_AFFILIATE_RETRIEVED"] = "SUCCESS_AFFILIATE_RETRIEVED";
  MessageCode2["SUCCESS_AFFILIATE_LIST_RETRIEVED"] = "SUCCESS_AFFILIATE_LIST_RETRIEVED";
  MessageCode2["SUCCESS_AFFILIATE_COUNT_RETRIEVED"] = "SUCCESS_AFFILIATE_COUNT_RETRIEVED";
  MessageCode2["SUCCESS_BUSINESS_CREATED"] = "SUCCESS_BUSINESS_CREATED";
  MessageCode2["SUCCESS_BUSINESS_UPDATED"] = "SUCCESS_BUSINESS_UPDATED";
  MessageCode2["SUCCESS_BUSINESS_DELETED"] = "SUCCESS_BUSINESS_DELETED";
  MessageCode2["SUCCESS_BUSINESS_TYPE_UPDATED"] = "SUCCESS_BUSINESS_TYPE_UPDATED";
  MessageCode2["SUCCESS_BUSINESS_DETAILS_UPDATED"] = "SUCCESS_BUSINESS_DETAILS_UPDATED";
  MessageCode2["SUCCESS_BUSINESS_DETAILS_RETRIEVED"] = "SUCCESS_BUSINESS_DETAILS_RETRIEVED";
  MessageCode2["SUCCESS_ORGANIZATION_CREATED"] = "SUCCESS_ORGANIZATION_CREATED";
  MessageCode2["SUCCESS_ORGANIZATION_UPDATED"] = "SUCCESS_ORGANIZATION_UPDATED";
  MessageCode2["SUCCESS_BRAND_CREATED"] = "SUCCESS_BRAND_CREATED";
  MessageCode2["SUCCESS_BRAND_UPDATED"] = "SUCCESS_BRAND_UPDATED";
  MessageCode2["SUCCESS_BRAND_RETRIEVED"] = "SUCCESS_BRAND_RETRIEVED";
  MessageCode2["SUCCESS_BRAND_SWITCHED"] = "SUCCESS_BRAND_SWITCHED";
  MessageCode2["SUCCESS_BRAND_DNA_RETRIEVED"] = "SUCCESS_BRAND_DNA_RETRIEVED";
  MessageCode2["SUCCESS_BRAND_DNA_UPDATED"] = "SUCCESS_BRAND_DNA_UPDATED";
  MessageCode2["SUCCESS_BRAND_DNA_GENERATED"] = "SUCCESS_BRAND_DNA_GENERATED";
  MessageCode2["SUCCESS_PROGRAM_CREATED"] = "SUCCESS_PROGRAM_CREATED";
  MessageCode2["SUCCESS_PROGRAM_UPDATED"] = "SUCCESS_PROGRAM_UPDATED";
  MessageCode2["SUCCESS_PROGRAM_DELETED"] = "SUCCESS_PROGRAM_DELETED";
  MessageCode2["SUCCESS_PROGRAM_RETRIEVED"] = "SUCCESS_PROGRAM_RETRIEVED";
  MessageCode2["SUCCESS_PROGRAM_LIST_RETRIEVED"] = "SUCCESS_PROGRAM_LIST_RETRIEVED";
  MessageCode2["SUCCESS_PROGRAM_COUNT_RETRIEVED"] = "SUCCESS_PROGRAM_COUNT_RETRIEVED";
  MessageCode2["SUCCESS_CREATOR_CREATED"] = "SUCCESS_CREATOR_CREATED";
  MessageCode2["SUCCESS_CREATOR_UPDATED"] = "SUCCESS_CREATOR_UPDATED";
  MessageCode2["SUCCESS_CREATOR_RETRIEVED"] = "SUCCESS_CREATOR_RETRIEVED";
  MessageCode2["SUCCESS_CREATOR_PROFILE_UNLOCKED"] = "SUCCESS_CREATOR_PROFILE_UNLOCKED";
  MessageCode2["SUCCESS_CREATOR_LIST_RETRIEVED"] = "SUCCESS_CREATOR_LIST_RETRIEVED";
  MessageCode2["SUCCESS_CREATOR_STATS_RETRIEVED"] = "SUCCESS_CREATOR_STATS_RETRIEVED";
  MessageCode2["SUCCESS_CREATORS_DISCOVERED"] = "SUCCESS_CREATORS_DISCOVERED";
  MessageCode2["SUCCESS_CREATORS_LISTED"] = "SUCCESS_CREATORS_LISTED";
  MessageCode2["SUCCESS_CREATOR_GROWTH_FETCHED"] = "SUCCESS_CREATOR_GROWTH_FETCHED";
  MessageCode2["SUCCESS_CREATOR_HUB_CONFIG_RETRIEVED"] = "SUCCESS_CREATOR_HUB_CONFIG_RETRIEVED";
  MessageCode2["SUCCESS_CREATOR_HUB_IDENTITY_RETRIEVED"] = "SUCCESS_CREATOR_HUB_IDENTITY_RETRIEVED";
  MessageCode2["SUCCESS_CREATOR_HUB_EMAIL_LINK_CODE_SENT"] = "SUCCESS_CREATOR_HUB_EMAIL_LINK_CODE_SENT";
  MessageCode2["SUCCESS_CREATOR_HUB_EMAIL_LINKED"] = "SUCCESS_CREATOR_HUB_EMAIL_LINKED";
  MessageCode2["SUCCESS_CREATOR_HUB_EMAIL_ALREADY_LINKED"] = "SUCCESS_CREATOR_HUB_EMAIL_ALREADY_LINKED";
  MessageCode2["SUCCESS_CREATOR_HUB_SESSION_REVOKED"] = "SUCCESS_CREATOR_HUB_SESSION_REVOKED";
  MessageCode2["SUCCESS_CREATOR_HUB_SESSIONS_RETRIEVED"] = "SUCCESS_CREATOR_HUB_SESSIONS_RETRIEVED";
  MessageCode2["SUCCESS_CREATOR_HUB_TOKEN_REFRESHED"] = "SUCCESS_CREATOR_HUB_TOKEN_REFRESHED";
  MessageCode2["SUCCESS_CREATOR_HUB_LOGGED_OUT"] = "SUCCESS_CREATOR_HUB_LOGGED_OUT";
  MessageCode2["SUCCESS_CREATOR_HUB_MAGIC_LINK_SENT"] = "SUCCESS_CREATOR_HUB_MAGIC_LINK_SENT";
  MessageCode2["SUCCESS_CREATOR_HUB_MAGIC_LINK_AUTHENTICATED"] = "SUCCESS_CREATOR_HUB_MAGIC_LINK_AUTHENTICATED";
  MessageCode2["SUCCESS_CREATOR_HUB_GOOGLE_AUTHENTICATED"] = "SUCCESS_CREATOR_HUB_GOOGLE_AUTHENTICATED";
  MessageCode2["SUCCESS_CREATOR_HUB_APPLE_AUTHENTICATED"] = "SUCCESS_CREATOR_HUB_APPLE_AUTHENTICATED";
  MessageCode2["SUCCESS_CREATOR_HUB_SIGN_IN_CODE_SENT"] = "SUCCESS_CREATOR_HUB_SIGN_IN_CODE_SENT";
  MessageCode2["SUCCESS_CREATOR_HUB_SIGN_IN_CODE_AUTHENTICATED"] = "SUCCESS_CREATOR_HUB_SIGN_IN_CODE_AUTHENTICATED";
  MessageCode2["SUCCESS_CREATOR_HUB_REVIEW_AUTHENTICATED"] = "SUCCESS_CREATOR_HUB_REVIEW_AUTHENTICATED";
  MessageCode2["SUCCESS_CREATOR_HUB_ACCOUNT_DELETION_PREVIEW_RETRIEVED"] = "SUCCESS_CREATOR_HUB_ACCOUNT_DELETION_PREVIEW_RETRIEVED";
  MessageCode2["SUCCESS_CREATOR_HUB_ACCOUNT_DELETION_CHALLENGE_CREATED"] = "SUCCESS_CREATOR_HUB_ACCOUNT_DELETION_CHALLENGE_CREATED";
  MessageCode2["SUCCESS_CREATOR_HUB_ACCOUNT_DELETION_ACCEPTED"] = "SUCCESS_CREATOR_HUB_ACCOUNT_DELETION_ACCEPTED";
  MessageCode2["SUCCESS_CREATOR_HUB_HOME_RETRIEVED"] = "SUCCESS_CREATOR_HUB_HOME_RETRIEVED";
  MessageCode2["SUCCESS_CREATOR_PERFORMANCE_RETRIEVED"] = "SUCCESS_CREATOR_PERFORMANCE_RETRIEVED";
  MessageCode2["SUCCESS_CREATOR_HUB_WALLET_RETRIEVED"] = "SUCCESS_CREATOR_HUB_WALLET_RETRIEVED";
  MessageCode2["SUCCESS_CREATOR_HUB_WALLET_MOVEMENTS_RETRIEVED"] = "SUCCESS_CREATOR_HUB_WALLET_MOVEMENTS_RETRIEVED";
  MessageCode2["SUCCESS_CREATOR_HUB_WALLET_MOVEMENT_RETRIEVED"] = "SUCCESS_CREATOR_HUB_WALLET_MOVEMENT_RETRIEVED";
  MessageCode2["SUCCESS_CREATOR_HUB_GIFTS_RETRIEVED"] = "SUCCESS_CREATOR_HUB_GIFTS_RETRIEVED";
  MessageCode2["SUCCESS_CREATOR_HUB_COLLAB_RESOLVED"] = "SUCCESS_CREATOR_HUB_COLLAB_RESOLVED";
  MessageCode2["SUCCESS_CREATOR_HUB_COLLABS_RETRIEVED"] = "SUCCESS_CREATOR_HUB_COLLABS_RETRIEVED";
  MessageCode2["SUCCESS_CREATOR_HUB_COLLAB_RETRIEVED"] = "SUCCESS_CREATOR_HUB_COLLAB_RETRIEVED";
  MessageCode2["SUCCESS_CREATOR_HUB_DELIVERABLE_PUBLISHED"] = "SUCCESS_CREATOR_HUB_DELIVERABLE_PUBLISHED";
  MessageCode2["SUCCESS_CREATOR_HUB_PUSH_DEVICE_REGISTERED"] = "SUCCESS_CREATOR_HUB_PUSH_DEVICE_REGISTERED";
  MessageCode2["SUCCESS_CREATOR_HUB_PUSH_DEVICE_UNREGISTERED"] = "SUCCESS_CREATOR_HUB_PUSH_DEVICE_UNREGISTERED";
  MessageCode2["SUCCESS_CREATOR_HUB_PUSH_DEVICES_RETRIEVED"] = "SUCCESS_CREATOR_HUB_PUSH_DEVICES_RETRIEVED";
  MessageCode2["SUCCESS_CREATOR_HUB_PUSH_PREFERENCES_RETRIEVED"] = "SUCCESS_CREATOR_HUB_PUSH_PREFERENCES_RETRIEVED";
  MessageCode2["SUCCESS_CREATOR_HUB_PUSH_PREFERENCES_UPDATED"] = "SUCCESS_CREATOR_HUB_PUSH_PREFERENCES_UPDATED";
  MessageCode2["SUCCESS_CREATOR_HUB_SOCIAL_CONNECTIONS_RETRIEVED"] = "SUCCESS_CREATOR_HUB_SOCIAL_CONNECTIONS_RETRIEVED";
  MessageCode2["SUCCESS_CREATOR_HUB_SOCIAL_AUTHORIZATION_CREATED"] = "SUCCESS_CREATOR_HUB_SOCIAL_AUTHORIZATION_CREATED";
  MessageCode2["SUCCESS_CREATOR_HUB_SOCIAL_CONNECTION_DISCONNECTED"] = "SUCCESS_CREATOR_HUB_SOCIAL_CONNECTION_DISCONNECTED";
  MessageCode2["SUCCESS_CREATOR_HUB_PROFILE_RETRIEVED"] = "SUCCESS_CREATOR_HUB_PROFILE_RETRIEVED";
  MessageCode2["SUCCESS_CREATOR_HUB_ONBOARDING_PROFILE_UPDATED"] = "SUCCESS_CREATOR_HUB_ONBOARDING_PROFILE_UPDATED";
  MessageCode2["SUCCESS_CREATOR_HUB_ONBOARDING_SECTORS_UPDATED"] = "SUCCESS_CREATOR_HUB_ONBOARDING_SECTORS_UPDATED";
  MessageCode2["SUCCESS_CREATOR_HUB_ONBOARDING_SOCIALS_REVIEWED"] = "SUCCESS_CREATOR_HUB_ONBOARDING_SOCIALS_REVIEWED";
  MessageCode2["SUCCESS_CREATOR_HUB_ONBOARDING_ACTIVITY_UPDATED"] = "SUCCESS_CREATOR_HUB_ONBOARDING_ACTIVITY_UPDATED";
  MessageCode2["SUCCESS_CREATOR_HUB_ONBOARDING_PAYOUT_REVIEWED"] = "SUCCESS_CREATOR_HUB_ONBOARDING_PAYOUT_REVIEWED";
  MessageCode2["SUCCESS_CREATOR_HUB_CONSENTS_RENEWED"] = "SUCCESS_CREATOR_HUB_CONSENTS_RENEWED";
  MessageCode2["SUCCESS_CREATOR_HUB_LANGUAGE_UPDATED"] = "SUCCESS_CREATOR_HUB_LANGUAGE_UPDATED";
  MessageCode2["SUCCESS_CREATOR_HUB_NAME_UPDATED"] = "SUCCESS_CREATOR_HUB_NAME_UPDATED";
  MessageCode2["SUCCESS_CREATOR_HUB_DELIVERY_ADDRESS_RETRIEVED"] = "SUCCESS_CREATOR_HUB_DELIVERY_ADDRESS_RETRIEVED";
  MessageCode2["SUCCESS_CREATOR_HUB_DELIVERY_ADDRESS_UPDATED"] = "SUCCESS_CREATOR_HUB_DELIVERY_ADDRESS_UPDATED";
  MessageCode2["SUCCESS_CREATOR_HUB_LEGAL_IDENTITY_RETRIEVED"] = "SUCCESS_CREATOR_HUB_LEGAL_IDENTITY_RETRIEVED";
  MessageCode2["SUCCESS_CREATOR_HUB_LEGAL_IDENTITY_UPDATED"] = "SUCCESS_CREATOR_HUB_LEGAL_IDENTITY_UPDATED";
  MessageCode2["SUCCESS_CREATOR_HUB_UGC_RETRIEVED"] = "SUCCESS_CREATOR_HUB_UGC_RETRIEVED";
  MessageCode2["SUCCESS_CREATOR_HUB_UGC_UPDATED"] = "SUCCESS_CREATOR_HUB_UGC_UPDATED";
  MessageCode2["SUCCESS_CREATOR_UGC_SAMPLE_UPLOAD_STARTED"] = "SUCCESS_CREATOR_UGC_SAMPLE_UPLOAD_STARTED";
  MessageCode2["SUCCESS_CREATOR_UGC_SAMPLE_UPLOAD_COMPLETED"] = "SUCCESS_CREATOR_UGC_SAMPLE_UPLOAD_COMPLETED";
  MessageCode2["SUCCESS_CREATOR_UGC_SAMPLE_DELETED"] = "SUCCESS_CREATOR_UGC_SAMPLE_DELETED";
  MessageCode2["SUCCESS_CREATOR_HUB_PAYOUT_ACCOUNT_SAVED"] = "SUCCESS_CREATOR_HUB_PAYOUT_ACCOUNT_SAVED";
  MessageCode2["SUCCESS_CREATOR_HUB_PAYOUT_BANK_ACCOUNT_SAVED"] = "SUCCESS_CREATOR_HUB_PAYOUT_BANK_ACCOUNT_SAVED";
  MessageCode2["SUCCESS_CREATOR_HUB_PAYOUT_DOCUMENT_SUBMITTED"] = "SUCCESS_CREATOR_HUB_PAYOUT_DOCUMENT_SUBMITTED";
  MessageCode2["SUCCESS_CREATOR_HUB_PAYOUT_READINESS_REFRESHED"] = "SUCCESS_CREATOR_HUB_PAYOUT_READINESS_REFRESHED";
  MessageCode2["SUCCESS_CREATOR_HUB_WITHDRAWAL_PREVIEW_RETRIEVED"] = "SUCCESS_CREATOR_HUB_WITHDRAWAL_PREVIEW_RETRIEVED";
  MessageCode2["SUCCESS_CREATOR_HUB_WITHDRAWAL_REQUESTED"] = "SUCCESS_CREATOR_HUB_WITHDRAWAL_REQUESTED";
  MessageCode2["SUCCESS_CREATOR_HUB_WITHDRAWAL_RETRIEVED"] = "SUCCESS_CREATOR_HUB_WITHDRAWAL_RETRIEVED";
  MessageCode2["SUCCESS_CREATOR_HUB_PAYOUT_STATEMENTS_RETRIEVED"] = "SUCCESS_CREATOR_HUB_PAYOUT_STATEMENTS_RETRIEVED";
  MessageCode2["SUCCESS_CREATOR_HUB_PAYOUT_STATEMENT_URL_RETRIEVED"] = "SUCCESS_CREATOR_HUB_PAYOUT_STATEMENT_URL_RETRIEVED";
  MessageCode2["SUCCESS_CREATOR_HUB_PRODUCT_LINKS_RETRIEVED"] = "SUCCESS_CREATOR_HUB_PRODUCT_LINKS_RETRIEVED";
  MessageCode2["SUCCESS_CREATOR_HUB_PRODUCT_LINK_CREATED"] = "SUCCESS_CREATOR_HUB_PRODUCT_LINK_CREATED";
  MessageCode2["SUCCESS_CREATOR_HUB_PRODUCT_LINK_DELETED"] = "SUCCESS_CREATOR_HUB_PRODUCT_LINK_DELETED";
  MessageCode2["SUCCESS_CREATOR_HUB_PRODUCT_CATALOG_RETRIEVED"] = "SUCCESS_CREATOR_HUB_PRODUCT_CATALOG_RETRIEVED";
  MessageCode2["INFO_CREATOR_PROFILE_NOT_FOUND"] = "INFO_CREATOR_PROFILE_NOT_FOUND";
  MessageCode2["SUCCESS_WISHLIST_CREATOR_ADDED"] = "SUCCESS_WISHLIST_CREATOR_ADDED";
  MessageCode2["SUCCESS_WISHLIST_CREATOR_UPDATED"] = "SUCCESS_WISHLIST_CREATOR_UPDATED";
  MessageCode2["SUCCESS_WISHLIST_CREATOR_REMOVED"] = "SUCCESS_WISHLIST_CREATOR_REMOVED";
  MessageCode2["SUCCESS_WISHLIST_CREATORS_BULK_REMOVED"] = "SUCCESS_WISHLIST_CREATORS_BULK_REMOVED";
  MessageCode2["SUCCESS_WISHLIST_RETRIEVED"] = "SUCCESS_WISHLIST_RETRIEVED";
  MessageCode2["SUCCESS_PARTNERSHIP_MESSAGE_SENT"] = "SUCCESS_PARTNERSHIP_MESSAGE_SENT";
  MessageCode2["SUCCESS_CREATOR_OUTREACH_QUEUED"] = "SUCCESS_CREATOR_OUTREACH_QUEUED";
  MessageCode2["SUCCESS_BULK_INVITATION_STARTED"] = "SUCCESS_BULK_INVITATION_STARTED";
  MessageCode2["SUCCESS_BULK_INVITATION_COMPLETED"] = "SUCCESS_BULK_INVITATION_COMPLETED";
  MessageCode2["SUCCESS_BULK_INVITATION_STATUS_RETRIEVED"] = "SUCCESS_BULK_INVITATION_STATUS_RETRIEVED";
  MessageCode2["SUCCESS_CSV_IMPORT_QUEUED"] = "SUCCESS_CSV_IMPORT_QUEUED";
  MessageCode2["SUCCESS_CSV_IMPORT_CANCELLED"] = "SUCCESS_CSV_IMPORT_CANCELLED";
  MessageCode2["SUCCESS_COMMISSION_CREATED"] = "SUCCESS_COMMISSION_CREATED";
  MessageCode2["SUCCESS_COMMISSION_UPDATED"] = "SUCCESS_COMMISSION_UPDATED";
  MessageCode2["SUCCESS_COMMISSION_APPROVED"] = "SUCCESS_COMMISSION_APPROVED";
  MessageCode2["SUCCESS_COMMISSION_REJECTED"] = "SUCCESS_COMMISSION_REJECTED";
  MessageCode2["SUCCESS_COMMISSION_RETRIEVED"] = "SUCCESS_COMMISSION_RETRIEVED";
  MessageCode2["SUCCESS_COMMISSIONS_LISTED"] = "SUCCESS_COMMISSIONS_LISTED";
  MessageCode2["SUCCESS_COMMISSIONS_RETRIEVED"] = "SUCCESS_COMMISSIONS_RETRIEVED";
  MessageCode2["SUCCESS_PAYOUT_REQUESTED"] = "SUCCESS_PAYOUT_REQUESTED";
  MessageCode2["SUCCESS_PAYOUT_PROCESSED"] = "SUCCESS_PAYOUT_PROCESSED";
  MessageCode2["SUCCESS_PAYOUT_CANCELLED"] = "SUCCESS_PAYOUT_CANCELLED";
  MessageCode2["SUCCESS_PAYOUT_RETRIEVED"] = "SUCCESS_PAYOUT_RETRIEVED";
  MessageCode2["SUCCESS_PAYOUT_LIST_RETRIEVED"] = "SUCCESS_PAYOUT_LIST_RETRIEVED";
  MessageCode2["SUCCESS_PAYOUT_ACTIVATION_DEFERRED"] = "SUCCESS_PAYOUT_ACTIVATION_DEFERRED";
  MessageCode2["SUCCESS_UNFINISHED_PAYOUTS_SUMMARY_FETCHED"] = "SUCCESS_UNFINISHED_PAYOUTS_SUMMARY_FETCHED";
  MessageCode2["SUCCESS_DASHBOARD_OVERVIEW_FETCHED"] = "SUCCESS_DASHBOARD_OVERVIEW_FETCHED";
  MessageCode2["SUCCESS_INVOICE_READY"] = "SUCCESS_INVOICE_READY";
  MessageCode2["SUCCESS_PAYOUT_STATEMENT_READY"] = "SUCCESS_PAYOUT_STATEMENT_READY";
  MessageCode2["SUCCESS_PAYOUT_STATEMENT_LIST_RETRIEVED"] = "SUCCESS_PAYOUT_STATEMENT_LIST_RETRIEVED";
  MessageCode2["SUCCESS_PAYMENT_METHOD_ADDED"] = "SUCCESS_PAYMENT_METHOD_ADDED";
  MessageCode2["SUCCESS_PAYMENT_METHOD_UPDATED"] = "SUCCESS_PAYMENT_METHOD_UPDATED";
  MessageCode2["SUCCESS_PAYMENT_METHOD_DELETED"] = "SUCCESS_PAYMENT_METHOD_DELETED";
  MessageCode2["SUCCESS_STRIPE_ACCOUNT_CREATED"] = "SUCCESS_STRIPE_ACCOUNT_CREATED";
  MessageCode2["SUCCESS_STRIPE_WEBHOOK_RECEIVED"] = "SUCCESS_STRIPE_WEBHOOK_RECEIVED";
  MessageCode2["SUCCESS_STRIPE_ACCOUNT_UPDATED"] = "SUCCESS_STRIPE_ACCOUNT_UPDATED";
  MessageCode2["SUCCESS_STRIPE_ACCOUNT_RETRIEVED"] = "SUCCESS_STRIPE_ACCOUNT_RETRIEVED";
  MessageCode2["SUCCESS_BALANCE_RETRIEVED"] = "SUCCESS_BALANCE_RETRIEVED";
  MessageCode2["SUCCESS_INTEGRATION_CONNECTED"] = "SUCCESS_INTEGRATION_CONNECTED";
  MessageCode2["SUCCESS_INTEGRATION_DISCONNECTED"] = "SUCCESS_INTEGRATION_DISCONNECTED";
  MessageCode2["SUCCESS_INTEGRATION_UPDATED"] = "SUCCESS_INTEGRATION_UPDATED";
  MessageCode2["SUCCESS_INTEGRATION_RETRIEVED"] = "SUCCESS_INTEGRATION_RETRIEVED";
  MessageCode2["SUCCESS_META_ADS_CONNECTED"] = "SUCCESS_META_ADS_CONNECTED";
  MessageCode2["SUCCESS_META_ADS_DEFAULT_SET"] = "SUCCESS_META_ADS_DEFAULT_SET";
  MessageCode2["SUCCESS_SHOPIFY_CONNECTED"] = "SUCCESS_SHOPIFY_CONNECTED";
  MessageCode2["SUCCESS_SHOPIFY_DISCONNECTED"] = "SUCCESS_SHOPIFY_DISCONNECTED";
  MessageCode2["SUCCESS_DISCOUNT_CODE_CREATED"] = "SUCCESS_DISCOUNT_CODE_CREATED";
  MessageCode2["SUCCESS_DISCOUNT_CODE_UPDATED"] = "SUCCESS_DISCOUNT_CODE_UPDATED";
  MessageCode2["SUCCESS_DISCOUNT_CODE_MIGRATION_PREVIEWED"] = "SUCCESS_DISCOUNT_CODE_MIGRATION_PREVIEWED";
  MessageCode2["SUCCESS_DISCOUNT_CODE_MIGRATION_STARTED"] = "SUCCESS_DISCOUNT_CODE_MIGRATION_STARTED";
  MessageCode2["SUCCESS_SUBSCRIPTION_CREATED"] = "SUCCESS_SUBSCRIPTION_CREATED";
  MessageCode2["SUCCESS_SUBSCRIPTION_ACTIVATED"] = "SUCCESS_SUBSCRIPTION_ACTIVATED";
  MessageCode2["SUCCESS_SUBSCRIPTION_UPDATED"] = "SUCCESS_SUBSCRIPTION_UPDATED";
  MessageCode2["SUCCESS_SUBSCRIPTION_CANCELLED"] = "SUCCESS_SUBSCRIPTION_CANCELLED";
  MessageCode2["SUCCESS_SWITCHED_TO_FREE_PLAN"] = "SUCCESS_SWITCHED_TO_FREE_PLAN";
  MessageCode2["SUCCESS_SUBSCRIPTION_STATUS_RETRIEVED"] = "SUCCESS_SUBSCRIPTION_STATUS_RETRIEVED";
  MessageCode2["SUCCESS_SUBSCRIPTION_PLAN_CHANGED"] = "SUCCESS_SUBSCRIPTION_PLAN_CHANGED";
  MessageCode2["SUCCESS_SUBSCRIPTION_PLAN_CHANGE_SCHEDULED"] = "SUCCESS_SUBSCRIPTION_PLAN_CHANGE_SCHEDULED";
  MessageCode2["SUCCESS_SUBSCRIPTION_PRICE_DROP_FETCHED"] = "SUCCESS_SUBSCRIPTION_PRICE_DROP_FETCHED";
  MessageCode2["SUCCESS_SUBSCRIPTION_PRICE_DROP_STARTED"] = "SUCCESS_SUBSCRIPTION_PRICE_DROP_STARTED";
  MessageCode2["SUCCESS_INSTAGRAM_CONNECTED"] = "SUCCESS_INSTAGRAM_CONNECTED";
  MessageCode2["SUCCESS_INSTAGRAM_DISCONNECTED"] = "SUCCESS_INSTAGRAM_DISCONNECTED";
  MessageCode2["SUCCESS_FACEBOOK_CONNECTED"] = "SUCCESS_FACEBOOK_CONNECTED";
  MessageCode2["SUCCESS_FACEBOOK_DISCONNECTED"] = "SUCCESS_FACEBOOK_DISCONNECTED";
  MessageCode2["SUCCESS_GMAIL_CONNECTED"] = "SUCCESS_GMAIL_CONNECTED";
  MessageCode2["SUCCESS_GMAIL_DISCONNECTED"] = "SUCCESS_GMAIL_DISCONNECTED";
  MessageCode2["SUCCESS_GMAIL_SENDER_UPDATED"] = "SUCCESS_GMAIL_SENDER_UPDATED";
  MessageCode2["SUCCESS_OUTLOOK_CONNECTED"] = "SUCCESS_OUTLOOK_CONNECTED";
  MessageCode2["SUCCESS_OUTLOOK_DISCONNECTED"] = "SUCCESS_OUTLOOK_DISCONNECTED";
  MessageCode2["SUCCESS_EMAIL_CONNECTION_STATUS_RETRIEVED"] = "SUCCESS_EMAIL_CONNECTION_STATUS_RETRIEVED";
  MessageCode2["SUCCESS_GOOGLE_DRIVE_CONNECTED"] = "SUCCESS_GOOGLE_DRIVE_CONNECTED";
  MessageCode2["SUCCESS_GOOGLE_DRIVE_DISCONNECTED"] = "SUCCESS_GOOGLE_DRIVE_DISCONNECTED";
  MessageCode2["SUCCESS_GOOGLE_DRIVE_STATUS_RETRIEVED"] = "SUCCESS_GOOGLE_DRIVE_STATUS_RETRIEVED";
  MessageCode2["SUCCESS_GOOGLE_DRIVE_PERMISSIONS_LISTED"] = "SUCCESS_GOOGLE_DRIVE_PERMISSIONS_LISTED";
  MessageCode2["SUCCESS_GOOGLE_DRIVE_SHARED"] = "SUCCESS_GOOGLE_DRIVE_SHARED";
  MessageCode2["SUCCESS_GOOGLE_DRIVE_UNSHARED"] = "SUCCESS_GOOGLE_DRIVE_UNSHARED";
  MessageCode2["SUCCESS_BULK_EMAIL_STARTED"] = "SUCCESS_BULK_EMAIL_STARTED";
  MessageCode2["SUCCESS_BULK_EMAIL_STATUS"] = "SUCCESS_BULK_EMAIL_STATUS";
  MessageCode2["SUCCESS_BULK_EMAIL_ITEMS"] = "SUCCESS_BULK_EMAIL_ITEMS";
  MessageCode2["SUCCESS_ATTACHMENT_UPLOADED"] = "SUCCESS_ATTACHMENT_UPLOADED";
  MessageCode2["SUCCESS_ATTACHMENT_DELETED"] = "SUCCESS_ATTACHMENT_DELETED";
  MessageCode2["SUCCESS_SENT_BATCHES_LISTED"] = "SUCCESS_SENT_BATCHES_LISTED";
  MessageCode2["SUCCESS_SENT_BATCH_DETAILS"] = "SUCCESS_SENT_BATCH_DETAILS";
  MessageCode2["SUCCESS_TIKTOK_CONNECTED"] = "SUCCESS_TIKTOK_CONNECTED";
  MessageCode2["SUCCESS_TIKTOK_DISCONNECTED"] = "SUCCESS_TIKTOK_DISCONNECTED";
  MessageCode2["SUCCESS_MESSAGING_SECTION_COUNTERS_RETRIEVED"] = "SUCCESS_MESSAGING_SECTION_COUNTERS_RETRIEVED";
  MessageCode2["SUCCESS_MESSAGE_SENT"] = "SUCCESS_MESSAGE_SENT";
  MessageCode2["SUCCESS_MESSAGE_RETRIEVED"] = "SUCCESS_MESSAGE_RETRIEVED";
  MessageCode2["SUCCESS_MESSAGE_COMPILED"] = "SUCCESS_MESSAGE_COMPILED";
  MessageCode2["SUCCESS_MESSAGE_PREVIEW_GENERATED"] = "SUCCESS_MESSAGE_PREVIEW_GENERATED";
  MessageCode2["SUCCESS_CONVERSATION_CREATED"] = "SUCCESS_CONVERSATION_CREATED";
  MessageCode2["SUCCESS_CONVERSATION_RETRIEVED"] = "SUCCESS_CONVERSATION_RETRIEVED";
  MessageCode2["SUCCESS_STATS_RETRIEVED"] = "SUCCESS_STATS_RETRIEVED";
  MessageCode2["SUCCESS_ANALYTICS_RETRIEVED"] = "SUCCESS_ANALYTICS_RETRIEVED";
  MessageCode2["SUCCESS_MENTIONS_SEEN"] = "SUCCESS_MENTIONS_SEEN";
  MessageCode2["SUCCESS_UNSEEN_MENTIONS_COUNT"] = "SUCCESS_UNSEEN_MENTIONS_COUNT";
  MessageCode2["SUCCESS_MENTION_ARCHIVE_ENQUEUED"] = "SUCCESS_MENTION_ARCHIVE_ENQUEUED";
  MessageCode2["SUCCESS_MENTION_ARCHIVE_DEDUPLICATED"] = "SUCCESS_MENTION_ARCHIVE_DEDUPLICATED";
  MessageCode2["SUCCESS_MENTION_ARCHIVE_STATE_RETRIEVED"] = "SUCCESS_MENTION_ARCHIVE_STATE_RETRIEVED";
  MessageCode2["SUCCESS_MENTION_BOOST_ELIGIBILITY_RETRIEVED"] = "SUCCESS_MENTION_BOOST_ELIGIBILITY_RETRIEVED";
  MessageCode2["SUCCESS_MENTION_BOOST_AUTHORIZATION_REQUESTED"] = "SUCCESS_MENTION_BOOST_AUTHORIZATION_REQUESTED";
  MessageCode2["SUCCESS_MENTION_BOOST_SETUP_RETRIEVED"] = "SUCCESS_MENTION_BOOST_SETUP_RETRIEVED";
  MessageCode2["SUCCESS_MENTION_BOOST_SETUP_SAVED"] = "SUCCESS_MENTION_BOOST_SETUP_SAVED";
  MessageCode2["SUCCESS_MENTION_BOOST_LAUNCHED"] = "SUCCESS_MENTION_BOOST_LAUNCHED";
  MessageCode2["SUCCESS_MENTION_BOOST_STOPPED"] = "SUCCESS_MENTION_BOOST_STOPPED";
  MessageCode2["SUCCESS_MENTION_BOOST_INSIGHTS_RETRIEVED"] = "SUCCESS_MENTION_BOOST_INSIGHTS_RETRIEVED";
  MessageCode2["SUCCESS_MENTION_BOOST_CAMPAIGNS_RETRIEVED"] = "SUCCESS_MENTION_BOOST_CAMPAIGNS_RETRIEVED";
  MessageCode2["SUCCESS_MENTION_BOOST_CAMPAIGN_CONFLICT_RETRIEVED"] = "SUCCESS_MENTION_BOOST_CAMPAIGN_CONFLICT_RETRIEVED";
  MessageCode2["SUCCESS_CO_PUBLICITES_RETRIEVED"] = "SUCCESS_CO_PUBLICITES_RETRIEVED";
  MessageCode2["SUCCESS_DOWNLOAD_ACKNOWLEDGMENT_RECORDED"] = "SUCCESS_DOWNLOAD_ACKNOWLEDGMENT_RECORDED";
  MessageCode2["SUCCESS_DOWNLOAD_ACKNOWLEDGMENT_STATUS_RETRIEVED"] = "SUCCESS_DOWNLOAD_ACKNOWLEDGMENT_STATUS_RETRIEVED";
  MessageCode2["SUCCESS_ARCHIVE_ACKNOWLEDGMENT_STATUS_RETRIEVED"] = "SUCCESS_ARCHIVE_ACKNOWLEDGMENT_STATUS_RETRIEVED";
  MessageCode2["SUCCESS_NOTIFICATIONS_RETRIEVED"] = "SUCCESS_NOTIFICATIONS_RETRIEVED";
  MessageCode2["SUCCESS_NOTIFICATION_UNREAD_COUNT_RETRIEVED"] = "SUCCESS_NOTIFICATION_UNREAD_COUNT_RETRIEVED";
  MessageCode2["SUCCESS_NOTIFICATION_PREFERENCES_RETRIEVED"] = "SUCCESS_NOTIFICATION_PREFERENCES_RETRIEVED";
  MessageCode2["SUCCESS_NOTIFICATION_PREFERENCES_UPDATED"] = "SUCCESS_NOTIFICATION_PREFERENCES_UPDATED";
  MessageCode2["SUCCESS_NOTIFICATION_READ"] = "SUCCESS_NOTIFICATION_READ";
  MessageCode2["SUCCESS_NOTIFICATIONS_READ"] = "SUCCESS_NOTIFICATIONS_READ";
  MessageCode2["SUCCESS_NOTIFICATION_DISMISSED"] = "SUCCESS_NOTIFICATION_DISMISSED";
  MessageCode2["SUCCESS_ORDER_CREATED"] = "SUCCESS_ORDER_CREATED";
  MessageCode2["SUCCESS_ORDER_UPDATED"] = "SUCCESS_ORDER_UPDATED";
  MessageCode2["SUCCESS_ORDER_RETRIEVED"] = "SUCCESS_ORDER_RETRIEVED";
  MessageCode2["SUCCESS_ORDERS_LISTED"] = "SUCCESS_ORDERS_LISTED";
  MessageCode2["SUCCESS_ONBOARDING_STEP_COMPLETED"] = "SUCCESS_ONBOARDING_STEP_COMPLETED";
  MessageCode2["SUCCESS_ONBOARDING_COMPLETED"] = "SUCCESS_ONBOARDING_COMPLETED";
  MessageCode2["SUCCESS_LEGAL_ACCEPTED"] = "SUCCESS_LEGAL_ACCEPTED";
  MessageCode2["SUCCESS_PLANS_LISTED"] = "SUCCESS_PLANS_LISTED";
  MessageCode2["SUCCESS_FEATURES_RETRIEVED"] = "SUCCESS_FEATURES_RETRIEVED";
  MessageCode2["SUCCESS_GIFT_CREATED"] = "SUCCESS_GIFT_CREATED";
  MessageCode2["SUCCESS_GIFT_CLAIM_STARTED"] = "SUCCESS_GIFT_CLAIM_STARTED";
  MessageCode2["SUCCESS_GIFT_PRODUCT_SELECTED"] = "SUCCESS_GIFT_PRODUCT_SELECTED";
  MessageCode2["SUCCESS_GIFT_CONFIRMED"] = "SUCCESS_GIFT_CONFIRMED";
  MessageCode2["SUCCESS_GIFT_ORDER_CREATED"] = "SUCCESS_GIFT_ORDER_CREATED";
  MessageCode2["SUCCESS_GIFT_SHIPPED"] = "SUCCESS_GIFT_SHIPPED";
  MessageCode2["SUCCESS_GIFT_DELIVERED"] = "SUCCESS_GIFT_DELIVERED";
  MessageCode2["SUCCESS_GIFT_CANCELLED"] = "SUCCESS_GIFT_CANCELLED";
  MessageCode2["SUCCESS_GIFT_RETRIEVED"] = "SUCCESS_GIFT_RETRIEVED";
  MessageCode2["SUCCESS_GIFT_LIST_RETRIEVED"] = "SUCCESS_GIFT_LIST_RETRIEVED";
  MessageCode2["SUCCESS_GIFT_REOFFER_REVIEWED"] = "SUCCESS_GIFT_REOFFER_REVIEWED";
  MessageCode2["SUCCESS_GIFT_REOFFERED"] = "SUCCESS_GIFT_REOFFERED";
  MessageCode2["SUCCESS_COMPANION_GIFT_REOFFERS_PROCESSED"] = "SUCCESS_COMPANION_GIFT_REOFFERS_PROCESSED";
  MessageCode2["SUCCESS_GIFT_MESSAGE_GENERATED"] = "SUCCESS_GIFT_MESSAGE_GENERATED";
  MessageCode2["SUCCESS_FLOW_CREATED"] = "SUCCESS_FLOW_CREATED";
  MessageCode2["SUCCESS_FLOW_UPDATED"] = "SUCCESS_FLOW_UPDATED";
  MessageCode2["SUCCESS_FLOW_DELETED"] = "SUCCESS_FLOW_DELETED";
  MessageCode2["SUCCESS_FLOW_RETRIEVED"] = "SUCCESS_FLOW_RETRIEVED";
  MessageCode2["SUCCESS_FLOW_LIST_RETRIEVED"] = "SUCCESS_FLOW_LIST_RETRIEVED";
  MessageCode2["SUCCESS_FLOW_PUBLISHED"] = "SUCCESS_FLOW_PUBLISHED";
  MessageCode2["SUCCESS_FLOW_PAUSED"] = "SUCCESS_FLOW_PAUSED";
  MessageCode2["SUCCESS_FLOW_PERSON_REMOVED"] = "SUCCESS_FLOW_PERSON_REMOVED";
  MessageCode2["SUCCESS_FLOW_PERSON_REMOVAL_LIFTED"] = "SUCCESS_FLOW_PERSON_REMOVAL_LIFTED";
  MessageCode2["SUCCESS_FLOW_EMAIL_QUEUED"] = "SUCCESS_FLOW_EMAIL_QUEUED";
  MessageCode2["SUCCESS_PARTNER_ONBOARDED"] = "SUCCESS_PARTNER_ONBOARDED";
  MessageCode2["SUCCESS_BRAND_TERMS_ACCEPTED"] = "SUCCESS_BRAND_TERMS_ACCEPTED";
  MessageCode2["SUCCESS_BRAND_TERMS_RETRIEVED"] = "SUCCESS_BRAND_TERMS_RETRIEVED";
  MessageCode2["SUCCESS_BRAND_TERMS_DRAFT_SAVED"] = "SUCCESS_BRAND_TERMS_DRAFT_SAVED";
  MessageCode2["SUCCESS_BRAND_TERMS_PUBLISHED"] = "SUCCESS_BRAND_TERMS_PUBLISHED";
  MessageCode2["SUCCESS_AI_CONVERSATION_CREATED"] = "SUCCESS_AI_CONVERSATION_CREATED";
  MessageCode2["SUCCESS_AI_CONVERSATION_RETRIEVED"] = "SUCCESS_AI_CONVERSATION_RETRIEVED";
  MessageCode2["SUCCESS_AI_CONVERSATIONS_LISTED"] = "SUCCESS_AI_CONVERSATIONS_LISTED";
  MessageCode2["SUCCESS_AI_CONVERSATION_DELETED"] = "SUCCESS_AI_CONVERSATION_DELETED";
  MessageCode2["SUCCESS_AI_MESSAGE_SENT"] = "SUCCESS_AI_MESSAGE_SENT";
  MessageCode2["SUCCESS_AI_RESULTS_REORDERED"] = "SUCCESS_AI_RESULTS_REORDERED";
  MessageCode2["SUCCESS_SUGGESTIONS_LOADED"] = "SUCCESS_SUGGESTIONS_LOADED";
  MessageCode2["SUCCESS_EXTENSION_LOOKUP"] = "SUCCESS_EXTENSION_LOOKUP";
  MessageCode2["SUCCESS_EXTENSION_QUICK_INVITE"] = "SUCCESS_EXTENSION_QUICK_INVITE";
  MessageCode2["SUCCESS_EXTENSION_BRANDS_LISTED"] = "SUCCESS_EXTENSION_BRANDS_LISTED";
  MessageCode2["SUCCESS_EXTENSION_AUTH_CODE_GENERATED"] = "SUCCESS_EXTENSION_AUTH_CODE_GENERATED";
  MessageCode2["SUCCESS_EXTENSION_TOKEN_EXCHANGED"] = "SUCCESS_EXTENSION_TOKEN_EXCHANGED";
  MessageCode2["SUCCESS_EXTENSION_CREATOR_PROFILE"] = "SUCCESS_EXTENSION_CREATOR_PROFILE";
  MessageCode2["SUCCESS_IMPERSONATION_URL_GENERATED"] = "SUCCESS_IMPERSONATION_URL_GENERATED";
  MessageCode2["SUCCESS_DEEP_LINK_CREATED"] = "SUCCESS_DEEP_LINK_CREATED";
  MessageCode2["SUCCESS_DEEP_LINK_UPDATED"] = "SUCCESS_DEEP_LINK_UPDATED";
  MessageCode2["SUCCESS_DEEP_LINK_DELETED"] = "SUCCESS_DEEP_LINK_DELETED";
  MessageCode2["SUCCESS_DEEP_LINKS_LISTED"] = "SUCCESS_DEEP_LINKS_LISTED";
  MessageCode2["SUCCESS_EXPORT_READY"] = "SUCCESS_EXPORT_READY";
  MessageCode2["SUCCESS_EXPORT_QUEUED"] = "SUCCESS_EXPORT_QUEUED";
  MessageCode2["SUCCESS_EXPORT_EMPTY"] = "SUCCESS_EXPORT_EMPTY";
  MessageCode2["SUCCESS_TEMPLATE_CREATED"] = "SUCCESS_TEMPLATE_CREATED";
  MessageCode2["SUCCESS_TEMPLATE_UPDATED"] = "SUCCESS_TEMPLATE_UPDATED";
  MessageCode2["SUCCESS_TEMPLATE_DELETED"] = "SUCCESS_TEMPLATE_DELETED";
  MessageCode2["SUCCESS_TEMPLATE_RETRIEVED"] = "SUCCESS_TEMPLATE_RETRIEVED";
  MessageCode2["SUCCESS_TEMPLATES_LISTED"] = "SUCCESS_TEMPLATES_LISTED";
  MessageCode2["SUCCESS_TEMPLATE_DEFAULT_SET"] = "SUCCESS_TEMPLATE_DEFAULT_SET";
  MessageCode2["SUCCESS_CREATED"] = "SUCCESS_CREATED";
  MessageCode2["SUCCESS_UPDATED"] = "SUCCESS_UPDATED";
  MessageCode2["SUCCESS_DELETED"] = "SUCCESS_DELETED";
  MessageCode2["SUCCESS_RETRIEVED"] = "SUCCESS_RETRIEVED";
  MessageCode2["SUCCESS_OPERATION_COMPLETED"] = "SUCCESS_OPERATION_COMPLETED";
  MessageCode2["SUCCESS_TEAM_MEMBERS_LISTED"] = "SUCCESS_TEAM_MEMBERS_LISTED";
  MessageCode2["SUCCESS_TEAM_MEMBER_ACCESS_UPDATED"] = "SUCCESS_TEAM_MEMBER_ACCESS_UPDATED";
  MessageCode2["SUCCESS_TEAM_MEMBER_REMOVED"] = "SUCCESS_TEAM_MEMBER_REMOVED";
  MessageCode2["SUCCESS_TEAM_INVITATION_SENT"] = "SUCCESS_TEAM_INVITATION_SENT";
  MessageCode2["SUCCESS_TEAM_INVITATION_RESENT"] = "SUCCESS_TEAM_INVITATION_RESENT";
  MessageCode2["SUCCESS_TEAM_INVITATION_CANCELLED"] = "SUCCESS_TEAM_INVITATION_CANCELLED";
  MessageCode2["SUCCESS_TEAM_INVITATION_ACCEPTED"] = "SUCCESS_TEAM_INVITATION_ACCEPTED";
  MessageCode2["SUCCESS_TEAM_INVITATION_REQUIRES_LOGIN"] = "SUCCESS_TEAM_INVITATION_REQUIRES_LOGIN";
  MessageCode2["SUCCESS_TEAM_INVITATION_DETAILS_RETRIEVED"] = "SUCCESS_TEAM_INVITATION_DETAILS_RETRIEVED";
  MessageCode2["SUCCESS_TEAM_INVITATIONS_LISTED"] = "SUCCESS_TEAM_INVITATIONS_LISTED";
  MessageCode2["SUCCESS_FORMER_MEMBERS_LISTED"] = "SUCCESS_FORMER_MEMBERS_LISTED";
  MessageCode2["SUCCESS_FORMER_MEMBER_REINVITED"] = "SUCCESS_FORMER_MEMBER_REINVITED";
  MessageCode2["SUCCESS_BRAND_SIGNUP_INVITATION_SENT"] = "SUCCESS_BRAND_SIGNUP_INVITATION_SENT";
  MessageCode2["SUCCESS_BRAND_SIGNUP_INVITATIONS_LISTED"] = "SUCCESS_BRAND_SIGNUP_INVITATIONS_LISTED";
  MessageCode2["SUCCESS_BRAND_SIGNUP_INVITATION_RESENT"] = "SUCCESS_BRAND_SIGNUP_INVITATION_RESENT";
  MessageCode2["SUCCESS_BRAND_SIGNUP_INVITATION_REVOKED"] = "SUCCESS_BRAND_SIGNUP_INVITATION_REVOKED";
  MessageCode2["SUCCESS_BRAND_SIGNUP_INVITATION_DETAILS_RETRIEVED"] = "SUCCESS_BRAND_SIGNUP_INVITATION_DETAILS_RETRIEVED";
  MessageCode2["SUCCESS_BRAND_SIGNUP_INVITATION_ACCEPTED"] = "SUCCESS_BRAND_SIGNUP_INVITATION_ACCEPTED";
  MessageCode2["SUCCESS_BRAND_SELF_SIGNUP_STATUS_FETCHED"] = "SUCCESS_BRAND_SELF_SIGNUP_STATUS_FETCHED";
  MessageCode2["SUCCESS_BRAND_SIGNUP_CODE_SENT"] = "SUCCESS_BRAND_SIGNUP_CODE_SENT";
  MessageCode2["SUCCESS_BRAND_REGISTERED"] = "SUCCESS_BRAND_REGISTERED";
  MessageCode2["SUCCESS_BRAND_ONBOARDING_UPDATED"] = "SUCCESS_BRAND_ONBOARDING_UPDATED";
  MessageCode2["SUCCESS_BRAND_ONBOARDING_COMPLETED"] = "SUCCESS_BRAND_ONBOARDING_COMPLETED";
  MessageCode2["SUCCESS_BUSINESS_TYPE_SWITCH_PREVIEWED"] = "SUCCESS_BUSINESS_TYPE_SWITCH_PREVIEWED";
  MessageCode2["SUCCESS_BUSINESS_TYPE_SWITCHED"] = "SUCCESS_BUSINESS_TYPE_SWITCHED";
  MessageCode2["SUCCESS_BUSINESS_CHANGES_LISTED"] = "SUCCESS_BUSINESS_CHANGES_LISTED";
  MessageCode2["SUCCESS_STRIPE_ACCOUNT_STATUS_RETRIEVED"] = "SUCCESS_STRIPE_ACCOUNT_STATUS_RETRIEVED";
  MessageCode2["SUCCESS_AGENT_SETTINGS_RETRIEVED"] = "SUCCESS_AGENT_SETTINGS_RETRIEVED";
  MessageCode2["SUCCESS_AGENT_SETTINGS_UPDATED"] = "SUCCESS_AGENT_SETTINGS_UPDATED";
  MessageCode2["SUCCESS_AGENT_TEST_INVOKED"] = "SUCCESS_AGENT_TEST_INVOKED";
  MessageCode2["SUCCESS_RECOMMENDATIONS_RETRIEVED"] = "SUCCESS_RECOMMENDATIONS_RETRIEVED";
  MessageCode2["SUCCESS_RECOMMENDATIONS_HISTORY_RETRIEVED"] = "SUCCESS_RECOMMENDATIONS_HISTORY_RETRIEVED";
  MessageCode2["SUCCESS_RECOMMENDATION_DISMISSED"] = "SUCCESS_RECOMMENDATION_DISMISSED";
  MessageCode2["SUCCESS_BRAND_MATCH_SCORES_RETRIEVED"] = "SUCCESS_BRAND_MATCH_SCORES_RETRIEVED";
  MessageCode2["SUCCESS_DISCOVERY_PREFERENCES_RETRIEVED"] = "SUCCESS_DISCOVERY_PREFERENCES_RETRIEVED";
  MessageCode2["SUCCESS_DISCOVERY_PREFERENCES_UPDATED"] = "SUCCESS_DISCOVERY_PREFERENCES_UPDATED";
  MessageCode2["SUCCESS_DISCOVERY_PREFERENCES_EXTRACTED"] = "SUCCESS_DISCOVERY_PREFERENCES_EXTRACTED";
  MessageCode2["SUCCESS_COMPANION_ONBOARDING_COMPLETED"] = "SUCCESS_COMPANION_ONBOARDING_COMPLETED";
  MessageCode2["SUCCESS_COMPANION_ONBOARDING_STARTED"] = "SUCCESS_COMPANION_ONBOARDING_STARTED";
  MessageCode2["SUCCESS_CONTACT_RESOLVED"] = "SUCCESS_CONTACT_RESOLVED";
  MessageCode2["SUCCESS_AFFILIATION_RETRIEVED"] = "SUCCESS_AFFILIATION_RETRIEVED";
  MessageCode2["SUCCESS_CONTACT_MENTIONS_RETRIEVED"] = "SUCCESS_CONTACT_MENTIONS_RETRIEVED";
  MessageCode2["SUCCESS_CONTACT_NOTES_RETRIEVED"] = "SUCCESS_CONTACT_NOTES_RETRIEVED";
  MessageCode2["SUCCESS_CONTACT_NOTE_CREATED"] = "SUCCESS_CONTACT_NOTE_CREATED";
  MessageCode2["SUCCESS_CONTACT_NOTE_UPDATED"] = "SUCCESS_CONTACT_NOTE_UPDATED";
  MessageCode2["SUCCESS_CONTACT_NOTE_DELETED"] = "SUCCESS_CONTACT_NOTE_DELETED";
  MessageCode2["SUCCESS_CONTACT_ADS_RETRIEVED"] = "SUCCESS_CONTACT_ADS_RETRIEVED";
  MessageCode2["SUCCESS_CONTACT_DETAILS_RETRIEVED"] = "SUCCESS_CONTACT_DETAILS_RETRIEVED";
  MessageCode2["SUCCESS_CONTACT_DETAILS_UPDATED"] = "SUCCESS_CONTACT_DETAILS_UPDATED";
  MessageCode2["SUCCESS_CONTACT_SUMMARY_RETRIEVED"] = "SUCCESS_CONTACT_SUMMARY_RETRIEVED";
  MessageCode2["SUCCESS_CONTACTS_SEARCHED"] = "SUCCESS_CONTACTS_SEARCHED";
  MessageCode2["SUCCESS_BRIEF_TEMPLATES_LISTED"] = "SUCCESS_BRIEF_TEMPLATES_LISTED";
  MessageCode2["SUCCESS_BRIEF_TEMPLATE_RETRIEVED"] = "SUCCESS_BRIEF_TEMPLATE_RETRIEVED";
  MessageCode2["SUCCESS_BRIEF_TEMPLATE_CREATED"] = "SUCCESS_BRIEF_TEMPLATE_CREATED";
  MessageCode2["SUCCESS_BRIEF_TEMPLATE_UPDATED"] = "SUCCESS_BRIEF_TEMPLATE_UPDATED";
  MessageCode2["SUCCESS_BRIEF_TEMPLATE_ARCHIVED"] = "SUCCESS_BRIEF_TEMPLATE_ARCHIVED";
  MessageCode2["SUCCESS_BRIEF_TEMPLATE_RESTORED"] = "SUCCESS_BRIEF_TEMPLATE_RESTORED";
  MessageCode2["SUCCESS_BRIEF_TEMPLATE_DUPLICATED"] = "SUCCESS_BRIEF_TEMPLATE_DUPLICATED";
  MessageCode2["SUCCESS_BRIEF_TEMPLATE_DELETED"] = "SUCCESS_BRIEF_TEMPLATE_DELETED";
  MessageCode2["SUCCESS_BRIEF_TEMPLATE_VERSION_CREATED"] = "SUCCESS_BRIEF_TEMPLATE_VERSION_CREATED";
  MessageCode2["SUCCESS_BRIEF_TEMPLATE_VERSIONS_LISTED"] = "SUCCESS_BRIEF_TEMPLATE_VERSIONS_LISTED";
  MessageCode2["SUCCESS_BRIEF_TEMPLATE_VERSION_RETRIEVED"] = "SUCCESS_BRIEF_TEMPLATE_VERSION_RETRIEVED";
  MessageCode2["SUCCESS_BRIEF_TEMPLATE_GENERATED"] = "SUCCESS_BRIEF_TEMPLATE_GENERATED";
  MessageCode2["SUCCESS_BRIEF_TEMPLATE_ATTACHMENT_UPLOADED"] = "SUCCESS_BRIEF_TEMPLATE_ATTACHMENT_UPLOADED";
  MessageCode2["SUCCESS_BRIEF_TEMPLATE_ATTACHMENT_DELETED"] = "SUCCESS_BRIEF_TEMPLATE_ATTACHMENT_DELETED";
  MessageCode2["SUCCESS_BRIEF_DIFFUSION_OPENED"] = "SUCCESS_BRIEF_DIFFUSION_OPENED";
  MessageCode2["SUCCESS_BRIEF_DIFFUSION_STOPPED"] = "SUCCESS_BRIEF_DIFFUSION_STOPPED";
  MessageCode2["SUCCESS_BRIEF_PROPOSED_CREATORS_RETRIEVED"] = "SUCCESS_BRIEF_PROPOSED_CREATORS_RETRIEVED";
  MessageCode2["SUCCESS_BRIEF_APPLICATION_SUBMITTED"] = "SUCCESS_BRIEF_APPLICATION_SUBMITTED";
  MessageCode2["SUCCESS_PROGRAM_APPLICATION_SUBMITTED"] = "SUCCESS_PROGRAM_APPLICATION_SUBMITTED";
  MessageCode2["SUCCESS_APPLICATIONS_RETRIEVED"] = "SUCCESS_APPLICATIONS_RETRIEVED";
  MessageCode2["SUCCESS_BRIEF_APPLICATION_RETRIEVED"] = "SUCCESS_BRIEF_APPLICATION_RETRIEVED";
  MessageCode2["SUCCESS_BRIEF_APPLICATION_DECLINED"] = "SUCCESS_BRIEF_APPLICATION_DECLINED";
  MessageCode2["SUCCESS_OPPORTUNITIES_RETRIEVED"] = "SUCCESS_OPPORTUNITIES_RETRIEVED";
  MessageCode2["SUCCESS_OPPORTUNITY_RETRIEVED"] = "SUCCESS_OPPORTUNITY_RETRIEVED";
  MessageCode2["SUCCESS_COLLAB_CREATED"] = "SUCCESS_COLLAB_CREATED";
  MessageCode2["SUCCESS_COLLAB_UPDATED"] = "SUCCESS_COLLAB_UPDATED";
  MessageCode2["SUCCESS_COLLAB_LISTED"] = "SUCCESS_COLLAB_LISTED";
  MessageCode2["SUCCESS_COLLAB_RETRIEVED"] = "SUCCESS_COLLAB_RETRIEVED";
  MessageCode2["SUCCESS_COLLAB_DELETED"] = "SUCCESS_COLLAB_DELETED";
  MessageCode2["SUCCESS_COLLAB_SENT"] = "SUCCESS_COLLAB_SENT";
  MessageCode2["SUCCESS_COLLAB_WITHDRAWN"] = "SUCCESS_COLLAB_WITHDRAWN";
  MessageCode2["SUCCESS_COLLAB_CLOSED"] = "SUCCESS_COLLAB_CLOSED";
  MessageCode2["SUCCESS_COLLAB_EVENTS_LISTED"] = "SUCCESS_COLLAB_EVENTS_LISTED";
  MessageCode2["SUCCESS_COLLAB_VIEW_RECORDED"] = "SUCCESS_COLLAB_VIEW_RECORDED";
  MessageCode2["SUCCESS_COLLAB_ACCEPTED"] = "SUCCESS_COLLAB_ACCEPTED";
  MessageCode2["SUCCESS_COLLAB_ACCEPTED_HELD_BY_ANOTHER_ACCOUNT"] = "SUCCESS_COLLAB_ACCEPTED_HELD_BY_ANOTHER_ACCOUNT";
  MessageCode2["SUCCESS_COLLAB_ACCEPTED_SIGN_IN_REQUIRED"] = "SUCCESS_COLLAB_ACCEPTED_SIGN_IN_REQUIRED";
  MessageCode2["SUCCESS_COLLAB_ADDRESS_VERIFIED"] = "SUCCESS_COLLAB_ADDRESS_VERIFIED";
  MessageCode2["SUCCESS_COLLAB_DECLINED"] = "SUCCESS_COLLAB_DECLINED";
  MessageCode2["SUCCESS_COLLAB_CODE_SENT"] = "SUCCESS_COLLAB_CODE_SENT";
  MessageCode2["SUCCESS_COLLAB_REMINDED"] = "SUCCESS_COLLAB_REMINDED";
  MessageCode2["SUCCESS_COLLAB_REMINDED_PARTIAL"] = "SUCCESS_COLLAB_REMINDED_PARTIAL";
  MessageCode2["SUCCESS_COLLAB_COUNTS_RETRIEVED"] = "SUCCESS_COLLAB_COUNTS_RETRIEVED";
  MessageCode2["SUCCESS_COLLAB_RECIPIENTS_RETRIEVED"] = "SUCCESS_COLLAB_RECIPIENTS_RETRIEVED";
  MessageCode2["SUCCESS_COLLAB_UGC_TERMS_RETRIEVED"] = "SUCCESS_COLLAB_UGC_TERMS_RETRIEVED";
  MessageCode2["SUCCESS_COLLAB_UGC_ATTENTION_RETRIEVED"] = "SUCCESS_COLLAB_UGC_ATTENTION_RETRIEVED";
  MessageCode2["SUCCESS_COLLAB_UGC_CONTENTS_RETRIEVED"] = "SUCCESS_COLLAB_UGC_CONTENTS_RETRIEVED";
  MessageCode2["SUCCESS_COLLAB_RECOVERY_CODE_RESOLVED"] = "SUCCESS_COLLAB_RECOVERY_CODE_RESOLVED";
  MessageCode2["SUCCESS_CREATOR_HUB_INVITATION_RESOLVED"] = "SUCCESS_CREATOR_HUB_INVITATION_RESOLVED";
  MessageCode2["SUCCESS_CREATOR_HUB_INVITATION_RECIPIENT_RETRIEVED"] = "SUCCESS_CREATOR_HUB_INVITATION_RECIPIENT_RETRIEVED";
  MessageCode2["SUCCESS_COLLAB_DELIVERABLE_MENTION_ATTACHED"] = "SUCCESS_COLLAB_DELIVERABLE_MENTION_ATTACHED";
  MessageCode2["SUCCESS_COLLAB_DELIVERABLE_MENTION_DETACHED"] = "SUCCESS_COLLAB_DELIVERABLE_MENTION_DETACHED";
  MessageCode2["SUCCESS_COLLAB_DELIVERABLE_VALIDATED"] = "SUCCESS_COLLAB_DELIVERABLE_VALIDATED";
  MessageCode2["SUCCESS_COLLAB_DELIVERABLE_REJECTED"] = "SUCCESS_COLLAB_DELIVERABLE_REJECTED";
  MessageCode2["SUCCESS_COLLAB_DELIVERABLES_LISTED"] = "SUCCESS_COLLAB_DELIVERABLES_LISTED";
  MessageCode2["SUCCESS_COLLAB_SETTLEMENT_RETRIEVED"] = "SUCCESS_COLLAB_SETTLEMENT_RETRIEVED";
  MessageCode2["SUCCESS_COLLAB_SETTLEMENT_PREPARED"] = "SUCCESS_COLLAB_SETTLEMENT_PREPARED";
  MessageCode2["SUCCESS_COLLAB_SETTLEMENT_COLLECTION_STARTED"] = "SUCCESS_COLLAB_SETTLEMENT_COLLECTION_STARTED";
  MessageCode2["SUCCESS_COLLAB_DEADLINE_EXTENDED"] = "SUCCESS_COLLAB_DEADLINE_EXTENDED";
  MessageCode2["SUCCESS_COLLAB_CLOSED_AND_PAID"] = "SUCCESS_COLLAB_CLOSED_AND_PAID";
  MessageCode2["SUCCESS_COLLAB_UGC_SHIPMENT_EXTENDED"] = "SUCCESS_COLLAB_UGC_SHIPMENT_EXTENDED";
  MessageCode2["SUCCESS_COLLAB_UGC_SHIPMENT_CANCELLED"] = "SUCCESS_COLLAB_UGC_SHIPMENT_CANCELLED";
  MessageCode2["SUCCESS_CREATOR_HUB_UGC_PRODUCT_RECEIVED"] = "SUCCESS_CREATOR_HUB_UGC_PRODUCT_RECEIVED";
  MessageCode2["SUCCESS_CREATOR_HUB_UGC_PRODUCT_RECEPTION_ANSWERED"] = "SUCCESS_CREATOR_HUB_UGC_PRODUCT_RECEPTION_ANSWERED";
  MessageCode2["SUCCESS_COLLAB_UGC_PRODUCT_RESHIPPED"] = "SUCCESS_COLLAB_UGC_PRODUCT_RESHIPPED";
  MessageCode2["SUCCESS_COLLAB_DISPUTE_OPENED"] = "SUCCESS_COLLAB_DISPUTE_OPENED";
  MessageCode2["SUCCESS_COLLAB_CREATOR_WITHDRAWN"] = "SUCCESS_COLLAB_CREATOR_WITHDRAWN";
  MessageCode2["SUCCESS_COLLAB_PAYMENT_TERMS_ACCEPTED"] = "SUCCESS_COLLAB_PAYMENT_TERMS_ACCEPTED";
  MessageCode2["SUCCESS_COLLAB_PAYMENT_TERMS_FETCHED"] = "SUCCESS_COLLAB_PAYMENT_TERMS_FETCHED";
  MessageCode2["SUCCESS_COLLAB_PAYMENT_DOCUMENT_READY"] = "SUCCESS_COLLAB_PAYMENT_DOCUMENT_READY";
  MessageCode2["SUCCESS_DISPLAY_RIGHTS_PROPOSAL_RETRIEVED"] = "SUCCESS_DISPLAY_RIGHTS_PROPOSAL_RETRIEVED";
  MessageCode2["SUCCESS_DISPLAY_RIGHTS_CODE_SENT"] = "SUCCESS_DISPLAY_RIGHTS_CODE_SENT";
  MessageCode2["SUCCESS_DISPLAY_RIGHTS_ACCEPTED"] = "SUCCESS_DISPLAY_RIGHTS_ACCEPTED";
  MessageCode2["SUCCESS_DISPLAY_RIGHTS_DECLINED"] = "SUCCESS_DISPLAY_RIGHTS_DECLINED";
  MessageCode2["SUCCESS_DISPLAY_RIGHTS_PROPOSAL_SENT"] = "SUCCESS_DISPLAY_RIGHTS_PROPOSAL_SENT";
  MessageCode2["SUCCESS_DISPLAY_RIGHTS_PROPOSAL_REVISED"] = "SUCCESS_DISPLAY_RIGHTS_PROPOSAL_REVISED";
  MessageCode2["SUCCESS_DISPLAY_RIGHTS_PROPOSAL_REMINDED"] = "SUCCESS_DISPLAY_RIGHTS_PROPOSAL_REMINDED";
  MessageCode2["SUCCESS_CREATOR_HUB_INBOX_RETRIEVED"] = "SUCCESS_CREATOR_HUB_INBOX_RETRIEVED";
  MessageCode2["SUCCESS_CREATOR_HUB_CONVERSATION_RETRIEVED"] = "SUCCESS_CREATOR_HUB_CONVERSATION_RETRIEVED";
  MessageCode2["SUCCESS_CREATOR_HUB_FEED_RETRIEVED"] = "SUCCESS_CREATOR_HUB_FEED_RETRIEVED";
  MessageCode2["SUCCESS_CREATOR_HUB_MESSAGE_SENT"] = "SUCCESS_CREATOR_HUB_MESSAGE_SENT";
  MessageCode2["SUCCESS_CREATOR_HUB_READ_ADVANCED"] = "SUCCESS_CREATOR_HUB_READ_ADVANCED";
  MessageCode2["SUCCESS_CREATOR_HUB_PARTICIPANT_BLOCK_UPDATED"] = "SUCCESS_CREATOR_HUB_PARTICIPANT_BLOCK_UPDATED";
  MessageCode2["SUCCESS_CREATOR_HUB_PARTICIPANT_REPORTED"] = "SUCCESS_CREATOR_HUB_PARTICIPANT_REPORTED";
  MessageCode2["SUCCESS_BRAND_SPACE_RETRIEVED"] = "SUCCESS_BRAND_SPACE_RETRIEVED";
  MessageCode2["SUCCESS_BRAND_SPACE_MENTIONS_RETRIEVED"] = "SUCCESS_BRAND_SPACE_MENTIONS_RETRIEVED";
  MessageCode2["SUCCESS_BRAND_SPACE_HOME_RETRIEVED"] = "SUCCESS_BRAND_SPACE_HOME_RETRIEVED";
  MessageCode2["SUCCESS_BRAND_SPACE_PROVISIONED"] = "SUCCESS_BRAND_SPACE_PROVISIONED";
  MessageCode2["SUCCESS_BRAND_SPACE_PREVIEW_TOKEN_CREATED"] = "SUCCESS_BRAND_SPACE_PREVIEW_TOKEN_CREATED";
  MessageCode2["SUCCESS_BRAND_SPACE_DRAFT_SAVED"] = "SUCCESS_BRAND_SPACE_DRAFT_SAVED";
  MessageCode2["SUCCESS_BRAND_SPACE_SLUG_AVAILABILITY_RETRIEVED"] = "SUCCESS_BRAND_SPACE_SLUG_AVAILABILITY_RETRIEVED";
  MessageCode2["SUCCESS_BRAND_SPACE_PUBLISHED"] = "SUCCESS_BRAND_SPACE_PUBLISHED";
  MessageCode2["SUCCESS_BRAND_SPACE_EMERGENCY_UNPUBLISHED"] = "SUCCESS_BRAND_SPACE_EMERGENCY_UNPUBLISHED";
  MessageCode2["SUCCESS_ADMIN_ACTION_PREVIEWED"] = "SUCCESS_ADMIN_ACTION_PREVIEWED";
  MessageCode2["SUCCESS_ADMIN_ACTION_CODE_SENT"] = "SUCCESS_ADMIN_ACTION_CODE_SENT";
  MessageCode2["SUCCESS_ADMIN_ACTION_SETTLED"] = "SUCCESS_ADMIN_ACTION_SETTLED";
  MessageCode2["SUCCESS_BLOCKED_EMAILS_LISTED"] = "SUCCESS_BLOCKED_EMAILS_LISTED";
  MessageCode2["SUCCESS_BRAND_SPACES_ADMIN_LISTED"] = "SUCCESS_BRAND_SPACES_ADMIN_LISTED";
  MessageCode2["SUCCESS_BRAND_SPACE_VARIANT_CREATED"] = "SUCCESS_BRAND_SPACE_VARIANT_CREATED";
  MessageCode2["SUCCESS_BRAND_SPACE_VARIANT_UPDATED"] = "SUCCESS_BRAND_SPACE_VARIANT_UPDATED";
  MessageCode2["SUCCESS_BRAND_SPACE_VARIANT_DELETED"] = "SUCCESS_BRAND_SPACE_VARIANT_DELETED";
  MessageCode2["SUCCESS_BRAND_SPACE_APPLICATION_CHALLENGE_RETRIEVED"] = "SUCCESS_BRAND_SPACE_APPLICATION_CHALLENGE_RETRIEVED";
  MessageCode2["SUCCESS_BRAND_SPACE_APPLICATION_RECEIVED"] = "SUCCESS_BRAND_SPACE_APPLICATION_RECEIVED";
  MessageCode2["SUCCESS_BRAND_SPACE_APPLICATIONS_RETRIEVED"] = "SUCCESS_BRAND_SPACE_APPLICATIONS_RETRIEVED";
  MessageCode2["SUCCESS_BRAND_SPACE_APPLICATION_ACCEPTED"] = "SUCCESS_BRAND_SPACE_APPLICATION_ACCEPTED";
  MessageCode2["SUCCESS_BRAND_SPACE_APPLICATION_REJECTED"] = "SUCCESS_BRAND_SPACE_APPLICATION_REJECTED";
  MessageCode2["SUCCESS_SUCCESS_FEE_MIGRATION_STATUS_FETCHED"] = "SUCCESS_SUCCESS_FEE_MIGRATION_STATUS_FETCHED";
  MessageCode2["SUCCESS_SUCCESS_FEE_MIGRATION_STARTED"] = "SUCCESS_SUCCESS_FEE_MIGRATION_STARTED";
  MessageCode2["SUCCESS_SUCCESS_FEE_TERMS_FETCHED"] = "SUCCESS_SUCCESS_FEE_TERMS_FETCHED";
  MessageCode2["SUCCESS_SUCCESS_FEE_TERMS_ACCEPTED"] = "SUCCESS_SUCCESS_FEE_TERMS_ACCEPTED";
  MessageCode2["SUCCESS_SUCCESS_FEE_RAIL_ELIGIBILITY_FETCHED"] = "SUCCESS_SUCCESS_FEE_RAIL_ELIGIBILITY_FETCHED";
  MessageCode2["SUCCESS_PARTNER_SUCCESS_FEES_FETCHED"] = "SUCCESS_PARTNER_SUCCESS_FEES_FETCHED";
  MessageCode2["SUCCESS_PARTNER_NETWORK_STATEMENT_FETCHED"] = "SUCCESS_PARTNER_NETWORK_STATEMENT_FETCHED";
  MessageCode2["SUCCESS_COMPANION_FEED_RETRIEVED"] = "SUCCESS_COMPANION_FEED_RETRIEVED";
  MessageCode2["SUCCESS_COMPANION_ACTION_UPDATED"] = "SUCCESS_COMPANION_ACTION_UPDATED";
  MessageCode2["SUCCESS_COMPANION_PANEL_VIEW_RECORDED"] = "SUCCESS_COMPANION_PANEL_VIEW_RECORDED";
  MessageCode2["SUCCESS_COMPANION_PANEL_CONVERSATION_FETCHED"] = "SUCCESS_COMPANION_PANEL_CONVERSATION_FETCHED";
  MessageCode2["SUCCESS_DEMO_INVITATION_RETRIEVED"] = "SUCCESS_DEMO_INVITATION_RETRIEVED";
  MessageCode2["SUCCESS_DEMO_AVAILABILITY_RETRIEVED"] = "SUCCESS_DEMO_AVAILABILITY_RETRIEVED";
  MessageCode2["SUCCESS_DEMO_BOOKED"] = "SUCCESS_DEMO_BOOKED";
  MessageCode2["SUCCESS_DEMO_INVITATION_DISMISSED"] = "SUCCESS_DEMO_INVITATION_DISMISSED";
  MessageCode2["SUCCESS_ORGANIZATION_OWNER_PROMOTED"] = "SUCCESS_ORGANIZATION_OWNER_PROMOTED";
  MessageCode2["SUCCESS_ORGANIZATION_MEMBER_ACCESS_REVOKED"] = "SUCCESS_ORGANIZATION_MEMBER_ACCESS_REVOKED";
  MessageCode2["SUCCESS_BRAND_ONBOARDING_EMAILS_STOPPED"] = "SUCCESS_BRAND_ONBOARDING_EMAILS_STOPPED";
  MessageCode2["SUCCESS_BRAND_ONBOARDING_EMAILS_RESUMED"] = "SUCCESS_BRAND_ONBOARDING_EMAILS_RESUMED";
  MessageCode2["SUCCESS_CONVERSATION_ATTACHMENT_UPLOAD_STARTED"] = "SUCCESS_CONVERSATION_ATTACHMENT_UPLOAD_STARTED";
  MessageCode2["SUCCESS_CONVERSATION_ATTACHMENT_PARTS_SIGNED"] = "SUCCESS_CONVERSATION_ATTACHMENT_PARTS_SIGNED";
  MessageCode2["SUCCESS_CONVERSATION_ATTACHMENT_UPLOAD_CONFIRMED"] = "SUCCESS_CONVERSATION_ATTACHMENT_UPLOAD_CONFIRMED";
  MessageCode2["SUCCESS_CONVERSATION_ATTACHMENT_UPLOAD_ABORTED"] = "SUCCESS_CONVERSATION_ATTACHMENT_UPLOAD_ABORTED";
  MessageCode2["SUCCESS_CONVERSATION_ATTACHMENT_URL_ISSUED"] = "SUCCESS_CONVERSATION_ATTACHMENT_URL_ISSUED";
  MessageCode2["SUCCESS_COLLAB_QUESTION_SENT"] = "SUCCESS_COLLAB_QUESTION_SENT";
  MessageCode2["SUCCESS_UGC_VERSION_UPLOAD_STARTED"] = "SUCCESS_UGC_VERSION_UPLOAD_STARTED";
  MessageCode2["SUCCESS_UGC_VERSION_UPLOAD_COMPLETED"] = "SUCCESS_UGC_VERSION_UPLOAD_COMPLETED";
  MessageCode2["SUCCESS_UGC_VERSIONS_RETRIEVED"] = "SUCCESS_UGC_VERSIONS_RETRIEVED";
  MessageCode2["SUCCESS_UGC_VERSION_PREVIEW_URL_ISSUED"] = "SUCCESS_UGC_VERSION_PREVIEW_URL_ISSUED";
  MessageCode2["SUCCESS_UGC_VERSION_ORIGINAL_URL_ISSUED"] = "SUCCESS_UGC_VERSION_ORIGINAL_URL_ISSUED";
  MessageCode2["SUCCESS_UGC_FEEDBACK_ADDED"] = "SUCCESS_UGC_FEEDBACK_ADDED";
  MessageCode2["SUCCESS_UGC_FEEDBACK_DELETED"] = "SUCCESS_UGC_FEEDBACK_DELETED";
  MessageCode2["SUCCESS_UGC_SERIES_DECIDED"] = "SUCCESS_UGC_SERIES_DECIDED";
  MessageCode2["SUCCESS_CREATOR_NOTIFICATIONS_RETRIEVED"] = "SUCCESS_CREATOR_NOTIFICATIONS_RETRIEVED";
  MessageCode2["SUCCESS_CREATOR_NOTIFICATIONS_UNREAD_COUNT_RETRIEVED"] = "SUCCESS_CREATOR_NOTIFICATIONS_UNREAD_COUNT_RETRIEVED";
  MessageCode2["SUCCESS_CREATOR_NOTIFICATION_READ"] = "SUCCESS_CREATOR_NOTIFICATION_READ";
  MessageCode2["SUCCESS_CREATOR_NOTIFICATIONS_READ_ALL"] = "SUCCESS_CREATOR_NOTIFICATIONS_READ_ALL";
  return MessageCode2;
})(MessageCode || {});

// src/api/notifications.ts
var NotificationCategory = {
  AGENT: "agent",
  AFFILIATE: "affiliate",
  SYSTEM: "system",
  BOOST: "boost",
  COLLAB: "collab"
};
var NotificationType = {
  AGENT_RECOMMENDATIONS_DELIVERED: "agent.recommendations.delivered",
  AFFILIATE_JOINED_PROGRAM: "affiliate.joined_program",
  BRAND_SPACE_APPLICATION_RECEIVED: "brand_space.application_received",
  GIFT_CLAIMED: "gift.claimed",
  BOOST_AUTHORIZATION_UPDATED: "boost.authorization.updated",
  BOOST_DELIVERY_UPDATED: "boost.delivery.updated",
  BOOST_DISPLAY_RIGHTS_UPDATED: "boost.display_rights.updated",
  COLLAB_VIEWED: "collab.viewed",
  COLLAB_ACCEPTED: "collab.accepted",
  COLLAB_DECLINED: "collab.declined",
  COLLAB_DELIVERY_FAILED: "collab.delivery_failed",
  COLLAB_PAYMENT_FAILED: "collab.payment_failed",
  COLLAB_CANCELLED: "collab.cancelled",
  COLLAB_FUNDING_REQUESTED: "collab.funding_requested",
  COLLAB_FUNDING_SECURED: "collab.funding_secured",
  COLLAB_FUNDING_DELAYED: "collab.funding_delayed",
  COLLAB_UNFUNDED: "collab.unfunded",
  COLLAB_PAYMENT_REFUNDED: "collab.payment_refunded",
  COLLAB_LATE_CAPTURE_REFUNDED: "collab.late_capture_refunded",
  COLLAB_BANK_DISPUTE_RESOLVED: "collab.bank_dispute_resolved",
  COLLAB_HOLD_AGE_WARNING: "collab.hold_age_warning",
  COLLAB_UGC_SHIPMENT_CHOICE: "collab.ugc_shipment_choice",
  COLLAB_UGC_PRODUCT_NOT_RECEIVED: "collab.ugc_product_not_received",
  COLLAB_UGC_RECEPTION_CHOICE: "collab.ugc_reception_choice",
  COLLAB_UGC_RIGHTS_ENDING: "collab.ugc_rights_ending",
  COLLAB_CONTENT_RECORDED: "collab.content_recorded",
  COLLAB_DELIVERABLE_REJECTIONS_EXHAUSTED: "collab.deliverable_rejections_exhausted",
  COLLAB_DELIVERABLE_TACITLY_VALIDATED: "collab.deliverable_tacitly_validated",
  COLLAB_PAYMENT_RELEASED: "collab.payment_released",
  COLLAB_PAYOUT_COUNTRY_UNSUPPORTED: "collab.payout_country_unsupported",
  GIFT_STOCK_ALERT: "gift.stock_alert",
  CONVERSATION_CREATOR_MESSAGE_RECEIVED: "conversation.creator_message_received",
  BRIEF_APPLICATION_RECEIVED: "brief.application_received",
  FLOW_TEAM_NOTIFIED: "flow.team_notified"
};
var NotificationSourceType = {
  RECOMMENDATION_BATCH: "recommendation_batch",
  AFFILIATE_PROGRAM_MEMBERSHIP: "affiliate_program_membership",
  BRAND_SPACE_APPLICATION: "brand_space_application",
  GIFT_REQUEST: "gift_request",
  PARTNERSHIP_AD_AUTHORIZATION: "partnership_ad_authorization",
  MENTION_BOOST: "mention_boost",
  COLLAB: "collab",
  SHOPIFY_PRODUCT: "shopify_product",
  CONVERSATION: "conversation",
  BRIEF_APPLICATION: "brief_application",
  FLOW_STEP_EXECUTION: "flow_step_execution"
};
var NotificationTab = {
  ALL: "all",
  AGENTS: "agents"
};
var NotificationActorType = {
  SYSTEM: "system",
  AGENT: "agent",
  USER: "user",
  AFFILIATE: "affiliate",
  CREATOR: "creator"
};
var NotificationRealtimeEventName = {
  CREATED: "notification.created"
};
var NotificationTypeConfig = {
  [NotificationType.FLOW_TEAM_NOTIFIED]: {
    category: NotificationCategory.SYSTEM,
    sourceType: NotificationSourceType.FLOW_STEP_EXECUTION,
    titleKey: "notifications.flow.teamNotified.title",
    bodyKey: "notifications.flow.teamNotified.body",
    defaultActionUrl: null
  },
  [NotificationType.AGENT_RECOMMENDATIONS_DELIVERED]: {
    category: NotificationCategory.AGENT,
    sourceType: NotificationSourceType.RECOMMENDATION_BATCH,
    titleKey: "notifications.agent.recommendationsDelivered.title",
    bodyKey: "notifications.agent.recommendationsDelivered.body",
    defaultActionUrl: "/dashboard/creators/discovery?tab=recommendations"
  },
  [NotificationType.AFFILIATE_JOINED_PROGRAM]: {
    category: NotificationCategory.AFFILIATE,
    sourceType: NotificationSourceType.AFFILIATE_PROGRAM_MEMBERSHIP,
    titleKey: "notifications.affiliate.joinedProgram.title",
    bodyKey: "notifications.affiliate.joinedProgram.body",
    defaultActionUrl: "/dashboard/affiliates"
  },
  [NotificationType.BRAND_SPACE_APPLICATION_RECEIVED]: {
    category: NotificationCategory.AFFILIATE,
    sourceType: NotificationSourceType.BRAND_SPACE_APPLICATION,
    titleKey: "notifications.brandSpace.applicationReceived.title",
    bodyKey: "notifications.brandSpace.applicationReceived.body",
    defaultActionUrl: "/affiliates/applications?applicationStatus=pending"
  },
  [NotificationType.GIFT_CLAIMED]: {
    category: NotificationCategory.AFFILIATE,
    sourceType: NotificationSourceType.GIFT_REQUEST,
    titleKey: "notifications.gift.claimed.title",
    bodyKey: "notifications.gift.claimed.body",
    defaultActionUrl: "/dashboard/affiliates"
  },
  [NotificationType.BOOST_AUTHORIZATION_UPDATED]: {
    category: NotificationCategory.BOOST,
    sourceType: NotificationSourceType.PARTNERSHIP_AD_AUTHORIZATION,
    // The copy variant is resolved from the `context` i18n param (the
    // authorization status) so a single key registry covers every outcome.
    titleKey: "notifications.boost.authorization.title",
    bodyKey: "notifications.boost.authorization.body",
    // The deep link targets the originating mention, so it is built per event
    // from the notification data rather than a static default.
    defaultActionUrl: null
  },
  [NotificationType.BOOST_DELIVERY_UPDATED]: {
    category: NotificationCategory.BOOST,
    sourceType: NotificationSourceType.MENTION_BOOST,
    titleKey: "notifications.boost.delivery.title",
    bodyKey: "notifications.boost.delivery.body",
    defaultActionUrl: null
  },
  [NotificationType.BOOST_DISPLAY_RIGHTS_UPDATED]: {
    category: NotificationCategory.BOOST,
    // The authorization IS the source: display rights hang off it, and a
    // renewal is a new proposal chain on the same authorization — keying the
    // notification to a proposal id would break that continuity.
    sourceType: NotificationSourceType.PARTNERSHIP_AD_AUTHORIZATION,
    // Same single-registry-entry convention as the authorization notifier: the
    // intent travels as the `context` i18n param, so one key covers both the
    // approaching deadline and the ending forced by a revocation.
    titleKey: "notifications.boost.displayRights.title",
    bodyKey: "notifications.boost.displayRights.body",
    // The deep link targets the originating mention, so it is built per event.
    defaultActionUrl: null
  },
  [NotificationType.COLLAB_VIEWED]: {
    category: NotificationCategory.COLLAB,
    sourceType: NotificationSourceType.COLLAB,
    titleKey: "notifications.collab.viewed.title",
    bodyKey: "notifications.collab.viewed.body",
    // Deep link targets the collab in the Suivi drawer, built per event from
    // the collab id.
    defaultActionUrl: null
  },
  [NotificationType.COLLAB_ACCEPTED]: {
    category: NotificationCategory.COLLAB,
    sourceType: NotificationSourceType.COLLAB,
    titleKey: "notifications.collab.accepted.title",
    bodyKey: "notifications.collab.accepted.body",
    defaultActionUrl: null
  },
  [NotificationType.COLLAB_DECLINED]: {
    category: NotificationCategory.COLLAB,
    sourceType: NotificationSourceType.COLLAB,
    titleKey: "notifications.collab.declined.title",
    bodyKey: "notifications.collab.declined.body",
    defaultActionUrl: null
  },
  [NotificationType.COLLAB_DELIVERY_FAILED]: {
    category: NotificationCategory.COLLAB,
    sourceType: NotificationSourceType.COLLAB,
    titleKey: "notifications.collab.deliveryFailed.title",
    bodyKey: "notifications.collab.deliveryFailed.body",
    defaultActionUrl: null
  },
  [NotificationType.COLLAB_PAYMENT_FAILED]: {
    category: NotificationCategory.COLLAB,
    sourceType: NotificationSourceType.COLLAB,
    titleKey: "notifications.collab.paymentFailed.title",
    bodyKey: "notifications.collab.paymentFailed.body",
    defaultActionUrl: null
  },
  /**
   * A collaboration ended without being executed: the creator withdrew, a
   * deadline passed with nothing delivered, or a dispute was settled in the
   * brand's favour. The coded reason travels in the event data, because what
   * the brand needs to read is why, not merely that.
   */
  [NotificationType.COLLAB_CANCELLED]: {
    category: NotificationCategory.COLLAB,
    sourceType: NotificationSourceType.COLLAB,
    titleKey: "notifications.collab.cancelled.title",
    bodyKey: "notifications.collab.cancelled.body",
    defaultActionUrl: null
  },
  /**
   * The creator said yes and the brand has seventy-two hours to pay. One kind
   * for the call and for its two reminders: the milestone travels in the event
   * data, because what changes between them is the urgency, not the news.
   */
  [NotificationType.COLLAB_FUNDING_REQUESTED]: {
    category: NotificationCategory.COLLAB,
    sourceType: NotificationSourceType.COLLAB,
    titleKey: "notifications.collab.fundingRequested.title",
    bodyKey: "notifications.collab.fundingRequested.body",
    defaultActionUrl: null
  },
  /** The money arrived and is held until the collaboration closes. */
  [NotificationType.COLLAB_FUNDING_SECURED]: {
    category: NotificationCategory.COLLAB,
    sourceType: NotificationSourceType.COLLAB,
    titleKey: "notifications.collab.fundingSecured.title",
    bodyKey: "notifications.collab.fundingSecured.body",
    defaultActionUrl: null
  },
  /** The funding window is frozen while the brand is blocked by its bank. */
  [NotificationType.COLLAB_FUNDING_DELAYED]: {
    category: NotificationCategory.COLLAB,
    sourceType: NotificationSourceType.COLLAB,
    titleKey: "notifications.collab.fundingDelayed.title",
    bodyKey: "notifications.collab.fundingDelayed.body",
    defaultActionUrl: null
  },
  /** The window closed with no money in; the brief can be proposed again once. */
  [NotificationType.COLLAB_UNFUNDED]: {
    category: NotificationCategory.COLLAB,
    sourceType: NotificationSourceType.COLLAB,
    titleKey: "notifications.collab.unfunded.title",
    bodyKey: "notifications.collab.unfunded.body",
    defaultActionUrl: null
  },
  /** The money went back to the brand, and why. */
  [NotificationType.COLLAB_PAYMENT_REFUNDED]: {
    category: NotificationCategory.COLLAB,
    sourceType: NotificationSourceType.COLLAB,
    titleKey: "notifications.collab.paymentRefunded.title",
    bodyKey: "notifications.collab.paymentRefunded.body",
    defaultActionUrl: null
  },
  /**
   * A charge the platform had already closed was paid, and given straight
   * back. Its own kind rather than the refund above: the brand is told its
   * payment arrived too late, not that a collaboration ended.
   */
  [NotificationType.COLLAB_LATE_CAPTURE_REFUNDED]: {
    category: NotificationCategory.COLLAB,
    sourceType: NotificationSourceType.COLLAB,
    titleKey: "notifications.collab.lateCaptureRefunded.title",
    bodyKey: "notifications.collab.lateCaptureRefunded.body",
    defaultActionUrl: null
  },
  /** The brand's bank settled the charge it was reclaiming, either way. */
  [NotificationType.COLLAB_BANK_DISPUTE_RESOLVED]: {
    category: NotificationCategory.COLLAB,
    sourceType: NotificationSourceType.COLLAB,
    titleKey: "notifications.collab.bankDisputeResolved.title",
    bodyKey: "notifications.collab.bankDisputeResolved.body",
    defaultActionUrl: null
  },
  /** The money has been held a long time and nobody has closed the collab. */
  [NotificationType.COLLAB_HOLD_AGE_WARNING]: {
    category: NotificationCategory.COLLAB,
    sourceType: NotificationSourceType.COLLAB,
    titleKey: "notifications.collab.holdAgeWarning.title",
    bodyKey: "notifications.collab.holdAgeWarning.body",
    defaultActionUrl: null
  },
  /**
   * A UGC product has not shipped seven days after the funding: the brand
   * extends once by seven days (the default) or cancels with everything back.
   */
  /** Asked whether the UGC product arrived, the creator answered it has not yet. */
  [NotificationType.COLLAB_UGC_PRODUCT_NOT_RECEIVED]: {
    category: NotificationCategory.COLLAB,
    sourceType: NotificationSourceType.COLLAB,
    titleKey: "notifications.collab.ugcProductNotReceived.title",
    bodyKey: "notifications.collab.ugcProductNotReceived.body",
    defaultActionUrl: null
  },
  /**
   * Fourteen days after the shipment the creator still says the UGC product has
   * not arrived: the brand sends it again (once) or cancels with everything back.
   */
  [NotificationType.COLLAB_UGC_RECEPTION_CHOICE]: {
    category: NotificationCategory.COLLAB,
    sourceType: NotificationSourceType.COLLAB,
    titleKey: "notifications.collab.ugcReceptionChoice.title",
    bodyKey: "notifications.collab.ugcReceptionChoice.body",
    defaultActionUrl: null
  },
  /**
   * Thirty days before the first rights end of a UGC collab's validated
   * contents: one message per collab, which blocks nothing.
   */
  [NotificationType.COLLAB_UGC_RIGHTS_ENDING]: {
    category: NotificationCategory.COLLAB,
    sourceType: NotificationSourceType.COLLAB,
    titleKey: "notifications.collab.ugcRightsEnding.title",
    bodyKey: "notifications.collab.ugcRightsEnding.body",
    defaultActionUrl: null
  },
  [NotificationType.COLLAB_UGC_SHIPMENT_CHOICE]: {
    category: NotificationCategory.COLLAB,
    sourceType: NotificationSourceType.COLLAB,
    titleKey: "notifications.collab.ugcShipmentChoice.title",
    bodyKey: "notifications.collab.ugcShipmentChoice.body",
    defaultActionUrl: null
  },
  /**
   * The creator delivered: the brand has seven days to answer before its
   * silence answers for it. One kind for a publication, a detection and an
   * attachment — what the brand owes is the same review in all three.
   */
  [NotificationType.COLLAB_CONTENT_RECORDED]: {
    category: NotificationCategory.COLLAB,
    sourceType: NotificationSourceType.COLLAB,
    titleKey: "notifications.collab.contentRecorded.title",
    bodyKey: "notifications.collab.contentRecorded.body",
    defaultActionUrl: null
  },
  /** The third rejection is spent: the brand validates or opens a dispute. */
  [NotificationType.COLLAB_DELIVERABLE_REJECTIONS_EXHAUSTED]: {
    category: NotificationCategory.COLLAB,
    sourceType: NotificationSourceType.COLLAB,
    titleKey: "notifications.collab.deliverableRejectionsExhausted.title",
    bodyKey: "notifications.collab.deliverableRejectionsExhausted.body",
    defaultActionUrl: null
  },
  /** Seven days of silence validated a piece for the brand. */
  [NotificationType.COLLAB_DELIVERABLE_TACITLY_VALIDATED]: {
    category: NotificationCategory.COLLAB,
    sourceType: NotificationSourceType.COLLAB,
    titleKey: "notifications.collab.deliverableTacitlyValidated.title",
    bodyKey: "notifications.collab.deliverableTacitlyValidated.body",
    defaultActionUrl: null
  },
  /** The collaboration closed and the creator's money left for them. */
  [NotificationType.COLLAB_PAYMENT_RELEASED]: {
    category: NotificationCategory.COLLAB,
    sourceType: NotificationSourceType.COLLAB,
    titleKey: "notifications.collab.paymentReleased.title",
    bodyKey: "notifications.collab.paymentReleased.body",
    defaultActionUrl: null
  },
  /**
   * The yes was refused: payouts do not reach the creator's declared country
   * yet. In-app only (no email moment exists for it).
   */
  [NotificationType.COLLAB_PAYOUT_COUNTRY_UNSUPPORTED]: {
    category: NotificationCategory.COLLAB,
    sourceType: NotificationSourceType.COLLAB,
    titleKey: "notifications.collab.payoutCountryUnsupported.title",
    bodyKey: "notifications.collab.payoutCountryUnsupported.body",
    defaultActionUrl: null
  },
  /**
   * A product offered as a gift ran low or ran out. One kind for both
   * severities: the gestures are the same (restock it, or replace it in the
   * flow), only the urgency differs, and it travels in the event data.
   */
  [NotificationType.GIFT_STOCK_ALERT]: {
    category: NotificationCategory.SYSTEM,
    sourceType: NotificationSourceType.SHOPIFY_PRODUCT,
    titleKey: "notifications.gift.stockAlert.title",
    bodyKey: "notifications.gift.stockAlert.body",
    defaultActionUrl: "/dashboard/flows"
  },
  /**
   * A creator wrote to the brand. One per unread streak: the event action opens
   * the conversation, built per event from its id. Never quotes the message.
   */
  [NotificationType.CONVERSATION_CREATOR_MESSAGE_RECEIVED]: {
    category: NotificationCategory.AFFILIATE,
    sourceType: NotificationSourceType.CONVERSATION,
    titleKey: "notifications.conversation.creatorMessage.title",
    bodyKey: "notifications.conversation.creatorMessage.body",
    defaultActionUrl: "/messages"
  },
  /**
   * A signed-up creator applied to one of the brand's open briefs. The event
   * action opens that application on the applications page.
   */
  [NotificationType.BRIEF_APPLICATION_RECEIVED]: {
    category: NotificationCategory.AFFILIATE,
    sourceType: NotificationSourceType.BRIEF_APPLICATION,
    titleKey: "notifications.briefApplication.received.title",
    bodyKey: "notifications.briefApplication.received.body",
    defaultActionUrl: "/applications"
  }
};
var NotificationCategoryValues = Object.values(
  NotificationCategory
);
var NotificationTypeValues = Object.values(
  NotificationType
);
var NotificationTabValues = Object.values(
  NotificationTab
);
var NotificationPreferenceEmailDelivery = {
  IMMEDIATE: "immediate",
  OFF: "off"
};
var NotificationPreferenceEmailDeliveryValues = Object.values(
  NotificationPreferenceEmailDelivery
);
var EmailConfigurableNotificationType = {
  FLOW_TEAM_NOTIFIED: NotificationType.FLOW_TEAM_NOTIFIED,
  AGENT_RECOMMENDATIONS_DELIVERED: NotificationType.AGENT_RECOMMENDATIONS_DELIVERED,
  AFFILIATE_JOINED_PROGRAM: NotificationType.AFFILIATE_JOINED_PROGRAM,
  BRAND_SPACE_APPLICATION_RECEIVED: NotificationType.BRAND_SPACE_APPLICATION_RECEIVED,
  GIFT_CLAIMED: NotificationType.GIFT_CLAIMED,
  COLLAB_PAYMENT_FAILED: NotificationType.COLLAB_PAYMENT_FAILED,
  BRAND_FIRST_SALE: "brand.first_sale",
  /** The founders' emails to a brand in its first weeks. Not an inbox notification. */
  BRAND_ONBOARDING_TIPS: "brand.onboarding_tips",
  GIFT_STOCK_ALERT: NotificationType.GIFT_STOCK_ALERT,
  CONVERSATION_CREATOR_MESSAGE_RECEIVED: NotificationType.CONVERSATION_CREATOR_MESSAGE_RECEIVED,
  BRIEF_APPLICATION_RECEIVED: NotificationType.BRIEF_APPLICATION_RECEIVED
};
var EmailConfigurableNotificationTypeValues = Object.values(
  EmailConfigurableNotificationType
);
var GiftStockAlertSeverity = {
  /** Fewer than ten claimable units left. */
  LOW: "low",
  /** No claimable unit left. */
  OUT: "out"
};
var BoostDisplayRightsNotificationIntent = {
  /** The term is close. Sent once, days before the rights stop covering ads. */
  EXPIRY_APPROACHING: "expiry_approaching",
  /** The creator withdrew the Instagram authorization, so the rights stopped. */
  ENDED_BY_REVOCATION: "ended_by_revocation"
};
function dashboardNotificationsChannel(userId) {
  return `notifications/users/${userId}`;
}
var notificationUserChannel = dashboardNotificationsChannel;
function getNotificationCategory(type) {
  return NotificationTypeConfig[type].category;
}
function getNotificationSourceType(type) {
  return NotificationTypeConfig[type].sourceType;
}
function notificationBelongsToTab(category, tab) {
  if (tab === NotificationTab.ALL) {
    return true;
  }
  return category === NotificationCategory.AGENT;
}
function isNotificationCategory(value) {
  return typeof value === "string" && NotificationCategoryValues.includes(value);
}
function isNotificationType(value) {
  return typeof value === "string" && NotificationTypeValues.includes(value);
}
function isNotificationTab(value) {
  return typeof value === "string" && NotificationTabValues.includes(value);
}

// src/api/invitation.ts
var INVITATION_SCENARIOS = {
  ALREADY_LOGGED_IN_MATCH: "already_logged_in_match",
  ALREADY_LOGGED_IN_MISMATCH: "already_logged_in_mismatch",
  HAS_ACCOUNT_NOT_LOGGED_IN: "has_account_not_logged_in",
  NEW_USER_NO_ACCOUNT: "new_user_no_account",
  NEW_USER_CREATED: "new_user_created"
  // Deprecated - use NEW_USER_NO_ACCOUNT
};
var InvitationStatus = /* @__PURE__ */ ((InvitationStatus2) => {
  InvitationStatus2["PENDING"] = "Pending";
  InvitationStatus2["CLICKED"] = "Clicked";
  InvitationStatus2["JOINED"] = "Joined";
  InvitationStatus2["EXPIRED"] = "Expired";
  InvitationStatus2["UNDELIVERABLE"] = "Undeliverable";
  return InvitationStatus2;
})(InvitationStatus || {});
var PROGRAM_INVITATION_INTENTS = {
  CONTACT_REPROPOSAL: "contact_reproposal",
  AFFILIATE_ADD: "affiliate_add"
};
var INVITATION_TABLE_SORT_FIELDS = [
  "invitee",
  "email",
  "program",
  "method",
  "status",
  "joinedAt",
  "createdAt",
  "expiresAt"
];
var InvitationOutreachEmailStatus = /* @__PURE__ */ ((InvitationOutreachEmailStatus2) => {
  InvitationOutreachEmailStatus2["PENDING"] = "pending";
  InvitationOutreachEmailStatus2["SENDING"] = "sending";
  InvitationOutreachEmailStatus2["SENT"] = "sent";
  InvitationOutreachEmailStatus2["UNKNOWN"] = "unknown";
  InvitationOutreachEmailStatus2["FAILED"] = "failed";
  return InvitationOutreachEmailStatus2;
})(InvitationOutreachEmailStatus || {});
var DISCOUNT_CODE_RULES = {
  minLength: 3,
  maxLength: 20,
  pattern: /^[a-zA-Z0-9_-]+$/
};
var INVITATION_OUTREACH_VARIABLES = [
  "first_name",
  "invitee_name",
  "brand_name",
  "program_name",
  "invitation_link",
  "commission_rate"
];
var BULK_INVITATION_ACTION_LIMIT = 200;
var BULK_INVITATION_OUTREACH_LIMIT = 100;

// src/api/onboarding.ts
var OnboardingStep = /* @__PURE__ */ ((OnboardingStep2) => {
  OnboardingStep2["NOT_STARTED"] = "not_started";
  OnboardingStep2["COMPLIANCE_COMPLETED"] = "compliance_completed";
  OnboardingStep2["PROFILE_COMPLETED"] = "profile_completed";
  OnboardingStep2["BIRTH_INFO_COMPLETED"] = "birth_info_completed";
  OnboardingStep2["BUSINESS_PROFILE_COMPLETED"] = "business_profile_completed";
  OnboardingStep2["BUSINESS_TYPE_SELECTED"] = "business_type_selected";
  OnboardingStep2["BUSINESS_DETAILS_COMPLETED"] = "business_details_completed";
  OnboardingStep2["PAYMENT_INFO_COMPLETED"] = "payment_info_completed";
  OnboardingStep2["COMPLETE"] = "complete";
  return OnboardingStep2;
})(OnboardingStep || {});

// src/api/partner.ts
var PartnerIntegrationStatus = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  PENDING: "pending"
};
var PartnerProvider = {
  TIMEONE: "timeone",
  /**
   * Generic partner without an affiliate network. Attribution runs purely
   * through local discount codes; no external postback or tracked link.
   */
  DEFAULT: "default"
};

// src/api/partner-success-fees.ts
var PARTNER_SUCCESS_FEE_DEFAULT_BASIS_POINTS = 250;
var PARTNER_SUCCESS_FEE_LEAD_BASIS_POINTS = 500;
var PartnerRemunerationType = {
  SALE: "sale",
  LEAD: "lead"
};
function partnerSuccessFeeGridBasisPoints(remunerationType) {
  return remunerationType === PartnerRemunerationType.LEAD ? PARTNER_SUCCESS_FEE_LEAD_BASIS_POINTS : PARTNER_SUCCESS_FEE_DEFAULT_BASIS_POINTS;
}
var PARTNER_SUCCESS_FEE_SORT_BY = [
  "program",
  "sale",
  "revenueBasis",
  "feeAmount",
  "feeRate",
  "sourceDate",
  "partnerValidationAt",
  "billingState"
];
var PARTNER_SUCCESS_FEE_DATE_FILTER_TYPES = [
  "partnerValidationAt"
];

// src/api/payment-condition.ts
var PAYMENT_CONDITION_REGISTRY = {
  payment_via_app_identity_check: {
    1: {
      en: "Payment is made through the creator app, after identity verification.",
      fr: "Le paiement passe par l'application cr\xE9ateur, apr\xE8s v\xE9rification d'identit\xE9.",
      it: "Il pagamento avviene tramite l'app creator, dopo la verifica dell'identit\xE0."
    },
    /**
     * Version 2 says when the money is secured, not only how it travels.
     *
     * The rail now takes the brand's payment at acceptance and holds it until
     * the collaboration closes, so the sentence a creator reads before saying
     * yes has to state that guarantee. Version 1 stays exactly as it is: the
     * briefs that showed it promised what it says, and nothing rewrites those.
     */
    2: {
      en: "Payment is secured by Fluenceur as soon as you accept and is paid to you through the creator app, after identity verification, when the collaboration closes.",
      fr: "Le paiement est s\xE9curis\xE9 par Fluenceur d\xE8s votre acceptation et vous est vers\xE9 via l'app cr\xE9ateur, apr\xE8s v\xE9rification d'identit\xE9, \xE0 la cl\xF4ture de la collaboration.",
      it: "Il pagamento \xE8 garantito da Fluenceur dal momento in cui accetti e ti viene versato tramite l'app creator, dopo la verifica dell'identit\xE0, alla chiusura della collaborazione."
    },
    /**
     * Version 3 names no app: the creator is paid on the web too, and the
     * native app is being retired. The money lands in the creator's Fluenceur
     * balance. Versions 1 and 2 stay exactly as they are, for the agreements
     * that showed them.
     */
    3: {
      en: "Payment is secured by Fluenceur as soon as you accept and is paid to your Fluenceur balance, after identity verification, when the collaboration closes.",
      fr: "Le paiement est s\xE9curis\xE9 par Fluenceur d\xE8s votre acceptation et vous est vers\xE9 dans votre cagnotte Fluenceur, apr\xE8s v\xE9rification d'identit\xE9, \xE0 la cl\xF4ture de la collaboration.",
      it: "Il pagamento \xE8 garantito da Fluenceur dal momento in cui accetti e ti viene versato sul tuo saldo Fluenceur, dopo la verifica dell'identit\xE0, alla chiusura della collaborazione."
    }
  },
  /**
   * The UGC condition: the money is secured at acceptance like any paid
   * brief, and paid once the brand has validated every content, which is the
   * UGC payment rule. Nothing waits for the collaboration to close.
   */
  ugc_paid_once_contents_validated: {
    1: {
      en: "Payment is secured by Fluenceur as soon as you accept and is paid to your Fluenceur balance, after identity verification, once all the contents are validated.",
      fr: "Le paiement est s\xE9curis\xE9 par Fluenceur d\xE8s votre acceptation et vous est vers\xE9 dans votre cagnotte Fluenceur, apr\xE8s v\xE9rification d'identit\xE9, une fois tous les contenus valid\xE9s.",
      it: "Il pagamento \xE8 garantito da Fluenceur dal momento in cui accetti e ti viene versato sul tuo saldo Fluenceur, dopo la verifica dell'identit\xE0, una volta convalidati tutti i contenuti."
    }
  }
};
var CURRENT_PAYMENT_CONDITION = {
  key: "payment_via_app_identity_check",
  version: 3
};
var CURRENT_UGC_PAYMENT_CONDITION = {
  key: "ugc_paid_once_contents_validated",
  version: 1
};
function paymentConditionSentence(condition, language = "en") {
  if (!condition) return null;
  const versions = PAYMENT_CONDITION_REGISTRY[condition.key];
  if (!versions) return null;
  const wording = versions[condition.version];
  if (!wording) return null;
  return wording[language] ?? wording.en;
}

// src/api/payout.ts
var PayoutBatchStatus = /* @__PURE__ */ ((PayoutBatchStatus2) => {
  PayoutBatchStatus2["PENDING"] = "pending";
  PayoutBatchStatus2["DRAFT"] = "draft";
  PayoutBatchStatus2["PROCESSING"] = "processing";
  PayoutBatchStatus2["COMPLETED"] = "completed";
  PayoutBatchStatus2["PARTIALLY_COMPLETED"] = "partially_completed";
  PayoutBatchStatus2["FAILED"] = "failed";
  PayoutBatchStatus2["CANCELLED"] = "cancelled";
  return PayoutBatchStatus2;
})(PayoutBatchStatus || {});
var PayoutBatchClosedReason = {
  /** The brand cancelled it from the dashboard. */
  BRAND_CANCELLED: "brand_cancelled",
  /** The payment deadline announced in the reminder passed. */
  EXPIRED: "expired",
  /** Stripe cancelled the payment itself. */
  PAYMENT_CANCELED_BY_PROVIDER: "payment_canceled_by_provider",
  /** It held a sale that no longer stands: a cancelled commission or an order under review. */
  STALE_CONTENT: "stale_content",
  /** The payment was never created, so the brand was never asked to pay. */
  PAYMENT_NOT_CREATED: "payment_not_created",
  /** The brand's subscription ended before it paid. */
  SUBSCRIPTION_ENDED: "subscription_ended"
};
var PayoutTransferStatus = /* @__PURE__ */ ((PayoutTransferStatus2) => {
  PayoutTransferStatus2["PENDING"] = "pending";
  PayoutTransferStatus2["PROCESSING"] = "processing";
  PayoutTransferStatus2["SUCCEEDED"] = "succeeded";
  PayoutTransferStatus2["FAILED"] = "failed";
  return PayoutTransferStatus2;
})(PayoutTransferStatus || {});
function isInvoiceEligible(batch) {
  return batch.fundedAt !== null && batch.fundedAt !== void 0;
}

// src/api/success-fee-pricing.ts
var SUCCESS_FEE_BASIS_POINTS_BY_PLAN = {
  essential: 350,
  growth: 250,
  "free-beta": 0
};
var SUCCESS_FEE_NO_PAID_PLAN_BASIS_POINTS = 0;
var SUCCESS_FEE_OVERRIDE_MIN_BASIS_POINTS = 0;
var SUCCESS_FEE_OVERRIDE_MAX_BASIS_POINTS = 1e4;
var SUCCESS_FEE_UNPRICED_PLANS = ["enterprise"];
function classifySuccessFeePlanRate(planIdentifier) {
  if (!planIdentifier) {
    return {
      basisPoints: SUCCESS_FEE_NO_PAID_PLAN_BASIS_POINTS,
      basis: "no_plan"
    };
  }
  const rate = SUCCESS_FEE_BASIS_POINTS_BY_PLAN[planIdentifier];
  if (rate !== void 0) return { basisPoints: rate, basis: "plan_grid" };
  const unpriced = SUCCESS_FEE_UNPRICED_PLANS.includes(
    planIdentifier
  );
  return {
    basisPoints: SUCCESS_FEE_NO_PAID_PLAN_BASIS_POINTS,
    basis: unpriced ? "unpriced_plan" : "unknown_plan"
  };
}
function successFeeBasisPointsForPlan(planIdentifier) {
  return classifySuccessFeePlanRate(planIdentifier).basisPoints;
}
function isValidSuccessFeeOverrideBasisPoints(basisPoints) {
  return Number.isInteger(basisPoints) && basisPoints >= SUCCESS_FEE_OVERRIDE_MIN_BASIS_POINTS && basisPoints <= SUCCESS_FEE_OVERRIDE_MAX_BASIS_POINTS;
}

// src/api/plan-fee-grid.ts
var SUCCESS_FEE_FREE_PLAN_BASIS_POINTS = 500;
var COLLAB_PLATFORM_FEE_BASIS_POINTS_BY_OFFER = {
  free: 1500,
  essential: 1e3,
  growth: 1e3
};
function planFeeOfferOf(planIdentifier) {
  return planIdentifier === "essential" || planIdentifier === "growth" ? planIdentifier : "free";
}
function collabFeeBasisPointsForPlan(planIdentifier) {
  if (planIdentifier === "enterprise") {
    return COLLAB_PLATFORM_FEE_BASIS_POINTS_BY_OFFER.essential;
  }
  return COLLAB_PLATFORM_FEE_BASIS_POINTS_BY_OFFER[planFeeOfferOf(planIdentifier)];
}
function gridRow(offer, successFeeBasisPoints) {
  return {
    offer,
    collabFee: {
      basisPoints: COLLAB_PLATFORM_FEE_BASIS_POINTS_BY_OFFER[offer],
      floorMinorUnits: COLLAB_PLATFORM_FEE_FLOOR_MINOR_UNITS
    },
    giftingFeeBasisPoints: 0,
    successFeeBasisPoints
  };
}
var PLAN_FEE_GRID = {
  free: gridRow("free", SUCCESS_FEE_FREE_PLAN_BASIS_POINTS),
  essential: gridRow("essential", SUCCESS_FEE_BASIS_POINTS_BY_PLAN.essential),
  growth: gridRow("growth", SUCCESS_FEE_BASIS_POINTS_BY_PLAN.growth)
};

// src/api/program.ts
var AffiliateProgramFilterTimeRange = /* @__PURE__ */ ((AffiliateProgramFilterTimeRange2) => {
  AffiliateProgramFilterTimeRange2["SEVEN_DAYS"] = "7days";
  AffiliateProgramFilterTimeRange2["ONE_MONTH"] = "1month";
  AffiliateProgramFilterTimeRange2["THREE_MONTHS"] = "3months";
  AffiliateProgramFilterTimeRange2["SIX_MONTHS"] = "6months";
  AffiliateProgramFilterTimeRange2["ONE_YEAR"] = "1year";
  AffiliateProgramFilterTimeRange2["ALL"] = "all";
  return AffiliateProgramFilterTimeRange2;
})(AffiliateProgramFilterTimeRange || {});
var AffiliateProgramStatus = /* @__PURE__ */ ((AffiliateProgramStatus2) => {
  AffiliateProgramStatus2["REMOVED"] = "removed";
  AffiliateProgramStatus2["ENROLLED"] = "enrolled";
  AffiliateProgramStatus2["PENDING"] = "pending";
  AffiliateProgramStatus2["EXPIRED"] = "expired";
  AffiliateProgramStatus2["CANCELED"] = "canceled";
  AffiliateProgramStatus2["REJECTED"] = "rejected";
  return AffiliateProgramStatus2;
})(AffiliateProgramStatus || {});
var ProgramStatus = /* @__PURE__ */ ((ProgramStatus2) => {
  ProgramStatus2["Active"] = "active";
  ProgramStatus2["Inactive"] = "inactive";
  ProgramStatus2["Pending"] = "pending";
  return ProgramStatus2;
})(ProgramStatus || {});
var CommissionTypes = /* @__PURE__ */ ((CommissionTypes2) => {
  CommissionTypes2["FixedAmountPerOrder"] = "fixed_amount_per_order";
  CommissionTypes2["Percentage"] = "percentage";
  return CommissionTypes2;
})(CommissionTypes || {});
var DiscountCodeTypes = /* @__PURE__ */ ((DiscountCodeTypes2) => {
  DiscountCodeTypes2["FixedAmount"] = "fixed_amount";
  DiscountCodeTypes2["Percentage"] = "percentage";
  return DiscountCodeTypes2;
})(DiscountCodeTypes || {});
var MAX_COMMISSION_CATEGORY_RULES = 50;
function hasCommissionCategoryGrid(settings) {
  return Boolean(settings?.enabled && settings.categoryGrid?.categories.length);
}
function hasSingleCommissionRate(settings) {
  return Boolean(
    settings?.enabled && !settings.categoryGrid && settings.type !== void 0 && settings.value !== void 0
  );
}
function findCommissionCategory(settings, categoryKey) {
  if (!hasCommissionCategoryGrid(settings)) return null;
  const normalizedKey = categoryKey.trim().toLowerCase();
  return settings.categoryGrid.categories.find(
    (entry) => entry.key === normalizedKey
  ) ?? null;
}
var CodePatternPart = /* @__PURE__ */ ((CodePatternPart2) => {
  CodePatternPart2["CreatorName"] = "creator_name";
  CodePatternPart2["BrandName"] = "brand_name";
  CodePatternPart2["DiscountPercent"] = "discount_percent";
  CodePatternPart2["RandomCode"] = "random_code";
  CodePatternPart2["CustomText"] = "custom_text";
  return CodePatternPart2;
})(CodePatternPart || {});
var CodePatternSeparator = /* @__PURE__ */ ((CodePatternSeparator2) => {
  CodePatternSeparator2["Dash"] = "-";
  CodePatternSeparator2["Underscore"] = "_";
  CodePatternSeparator2["None"] = "none";
  return CodePatternSeparator2;
})(CodePatternSeparator || {});
var DEFAULT_CODE_PATTERN = {
  parts: [
    { type: "brand_name" /* BrandName */ },
    { type: "creator_name" /* CreatorName */ }
  ],
  separator: "-" /* Dash */,
  uppercase: true
};
var CODE_LIGATURES = {
  \u00E6: "ae",
  \u00C6: "AE",
  \u0153: "oe",
  \u0152: "OE",
  \u00F8: "o",
  \u00D8: "O",
  \u00DF: "ss",
  \u0111: "d",
  \u0110: "D",
  \u0142: "l",
  \u0141: "L"
};
function foldCodeSegmentToAscii(value) {
  return value.replace(/[æÆœŒøØßđĐłŁ]/g, (char) => CODE_LIGATURES[char] ?? char).normalize("NFD").replace(/\p{Diacritic}/gu, "");
}
function sanitizeCodeSegment(value, maxLength) {
  return foldCodeSegmentToAscii(value).replace(/[^A-Za-z0-9]/g, "").substring(0, maxLength);
}
var CODE_SEGMENT_MAX_LENGTH = {
  creatorName: 10,
  customText: 20
};
var DiscountCodeOrigin = /* @__PURE__ */ ((DiscountCodeOrigin2) => {
  DiscountCodeOrigin2["Generated"] = "generated";
  DiscountCodeOrigin2["Invitation"] = "invitation";
  DiscountCodeOrigin2["ManualRename"] = "manual_rename";
  return DiscountCodeOrigin2;
})(DiscountCodeOrigin || {});

// src/api/recurring-program.ts
var ProgramMode = /* @__PURE__ */ ((ProgramMode2) => {
  ProgramMode2["Commerce"] = "commerce";
  ProgramMode2["Recurring"] = "recurring";
  return ProgramMode2;
})(ProgramMode || {});
function normalizeRecurringDuration(input) {
  if (input.durationKind === "lifetime") {
    return input.durationMonths === null ? { durationKind: "lifetime", durationMonths: null } : null;
  }
  if (input.durationKind !== void 0 && input.durationKind !== "months")
    return null;
  const months = input.durationMonths;
  if (typeof months !== "number" || !Number.isInteger(months) || months < 1 || months > 120) {
    return null;
  }
  return { durationKind: "months", durationMonths: months };
}

// src/api/program-tracking.ts
var TIMEONE_TRACKING_MACROS = {
  partid: "{{partid}}",
  programId: "{{programId}}",
  affiliateId: "{{affiliateId}}",
  destinationUrl: "{{destinationUrl}}"
};

// src/api/stats.ts
var ComparisonPeriodType = /* @__PURE__ */ ((ComparisonPeriodType2) => {
  ComparisonPeriodType2["THIS_MONTH"] = "THIS_MONTH";
  ComparisonPeriodType2["LAST_7_DAYS"] = "LAST_7_DAYS";
  ComparisonPeriodType2["LAST_30_DAYS"] = "LAST_30_DAYS";
  ComparisonPeriodType2["LAST_90_DAYS"] = "LAST_90_DAYS";
  ComparisonPeriodType2["YEAR_TO_DATE"] = "YEAR_TO_DATE";
  ComparisonPeriodType2["CUSTOM"] = "CUSTOM";
  return ComparisonPeriodType2;
})(ComparisonPeriodType || {});

// src/api/creator-referral.ts
function creatorReferralInvitationCopy(language, brandName, firstName) {
  const copy = {
    fr: {
      subject: `${firstName} vous invite sur Fluenceur`,
      body: `Bonjour,

Je vous invite sur Fluenceur pour r\xE9unir les collaborations de ${brandName} au m\xEAme endroit.

Vous pouvez y trouver de nouveaux cr\xE9ateurs, inviter ceux avec qui vous travaillez d\xE9j\xE0, \xE9changer avec eux, suivre leurs contenus et les payer directement sur la plateforme.

Cr\xE9ez votre compte et pr\xE9parez votre prochaine collab.

${firstName}

Invitation envoy\xE9e via Fluenceur.`,
      action: "D\xE9couvrir Fluenceur",
      unsubscribe: "Se d\xE9sinscrire",
      unsubscribeTitle: "Se d\xE9sinscrire des invitations de parrainage",
      unsubscribeConfirmation: "Vous ne recevrez plus d\u2019invitations de parrainage de Fluenceur."
    },
    en: {
      subject: `${firstName} invites you to Fluenceur`,
      body: `Hello,

I\u2019m inviting you to Fluenceur to manage ${brandName}'s creator collaborations in one place.

You can find new creators, invite those you already work with, talk with them, track their content and pay them directly on the platform.

Create your account and prepare your next collab.

${firstName}

Invitation sent via Fluenceur.`,
      action: "Discover Fluenceur",
      unsubscribe: "Unsubscribe",
      unsubscribeTitle: "Unsubscribe from referral invitations",
      unsubscribeConfirmation: "You will no longer receive Fluenceur referral invitations."
    },
    it: {
      subject: `${firstName} ti invita su Fluenceur`,
      body: `Buongiorno,

Ti invito su Fluenceur per riunire le collaborazioni di ${brandName} in un unico posto.

Puoi trovare nuovi creator, invitare quelli con cui collabori gi\xE0, parlare con loro, seguire i loro contenuti e pagarli direttamente sulla piattaforma.

Crea il tuo account e prepara la tua prossima collaborazione.

${firstName}

Invito inviato tramite Fluenceur.`,
      action: "Scopri Fluenceur",
      unsubscribe: "Annulla l\u2019iscrizione",
      unsubscribeTitle: "Annulla l\u2019iscrizione agli inviti di segnalazione",
      unsubscribeConfirmation: "Non riceverai pi\xF9 inviti di segnalazione da Fluenceur."
    }
  };
  return copy[language];
}

// src/api/subscription.ts
var DeactivationReason = /* @__PURE__ */ ((DeactivationReason2) => {
  DeactivationReason2["USER_CANCELLED"] = "user_cancelled";
  DeactivationReason2["SHOPIFY_UNINSTALLED"] = "shopify_uninstalled";
  DeactivationReason2["GRACE_PERIOD_EXPIRED"] = "grace_period_expired";
  return DeactivationReason2;
})(DeactivationReason || {});
var SubscriptionCancellationReason = /* @__PURE__ */ ((SubscriptionCancellationReason2) => {
  SubscriptionCancellationReason2["SHOPIFY_CANCELLED"] = "shopify_cancelled";
  SubscriptionCancellationReason2["SHOPIFY_UNINSTALLED"] = "shopify_uninstalled";
  SubscriptionCancellationReason2["REPLACED"] = "replaced";
  SubscriptionCancellationReason2["SWITCHED_TO_FREE"] = "switched_to_free";
  SubscriptionCancellationReason2["OTHER"] = "other";
  return SubscriptionCancellationReason2;
})(SubscriptionCancellationReason || {});
var PayoutCancellationReason = /* @__PURE__ */ ((PayoutCancellationReason2) => {
  PayoutCancellationReason2["SUBSCRIPTION_CANCELLED"] = "subscription_cancelled";
  PayoutCancellationReason2["SHOPIFY_UNINSTALLED"] = "shopify_uninstalled";
  PayoutCancellationReason2["PAYMENT_METHOD_INVALID"] = "payment_method_invalid";
  PayoutCancellationReason2["OTHER"] = "other";
  return PayoutCancellationReason2;
})(PayoutCancellationReason || {});

// src/api/user.ts
var UserRole = /* @__PURE__ */ ((UserRole2) => {
  UserRole2["BRAND_OWNER"] = "brand_owner";
  UserRole2["BRAND_ADMIN"] = "brand_admin";
  UserRole2["BRAND_MEMBER"] = "brand_member";
  UserRole2["AFFILIATE"] = "affiliate";
  UserRole2["CREATOR"] = "creator";
  return UserRole2;
})(UserRole || {});
var DEFAULT_USER_SETTINGS = {
  preferredLanguage: "en"
};

// src/api/template.ts
var TemplateType = /* @__PURE__ */ ((TemplateType2) => {
  TemplateType2["IG_DM_MESSAGE_INVITATION"] = "ig_dm_message_invitation";
  TemplateType2["IG_COMMENT_REPLY_INVITATION"] = "ig_comment_reply_invitation";
  TemplateType2["CREATOR_OUTREACH_EMAIL_INVITATION"] = "creator_outreach_email_invitation";
  TemplateType2["CREATOR_OUTREACH_EMAIL_INVITATION_NO_COMMISSION"] = "creator_outreach_email_invitation_no_commission";
  TemplateType2["IG_DM_GENERIC"] = "ig_dm_generic";
  TemplateType2["EMAIL_GENERIC"] = "email_generic";
  TemplateType2["COLLAB_PROPOSAL_EMAIL"] = "collab_proposal_email";
  return TemplateType2;
})(TemplateType || {});
var TemplateChannel = /* @__PURE__ */ ((TemplateChannel2) => {
  TemplateChannel2["EMAIL"] = "email";
  TemplateChannel2["INSTAGRAM_DM"] = "instagram_dm";
  TemplateChannel2["INSTAGRAM_COMMENT"] = "instagram_comment";
  return TemplateChannel2;
})(TemplateChannel || {});
var TEMPLATE_CONTENT_MAX_LENGTH_BY_CHANNEL = {
  ["email" /* EMAIL */]: 8e3,
  ["instagram_dm" /* INSTAGRAM_DM */]: 800,
  ["instagram_comment" /* INSTAGRAM_COMMENT */]: 800
};
var TEMPLATE_CONTENT_WARN_LENGTH_BY_CHANNEL = {
  ["email" /* EMAIL */]: 5e3,
  ["instagram_dm" /* INSTAGRAM_DM */]: 700,
  ["instagram_comment" /* INSTAGRAM_COMMENT */]: 700
};
function templateContentMaxLength(channel) {
  return TEMPLATE_CONTENT_MAX_LENGTH_BY_CHANNEL[channel];
}
function templateContentWarnLength(channel) {
  return TEMPLATE_CONTENT_WARN_LENGTH_BY_CHANNEL[channel];
}
function countTemplateContentCharacters(content) {
  return countMessageCharacters(content);
}
var TemplateContext = /* @__PURE__ */ ((TemplateContext2) => {
  TemplateContext2["INVITATION"] = "invitation";
  TemplateContext2["GENERIC"] = "generic";
  TemplateContext2["COLLAB"] = "collab";
  return TemplateContext2;
})(TemplateContext || {});
var InvitationMethod = /* @__PURE__ */ ((InvitationMethod2) => {
  InvitationMethod2["COMMENT"] = "comment";
  InvitationMethod2["DIRECT_MESSAGE"] = "direct_message";
  InvitationMethod2["EMAIL"] = "email";
  return InvitationMethod2;
})(InvitationMethod || {});
var AFFILIATE_INVITATION_SHARED_VARIABLES = [
  {
    key: "first_name",
    label: "First Name",
    labelKey: "invitations.variables.first_name.label",
    fallback: "there",
    required: false,
    description: "Recipient's first name",
    descriptionKey: "invitations.variables.first_name.description"
  },
  {
    key: "brand_name",
    label: "Brand Name",
    labelKey: "invitations.variables.brand_name.label",
    fallback: "our brand",
    required: false,
    description: "Brand name",
    descriptionKey: "invitations.variables.brand_name.description"
  },
  {
    key: "program_name",
    label: "Program Name",
    labelKey: "invitations.variables.program_name.label",
    fallback: "our affiliate program",
    required: false,
    description: "Affiliate program name",
    descriptionKey: "invitations.variables.program_name.description"
  },
  {
    key: "affiliate_benefit",
    label: "Affiliate Benefit",
    labelKey: "invitations.variables.affiliate_benefit.label",
    fallback: "affiliate benefits",
    required: false,
    description: "Benefit earned by the affiliate for generated sales",
    descriptionKey: "invitations.variables.affiliate_benefit.description"
  },
  {
    key: "audience_offer_block",
    label: "Audience Offer",
    labelKey: "invitations.variables.audience_offer_block.label",
    fallback: "",
    required: false,
    description: "Complete localized paragraph describing the audience offer, empty when unavailable",
    descriptionKey: "invitations.variables.audience_offer_block.description"
  },
  {
    key: "sender_name",
    label: "Sender Name",
    labelKey: "invitations.variables.sender_name.label",
    fallback: "The team",
    required: false,
    description: "Name of the person sending the invitation",
    descriptionKey: "invitations.variables.sender_name.description"
  }
];
var AFFILIATE_INVITATION_LINK_VARIABLE = {
  key: "invitation_link",
  label: "Invitation Link",
  labelKey: "invitations.variables.invitation_link.label",
  fallback: "",
  required: true,
  description: "Unique invitation link",
  descriptionKey: "invitations.variables.invitation_link.description"
};
var VARIABLE_REGISTRY = {
  ["ig_dm_message_invitation" /* IG_DM_MESSAGE_INVITATION */]: [
    {
      key: "first_name",
      label: "First Name",
      labelKey: "invitations.variables.first_name.label",
      fallback: "there",
      required: false,
      description: "Creator's first name",
      descriptionKey: "invitations.variables.first_name.description"
    },
    {
      key: "last_name",
      label: "Last Name",
      labelKey: "invitations.variables.last_name.label",
      fallback: "",
      required: false,
      description: "Creator's last name",
      descriptionKey: "invitations.variables.last_name.description"
    },
    {
      key: "creator_name",
      label: "Creator Name",
      labelKey: "invitations.variables.creator_name.label",
      fallback: "there",
      required: false,
      description: "Creator's full name or username",
      descriptionKey: "invitations.variables.creator_name.description"
    },
    {
      key: "brand_name",
      label: "Brand Name",
      labelKey: "invitations.variables.brand_name.label",
      fallback: "our brand",
      required: false,
      description: "Brand name",
      descriptionKey: "invitations.variables.brand_name.description"
    },
    {
      key: "invitation_link",
      label: "Invitation Link",
      labelKey: "invitations.variables.invitation_link.label",
      fallback: "",
      required: true,
      description: "Unique invitation link for the creator",
      descriptionKey: "invitations.variables.invitation_link.description"
    }
  ],
  ["ig_comment_reply_invitation" /* IG_COMMENT_REPLY_INVITATION */]: [
    {
      key: "first_name",
      label: "First Name",
      labelKey: "invitations.variables.first_name.label",
      fallback: "there",
      required: false,
      description: "Creator's first name",
      descriptionKey: "invitations.variables.first_name.description"
    },
    {
      key: "last_name",
      label: "Last Name",
      labelKey: "invitations.variables.last_name.label",
      fallback: "",
      required: false,
      description: "Creator's last name",
      descriptionKey: "invitations.variables.last_name.description"
    },
    {
      key: "creator_name",
      label: "Creator Name",
      labelKey: "invitations.variables.creator_name.label",
      fallback: "there",
      required: false,
      description: "Creator's full name or username",
      descriptionKey: "invitations.variables.creator_name.description"
    },
    {
      key: "brand_name",
      label: "Brand Name",
      labelKey: "invitations.variables.brand_name.label",
      fallback: "our brand",
      required: false,
      description: "Brand name",
      descriptionKey: "invitations.variables.brand_name.description"
    }
    // Note: invitation_link is NOT included for comments because links are not clickable in Instagram comments
  ],
  ["creator_outreach_email_invitation" /* CREATOR_OUTREACH_EMAIL_INVITATION */]: [
    ...AFFILIATE_INVITATION_SHARED_VARIABLES,
    {
      key: "commission_rate",
      label: "Commission Rate",
      labelKey: "invitations.variables.commission_rate.label",
      fallback: "",
      required: false,
      description: "Commission percentage (e.g., 15%)",
      descriptionKey: "invitations.variables.commission_rate.description"
    },
    AFFILIATE_INVITATION_LINK_VARIABLE
  ],
  ["creator_outreach_email_invitation_no_commission" /* CREATOR_OUTREACH_EMAIL_INVITATION_NO_COMMISSION */]: [
    ...AFFILIATE_INVITATION_SHARED_VARIABLES,
    AFFILIATE_INVITATION_LINK_VARIABLE
  ],
  ["ig_dm_generic" /* IG_DM_GENERIC */]: [
    {
      key: "first_name",
      label: "First Name",
      labelKey: "invitations.variables.first_name.label",
      fallback: "there",
      required: false,
      description: "Creator's first name",
      descriptionKey: "invitations.variables.first_name.description"
    },
    {
      key: "creator_name",
      label: "Creator Name",
      labelKey: "invitations.variables.creator_name.label",
      fallback: "there",
      required: false,
      description: "Creator's full name or username",
      descriptionKey: "invitations.variables.creator_name.description"
    },
    {
      key: "brand_name",
      label: "Brand Name",
      labelKey: "invitations.variables.brand_name.label",
      fallback: "our brand",
      required: false,
      description: "Brand name",
      descriptionKey: "invitations.variables.brand_name.description"
    },
    {
      key: "discount_code",
      label: "Discount Code",
      labelKey: "invitations.variables.discount_code.label",
      fallback: "",
      required: false,
      description: "Discount code to share with the creator",
      descriptionKey: "invitations.variables.discount_code.description"
    },
    {
      key: "dashboard_link",
      label: "Dashboard Link",
      labelKey: "invitations.variables.dashboard_link.label",
      fallback: "",
      required: false,
      description: "Link to the affiliate dashboard",
      descriptionKey: "invitations.variables.dashboard_link.description"
    }
  ],
  ["email_generic" /* EMAIL_GENERIC */]: [
    {
      key: "first_name",
      label: "First Name",
      labelKey: "invitations.variables.first_name.label",
      fallback: "there",
      required: false,
      description: "Recipient's first name",
      descriptionKey: "invitations.variables.first_name.description"
    },
    {
      key: "brand_name",
      label: "Brand Name",
      labelKey: "invitations.variables.brand_name.label",
      fallback: "our brand",
      required: false,
      description: "Brand name",
      descriptionKey: "invitations.variables.brand_name.description"
    },
    {
      key: "discount_code",
      label: "Discount Code",
      labelKey: "invitations.variables.discount_code.label",
      fallback: "",
      required: false,
      description: "Discount code to share with the recipient",
      descriptionKey: "invitations.variables.discount_code.description"
    },
    {
      key: "dashboard_link",
      label: "Dashboard Link",
      labelKey: "invitations.variables.dashboard_link.label",
      fallback: "",
      required: false,
      description: "Link to the affiliate dashboard",
      descriptionKey: "invitations.variables.dashboard_link.description"
    }
  ],
  ["collab_proposal_email" /* COLLAB_PROPOSAL_EMAIL */]: [
    {
      key: "creator_first_name",
      label: "Creator First Name",
      labelKey: "invitations.variables.creator_first_name.label",
      fallback: "there",
      required: false,
      description: "Recipient's first name",
      descriptionKey: "invitations.variables.creator_first_name.description"
    },
    {
      key: "brand_name",
      label: "Brand Name",
      labelKey: "invitations.variables.brand_name.label",
      fallback: "our brand",
      required: false,
      description: "Brand name",
      descriptionKey: "invitations.variables.brand_name.description"
    },
    {
      key: "collab_name",
      label: "Collaboration Name",
      labelKey: "invitations.variables.collab_name.label",
      fallback: "our collaboration",
      required: false,
      description: "Name of the proposed collaboration",
      descriptionKey: "invitations.variables.collab_name.description"
    },
    {
      key: "compensation_summary",
      label: "Compensation Summary",
      labelKey: "invitations.variables.compensation_summary.label",
      fallback: "",
      required: false,
      description: "Short summary of what the collaboration offers",
      descriptionKey: "invitations.variables.compensation_summary.description"
    },
    {
      key: "respond_by",
      label: "Respond By",
      labelKey: "invitations.variables.respond_by.label",
      fallback: "",
      required: false,
      description: "Deadline for the recipient to respond",
      descriptionKey: "invitations.variables.respond_by.description"
    },
    {
      key: "collab_link",
      label: "Collaboration Link",
      labelKey: "invitations.variables.collab_link.label",
      fallback: "",
      required: true,
      description: "Unique link to view and accept the collaboration",
      descriptionKey: "invitations.variables.collab_link.description"
    }
  ]
};
function getTemplateVariables(templateType) {
  return VARIABLE_REGISTRY[templateType] || [];
}
function getRequiredVariables(templateType) {
  return getTemplateVariables(templateType).filter((v) => v.required);
}
function templatePairKey(channel, context) {
  return `${channel}:${context}`;
}
var PAIR_TO_TEMPLATE_TYPE = {
  "email:invitation": "creator_outreach_email_invitation" /* CREATOR_OUTREACH_EMAIL_INVITATION */,
  "instagram_dm:invitation": "ig_dm_message_invitation" /* IG_DM_MESSAGE_INVITATION */,
  "instagram_comment:invitation": "ig_comment_reply_invitation" /* IG_COMMENT_REPLY_INVITATION */,
  "instagram_dm:generic": "ig_dm_generic" /* IG_DM_GENERIC */,
  "email:generic": "email_generic" /* EMAIL_GENERIC */,
  // Collaboration proposal: only the email channel is supported. IG channels
  // for collab delivery are handled outside the brand template library (the
  // short DM message is resolved from system translations, not an editable
  // template), so those pairs stay unsupported here.
  "email:collab": "collab_proposal_email" /* COLLAB_PROPOSAL_EMAIL */,
  "instagram_dm:collab": void 0,
  "instagram_comment:collab": void 0,
  // Unsupported pair in V1 (left undefined on purpose):
  "instagram_comment:generic": void 0
};
var TEMPLATE_TYPE_TO_PAIR = {
  ["ig_dm_message_invitation" /* IG_DM_MESSAGE_INVITATION */]: {
    channel: "instagram_dm" /* INSTAGRAM_DM */,
    context: "invitation" /* INVITATION */
  },
  ["ig_comment_reply_invitation" /* IG_COMMENT_REPLY_INVITATION */]: {
    channel: "instagram_comment" /* INSTAGRAM_COMMENT */,
    context: "invitation" /* INVITATION */
  },
  ["creator_outreach_email_invitation" /* CREATOR_OUTREACH_EMAIL_INVITATION */]: {
    channel: "email" /* EMAIL */,
    context: "invitation" /* INVITATION */
  },
  // Legacy variant: resolves to the same email + invitation pair.
  ["creator_outreach_email_invitation_no_commission" /* CREATOR_OUTREACH_EMAIL_INVITATION_NO_COMMISSION */]: {
    channel: "email" /* EMAIL */,
    context: "invitation" /* INVITATION */
  },
  ["ig_dm_generic" /* IG_DM_GENERIC */]: {
    channel: "instagram_dm" /* INSTAGRAM_DM */,
    context: "generic" /* GENERIC */
  },
  ["email_generic" /* EMAIL_GENERIC */]: {
    channel: "email" /* EMAIL */,
    context: "generic" /* GENERIC */
  },
  ["collab_proposal_email" /* COLLAB_PROPOSAL_EMAIL */]: {
    channel: "email" /* EMAIL */,
    context: "collab" /* COLLAB */
  }
};
var SUPPORTED_TEMPLATE_PAIRS = [
  { channel: "email" /* EMAIL */, context: "invitation" /* INVITATION */ },
  { channel: "instagram_dm" /* INSTAGRAM_DM */, context: "invitation" /* INVITATION */ },
  { channel: "instagram_comment" /* INSTAGRAM_COMMENT */, context: "invitation" /* INVITATION */ },
  { channel: "instagram_dm" /* INSTAGRAM_DM */, context: "generic" /* GENERIC */ },
  { channel: "email" /* EMAIL */, context: "generic" /* GENERIC */ },
  { channel: "email" /* EMAIL */, context: "collab" /* COLLAB */ }
];
function isSupportedTemplatePair(channel, context) {
  return PAIR_TO_TEMPLATE_TYPE[templatePairKey(channel, context)] !== void 0;
}
function templateTypeForPair(channel, context) {
  return PAIR_TO_TEMPLATE_TYPE[templatePairKey(channel, context)] ?? null;
}
function pairForTemplateType(templateType) {
  return TEMPLATE_TYPE_TO_PAIR[templateType];
}
function getVariablesForPair(channel, context) {
  const templateType = templateTypeForPair(channel, context);
  return templateType ? VARIABLE_REGISTRY[templateType] : [];
}
function getTemplateVariableErrors(channel, context, content) {
  const allowed = getVariablesForPair(channel, context);
  const allowedKeys = new Set(allowed.map((variable) => variable.key));
  const used = [...content.matchAll(/\{\{([^}]+)\}\}/g)].map((match) => match[1].trim());
  return {
    invalidVariables: [...new Set(used.filter((key) => !allowedKeys.has(key)))],
    missingRequiredVariables: allowed.filter((variable) => variable.required && !content.includes(`{{${variable.key}}}`)).map((variable) => variable.key)
  };
}

// src/api/wishlist.ts
var WishlistCreatorStatus = /* @__PURE__ */ ((WishlistCreatorStatus2) => {
  WishlistCreatorStatus2["SAVED"] = "SAVED";
  WishlistCreatorStatus2["CONTACTED"] = "CONTACTED";
  WishlistCreatorStatus2["PENDING"] = "PENDING";
  WishlistCreatorStatus2["JOINED"] = "JOINED";
  return WishlistCreatorStatus2;
})(WishlistCreatorStatus || {});
var CreatorOutreachEmailStatus = /* @__PURE__ */ ((CreatorOutreachEmailStatus2) => {
  CreatorOutreachEmailStatus2["SENDING"] = "sending";
  CreatorOutreachEmailStatus2["UNKNOWN"] = "unknown";
  CreatorOutreachEmailStatus2["PENDING"] = "pending";
  CreatorOutreachEmailStatus2["SENT"] = "sent";
  CreatorOutreachEmailStatus2["FAILED"] = "failed";
  return CreatorOutreachEmailStatus2;
})(CreatorOutreachEmailStatus || {});
var BulkInvitationBatchStatus = /* @__PURE__ */ ((BulkInvitationBatchStatus2) => {
  BulkInvitationBatchStatus2["PENDING"] = "pending";
  BulkInvitationBatchStatus2["PROCESSING"] = "processing";
  BulkInvitationBatchStatus2["PAUSED_QUOTA"] = "paused_quota";
  BulkInvitationBatchStatus2["PAUSED_INTEGRATION"] = "paused_integration";
  BulkInvitationBatchStatus2["COMPLETED"] = "completed";
  BulkInvitationBatchStatus2["FAILED"] = "failed";
  BulkInvitationBatchStatus2["CANCELLED"] = "cancelled";
  return BulkInvitationBatchStatus2;
})(BulkInvitationBatchStatus || {});
function isBulkInvitationBatchPaused(status) {
  return status === "paused_quota" /* PAUSED_QUOTA */ || status === "paused_integration" /* PAUSED_INTEGRATION */;
}
var BulkInvitationItemStatus = /* @__PURE__ */ ((BulkInvitationItemStatus2) => {
  BulkInvitationItemStatus2["PENDING"] = "pending";
  BulkInvitationItemStatus2["SENT"] = "sent";
  BulkInvitationItemStatus2["FAILED"] = "failed";
  BulkInvitationItemStatus2["SKIPPED"] = "skipped";
  return BulkInvitationItemStatus2;
})(BulkInvitationItemStatus || {});
var AiPersonalizationStatus = /* @__PURE__ */ ((AiPersonalizationStatus2) => {
  AiPersonalizationStatus2["SKIPPED"] = "skipped";
  AiPersonalizationStatus2["COMPLETED"] = "completed";
  AiPersonalizationStatus2["FAILED"] = "failed";
  return AiPersonalizationStatus2;
})(AiPersonalizationStatus || {});

// src/api/withdrawal.ts
var WithdrawalStatus = /* @__PURE__ */ ((WithdrawalStatus2) => {
  WithdrawalStatus2["PENDING"] = "pending";
  WithdrawalStatus2["PROCESSING"] = "processing";
  WithdrawalStatus2["SUCCEEDED"] = "succeeded";
  WithdrawalStatus2["FAILED"] = "failed";
  return WithdrawalStatus2;
})(WithdrawalStatus || {});

// src/api/locales.ts
var BRAND_SURFACE_LOCALES = ["en", "fr"];

// src/api/permissions.ts
var OrganizationRole = /* @__PURE__ */ ((OrganizationRole2) => {
  OrganizationRole2["OWNER"] = "owner";
  OrganizationRole2["MEMBER"] = "member";
  return OrganizationRole2;
})(OrganizationRole || {});
var BrandRole = /* @__PURE__ */ ((BrandRole2) => {
  BrandRole2["ADMIN"] = "admin";
  BrandRole2["VIEWER"] = "viewer";
  return BrandRole2;
})(BrandRole || {});

// src/api/team.ts
var TeamInvitationStatus = /* @__PURE__ */ ((TeamInvitationStatus2) => {
  TeamInvitationStatus2["PENDING"] = "pending";
  TeamInvitationStatus2["ACCEPTED"] = "accepted";
  TeamInvitationStatus2["EXPIRED"] = "expired";
  TeamInvitationStatus2["CANCELLED"] = "cancelled";
  return TeamInvitationStatus2;
})(TeamInvitationStatus || {});

// src/api/gift.ts
var MIN_COLLECTION_PRODUCTS = 2;
var MAX_COLLECTION_PRODUCTS = 15;
var GiftRequestStatus = /* @__PURE__ */ ((GiftRequestStatus2) => {
  GiftRequestStatus2["AVAILABLE"] = "AVAILABLE";
  GiftRequestStatus2["CLAIMING"] = "CLAIMING";
  GiftRequestStatus2["CONFIRMED"] = "CONFIRMED";
  GiftRequestStatus2["ORDER_CREATED"] = "ORDER_CREATED";
  GiftRequestStatus2["SHIPPED"] = "SHIPPED";
  GiftRequestStatus2["DELIVERED"] = "DELIVERED";
  GiftRequestStatus2["EXPIRED"] = "EXPIRED";
  GiftRequestStatus2["CANCELLED"] = "CANCELLED";
  return GiftRequestStatus2;
})(GiftRequestStatus || {});
var GiftMode = /* @__PURE__ */ ((GiftMode2) => {
  GiftMode2["SINGLE_PRODUCT"] = "SINGLE_PRODUCT";
  GiftMode2["COLLECTION"] = "COLLECTION";
  return GiftMode2;
})(GiftMode || {});
var GiftOfferSnapshotPolicy = {
  WORKFLOW_REFRESH: "workflow_refresh",
  IMMUTABLE_EXACT: "immutable_exact"
};
var GiftReofferCatalogStatus = {
  AVAILABLE: "available",
  OUT_OF_STOCK: "out_of_stock",
  MISSING: "missing",
  NOT_ORDERABLE: "not_orderable"
};
var GiftAvailabilityNotificationStatus = {
  /** A provider effect cannot safely be retried or has no confirmed receipt. */
  UNKNOWN: "unknown",
  PENDING: "pending",
  QUEUED: "queued",
  SENT: "sent",
  RETRYABLE_FAILURE: "retryable_failure",
  PERMANENT_FAILURE: "permanent_failure"
};
var GiftReofferOutcome = {
  CREATED: "created",
  EXISTING: "existing"
};
var GiftBlockedReasonCode = /* @__PURE__ */ ((GiftBlockedReasonCode3) => {
  GiftBlockedReasonCode3["VARIANT_OUT_OF_STOCK"] = "VARIANT_OUT_OF_STOCK";
  GiftBlockedReasonCode3["NO_SHIPPING_RATE"] = "NO_SHIPPING_RATE";
  GiftBlockedReasonCode3["ADDRESS_INVALID"] = "ADDRESS_INVALID";
  GiftBlockedReasonCode3["SHOPIFY_PERMISSION"] = "SHOPIFY_PERMISSION";
  GiftBlockedReasonCode3["SHOPIFY_RATE_LIMITED"] = "SHOPIFY_RATE_LIMITED";
  GiftBlockedReasonCode3["RECONCILIATION_REQUIRED"] = "RECONCILIATION_REQUIRED";
  GiftBlockedReasonCode3["UNKNOWN"] = "UNKNOWN";
  return GiftBlockedReasonCode3;
})(GiftBlockedReasonCode || {});
function giftBlockedSeverityOf(code) {
  return code === "ADDRESS_INVALID" /* ADDRESS_INVALID */ ? "suspension" : "failure";
}
function giftAwaitsCreator(status, blockedCode) {
  if (status === "AVAILABLE" /* AVAILABLE */ || status === "CLAIMING" /* CLAIMING */) {
    return true;
  }
  return blockedCode !== null && giftBlockedSeverityOf(blockedCode) === "suspension";
}
var GIFT_TRACKING_FILTERS = [
  "all",
  "to_handle",
  "to_claim",
  "in_transit",
  "delivered",
  "closed"
];

// src/api/flow.ts
var FlowStatus = /* @__PURE__ */ ((FlowStatus2) => {
  FlowStatus2["DRAFT"] = "draft";
  FlowStatus2["PUBLISHED"] = "published";
  FlowStatus2["PAUSED"] = "paused";
  FlowStatus2["ARCHIVED"] = "archived";
  return FlowStatus2;
})(FlowStatus || {});
var FlowExecutionStatus = /* @__PURE__ */ ((FlowExecutionStatus2) => {
  FlowExecutionStatus2["PENDING"] = "pending";
  FlowExecutionStatus2["RUNNING"] = "running";
  FlowExecutionStatus2["WAITING"] = "waiting";
  FlowExecutionStatus2["COMPLETED"] = "completed";
  FlowExecutionStatus2["FAILED"] = "failed";
  FlowExecutionStatus2["CANCELLED"] = "cancelled";
  return FlowExecutionStatus2;
})(FlowExecutionStatus || {});
var FLOW_EXECUTION_IN_PROGRESS_STATUSES = [
  "pending" /* PENDING */,
  "running" /* RUNNING */,
  "waiting" /* WAITING */
];
var FlowStepExecutionStatus = /* @__PURE__ */ ((FlowStepExecutionStatus2) => {
  FlowStepExecutionStatus2["PENDING"] = "pending";
  FlowStepExecutionStatus2["RUNNING"] = "running";
  FlowStepExecutionStatus2["WAITING"] = "waiting";
  FlowStepExecutionStatus2["COMPLETED"] = "completed";
  FlowStepExecutionStatus2["FAILED"] = "failed";
  FlowStepExecutionStatus2["SKIPPED"] = "skipped";
  return FlowStepExecutionStatus2;
})(FlowStepExecutionStatus || {});
var FlowConditionWatcherStatus = /* @__PURE__ */ ((FlowConditionWatcherStatus2) => {
  FlowConditionWatcherStatus2["ACTIVE"] = "active";
  FlowConditionWatcherStatus2["MET"] = "met";
  FlowConditionWatcherStatus2["EXPIRED"] = "expired";
  FlowConditionWatcherStatus2["CANCELLED"] = "cancelled";
  return FlowConditionWatcherStatus2;
})(FlowConditionWatcherStatus || {});
var FlowTriggerType = /* @__PURE__ */ ((FlowTriggerType2) => {
  FlowTriggerType2["AFFILIATE_ENROLLED"] = "affiliate_enrolled";
  FlowTriggerType2["FIRST_ORDER"] = "first_order";
  FlowTriggerType2["MILESTONE_REACHED"] = "milestone_reached";
  FlowTriggerType2["AFFILIATE_INACTIVE"] = "affiliate_inactive";
  FlowTriggerType2["DAYS_SINCE_ENROLLED"] = "days_since_enrolled";
  return FlowTriggerType2;
})(FlowTriggerType || {});
var FlowActionType = /* @__PURE__ */ ((FlowActionType2) => {
  FlowActionType2["SEND_GIFT"] = "send_gift";
  FlowActionType2["UPDATE_COMMISSION"] = "update_commission";
  FlowActionType2["DELAY"] = "delay";
  FlowActionType2["SEND_EMAIL"] = "send_email";
  return FlowActionType2;
})(FlowActionType || {});
var FlowConditionType = /* @__PURE__ */ ((FlowConditionType2) => {
  FlowConditionType2["CONDITION_GROUP"] = "condition_group";
  FlowConditionType2["EMAIL_CLICKED"] = "email_clicked";
  FlowConditionType2["GIFT_STOCK_AVAILABLE"] = "gift_stock_available";
  return FlowConditionType2;
})(FlowConditionType || {});
var ConditionOperator = /* @__PURE__ */ ((ConditionOperator2) => {
  ConditionOperator2["EQUALS"] = "equals";
  ConditionOperator2["NOT_EQUALS"] = "not_equals";
  ConditionOperator2["GREATER_THAN"] = "greater_than";
  ConditionOperator2["AT_LEAST"] = "at_least";
  ConditionOperator2["LESS_THAN"] = "less_than";
  ConditionOperator2["CONTAINS"] = "contains";
  ConditionOperator2["IS_EMPTY"] = "is_empty";
  return ConditionOperator2;
})(ConditionOperator || {});
var MilestoneType = /* @__PURE__ */ ((MilestoneType2) => {
  MilestoneType2["TOTAL_ORDERS"] = "total_orders";
  MilestoneType2["TOTAL_REVENUE"] = "total_revenue";
  MilestoneType2["TOTAL_COMMISSION"] = "total_commission";
  MilestoneType2["DAYS_IN_PROGRAM"] = "days_in_program";
  return MilestoneType2;
})(MilestoneType || {});
var GIFT_CUSTOM_FIELD_DEFAULT_MAX_LENGTH = 1e3;
var GIFT_CUSTOM_FIELD_HARD_MAX_LENGTH = 5e3;

// src/api/flow-tracking.ts
var FLOW_MESSAGE_ISSUE_CODES = [
  "message_recipient_blocked",
  "message_conversation_unavailable",
  "message_mailbox_unavailable",
  "message_email_unavailable",
  "message_recipient_suppressed",
  "message_recipient_opted_out",
  "message_instagram_unobservable",
  "message_no_available_channel",
  "message_variable_unavailable",
  "message_body_empty",
  "message_too_long",
  "message_subject_too_long",
  "message_test_recipient_override",
  "message_mailbox_preflight_changed",
  "message_email_preflight_failed",
  "message_recipient_changed",
  "message_email_refused",
  "message_email_quota_exceeded",
  "message_delivery_unknown",
  "message_attachment_unavailable",
  "message_attachments_too_large"
];
var FLOW_CONTACT_DEFERRAL_CAUSES = [
  "daily_limit",
  "weekly_limit",
  "send_window"
];

// src/api/flow-definition-v2.ts
var FLOW_TRIGGER_CATALOG_V2 = [
  { type: "gift_unclaimed", source: "gifting" },
  { type: "gift_chosen", source: "gifting" },
  { type: "gift_received", source: "gifting" },
  { type: "gift_not_received", source: "gifting" },
  { type: "application_submitted", source: "collabs" },
  { type: "proposal_unanswered", source: "collabs" },
  { type: "proposal_declined", source: "collabs" },
  { type: "proposal_accepted", source: "collabs" },
  { type: "deliverable_validated", source: "collabs" },
  { type: "collab_completed", source: "collabs" },
  { type: "ugc_content_delivered", source: "ugc" },
  { type: "ugc_content_validated", source: "ugc" },
  { type: "ugc_rights_expiring", source: "ugc" },
  { type: "mention_created", source: "mentions" },
  { type: "customer_order", source: "customers" },
  { type: "affiliate_enrolled" /* AFFILIATE_ENROLLED */, source: "affiliation" },
  { type: "first_order" /* FIRST_ORDER */, source: "affiliation" },
  { type: "milestone_reached" /* MILESTONE_REACHED */, source: "affiliation" },
  { type: "affiliate_inactive" /* AFFILIATE_INACTIVE */, source: "affiliation" }
];
function isFlowTriggerTypeV2(value) {
  return typeof value === "string" && FLOW_TRIGGER_CATALOG_V2.some((trigger) => trigger.type === value);
}
var FLOW_CUSTOMER_ORDER_AUDIENCES_V2 = [
  "identified_creators",
  "all_customers"
];
var FLOW_CUSTOMER_ORDER_MIN_FOLLOWERS_V2 = {
  default: 3e3,
  min: 0,
  max: 1e7
};
var FLOW_CUSTOMER_ORDER_DAILY_INVITATIONS_V2 = 50;
var FLOW_PROPOSAL_RESPONSE_OUTCOMES_V2 = [
  "confirmed",
  "declined",
  "expired",
  "not_sent"
];
var FLOW_CONDITION_OUTCOMES_V2 = ["satisfied", "expired"];
function flowConditionOutcomesV2(config) {
  if (config.kind === "proposal_response") return FLOW_PROPOSAL_RESPONSE_OUTCOMES_V2;
  return config.timeout ? FLOW_CONDITION_OUTCOMES_V2 : ["satisfied"];
}
function normalizeFlowMessageChannels(config) {
  if (config.channel !== void 0) {
    if (config.channels !== void 0 || config.channel !== "conversation" && config.channel !== "email")
      throw new Error("flow_message_channels_invalid");
    return [config.channel];
  }
  const channels = config.channels;
  if (channels === void 0) return [];
  if (!Array.isArray(channels) || !channels.every(
    (channel) => channel === "conversation" || channel === "email"
  ))
    throw new Error("flow_message_channels_invalid");
  return ["conversation", "email"].filter(
    (channel) => channels.includes(channel)
  );
}
function flowMessageBodyFormat(config) {
  if (config.channel === "conversation") return "text";
  if (config.channel === "email") return "html";
  if (config.bodyFormat === void 0) return "html";
  if (config.bodyFormat !== "html" && config.bodyFormat !== "text")
    throw new Error("flow_message_body_format_invalid");
  return config.bodyFormat;
}
var FLOW_PROPOSAL_RESPONSE_DAYS_V2 = {
  default: 7,
  min: 1,
  max: 90
};
var FLOW_INVITE_TO_COLLAB_DAILY_CAP_V2 = {
  default: 10,
  min: 1,
  max: 100
};
var FLOW_INVITE_PROGRAM_VARIABLES_V2 = ["invitation_link"];
var FLOW_TEAM_NOTIFICATION_CHANNELS_V2 = [
  "notification",
  "email"
];
var FLOW_TEAM_NOTIFICATION_MAX_RECIPIENTS_V2 = 100;
var FLOW_GOALS_V2 = [
  "first_order",
  "program_joined",
  "flow_gift_claimed",
  "proposal_accepted",
  "mention_published"
];
function isFlowDefinitionV2(value) {
  if (typeof value !== "object" || value === null) return false;
  const definition = value;
  return definition.version === 2 && Object.prototype.hasOwnProperty.call(definition, "entryStepId") && (definition.entryStepId === null || typeof definition.entryStepId === "string");
}

// src/api/flow-capabilities-v2.ts
var NONE = { actions: [], conditions: [] };
var PROPOSAL_SOURCE = {
  actions: ["send_message", "invite_to_collab", "notify_team"],
  conditions: ["proposal_response"]
};
var DECLINED_SOURCE = {
  actions: ["invite_to_collab", "notify_team"],
  conditions: ["proposal_response"]
};
var GIFT_SOURCE = {
  actions: ["send_message", "notify_team"],
  conditions: []
};
var AFFILIATE_JOURNEY = {
  actions: ["send_message", "send_gift", "update_commission", "notify_team"],
  // The gift received wait follows only a gift sent by the same flow (exact scope).
  conditions: ["metric", "gift_received"]
};
var FLOW_TRIGGER_CAPABILITIES_V2 = {
  mention_created: {
    actions: [
      "send_message",
      "send_gift",
      "invite_to_collab",
      "invite_program",
      "notify_team"
    ],
    conditions: ["gift_received", "proposal_response"]
  },
  // Only the invitation the journey exists for: a customer is never written to otherwise.
  customer_order: {
    actions: ["invite_program", "notify_team"],
    conditions: []
  },
  application_submitted: {
    actions: [
      "send_message",
      "invite_to_collab",
      "notify_team"
    ],
    conditions: ["proposal_response"]
  },
  proposal_accepted: PROPOSAL_SOURCE,
  collab_completed: PROPOSAL_SOURCE,
  proposal_declined: DECLINED_SOURCE,
  ugc_content_delivered: PROPOSAL_SOURCE,
  ugc_content_validated: PROPOSAL_SOURCE,
  gift_chosen: GIFT_SOURCE,
  gift_received: GIFT_SOURCE,
  affiliate_enrolled: AFFILIATE_JOURNEY,
  first_order: AFFILIATE_JOURNEY,
  milestone_reached: AFFILIATE_JOURNEY
};
var FLOW_AFFILIATE_JOURNEY_TRIGGERS_V2 = [
  "affiliate_enrolled",
  "first_order",
  "milestone_reached"
];
function isAffiliateJourneyTriggerV2(type) {
  return FLOW_AFFILIATE_JOURNEY_TRIGGERS_V2.includes(
    type
  );
}
var PROGRAM_APPLICATION = {
  actions: ["send_message", "notify_team"],
  conditions: []
};
function flowTriggerCapabilitiesV2(trigger) {
  if (trigger.type === "application_submitted") {
    const target = trigger.config?.applicationTarget;
    if (target === "program") return PROGRAM_APPLICATION;
    if (target !== "brief") return NONE;
  }
  if (!trigger.type || !Object.prototype.hasOwnProperty.call(
    FLOW_TRIGGER_CAPABILITIES_V2,
    trigger.type
  ))
    return NONE;
  return FLOW_TRIGGER_CAPABILITIES_V2[trigger.type] ?? NONE;
}
function flowStepsIncompatibleWithTriggerV2(trigger, steps) {
  const target = trigger.config?.applicationTarget;
  const sources = trigger.type === "application_submitted" && target !== "brief" && target !== "program" ? ["brief", "program"].map((applicationTarget) => ({
    type: trigger.type,
    config: { applicationTarget }
  })) : [trigger];
  return steps.filter((step) => {
    if (step.type === "action")
      return !sources.some(
        (source) => flowTriggerCapabilitiesV2(source).actions.includes(
          step.actionType
        )
      );
    if (step.type !== "condition") return false;
    const kind = step.config?.kind;
    return kind !== void 0 && !sources.some(
      (source) => flowTriggerCapabilitiesV2(source).conditions.includes(kind)
    );
  });
}
function findUpstreamFlowStepV2(steps, toStepId, predicate) {
  const parents = /* @__PURE__ */ new Map();
  for (const step of steps)
    for (const edge of step.connections)
      parents.set(edge.targetStepId, [
        ...parents.get(edge.targetStepId) ?? [],
        step
      ]);
  const seen = /* @__PURE__ */ new Set([toStepId]);
  const queue = [...parents.get(toStepId) ?? []];
  while (queue.length) {
    const step = queue.shift();
    if (seen.has(step.id)) continue;
    seen.add(step.id);
    if (predicate(step)) return step;
    queue.push(...parents.get(step.id) ?? []);
  }
  return void 0;
}
function findReachableFlowStepV2(steps, fromStepId, predicate) {
  const byId = new Map(steps.map((step) => [step.id, step]));
  const seen = /* @__PURE__ */ new Set([fromStepId]);
  const queue = (byId.get(fromStepId)?.connections ?? []).map(
    (edge) => edge.targetStepId
  );
  while (queue.length) {
    const id = queue.shift();
    if (seen.has(id)) continue;
    seen.add(id);
    const step = byId.get(id);
    if (!step) continue;
    if (predicate(step)) return step;
    queue.push(...step.connections.map((edge) => edge.targetStepId));
  }
  return void 0;
}
function flowGoalsForTriggerV2(trigger) {
  const capabilities = flowTriggerCapabilitiesV2(trigger);
  if (!capabilities.actions.length) return [];
  const affiliate = isAffiliateJourneyTriggerV2(trigger.type);
  return FLOW_GOALS_V2.filter((goal) => {
    switch (goal) {
      case "first_order":
        return trigger.type === "affiliate_enrolled" || trigger.type === "mention_created";
      case "program_joined":
        return !affiliate && capabilities.actions.includes("invite_program");
      case "flow_gift_claimed":
        return capabilities.actions.includes("send_gift");
      case "proposal_accepted":
        return capabilities.actions.includes("invite_to_collab");
      case "mention_published":
        return trigger.type !== "mention_created";
    }
  });
}

// src/api/announcement.ts
var DASHBOARD_ANNOUNCEMENTS_API_PATH = "/dashboard/announcements";
function dashboardAnnouncementDismissApiPath(announcementId) {
  return `${DASHBOARD_ANNOUNCEMENTS_API_PATH}/${encodeURIComponent(announcementId)}/dismiss`;
}
var PLATFORM_ANNOUNCEMENT_STATUSES = [
  "info",
  "degraded",
  "maintenance",
  "outage"
];

// src/api/ai-conversation.ts
function aiConversationChannel(conversationId) {
  return `ai/conversations/${conversationId}/stream`;
}

// src/api/bulk-email.ts
var EMAIL_ATTACHMENT_LIMITS = {
  maxCount: 5,
  maxFileBytes: 10 * 1024 * 1024,
  maxTotalBytes: 20 * 1024 * 1024,
  outlookMaxTotalBytes: 2 * 1024 * 1024
};
var BULK_AFFILIATE_EMAIL_LIMIT = 500;
var BulkEmailBatchStatus = /* @__PURE__ */ ((BulkEmailBatchStatus2) => {
  BulkEmailBatchStatus2["UNKNOWN"] = "unknown";
  BulkEmailBatchStatus2["PENDING"] = "pending";
  BulkEmailBatchStatus2["PROCESSING"] = "processing";
  BulkEmailBatchStatus2["COMPLETED"] = "completed";
  BulkEmailBatchStatus2["FAILED"] = "failed";
  return BulkEmailBatchStatus2;
})(BulkEmailBatchStatus || {});
var BulkEmailItemStatus = /* @__PURE__ */ ((BulkEmailItemStatus2) => {
  BulkEmailItemStatus2["SENDING"] = "sending";
  BulkEmailItemStatus2["UNKNOWN"] = "unknown";
  BulkEmailItemStatus2["PENDING"] = "pending";
  BulkEmailItemStatus2["SENT"] = "sent";
  BulkEmailItemStatus2["FAILED"] = "failed";
  BulkEmailItemStatus2["SKIPPED"] = "skipped";
  return BulkEmailItemStatus2;
})(BulkEmailItemStatus || {});
var BULK_EMAIL_VARIABLES = [
  "first_name",
  "brand_name",
  "program_name",
  "affiliate_link",
  "discount_code",
  "commission_rate"
];
var PROGRAM_SCOPED_VARIABLES = [
  "program_name",
  "affiliate_link",
  "discount_code",
  "commission_rate"
];

// src/api/export.ts
var ExportStatus = /* @__PURE__ */ ((ExportStatus2) => {
  ExportStatus2["PENDING"] = "pending";
  ExportStatus2["PROCESSING"] = "processing";
  ExportStatus2["READY"] = "ready";
  ExportStatus2["FAILED"] = "failed";
  return ExportStatus2;
})(ExportStatus || {});
var EXPORT_FILE_FORMATS = ["csv", "xlsx"];
var AFFILIATE_EXPORT_FIELDS = [
  "affiliateName",
  "affiliateEmail",
  "programs",
  "programStatus",
  "networks",
  "source",
  "referralCode",
  "referralLink",
  "joinedAt",
  "orders",
  "visits",
  "revenue",
  "conversionRate",
  "averageOrderValue",
  "payableCommission",
  "payoutStatus",
  "lastOrderAt"
];
var AFFILIATE_EXPORT_DEFAULT_FIELDS = [
  "affiliateName",
  "affiliateEmail",
  "programs",
  "programStatus",
  "referralCode",
  "referralLink",
  "joinedAt",
  "orders",
  "visits",
  "revenue",
  "conversionRate",
  "payableCommission"
];
var AFFILIATE_EXPORT_STRUCTURES = [
  "combined",
  "sheet_per_program"
];

// src/exports/naming.ts
var ExportResourceKey = /* @__PURE__ */ ((ExportResourceKey2) => {
  ExportResourceKey2["PAYOUT_BATCHES"] = "payout_batches";
  ExportResourceKey2["COMMISSIONS"] = "commissions";
  ExportResourceKey2["AFFILIATES"] = "affiliates";
  return ExportResourceKey2;
})(ExportResourceKey || {});
var RESOURCE_SLUG_BY_LOCALE = {
  ["payout_batches" /* PAYOUT_BATCHES */]: {
    fr: "versements",
    en: "payouts"
  },
  ["commissions" /* COMMISSIONS */]: {
    fr: "commissions",
    en: "commissions"
  },
  ["affiliates" /* AFFILIATES */]: {
    fr: "affilies",
    en: "affiliates"
  }
};
function padTwo(value) {
  return value < 10 ? `0${value}` : `${value}`;
}
function buildExportFilename(resourceKey, locale, date = /* @__PURE__ */ new Date(), extension = "csv") {
  const slug = RESOURCE_SLUG_BY_LOCALE[resourceKey]?.[locale] ?? RESOURCE_SLUG_BY_LOCALE[resourceKey]?.en ?? resourceKey;
  const yyyy = date.getFullYear();
  const mm = padTwo(date.getMonth() + 1);
  const dd = padTwo(date.getDate());
  const hh = padTwo(date.getHours());
  const mi = padTwo(date.getMinutes());
  const ss = padTwo(date.getSeconds());
  return `export_${slug}_${yyyy}-${mm}-${dd}_${hh}${mi}${ss}.${extension}`;
}

// src/utils/utm.ts
var UTM_KEY_REGEX = /^[a-z0-9_.-]+$/;
function slugifyUtmValue(input) {
  return input.normalize("NFKD").replace(/[̀-ͯ]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/-+/g, "-").replace(/^-+|-+$/g, "");
}
function buildDefaultUtmParameters(input) {
  const creatorSlug2 = slugifyUtmValue(input.creatorUsername);
  const productSlug2 = (input.productHandle ? slugifyUtmValue(input.productHandle) : "") || (input.productTitle ? slugifyUtmValue(input.productTitle) : "");
  const campaignSlug = creatorSlug2 || productSlug2;
  const params = [
    { key: "utm_source", value: "instagram" },
    { key: "utm_medium", value: "partnership_ad" },
    { key: "utm_campaign", value: campaignSlug ? `copub-${campaignSlug}` : "" }
  ];
  if (productSlug2) {
    params.push({ key: "utm_content", value: productSlug2 });
  }
  return params;
}
function utmParamsToUrlTags(params) {
  const pairs = params.map((p) => ({ key: p.key.trim().toLowerCase(), value: p.value.trim() })).filter((p) => UTM_KEY_REGEX.test(p.key) && p.value.length > 0);
  if (pairs.length === 0) return null;
  return pairs.map((p) => `${p.key}=${encodeURIComponent(p.value)}`).join("&");
}
function safeDecode(value) {
  try {
    return decodeURIComponent(value.replace(/\+/g, " "));
  } catch {
    return value;
  }
}
function readExistingQuery(base) {
  const existing = /* @__PURE__ */ new Map();
  const queryIndex = base.indexOf("?");
  if (queryIndex < 0) return existing;
  const queryString = base.slice(queryIndex + 1);
  if (queryString.length === 0) return existing;
  for (const part of queryString.split("&")) {
    if (part.length === 0) continue;
    const eqIndex = part.indexOf("=");
    const rawKey = eqIndex >= 0 ? part.slice(0, eqIndex) : part;
    const rawValue = eqIndex >= 0 ? part.slice(eqIndex + 1) : "";
    const key = safeDecode(rawKey).trim().toLowerCase();
    if (key.length === 0) continue;
    const value = safeDecode(rawValue).trim();
    if (value.length === 0) continue;
    if (!existing.has(key)) existing.set(key, value);
  }
  return existing;
}
function planUtmApplication(targetUrl, params) {
  const hashIndex = targetUrl.indexOf("#");
  const base = hashIndex >= 0 ? targetUrl.slice(0, hashIndex) : targetUrl;
  const hash = hashIndex >= 0 ? targetUrl.slice(hashIndex) : "";
  const existing = readExistingQuery(base);
  const appliedParams = [];
  const lockedKeys = [];
  for (const param of params) {
    const key = param.key.trim();
    if (key.length === 0) continue;
    const lookup = key.toLowerCase();
    if (existing.has(lookup)) {
      lockedKeys.push({ key: lookup, value: existing.get(lookup) ?? "" });
      continue;
    }
    const value = param.value.trim();
    if (value.length === 0) continue;
    appliedParams.push({ key: lookup, value });
  }
  const urlTags = utmParamsToUrlTags(appliedParams);
  let previewUrl = targetUrl;
  if (urlTags !== null) {
    const separator = base.endsWith("?") || base.endsWith("&") ? "" : base.includes("?") ? "&" : "?";
    previewUrl = `${base}${separator}${urlTags}${hash}`;
  }
  return { appliedParams, lockedKeys, urlTags, previewUrl };
}

// src/utils/boost-placement.ts
var NEW_CAMPAIGN_LEVELS = [
  "campaign",
  "ad_set",
  "ad"
];
var EXISTING_CAMPAIGN_LEVELS = ["ad_set", "ad"];
function resolvePlacementMode(mode) {
  return mode ?? "new_campaign" /* NEW_CAMPAIGN */;
}
function ownedLevels(mode) {
  return resolvePlacementMode(mode) === "existing_campaign" /* EXISTING_CAMPAIGN */ ? [...EXISTING_CAMPAIGN_LEVELS] : [...NEW_CAMPAIGN_LEVELS];
}
function ownsCampaignLevel(mode) {
  return ownedLevels(mode).includes("campaign");
}
var NAME_PREFIX = "[Fluenceur] Copub";
var NAME_SEPARATOR = " \xB7 ";
var NAMING_TIME_ZONE = "Europe/Paris";
function productSlug(input) {
  return (input.productHandle ? slugifyUtmValue(input.productHandle) : "") || (input.productTitle ? slugifyUtmValue(input.productTitle) : "");
}
function creatorSlug(input) {
  return input.creatorUsername ? slugifyUtmValue(input.creatorUsername) : "";
}
function creatorHandle(input) {
  const raw = (input.creatorUsername ?? "").trim().replace(/^@+/, "");
  return raw.length > 0 ? `@${raw}` : "";
}
function launchMonth(launchedAt) {
  const date = launchedAt ? new Date(launchedAt) : /* @__PURE__ */ new Date();
  if (Number.isNaN(date.getTime())) return "";
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: NAMING_TIME_ZONE,
    year: "numeric",
    month: "2-digit"
  }).formatToParts(date);
  const year = parts.find((part) => part.type === "year")?.value ?? "";
  const month = parts.find((part) => part.type === "month")?.value ?? "";
  return year && month ? `${year}-${month}` : "";
}
function joinSegments(segments) {
  return [NAME_PREFIX, ...segments.filter((segment) => !!segment)].join(
    NAME_SEPARATOR
  );
}
function buildBoostCampaignName(input) {
  return joinSegments(["Campagne", productSlug(input) || creatorSlug(input)]);
}
function buildBoostAdSetName(input) {
  return joinSegments(["Ad set", creatorHandle(input), productSlug(input)]);
}
function buildBoostAdName(input) {
  return joinSegments([
    creatorHandle(input),
    productSlug(input),
    launchMonth(input.launchedAt)
  ]);
}

// src/utils/boost-budget.ts
var META_WHOLE_UNIT_CURRENCIES = /* @__PURE__ */ new Set([
  "CLP",
  "COP",
  "CRC",
  "HUF",
  "ISK",
  "IDR",
  "JPY",
  "KRW",
  "PYG",
  "TWD",
  "VND"
]);
var META_THOUSANDTH_UNIT_CURRENCIES = /* @__PURE__ */ new Set([
  "BHD",
  "IQD",
  "JOD",
  "KWD",
  "LYD",
  "OMR",
  "TND"
]);
function toMetaBoostBudgetUnits(amountInCents, currencyCode) {
  if (!Number.isSafeInteger(amountInCents) || amountInCents <= 0) return null;
  const code = currencyCode.trim().toUpperCase();
  if (META_THOUSANDTH_UNIT_CURRENCIES.has(code)) return null;
  const units = META_WHOLE_UNIT_CURRENCIES.has(code) ? amountInCents / 100 : amountInCents;
  return Number.isInteger(units) ? units : null;
}

// src/utils/product-url.ts
function normalizeUrlBase(value) {
  const trimmed = value?.trim();
  if (!trimmed) return null;
  const withProtocol = trimmed.startsWith("http://") || trimmed.startsWith("https://") ? trimmed : `https://${trimmed}`;
  return withProtocol.replace(/\/+$/, "") || null;
}
function buildProductUrl(baseUrl, handle) {
  const trimmedHandle = handle?.trim();
  if (!baseUrl || !trimmedHandle) return null;
  return `${baseUrl}/products/${trimmedHandle}`;
}
function resolveProductUrl(input) {
  const baseUrl = normalizeUrlBase(input.primaryDomainUrl) ?? normalizeUrlBase(input.shopDomain);
  return buildProductUrl(baseUrl, input.handle);
}

// src/utils/display-rights.ts
function computeDisplayRightsTotalCents(input) {
  return input.compensationModel === "monthly" /* MONTHLY */ ? input.amountCents * input.durationMonths : input.amountCents;
}
function addMonths(iso, months) {
  const from = new Date(iso);
  const day = from.getUTCDate();
  const target = new Date(
    Date.UTC(
      from.getUTCFullYear(),
      from.getUTCMonth() + months,
      1,
      from.getUTCHours(),
      from.getUTCMinutes(),
      from.getUTCSeconds(),
      from.getUTCMilliseconds()
    )
  );
  const lastDayOfTargetMonth = new Date(
    Date.UTC(target.getUTCFullYear(), target.getUTCMonth() + 1, 0)
  ).getUTCDate();
  target.setUTCDate(Math.min(day, lastDayOfTargetMonth));
  return target.toISOString();
}
function computeDisplayRightsEndAt(input) {
  if (!input.rightsStartedAt) return null;
  return addMonths(input.rightsStartedAt, input.durationMonths);
}

// src/utils/commission-source.ts
function formatExactCommissionMoney(amount, locale) {
  const match = /^(-?)(\d+)(?:\.(\d+))?$/.exec(amount.amount);
  if (!match) return amount.amount;
  const [, sign, rawInteger, rawFraction = ""] = match;
  const fractionDigits = Math.max(amount.minorUnitExponent, rawFraction.length);
  if (fractionDigits > 20) return amount.amount;
  const integer = BigInt(rawInteger);
  const groupedInteger = new Intl.NumberFormat(locale, {
    useGrouping: true,
    maximumFractionDigits: 0
  }).format(integer);
  const fraction = rawFraction.padEnd(fractionDigits, "0");
  const formatter = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: amount.currencyCode,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits
  });
  const parts = formatter.formatToParts(sign === "-" ? -1 : 0);
  return parts.map((part) => {
    if (part.type === "integer") return groupedInteger;
    if (part.type === "fraction") return fraction;
    return part.value;
  }).join("");
}
function getCommissionSourcePresentation(commission) {
  if (commission.source?.kind === "recurring") {
    return {
      kind: "recurring",
      occurredAt: commission.source.occurredAt,
      reference: commission.source.subscriptionId,
      servicePeriod: commission.source.servicePeriod,
      originalAmount: commission.source.originalAmount
    };
  }
  if (commission.source?.kind === "order") {
    return {
      kind: "order",
      occurredAt: commission.source.occurredAt,
      reference: commission.source.orderNumber,
      servicePeriod: null,
      originalAmount: commission.source.originalAmount
    };
  }
  if (commission.order) {
    return {
      kind: "order",
      occurredAt: commission.order.createdAt,
      reference: commission.order.orderNumber,
      servicePeriod: null,
      originalAmount: null
    };
  }
  return {
    kind: "detached",
    occurredAt: commission.createdAt,
    reference: null,
    servicePeriod: null,
    originalAmount: null
  };
}

// src/api/mcp.ts
var MCP_SCOPES = [
  "fluenceur:read",
  "discovery:run",
  "programs:write",
  "communications:send",
  "gifts:write",
  "collaborations:write",
  "copublicity:prepare"
];
var MCP_CAPABILITY_KEYS = [
  "programs.create",
  "programs.update",
  "gifts.propose",
  "gifts.cancel",
  "gifts.reoffer",
  "collaborations.review_deliverable",
  "collaborations.remind_deliverable",
  "communications.reply_native",
  "discovery.contact_resolution",
  "invitations.connected_email",
  "invitations.bulk_connected_email",
  "invitations.external",
  "copublicity.review"
];
var MCP_DIRECT_WRITE_KEYS = [
  "favorites.add",
  "favorites.note",
  "discovery.selection"
];
var MCP_CONNECTION_ACTIVITY_EVENTS = [
  "connection_authorized",
  "connection_reduced",
  "connection_revoked",
  "capability_accepted",
  "capability_completed",
  "capability_rejected"
];

// src/utils/boost-insights.ts
function resolveInsightsView(insights) {
  return insights.recommendedView === "conversion" && insights.roas !== null ? "conversion" : "traffic";
}

// src/utils/gift-display.ts
var GIFT_STATUS_DISPLAY = {
  ["AVAILABLE" /* AVAILABLE */]: {
    labelKey: "gifting.tracking.status.available",
    palette: "gray"
  },
  ["CLAIMING" /* CLAIMING */]: {
    labelKey: "gifting.tracking.status.claiming",
    palette: "blue"
  },
  ["CONFIRMED" /* CONFIRMED */]: {
    labelKey: "gifting.tracking.status.confirmed",
    palette: "blue"
  },
  ["ORDER_CREATED" /* ORDER_CREATED */]: {
    labelKey: "gifting.tracking.status.orderCreated",
    palette: "blue"
  },
  ["SHIPPED" /* SHIPPED */]: {
    labelKey: "gifting.tracking.status.shipped",
    palette: "blue"
  },
  ["DELIVERED" /* DELIVERED */]: {
    labelKey: "gifting.tracking.status.delivered",
    palette: "green"
  },
  ["EXPIRED" /* EXPIRED */]: {
    labelKey: "gifting.tracking.status.expired",
    palette: "orange"
  },
  ["CANCELLED" /* CANCELLED */]: {
    labelKey: "gifting.tracking.status.cancelled",
    palette: "red"
  }
};
var classifyGiftStoppage = (gift) => {
  if (gift.status === "EXPIRED" /* EXPIRED */) {
    return { kind: "expired" };
  }
  if (gift.status === "CANCELLED" /* CANCELLED */) {
    return gift.cancellation?.source === "shopify" ? { kind: "cancelledByShopify" } : { kind: "cancelledByBrand", reason: gift.cancellation?.reason ?? null };
  }
  if (gift.blocked) {
    return {
      kind: "blocked",
      code: gift.blocked.code,
      severity: gift.blocked.severity
    };
  }
  return { kind: "none" };
};
export {
  AFFILIATE_CSV_IMPORT_LIMITS,
  AFFILIATE_EXPORT_DEFAULT_FIELDS,
  AFFILIATE_EXPORT_FIELDS,
  AFFILIATE_EXPORT_STRUCTURES,
  AFFILIATE_TABLE_DATE_FILTER_TYPES,
  AFFILIATE_TABLE_SORT_FIELDS,
  AGE_BUCKET_VALUES,
  ALLOWED_SHIPPING_COUNTRIES,
  ALLOWED_SHIPPING_COUNTRIES_UPPER,
  ALLOWED_SHIPPING_COUNTRIES_UPPER_SET,
  ANALYTICS_ACTIONS,
  ANALYTICS_CLIENT_EVENTS,
  ANALYTICS_ENTRY_POINTS,
  ANALYTICS_EVENTS,
  ANALYTICS_FEATURES,
  ANALYTICS_OUTCOMES,
  ANALYTICS_ROUTES,
  ANALYTICS_STEPS,
  ANALYTICS_SURFACES,
  AUDIENCE_INTEREST_VALUES,
  AffiliateEnrollmentSource,
  AffiliateProgramFilterTimeRange,
  AffiliateProgramStatus,
  AgentInvocationStatus,
  AgentSlug,
  AiPersonalizationStatus,
  BRAND_COLLABORATION_TYPES,
  BRAND_LEGAL_IDENTITY_REQUIRED_FIELDS,
  BRAND_SALES_CHANNELS,
  BRAND_SPACE_ADDRESS_MAX_LENGTH,
  BRAND_SPACE_APPLICATIONS_API_PATH,
  BRAND_SPACE_APPLICATION_ANSWERS_MAX_BYTES,
  BRAND_SPACE_APPLICATION_CHALLENGE_API_PATH,
  BRAND_SPACE_APPLICATION_DECISION_OUTCOMES,
  BRAND_SPACE_APPLICATION_DELIVERY_STATUS,
  BRAND_SPACE_APPLICATION_IDENTITY_LIMITS,
  BRAND_SPACE_APPLICATION_PROOF_LIMITS,
  BRAND_SPACE_APPLICATION_QUESTION_KINDS,
  BRAND_SPACE_APPLICATION_STATE,
  BRAND_SPACE_APPLICATION_TABLE_SORT_FIELDS,
  BRAND_SPACE_CONFIG_DB_MAX_BYTES,
  BRAND_SPACE_CONFIG_MAX_BYTES,
  BRAND_SPACE_CONFIG_VERSION,
  BRAND_SPACE_CREATOR_PLATFORMS,
  BRAND_SPACE_DASHBOARD_APPLICATIONS_API_PATH,
  BRAND_SPACE_DEFAULT_COPY,
  BRAND_SPACE_DEFAULT_PUBLIC_ORIGIN,
  BRAND_SPACE_EMERGENCY_UNPUBLISH_ACTOR_ASSERTION_DOMAIN,
  BRAND_SPACE_FALLBACK_LOCALE,
  BRAND_SPACE_FONT_PAIRINGS,
  BRAND_SPACE_HOME_API_PATH,
  BRAND_SPACE_INTERNAL_API_PATH,
  BRAND_SPACE_ITEM_KEY_PATTERN,
  BRAND_SPACE_LAYOUTS,
  BRAND_SPACE_LEGACY_PUBLIC_PATH,
  BRAND_SPACE_LIMITS,
  BRAND_SPACE_LINK_ICON_IDS,
  BRAND_SPACE_OVERRIDE_DB_MAX_BYTES,
  BRAND_SPACE_OVERRIDE_MAX_BYTES,
  BRAND_SPACE_OVERRIDE_PATHS,
  BRAND_SPACE_PRESENTATION_LIMITS,
  BRAND_SPACE_PREVIEW_API_SEGMENT,
  BRAND_SPACE_PREVIEW_CHANNEL,
  BRAND_SPACE_PREVIEW_HEADER,
  BRAND_SPACE_PREVIEW_MESSAGE_MAX_BYTES,
  BRAND_SPACE_PREVIEW_TOKEN_API_PATH,
  BRAND_SPACE_PREVIEW_VERSION,
  BRAND_SPACE_PRIVATE_CACHE_CONTROL,
  BRAND_SPACE_PROFILE_DESCRIPTION_DISPLAY_LIMIT,
  BRAND_SPACE_PROGRAMME_SEGMENT,
  BRAND_SPACE_PUBLIC_API_PATH,
  BRAND_SPACE_PUBLIC_CACHE_CONTROL,
  BRAND_SPACE_PUBLIC_LOCALES,
  BRAND_SPACE_RESERVED_SEGMENTS,
  BRAND_SPACE_REVALIDATION_ADDRESS_CAP,
  BRAND_SPACE_SECTION_KEYS,
  BRAND_SPACE_SITEMAP_API_PATH,
  BRAND_SPACE_SITEMAP_ENTRY_CAP,
  BRAND_SPACE_SLUG_AVAILABILITY_REASONS,
  BRAND_SPACE_STATUSES,
  BRAND_SPACE_STUDIO_API_PATH,
  BRAND_SPACE_STUDIO_DRAFT_API_PATH,
  BRAND_SPACE_STUDIO_MENTIONS_API_PATH,
  BRAND_SPACE_STUDIO_MENTIONS_MAX_PAGE,
  BRAND_SPACE_STUDIO_MENTIONS_PAGE_SIZE,
  BRAND_SPACE_STUDIO_MENTION_SORTS,
  BRAND_SPACE_STUDIO_MENTION_THUMBNAIL_KINDS,
  BRAND_SPACE_STUDIO_MIRROR_BATCH_STATUSES,
  BRAND_SPACE_STUDIO_PUBLISH_API_PATH,
  BRAND_SPACE_STUDIO_SLUG_AVAILABILITY_API_PATH,
  BRAND_SPACE_STUDIO_VARIANTS_API_PATH,
  BRAND_SPACE_VARIANTS_API_SEGMENT,
  BRAND_SPACE_VARIANT_V1_CAP,
  BRAND_SPACE_VISITOR_IP_HEADER,
  BRAND_SPACE_VISITOR_USER_AGENT_HEADER,
  BRAND_SURFACE_LOCALES,
  BRIEF_APPLICATION_MESSAGE_MAX_LENGTH,
  BULK_AFFILIATE_EMAIL_LIMIT,
  BULK_EMAIL_VARIABLES,
  BULK_INVITATION_ACTION_LIMIT,
  BULK_INVITATION_OUTREACH_LIMIT,
  BoostDisplayRightsNotificationIntent,
  BrandAccountType,
  BrandCollaborationType,
  BrandRole,
  BrandSalesChannel,
  BrandSignupInvitationStatus,
  BrandSpaceApplicationSource,
  BrandSpaceConfigUpgradeError,
  BrandSpaceOverrideError,
  BrandSpacePreviewProtocolError,
  BrandSpaceStorageError,
  BriefApplicationState,
  BriefDiffusionStatus,
  BriefGenerationObjective,
  BriefTemplateStatus,
  BulkEmailBatchStatus,
  BulkEmailItemStatus,
  BulkInvitationBatchStatus,
  BulkInvitationItemStatus,
  CODE_SEGMENT_MAX_LENGTH,
  COLLAB_ABANDON_REASON_MAX_LENGTH,
  COLLAB_AGE_ATTESTATION_SCOPE,
  COLLAB_CANCELLATION_REASONS,
  COLLAB_CODE_PURPOSES,
  COLLAB_COLLECTION_FAILURE_OUTCOMES,
  COLLAB_DECLINE_REASON_CODES,
  COLLAB_DELIVERABLE_BOARD_STATUSES,
  COLLAB_DELIVERABLE_MAX_REJECTIONS,
  COLLAB_DISPUTE_GROUNDS,
  COLLAB_DISPUTE_OUTCOMES,
  COLLAB_END_DEADLINE_DECISION_DAYS,
  COLLAB_END_DEADLINE_EXTENSION_DAYS,
  COLLAB_FUNDING_WINDOW_HOURS,
  COLLAB_HOLD_LIMIT_DAYS,
  COLLAB_HOLD_WARNING_DAYS,
  COLLAB_MONEY_STATES,
  COLLAB_PAID_BRIEF_MAX_AMOUNT_MINOR_UNITS,
  COLLAB_PAID_BRIEF_MAX_END_DAYS,
  COLLAB_PAYMENT_RIGHT_VOID_REASONS,
  COLLAB_PAYMENT_TERMS_CONSENT_TYPE,
  COLLAB_PLATFORM_FEE_BASIS_POINTS_BY_OFFER,
  COLLAB_PLATFORM_FEE_FLOOR_MINOR_UNITS,
  COLLAB_PROCESSING_FEE_BASIS_POINTS_CROSS_CURRENCY,
  COLLAB_PROCESSING_FEE_BASIS_POINTS_DOMESTIC,
  COLLAB_SETTLEABLE_CURRENCIES,
  COLLAB_SETTLEMENT_REFUND_REASONS,
  COLLAB_TACIT_REMINDER_MILESTONE_DAYS,
  COLLAB_TACIT_VALIDATION_DAYS,
  COLLAB_TRACKING_PATH,
  COMPANION_KIND_RANK,
  COMPANION_KIND_SLUGS,
  COMPANION_NON_TERMINAL_STATUSES,
  COMPANION_PAGE_FILTER_KEYS,
  COMPANION_PAGE_IDS,
  COMPANION_PANEL_FILTER_MAX_KEYS,
  COMPANION_PANEL_FILTER_VALUE_MAX_LENGTH,
  COMPANION_PANEL_QUESTION_MAX_LENGTH,
  COMPANION_SLUGS_SEED_VERSION,
  CONTACT_DRAWER_QUERY_KEYS,
  CONTACT_ENTRIES,
  CONTACT_PLATFORMS,
  CONTRACT_AMOUNT_MAX_CENTS,
  CONTRACT_CLAUSE_REGISTRY,
  CONVERSATION_ATTACHMENT_RULES,
  COUNTRY_CURRENCIES,
  COUNTRY_REGISTRATION_CONFIGS,
  CO_PUBLICITE_TABLE_SORT_FIELDS,
  CREATOR_ADVANCED_STAT_FIELDS,
  CREATOR_API_DISCOVERY_REGULAR_UNSUPPORTED_FILTERS,
  CREATOR_API_DISCOVERY_SIMILAR_UNSUPPORTED_FILTERS,
  CREATOR_DISCOVERY_PATH,
  CREATOR_GROWTH_DAYS,
  CREATOR_HUB_AVAILABILITY_VALUES,
  CREATOR_HUB_COLLAB_MOMENTS,
  CREATOR_HUB_CONTENT_FORMAT_VALUES,
  CREATOR_HUB_CONTENT_LANGUAGE_VALUES,
  CREATOR_HUB_LANGUAGE_VALUES,
  CREATOR_HUB_MESSAGE_MAX_CHARACTERS,
  CREATOR_HUB_NAME_MAX_LENGTH,
  CREATOR_HUB_ONBOARDING_STEP_VALUES,
  CREATOR_HUB_OPPORTUNITY_INTEREST_VALUES,
  CREATOR_HUB_PUSH_CATEGORIES,
  CREATOR_HUB_SECTOR_VALUES,
  CREATOR_HUB_SOCIAL_OAUTH_RESULTS,
  CREATOR_HUB_SOCIAL_PLATFORMS,
  CREATOR_HUB_WITHDRAWAL_ARRIVAL_NOTICES,
  CREATOR_HUB_WITHDRAWAL_FAILURE_REASONS,
  CREATOR_IDENTITY_FIELDS,
  CREATOR_NOTIFICATIONS_DEFAULT_LIMIT,
  CREATOR_NOTIFICATIONS_MAX_LIMIT,
  CREATOR_STRICT_FILTER_VALUES,
  CREATOR_TIER_REASON_VALUES,
  CREATOR_UGC_MAX_SAMPLES,
  CREATOR_UGC_MAX_SAMPLE_URLS,
  CREATOR_UGC_MODIFICATION_REQUEST_CHOICES,
  CURRENT_CONSENT_VERSIONS,
  CURRENT_CONTRACT_CLAUSES,
  CURRENT_PAYMENT_CONDITION,
  CURRENT_UGC_CONTRACT_CLAUSES,
  CURRENT_UGC_PAYMENT_CONDITION,
  CodePatternPart,
  CodePatternSeparator,
  CollabAcceptanceMethod,
  CollabCloseOutcome,
  CollabDeclineReasonCode,
  CollabDeliverableStatus,
  CollabDeliveryChannel,
  CollabEventType,
  CollabPaymentRightStatus,
  CollabSettlementStatus,
  CollabStatus,
  CollabType,
  CommissionFeeRegime,
  CommissionStatus,
  CommissionTypes,
  CompanionActionKind,
  CompanionActionStatus,
  CompanionActionVisibility,
  CompanionBrandContactChannel,
  CompanionCtaWorkflow,
  CompanionDismissReason,
  CompanionDoneSource,
  CompanionEventType,
  CompanionGiftReofferDecisionStatus,
  CompanionMentionSignal,
  CompanionNarrationSource,
  CompanionOutcome,
  CompanionPayoutExclusionReason,
  CompanionPerformanceMetric,
  CompanionRealtimeEventName,
  CompanionRealtimeReason,
  CompanionResumeStatus,
  CompanionRunStatus,
  CompanionUnavailableReason,
  ComparisonPeriodType,
  ConditionOperator,
  ConversationAttachmentKind,
  ConversationAwaitNature,
  ConversationAwaitNatureValues,
  ConversationChannelExternalPlatform,
  ConversationChannelType,
  ConversationChannelTypeValues,
  CreatorHubCapabilityReason,
  CreatorHubConversationRelationshipKind,
  CreatorHubConversationSide,
  CreatorHubFeedItemType,
  CreatorHubFeedItemTypeValues,
  CreatorHubPushApplicationType,
  CreatorHubPushApplicationVersion,
  CreatorHubPushCollabMomentType,
  CreatorHubPushCollabMomentVersion,
  CreatorHubPushCollabProposalType,
  CreatorHubPushCollabProposalVersion,
  CreatorHubPushDeadlineType,
  CreatorHubPushDeadlineVersion,
  CreatorHubPushEnvironmentValues,
  CreatorHubPushGiftType,
  CreatorHubPushGiftVersion,
  CreatorHubPushMessageType,
  CreatorHubPushMessageVersion,
  CreatorHubPushOpportunityType,
  CreatorHubPushOpportunityVersion,
  CreatorHubPushWalletType,
  CreatorHubPushWalletVersion,
  CreatorHubPushWithdrawalType,
  CreatorHubPushWithdrawalVersion,
  CreatorHubRealtimeEventName,
  CreatorHubReportReason,
  CreatorHubSystemEventName,
  CreatorOutreachEmailStatus,
  CreatorStatus,
  DASHBOARD_ANNOUNCEMENTS_API_PATH,
  DASHBOARD_DECISION_SOURCE_KEYS,
  DASHBOARD_TABLE_SORT_DIRECTIONS,
  DASHBOARD_TODO_SOURCE_KEYS,
  DEFAULT_AFFILIATE_USER_SETTINGS,
  DEFAULT_BRAND_SPACE_CONFIG,
  DEFAULT_CODE_PATTERN,
  DEFAULT_CREATOR_GROWTH_DAYS,
  DEFAULT_CREATOR_UGC_MODIFICATION_REQUESTS,
  DEFAULT_CURRENCY_CODE,
  DEFAULT_DISCOVERY_SORT,
  DEFAULT_ON_FLAGS,
  DEFAULT_SIZE_TARGETS,
  DEFAULT_UGC_DELIVERY,
  DEFAULT_USER_SETTINGS,
  DISCOUNT_CODE_RULES,
  DISCOVERY_QUALITY_SORT_OPTIONS,
  DISCOVERY_SEARCH_ERROR_CODES,
  DISCOVERY_SIZE_RANGES,
  DISCOVERY_SORT_OPTIONS,
  DISPLAY_RIGHTS_CODE_EXPIRY_MINUTES,
  DISPLAY_RIGHTS_CODE_LENGTH,
  DISPLAY_RIGHTS_CODE_MAX_ATTEMPTS,
  DISPLAY_RIGHTS_CODE_RESEND_COOLDOWN_SECONDS,
  DISPLAY_RIGHTS_DASHBOARD_BASE_PATH,
  DISPLAY_RIGHTS_DASHBOARD_SEGMENTS,
  DISPLAY_RIGHTS_DEFAULT_EXPIRES_IN_DAYS,
  DISPLAY_RIGHTS_EXPIRY_NOTICE_DAYS,
  DISPLAY_RIGHTS_LINKS_BASE_PATH,
  DISPLAY_RIGHTS_LINK_SEGMENTS,
  DISPLAY_RIGHTS_MAX_DURATION_MONTHS,
  DISPLAY_RIGHTS_MAX_EXPIRES_IN_DAYS,
  DISPLAY_RIGHTS_MAX_NOTE_LENGTH,
  DISPLAY_RIGHTS_MIN_AMOUNT_CENTS,
  DISPLAY_RIGHTS_MIN_DURATION_MONTHS,
  DISPLAY_RIGHTS_MIN_EXPIRES_IN_DAYS,
  DISPLAY_RIGHTS_OPEN_STATUSES,
  DM_MAX_CHARACTERS,
  DRIVE_SHARE_EMAIL_REGEX,
  DashboardConversationFeedItemType,
  DashboardConversationSystemEventNames,
  DeactivationReason,
  DiscountCodeManagementMode,
  DiscountCodeOrigin,
  DiscountCodeTypes,
  DisplayRightsAcceptanceMethod,
  DisplayRightsCompensationModel,
  DisplayRightsDeclineReason,
  DisplayRightsDeliveryChannel,
  DisplayRightsEmailChannelBlocker,
  DisplayRightsEndReason,
  DisplayRightsProposalStatus,
  EMAIL_ATTACHMENT_LIMITS,
  EMAIL_SOURCE,
  EU_MEMBER_COUNTRIES,
  EU_VAT_NUMBER_SHAPES,
  EXPORT_FILE_FORMATS,
  EmailConfigurableNotificationType,
  EmailConfigurableNotificationTypeValues,
  ErrorCode,
  ExportResourceKey,
  ExportStatus,
  FLOW_AFFILIATE_JOURNEY_TRIGGERS_V2,
  FLOW_CONDITION_OUTCOMES_V2,
  FLOW_CONTACT_DEFERRAL_CAUSES,
  FLOW_CUSTOMER_ORDER_AUDIENCES_V2,
  FLOW_CUSTOMER_ORDER_DAILY_INVITATIONS_V2,
  FLOW_CUSTOMER_ORDER_MIN_FOLLOWERS_V2,
  FLOW_EXECUTION_IN_PROGRESS_STATUSES,
  FLOW_GOALS_V2,
  FLOW_INVITE_PROGRAM_VARIABLES_V2,
  FLOW_INVITE_TO_COLLAB_DAILY_CAP_V2,
  FLOW_MESSAGE_ISSUE_CODES,
  FLOW_PROPOSAL_RESPONSE_DAYS_V2,
  FLOW_PROPOSAL_RESPONSE_OUTCOMES_V2,
  FLOW_TEAM_NOTIFICATION_CHANNELS_V2,
  FLOW_TEAM_NOTIFICATION_MAX_RECIPIENTS_V2,
  FLOW_TRIGGER_CAPABILITIES_V2,
  FLOW_TRIGGER_CATALOG_V2,
  FOLLOWER_TIERS_META,
  FeatureFlag,
  FlowActionType,
  FlowConditionType,
  FlowConditionWatcherStatus,
  FlowExecutionStatus,
  FlowStatus,
  FlowStepExecutionStatus,
  FlowTriggerType,
  GIFT_CUSTOM_FIELD_DEFAULT_MAX_LENGTH,
  GIFT_CUSTOM_FIELD_HARD_MAX_LENGTH,
  GIFT_STATUS_DISPLAY,
  GIFT_TRACKING_FILTERS,
  Gender,
  GiftAvailabilityNotificationStatus,
  GiftBlockedReasonCode,
  GiftMode,
  GiftOfferSnapshotPolicy,
  GiftReofferCatalogStatus,
  GiftReofferOutcome,
  GiftRequestStatus,
  GiftStockAlertSeverity,
  HOSTED_MENTION_THUMBNAIL_FILENAME,
  HOSTED_MENTION_THUMBNAIL_PATH,
  HOSTED_MENTION_VIDEO_FILENAME,
  IBAN_LENGTHS,
  INVITATION_OUTREACH_VARIABLES,
  INVITATION_SCENARIOS,
  INVITATION_TABLE_SORT_FIELDS,
  InfluenceSector,
  IntegrationStatus,
  InvitationMethod,
  InvitationOutreachEmailStatus,
  InvitationStatus,
  LIVE_MENTION_BOOST_DELIVERY_STATES,
  LOWEST_REVIEW_BOUNDS,
  Language,
  MAX_COLLECTION_PRODUCTS,
  MAX_COMMISSION_CATEGORY_RULES,
  MAX_INFLUENCE_SECTORS,
  MCP_CAPABILITY_KEYS,
  MCP_CONNECTION_ACTIVITY_EVENTS,
  MCP_DIRECT_WRITE_KEYS,
  MCP_SCOPES,
  MENTION_BOOST_TREND_MIN_POINTS,
  MENTION_MESSAGE_TYPES,
  MIN_COLLECTION_PRODUCTS,
  MentionBoostAuthorizationScope,
  MentionBoostAuthorizationSource,
  MentionBoostAuthorizationStatus,
  MentionBoostCampaignBudgetMode,
  MentionBoostCampaignObjective,
  MentionBoostCampaignStatus,
  MentionBoostDeliveryState,
  MentionBoostDestinationType,
  MentionBoostEligibilityBlockerCode,
  MentionBoostEligibilityStatus,
  MentionBoostLaunchFailureReason,
  MentionBoostPlacementMode,
  MentionBoostProvider,
  MentionBoostReadinessBlockerCode,
  MentionBoostSetupAudienceMode,
  MentionBoostTargetLocationType,
  MentionDownloadAuditStatus,
  MentionDriveArchiveStatus,
  MentionMediaType,
  MentionPlatform,
  MentionTrackingStatus,
  MentionType,
  MessageCode,
  MessageTypeEnum,
  MessagingMethod,
  MilestoneType,
  MoneyUtils,
  NICHE_VALUES,
  NotificationActorType,
  NotificationCategory,
  NotificationCategoryValues,
  NotificationPreferenceEmailDelivery,
  NotificationPreferenceEmailDeliveryValues,
  NotificationRealtimeEventName,
  NotificationSourceType,
  NotificationTab,
  NotificationTabValues,
  NotificationType,
  NotificationTypeConfig,
  NotificationTypeValues,
  OnboardingStep,
  OrganizationRole,
  PARTNER_SUCCESS_FEE_DATE_FILTER_TYPES,
  PARTNER_SUCCESS_FEE_DEFAULT_BASIS_POINTS,
  PARTNER_SUCCESS_FEE_LEAD_BASIS_POINTS,
  PARTNER_SUCCESS_FEE_SORT_BY,
  PAYMENT_CONDITION_REGISTRY,
  PAYOUT_FLOW_STEP_ORDER,
  PAYOUT_STEP_BY_SECTION,
  PLAN_ENTITLEMENTS,
  PLAN_FEATURES,
  PLAN_FEE_GRID,
  PLAN_IDS,
  PLATFORM_ANNOUNCEMENT_STATUSES,
  PRODUCT_ANALYTICS_VERSION,
  PROGRAM_INVITATION_INTENTS,
  PROGRAM_SCOPED_VARIABLES,
  PartnerIntegrationStatus,
  PartnerProvider,
  PartnerRemunerationType,
  PayoutBatchClosedReason,
  PayoutBatchStatus,
  PayoutCancellationReason,
  PayoutTransferStatus,
  PlanLimit,
  PlanTier,
  PlatformEnum,
  ProgramMode,
  ProgramStatus,
  REMIND_COOLDOWN_HOURS,
  REMIND_EXPIRY_WINDOW_DAYS,
  SHOPIFY_ONLY_DISCOUNT_SETTINGS,
  SIZE_TARGETS,
  SUBSCRIPTION_SYNC_GRACE_PERIOD_HOURS,
  SUCCESS_FEE_BASIS_POINTS_BY_PLAN,
  SUCCESS_FEE_FREE_PLAN_BASIS_POINTS,
  SUCCESS_FEE_NO_PAID_PLAN_BASIS_POINTS,
  SUCCESS_FEE_OVERRIDE_MAX_BASIS_POINTS,
  SUCCESS_FEE_OVERRIDE_MIN_BASIS_POINTS,
  SUCCESS_FEE_TERMS_CONSENT_TYPE,
  SUCCESS_FEE_UNPRICED_PLANS,
  SUPPORTED_COUNTRIES,
  SUPPORTED_TEMPLATE_PAIRS,
  SubscriptionCancellationReason,
  TAX_RESIDENCE_COUNTRIES,
  TAX_RESIDENCE_COUNTRY_CODES,
  TEMPLATE_CONTENT_MAX_LENGTH_BY_CHANNEL,
  TEMPLATE_CONTENT_WARN_LENGTH_BY_CHANNEL,
  TIMEONE_TRACKING_MACROS,
  TeamInvitationStatus,
  TemplateChannel,
  TemplateContext,
  TemplateType,
  UGC_BRIEF_MAX_END_DAYS,
  UGC_CONTENT_FORMAT_FILTERS,
  UGC_CONTENT_STATUS_FILTERS,
  UGC_DECISION_CALENDAR_DAYS,
  UGC_DECISION_URGENT_HOURS,
  UGC_DELIVERABLE_FORMATS,
  UGC_DELIVERY_RESOLUTIONS,
  UGC_DURATION_TOLERANCE_SECONDS,
  UGC_FALLBACK_RIGHTS_MONTHS,
  UGC_FEEDBACK_MAX_CHARACTERS,
  UGC_FILE_LIMITS,
  UGC_FILE_RATIOS,
  UGC_MAX_DURATION_SECONDS,
  UGC_MINIMUM_CENTS_PER_FORMAT,
  UGC_MODIFICATION_REQUEST_CATEGORIES,
  UGC_ORIGINALS_KEPT_MONTHS,
  UGC_PENDING_FEEDBACK_CHOICES,
  UGC_PRODUCT_RECEPTION_ANSWERS,
  UGC_PRODUCT_RECEPTION_SOURCES,
  UGC_RATIO_TOLERANCE,
  UGC_RECEPTION_ASSUMED_AFTER_DAYS,
  UGC_RECEPTION_QUESTION_DAYS,
  UGC_RESOLUTION_SHORT_SIDE,
  UGC_RIGHTS_NOTICE_DAYS,
  UGC_TACIT_REMINDER_HOURS,
  UGC_TACIT_VALIDATION_HOURS,
  UGC_TRACKING_PATH,
  UGC_USAGE_RIGHTS_CLAUSE_TERMS,
  UGC_USAGE_RIGHTS_DURATIONS,
  UGC_VERSION_NOTE_MAX_CHARACTERS,
  UGC_VERSION_STATUSES,
  UTM_KEY_REGEX,
  UserRole,
  VARIABLE_REGISTRY,
  WEB_PAYOUT_COUNTRIES,
  WITHDRAWN_RECENCY_WINDOW_DAYS,
  WishlistCreatorStatus,
  WithdrawalStatus,
  addMonths,
  aiConversationChannel,
  brandSpaceGraphemes,
  brandSpaceHarvestedPlatforms,
  brandSpaceJsonByteLength,
  brandSpaceOffersApplications,
  brandSpaceUtf8ByteLength,
  briefGiftChoiceLabel,
  buildBoostAdName,
  buildBoostAdSetName,
  buildBoostCampaignName,
  buildBrandSpaceEmergencyUnpublishActorAssertionPayload,
  buildBrandSpaceLegacyPublicPath,
  buildBrandSpacePublicPath,
  buildDefaultUtmParameters,
  buildExportFilename,
  buildHostedMentionPath,
  buildHostedMentionThumbnailUrl,
  buildHostedMentionVideoUrl,
  buildProductUrl,
  canCarryDisplayRightsTerms,
  clampBrandSpaceDisplayText,
  classifyBrandSpaceAddressSegment,
  classifyGiftStoppage,
  classifySuccessFeePlanRate,
  cleanRegistrationNumber,
  coerceBrandSpacePublicLocale,
  collabDashboardHref,
  collabFeeBasisPointsForPlan,
  collabProcessingFeeBasisPoints,
  companionBrandChannel,
  compensationOfferedProduct,
  computeDisplayRightsEndAt,
  computeDisplayRightsTotalCents,
  contractClauseSentence,
  conversationAttachmentKindOf,
  conversationMessageMaxCharacters,
  countBrandSpaceOverrides,
  countMessageCharacters,
  countTemplateContentCharacters,
  createBrandSpacePreviewAppliedMessage,
  createBrandSpacePreviewReadyMessage,
  createBrandSpacePreviewRenderMessage,
  createDefaultBrandSpaceConfig,
  creatorReferralInvitationCopy,
  currentConsentVersion,
  dashboardAnnouncementDismissApiPath,
  dashboardNotificationsChannel,
  daysUntil,
  decisionFromUgcLine,
  decodeCreatorHubAffiliationCollabId,
  decodeCreatorHubContractualCollabId,
  defaultDiscoverySort,
  deriveBrandSpaceStudioMirrorBatchStatus,
  deriveNextAction,
  deriveToBeHandled,
  describeRegistrationNumber,
  diffBrandSpaceConfig,
  discountCodeMode,
  discoverySortOptions,
  displayRightsDashboardPaths,
  displayRightsDaysUntil,
  displayRightsLinkPaths,
  euVatNumberShape,
  exceedsBrandSpaceGraphemeLimit,
  findCommissionCategory,
  findReachableFlowStepV2,
  findUpstreamFlowStepV2,
  flowConditionOutcomesV2,
  flowGoalsForTriggerV2,
  flowMessageBodyFormat,
  flowStepsIncompatibleWithTriggerV2,
  flowTriggerCapabilitiesV2,
  foldCodeSegmentToAscii,
  formatExactCommissionMoney,
  formatRegistrationNumber,
  getCommissionSourcePresentation,
  getCountryRegistrationConfig,
  getNotificationCategory,
  getNotificationSourceType,
  getPhoneCountryOptions,
  getRequiredVariables,
  getTemplateVariableErrors,
  getTemplateVariables,
  getVariablesForPair,
  giftAwaitsCreator,
  giftBlockedSeverityOf,
  hasCommissionCategoryGrid,
  hasSingleCommissionRate,
  hasUniqueBrandSpaceItemKeys,
  hasUniqueBrandSpaceLinkKeys,
  hasUnresolvedDeliveryFailure,
  isAffiliateJourneyTriggerV2,
  isAffiliateParticipant,
  isBrandLegalIdentityComplete,
  isBrandSpaceApplicationQuestion,
  isBrandSpaceConfig,
  isBrandSpaceConfigV1,
  isBrandSpaceConfigV2,
  isBrandSpaceConfigV3,
  isBrandSpaceConfigV4,
  isBrandSpaceGraphemeBoundedString,
  isBrandSpaceItemKey,
  isBrandSpaceMediaHost,
  isBrandSpacePreviewInstanceId,
  isBrandSpaceProgramId,
  isBrandSpacePublicLocale,
  isBulkInvitationBatchPaused,
  isCollabAgeAttestationAsked,
  isCollabSettleableCurrency,
  isCountryOutsidePayoutPerimeter,
  isCreatorHubCollabMoment,
  isCreatorParticipant,
  isDeliveryFailureActionable,
  isDisplayRightsProposalOpen,
  isEuMemberCountry,
  isFlowDefinitionV2,
  isFlowTriggerTypeV2,
  isInvoiceEligible,
  isNotificationCategory,
  isNotificationTab,
  isNotificationType,
  isProductAnalyticsClientEvent,
  isProductAnalyticsProperties,
  isRemindCooldownOver,
  isSafeBrandSpaceWebUrl,
  isSupportedCountry,
  isSupportedTemplatePair,
  isTaxResidenceCountry,
  isUgcContentLate,
  isUgcDeliverableFormat,
  isUgcModificationRequestCategory,
  isUgcVideoFormat,
  isValidSuccessFeeOverrideBasisPoints,
  isValidUgcDeliverable,
  isWebPayoutCountry,
  judgeCollabPublicationUrl,
  looksLikeEuVatNumber,
  mergeBrandSpaceConfig,
  nextRemindAllowedAt,
  normalizeBrandSpaceAddressSegment,
  normalizeBrandSpaceMentionHandleQuery,
  normalizeBrandSpaceStudioOrigin,
  normalizeBrandSpaceText,
  normalizeCountry,
  normalizeDiscoverySort,
  normalizeEuVatNumber,
  normalizeFlowMessageChannels,
  normalizePhoneNumber,
  normalizeProductAnalyticsRoute,
  normalizeRecurringDuration,
  normalizeUrlBase,
  notificationBelongsToTab,
  notificationUserChannel,
  offeredCatalogProducts,
  ownedLevels,
  ownsCampaignLevel,
  paidBriefMaxEndDays,
  pairForTemplateType,
  parseBrandSpacePreviewControlMessage,
  parseBrandSpacePreviewRenderMessage,
  parseBrandSpacePublicAddress,
  parsePhoneNumberValue,
  partnerSuccessFeeGridBasisPoints,
  paymentConditionSentence,
  planFeeOfferOf,
  planUtmApplication,
  readCollabPublicationUrl,
  removeBrandSpaceOverride,
  resolveInsightsView,
  resolvePlacementMode,
  resolveProductUrl,
  retainBrandSpaceEmergencyUnpublishAttempt,
  reviewPolicyFor,
  sanitizeCodeSegment,
  sanitizeDiscountSettingsForMode,
  selectPayoutFlowSteps,
  slugifyUtmValue,
  successFeeBasisPointsForPlan,
  tacitReminderMilestoneHours,
  templateContentMaxLength,
  templateContentWarnLength,
  templatePairKey,
  templateTypeForPair,
  toBrandSpacePublicConfig,
  toBrandSpaceStudioCreatorContentCandidate,
  toMetaBoostBudgetUnits,
  truncateBrandSpaceMetadataText,
  ugcBriefGaps,
  ugcDeliverableLabel,
  ugcDeliverableState,
  ugcFileKindForFormat,
  ugcFileKindOf,
  ugcFileRatioForFormat,
  ugcMinimumPaymentCents,
  ugcModificationRequestsOf,
  ugcPaymentShortfall,
  ugcRightsEndDate,
  ugcRightsExpireSoon,
  ugcRightsPriceSplit,
  ugcVideoUnits,
  upgradeBrandSpaceConfig,
  upgradeBrandSpaceConfigOverride,
  upgradeTierFor,
  utmParamsToUrlTags,
  validateBrandSpaceApplicationAnswers,
  validateBrandSpaceConfigStorage,
  validateBrandSpaceCreatorContentPresentation,
  validateBrandSpaceOverrideStorage,
  validateBrandSpacePublicConfigStorage,
  validateFinnishChecksum,
  validateItalianChecksum,
  validateItalianCodiceFiscale,
  validateLuhnChecksum,
  validateMod97Checksum,
  validateRegistrationNumber,
  validateSpanishChecksum
};
